var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBorderWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1920 121.74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #f9f9f9;\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1301.3,69.48c1.63-.75-2.59-.12,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1299.17,103.77v.77h1.28c.12-.62-.4-.66-.42-1.15-.35.07-.43.39-.85.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1301.35,78.13c.06.19.18.32.34.42-.07-.18-.19-.31-.34-.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1298.75,100.31c1.63-.76-2.59-.12,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1302.58,73.72c-.88-1.37-1.18.94-1.71,1.16.12.91,1.14-.44,1.71-.38-.26-.34-.52-.69,0-.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1299.6,71.41c.99-.11.98-1.03.43-1.54-.58.12-.36.97-.43,1.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1299.17,67.56c.32.06.48-.19.51-.48-.36.04-.69.03-.93-.11v.2c.36-.07.4.15.43.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1295.76,54.88v1.89c.35-.84,1.61-.86,1.7-1.93h-1.7s0,.02,0,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1296.19,53.3c-1.43-.26-1.56.65-1.7,1.54h.87c.7-.13.98-.64.83-1.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1299.55,66.54c-.15-.23-.42-.35-.81-.13v.14c.29.07.56.06.81,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1307.7,74.11c.89.43.9.42.43-.39-.4.41-1.57.12-1.28,1.16.73.14.81-.3.85-.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1305.99,71.8c1.69-.45-1.68-.45,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1306.84,81.04c-.03.13-.04.24-.04.34.1-.04.22-.09.35-.14-.09-.06-.19-.13-.31-.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1305.99,74.16c-.02.21-.06.4-.16.54.21-.11.41-.19.58-.21-.12-.2-.27-.3-.42-.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1288.52,84.13c.84-.27,1.14-1.03,1.28-1.93-1.33-.18-1.36.82-1.28,1.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1305.13,74.45c-.46.3-.92.73-1.27.81.23.52.94.03,1.63-.37-.1.01-.21.01-.34-.02-.05-.18-.05-.31-.02-.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1302.15,77.19c.12.8,1.17.75,1.29,1.54,0,0,0,0,0,0,.07.06.04.04,0,0,.02.11.02.24,0,.39.41-.01.33-.47.43-.77.36-.07.4.15.43.39.99-.55-1.11-1.53-2.13-1.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1305.14,78.73c-.28-.25.18.16,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1289.8,79.12c-1.33-.18-1.52.97-.85,1.54.38-.24.76-.47.85,0,1.28-.25-.41-.82,0-1.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1312.38,67.17c-.42,0-.33.47-.43.77.42-.01.33-.47.43-.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1295.34,66.02c.42-.01.33-.47.43-.77-.42.01-.33.47-.43.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1310.68,94.14c2.01-.6.57-1.91,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1301.33,67.08c0-.1-.03-.18-.02-.29-.3.05-.59.11-.88.17.24.14.55.16.91.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1309.57,65.19c.09.02.17.04.26.06.04.16.04.29.02.4.15.24.31.48.42.76-.06.1-.13.16-.22.22.64.12,1.57.41,1.91-.22-.22-.57-.63-.97-.85-1.54-2.85-.04-3.05-2.38-5.78-1.73,1.31.4,1.97,1.7,4.08,1.73.05.12.1.22.16.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1289.8,81.81c1.62-.76-2.59-.12,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1293.21,101.08c-.04-.67-1.12-.39-1.95-.35.14.07.24.17.25.35-.39-.07-.66-.04-.85.05.12.26.47.31.84.34-.36.81-.26,1.13.01,1.6v-1.22c.19-.01.35.02.48.07-.03-.56.21-1.02,1.22-.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1311.53,87.59c-.12-.79-1.59-.36-1.71-1.15-.04.3-.16.54-.31.74.17.08.29.21.32.41-.45.48-1.32.58-2.08.78-.51.33-.91.75-.92,1.53.73.08,1.11-.66,1.28,0,.48-.07.24-.39,0-.38.2-1.49,2.56-1.02,3.41-1.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1290.22,68.71c-.76-.05-.9.47-1.71.38.62.73.95,1.71,2.56,1.54-.18-.73-1.22-.7-.85-1.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1293.21,101.85v.7c.12-.06.26-.15.43-.32.03.64-.09,1.18-.29,1.63,1.04.09.4.18-.33.54-.27.35-.61.62-.98.83-.07.14-.12.3-.12.47,1.49-.01,3.52-.95,3.41-3.47-1.14,1.06-.92-.45-2.13-.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1302.98,66.79s.01,0,.02,0c0,0,0,.01,0,.02.45.23,1.28.27,1.71.75-.35.21-.69.35-1.03.45.66.29,1.7.17,2.72-.45-.77-.87-2.81-.32-1.71-1.93-.75-.12-1.32-.01-1.79.16-.35.57-.24.84.07,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1305.14,60.24c-.28-.25.18.16,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1310.68,72.57c1.06-.26-.63-1.17-.85-1.54-1.06.26.63,1.17.85,1.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1303.43,69.48c-1.12-.12-1.1.8-1.28,1.54,1.12.12,1.4-.53,1.28-1.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1309.4,81.04c-1.1.4-1.41.58-1.65.55-.15.23-.59.2-.83.34.27.47.95.56,1.63.65-.52-1.25,1.38-.3.85-1.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1308.5,66.66c-.03.13-.03.29.04.52h1.28c.08-.33-.16-.36-.43-.39,0,0,0,0,0,0-.3,0-.61-.07-.9-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1308.97,69.87c-.28-.25.18.16,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1308.12,78.35c1.68-.45-1.68-.45,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1302.16,78.35c-.04.11-.05.24-.07.36.15.02.3.04.49.03,0-.04,0-.06,0-.1-.03-.19-.1-.35-.41-.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1328.58,98.38c1.63-.75-2.59-.12,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1329.43,95.3c-.52-1.17-1.63.27-2.13.39.52,1.17,1.63-.27,2.13-.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1327.73,85.28c-.41.01-.33.47-.43.77.41-.01.33-.47.43-.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1329.01,102.23c.29.06.47.02.59-.08-.42-.15-.16-.24.17-.25.08-.23.07-.54.09-.82-.52.17-.87.49-.85,1.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1328.58,99.53c1.3,1.05-1.16-1.17,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1327.73,83.74c-.5.06-.36.7-.43,1.16.5-.06.36-.7.43-1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1326.45,98.76c-.28-.25.18.16,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1324.74,85.67c.1.68.73.88,1.7.77.12-.61-.38-.66-.42-1.13-.08.3-.02.73-.42.74.09-.3.02-.75.42-.77,0,0,0,0,0,0h.85c-.52-1.17-1.63.27-2.13.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1329.43,78.35c-.41.01-.33.47-.42.77.41-.01.33-.47.42-.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1324.31,87.59c-.08,1.1-.05,2.1,1.28,1.93-.05-.98-.08-1.98-1.28-1.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1334.55,78.35c.29-1.27-.89-.62-.88.14.45-.13.64.43,1.73.25-.1-.27-.01-.54.13-.75-.35.1-.69.2-.98.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1334.97,73.34c-.47.17-.79.46-1.1.77.11.11.21.22.25.38-.22-.03-.42-.03-.6-.02-.31.32-.64.62-1.11.79,1.09.37,1.5-1.01,3.41-.77-.15-.51-.75-.61-.85-1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1344.35,68.38c-.01.12,0,.23.02.32.79-.22.39-.32-.02-.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1335.03,76.88c-.76-.08-1.48-.25-2.19-.46-.28.05-.21.18-.04.39.71.11,1.44.15,2.23.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1331.56,102.23c1.68-.45-1.68-.45,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1331.99,75.65c-.36.17-.53.49-.73.8.24.07.48.14.73.19v-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1331.63,77.56c-.16-.35-.43-.62-.57-.81-.18.22-.4.39-.76.44v.02c.12.41.76.35,1.34.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1330.71,74.88c.05.14.11.24.16.31.55-.25.91-.67,1.3-1.08-.42-.29-.99.81-1.46.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1309.4,89.9c-.28-.25.18.16,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1317.5,67.94c-.19-.73.58-2.32-.85-1.93.33.34.46.87.43,1.54-.5.06-.76-.08-.85-.38-1.07.16.41,1.1,1.28.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1314.95,69.48s0,0,0,0c0,0-.02,0-.02,0-.3.19-.5.45-.41.76,1.36.33,1.32-.61,2.13-.77-.07-.44-1.09-.37-1.7,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1315.8,94.91s0,0,0,0c0,0,0,0,0,.01,0,.13,0,.26,0,.37.57-.25.79-.82.85-1.54-1.07-.32-.88.48-.85,1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1313.78,70.24c.09,0,.18,0,.31.02-.01-.06-.05-.1-.07-.15-.07.05-.15.1-.24.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1317.07,95.68c.42-.01.33-.47.43-.77-.42.01-.33.47-.43.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1309.4,96.84c1.66-.96-1.41-.56,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1312.82,70.26c-.08-.27.06-.5.29-.68-.3.05-.59.22-.81.47.03.07.07.12.09.21-.1-.02-.17-.01-.24-.02-.15.23-.23.5-.19.79,1.26.44,1.06-.45,1.54-.72-.18.02-.39.02-.67-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1310.27,98.04c-.04.16-.14.29-.27.39.29.41,2.29.4,1.96-.81-1.05-.5-1.33,1.46-1.69.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1320.91,85.67c-1.1-.5-.82-1.27-.43-2.31-.97.32-1.16,2.37-.42,3.08.36.07.4-.15.42-.39-.08-.33.17-.36.43-.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1322.19,86.82c.41-.01.33-.47.42-.77-.42.01-.33.47-.42.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1322.67,88.86c-.35.38-.06,1.53.79,1.05.03-.16.02-.27-.01-.37-.46-.05-.67-.31-.78-.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1323.04,83.35c-1.37.91,1.5,1.56,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1321.33,76.42c0,.12.02.22.05.31.42.06.74.22.79.62.51.13,1.17.12,1.72.22.15-1.3-1.85-.64-2.56-1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1321.76,93.76c-1.24-.34-.48-.58-.43-1.54-2.09,0,.16,2.79.85,1.54-.08-.44-.43-.21-.43,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1322.61,97.22c1.68-.45-1.68-.45,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1325.17,100.69c.42-.01.33-.47.43-.77-.41.01-.33.47-.43.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1316.22,83.35h.85c-.08-.33.17-.36.43-.39.17-.75-1.94-.56-1.28.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1279.57,89.89s0,0,0,0c0,0,0,0,0,0-.33.45-.45.98,0,1.16,1.12.11.34-1.49,1.71-1.16-.14-1.26-1.17-.72-1.7,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1253.96,84.33c.03.05.05.11.04.18-.05.03-.08.05-.12.08,0,.09.04.19.11.31.87-.67.84.29,1.7-.39.1-.52-1.37-.65-1.74-.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1254.42,67.56c-.1-.56-1.27-.13-1.28-.77.26-1.07-.1-.3-.44.73,0,.01.02.02.02.04-.02.01-.03.03-.04.04-.16.51-.32,1.07-.39,1.5,1.83.5,1.35-1.09,2.13-1.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1256.55,64.09c-1.23,1.11,1.23-1.11,0,0h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "1253.57 64.48 1253.57 64.47 1253.57 64.48 1253.57 64.48"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1256.98,52.53c-.26-.34-.51-.69,0-.77-.03-.09-.06-.16-.1-.22-.14.3-.4.49-.74.6-.01-.4.12-.67.34-.86-.46.01-1.01.71-1.2.86.13.52,1.07.32,1.7.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1254.86,53.69c-.31-.02-.51.06-.65.18.36.55.9.99,1.5.97-.15-.77.09-1.21.85-1.16-.07-.45-.78-.32-1.28-.39-.42-.03-.47-.41-.51-.78-.36,0-.73.01-.96-.11-.04.27,0,.59.13.91.43.01.88.01.93.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1255.27,64.48c.15-1.4.87-2.3,1.28-3.47-1.43-.26-1.56.65-1.7,1.54-.2-.12-.31-.31-.45-.48-.24.5-.48,1-.64,1.57.39.13.55.46.86.67.06-.05.13-.12.24-.22.8-.72.05-.05-.24.22.16.11.36.18.66.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1252.31,61.8c.42.12.5.55.84.75.11-.67.21-1.36.87-1.54.33-.6.57-1.27.4-2.31-.52-.17-.87-.49-.85-1.15-.73.1-1.17.4-1.41.82.15.15.33.26.56.33.2,1.2-.15,1.9-.54,2.57.04.18.09.36.13.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1256.98,69.48c1.68-.45-1.68-.45,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1253.58,64.47c.78-.21.46-.32.07-.33-.02.11-.06.21-.07.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1262.95,55.23c-.37-.58-.64.1-1.71-.39-.02.11-.03.22-.04.32.02.02.04.04.05.06-.02.02-.05.04-.07.06-.06.95.37,1.46.49,2.26h1.28v-1.16c-1.26,1.1-.59-.75,0-1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1259,53.08c-.57.79-.49,2.16-1.1,2.91.58-.03,1.14-.04,1.21.39.18-.08.32-.19.44-.32-.07-.34-.1-.72,0-1.22.2.09.36.13.51.16.2-.75.29-1.59.77-2.08-1.08,1.43-.76.79-1.81.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1266.35,52.15c-.12.62.4.66.43,1.15.82.15.62-1.75-.43-1.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1267.21,105.7c.18.16-.28-.25,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1258.26,72.95c.94.21.61-.74,1.28-.77-.17-.96-1.65-.02-1.28.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1259.96,67.56c.72-1.78.34-.34-1.28-.38-.06.19-.06.32-.04.44.25.03.47.08.48.33-.1,0-.18.03-.24.07.36.24.97.24,1.08.7.46-.1.29-.77.85-.77-.01-.37-.52-.3-.85-.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1257.41,70.79c.25.13.43.32.43.63-.16-.05-.38-.05-.61-.04.52.24,1.72-.14,2.3.04,0-.87-1.34-.92-2.13-.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1259.54,57.16c-1.17,1.22-.26,2.02-1.28,3.08,1.5-.03,1.66-2.54,1.28-3.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1248.03,81.43c-1.57,1.17,1.3,1.3,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1244.24,61.06c-.06-.18-.06-.32.09-.4.1-.33.26-.62.44-.87-.06-.77.33-1.54.52-2.2-.08-.02-.17-.03-.24-.05.06-.3.16-.57.27-.82-.12-.31-.44-.56-1.13-.72.28.77,1.47,1.64,0,1.93-.93.06-.19-1.37-.43-1.93-.5.06-.76-.09-.85-.39-.18.08-.29.23-.36.4,1.87.46.93,1.63.61,2.94.29-.13.53-.31,1.03-.26.18.76-.49.74-1.11.76,0,.09,0,.17,0,.26.52.81.81,1.37.26,2.44.47-.06.72.07.83.34-.04-.54-.02-1.02.07-1.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1245.05,87.59c.34-.07.42-.39.85-.38v-.77h-1.28c.23.31.45.62.43,1.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1244.62,97.99c1.68-.45-1.68-.45,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1245.06,82.2c-.19-.05-.34-.06-.47-.06.04.12.06.27.03.45.68.1.87-.24,1.27-.39-.11-.15-.04-.41.44-.77.36.36.39.6.3.75.04,0,.07,0,.12.02v-1.54c-.73,0-1.07.34-1.7.43v1.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1242.06,71.41c1.75.29,1.47-1.24,1.7-2.31-1.16.24-1.67,1.06-1.7,2.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1243.34,66.02c1.68-.45-1.68-.45,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1242.91,79.12c1.68-.45-1.68-.45,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1242.06,73.34c.19.47.54.79,1.28.77-.19-.47-.54-.79-1.28-.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1267.21,71.03c.5-.06.36-.7.43-1.16-.5.06-.36.7-.43,1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1257.83,62.55c-.41,0-.33.47-.42.77.41-.01.33-.47.42-.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1257.83,50.22c.33-1.23-.52-2.93-.42-.77-.01.38-.52.3-.85.39.07.45.78.32,1.28.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1258.68,50.99c-.52.17-.87.49-.85,1.16.52-.17.88-.49.85-1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1256.13,41.74c-.28-.25.18.16,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1258.66,53.49c.09-.1.2-.24.33-.41-.09-.05-.19-.11-.31-.16.01.23,0,.42-.02.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1249.73,52.92c-.08.22-.18.42-.3.6.23.3.34.71.34,1.22.36.26.85.69,1.67.49.17-1.44-.34-2.26-1.7-2.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1248.52,65.25c.5.04.94.14,1.22.38v.28c.96-.11.6.96,1.52.88.07-.18.13-.31.17-.41v-.76c-.57-.49-1.76-.42-2.92-.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1247.61,66.02s-.02.06-.03.08c.42.92.79,2.01-.36,1.64-.02.14-.04.28-.07.41.43.32,1.02.49.88,1.33.92-.41.82-1.74,1.05-2.78-.4-.31-.26-1.1-1.46-.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1259.96,50.61c-.28-.25.18.16,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1287.75,89.41c.11.68-.92.33-1.01.83.56.17,1.14.33,1.78.44-.52-1.25,1.38-.29.85-1.54-.63-.09-1.16.08-1.62.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1273.17,84.51c1.68-.45-1.69-.45,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1276.16,74.88c-.41.01-.33.47-.42.77.41-.01.33-.47.42-.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1277.76,53.02c-.26.16-.57.27-1.01.27-.07.26,0,.53.26.78.72-.08.91-.58.75-1.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1280.42,69.48c1.62-.75-2.59-.12,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1278.29,82.2c-.96.49-1.31.57-1.93.63-.22.73-.05,1.14,1.51.92,0,.13,0,.26-.02.38.6.22.92.79.44,2.32.69-.66,1.29-1.4,1.28-2.7-1.97.29-1.74-.43-1.28-1.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1277.86,79.5c-.4.16-.2.93.14,1.63.3.27.5.53.46.78.09.12.18.23.25.29.34-.27,1.17-.6,1.28,0,.84-.79-1.68-1.8-2.13-2.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1280.42,88.36c1.03-1.29-1.43.93,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1279.39,65.99c.12-.2.24-.41.35-.63-.16-.07-.37-.1-.59-.12.08.33-.17.36-.43.39.04.28.34.34.67.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1278.22,69.44c-.99-.12.37-.39.77-.3.13-.09.22-.19.3-.3-.41-.18-.71-.46-.95-.79-.45.22-.56.74-.48,1.44.13,0,.25-.02.36-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1275.73,78.73h-.85c.04.54.07,1.08-.42,1.15,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,.26,1.06.81-.13,1.51-.05.02-.16.07-.28.2-.33,0,0,0,.01.01.02,0-.4-.06-.74-.44-.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1287.66,97.61c.42-.01.33-.47.43-.77-.41.01-.33.47-.43.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1287.24,92.99c1.68-.45-1.68-.45,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1288.52,93.37c.18.16-.28-.25,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1287.24,96.07s.04.07.07.1c-.03-.04-.05-.08-.07-.12,0,0,0,0,0,.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1284.26,87.59c-.84-.12-.69.65-.85,1.15.13.15.27.28.43.39.39-.2.64-.52.95-.8-.17-.25-.34-.51-.53-.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1280.85,86.82c.51,1.6,1.81-.32,2.13-1.16-1.21-.06-.99,1.16-2.13,1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1288.94,86.82c-.5.06-.36.7-.43,1.16-.55-.14-.95-.13-1.27-.06v.44c-.32.24-.79.35-1.28.46-.13.12-.27.23-.44.31-.08-.05-.13-.11-.2-.17-.41.1-.77.25-1.01.5.28.08.56.17.83.26.3-.06.61-.2.96-.34.68-.58,2.11-.48,2.83-1.02v-1.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1342.22,69.1c-.36.23-.48.52-.48.77.19.03.38.11.55.21.03-.21.02-.52-.07-.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1294.06,85.28c1.41-.56-1.66-.96,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1291.93,74.49c-.52.17-.88.49-.85,1.15.52-.17.88-.49.85-1.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1294.06,60.24c-.48-.3-1.55-.41-2.55-.27.35.05.65.14.85.27-1.41-.18-2.09.3-2.86.69-.08.14-.13.29-.13.46,2.02.03,2.37-1.45,4.69-1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1287.24,64.09c-.03-.1-.04-.19-.04-.27-.13.34-.41.55-.37,1.04h1.7c-.05-.69.52-.81.43-1.54-.84,0-.54,1.05-1.7.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1268.49,67.56c1.37-.91-3.29.06,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1294.48,85.67c-.56.14-.67.68-1.28.77.17.96,1.65.02,1.28-.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1293.21,99.92c1.46-.99-2.19-.93,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1294.48,82.58c-1.27-1.1-1.34.89-.43,1.54,1.5-.11-1.07-1.44.43-1.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1281.7,64.86c-.34.61-.61,1.27-1.1,1.74-.01.5-.12,1.08-.16,1.9.4.34.94.56,1.68.6-.02-2.23.63-2.8-.43-4.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1287.66,84.13c-1.63-.07-.15.32-.43,1.16-.62-.08-.9-.24-1.01-.46-.27.49-1.36.9-.94,1.67.75-.37.89-.12,1.95.34-1.37-1.37,1.7-1.69.43-2.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1285.06,86.6c-.11-.05-.21-.1-.29-.14-.04.12-.07.25-.09.36.15-.09.27-.16.38-.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1283.4,63.71c1.3,1.05-1.16-1.17,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1284.26,81.81h-1.7v.77h1.7v-.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1288.09,82.2c1.06-.06.12-1.3,0-1.54-.6.03-.56.44-.39.84.53-.09,1.23-.07.4.32-.1,0-.17-.01-.25-.02.1.18.2.33.24.4,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1282.55,63.32c-.42.01-.33.47-.43.77.42-.01.33-.47.43-.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1286.6,63.7c.14-.19.29-.38.65-.38,0,.07,0,.13,0,.19.32-.7,1.87-.45.84-1.35-.41,1.03-2.19.81-2.5,1.93.11.02.2.03.28.04.16-.22.33-.43.72-.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1285.29,85.24c.08.02.16.03.25.04.27-.84-1.21-1.23.43-1.16.09.07.16.14.21.21.05-.37.21-.82.21-1.36-.75.3-1.5.59-1.89,1.22-.04.24-.06.44.02.6.97-.37.99-.08.78.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1286.39,64.86h-.66c-.24.1-.46.21-.62.39.3,2.75.68,2.5,1.28-.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1370.34,84.13c.18.16-.28-.25,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1398.05,80.66c-.2-.44-.43-.49-.59-.37-.01.04-.07.13-.18.27-.1.3-.04.71.34.86.48-.07.24-.39,0-.38-.08-.33.17-.36.43-.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1397.19,84.51h.44c.15-.01.29-.02.42-.02v-.75h-.85v.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1398.9,102.23c1.06-.26-.63-1.17-.85-1.54-1.54.69.59,1.21.85,1.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1398.9,80.66c1.03-1.29-1.43.93,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1399.32,72.57c1.66-.96-1.41-.56,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1400.18,86.82c-.14.89.07,1.48.43,1.93.69.07.86-2.52-.43-1.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1383.56,84.9c-.49,1.21.67.93.85,1.54,1.04-.24.23-1.95-.85-1.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1399.32,84.51c.08.2.04.4-.03.58.05.16.07.34.04.57-.63.16-1.08.18-1.44.28.16.31.48.66.57,1.2,0-.11,0-.21.02-.33.07-.03.13-.05.2-.07.54-1.02,1.1-.77,2.35-1.09.13-1.02-.59-1.26-1.7-1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1400.6,99.92c1.68-.45-1.68-.45,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1401.88,81.43c1.68-.45-1.68-.45,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1392.24,74.24c.3.17.6.35.96.48.05-.08.1-.16.16-.23.99.42.51,1.01,1.03,1.53.73-.07.84-.64.84-1.2-1.15-.27-1.63-1.15-3.14-1.1.07.19.12.36.16.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1396.03,73.29s-.06.04-.11.04c.01-.52-.17-.87-.44-1.14-.12-.01-.26-.02-.42-.02-.36.77-.32,1.3.23,1.62.04-.06.11-.09.21-.08.02.08.05.15.08.22.21.08.46.14.77.17-.32-.25-.35-.54-.31-.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1391.65,104.54c.08.31.43.38.43.77h.85c.04-.61-.2-1.47.42-1.54.58-1.24-.94.81-1.7.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1396.23,86c-.04-.08-.08-.15-.1-.22-.25.07-.33.16.1.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1393.79,71.8c.03-.27.03-.51,0-.72-.16-.13-.31-.26-.42-.43.06-.04.14-.05.2-.08-.2-.24-.53-.36-1.06-.31-.12,1.01-.15,1.93,1.28,1.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1396.27,71.57c.37.2.72.4.98.7,0-.36,1.72-.47.38.3-.12-.05-.2-.09-.26-.14.16.24.26.52.25.91.46-.09.29-.77.85-.77-.27-1.35-2.18-2.66-3.41-1.93,0,0,0,0,0,.01.46.2.89.52,1.2.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1392.6,75.93c-.22-.29-.19-.59-.31-.87-.03.37-.12.77-.22,1.36.23-.11.39-.29.52-.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1396.77,77.19c.36-1.21,1.61-1.63,1.7-3.08-.61.43-1.04.42-1.28-.39-.77-.08.47,2.33-1.28,2.31.05.27.42.82.6,1.26.13.06.22.14.26.28-.04,0-.11.03-.16.05.02.19-.03.33-.27.34.04.73,1.59-.31,2.13-.38-.13-.52-1.07-.32-1.7-.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1391.65,98.76c.41.01.33.47.43.77.88-.23,1.62-.6,1.28-1.93-.6.03-1.2.06-1.28-.39-.26.08-.46.23-.62.39.07,0,.14,0,.2,0,.13.52.1.89-.04,1.16.01,0,.02,0,.03,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1381.86,97.22c-.66.43-.49.19-.22-.07-.39.02-.72-.22-1.08-.15-.01.22,0,.46-.06.65.57,0,1.55-.36,1.34.34.5-.06.36-.7.43-1.16-.1.09-.19.15-.28.2-.04.05-.08.11-.14.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1381,99.53c-.28-.25.18.16,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1384.41,80.28c-.25-.39-.4-.96-.8-1.3-.1-.05-.18-.1-.26-.16-.07-.03-.14-.06-.22-.08-.21.76.35,1.34.76,1.81.15-.06.32-.15.52-.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1380.15,92.99c-.62.17.05.34,0,.77.54-.1.43-.77,0-.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1382.28,87.59c.41,0,.33-.47.42-.77-.41.01-.33.47-.42.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1384,76.89c0-.15-.01-.31-.02-.47-.52.27-.6.94-.75,1.55.49-.15.38-.84.77-1.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1384.41,97.61c.18.16-.28-.25,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1380.57,81.81c1.03-1.29-1.43.93,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1381.42,91.06c-.41.01-.33.47-.43.77.42,0,.33-.47.43-.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1402.31,74.11c-.42.01-.33.47-.43.77.42-.01.33-.47.43-.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1389.52,93.37c-.62.17.05.34,0,.77.54-.1.43-.77,0-.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1388.67,84.51c.41,0,.33-.47.43-.77-.42.01-.33.47-.43.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1389.52,80.27c.08.31.43.38.43.77h.85c.2-.82-.61-.73-1.28-.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1387.82,96.84c-.62.17.04.34,0,.77.54-.1.43-.77,0-.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1384.32,99.26c.11.48,0,1.02-.32.27,0,0,0,0,0,0-.23.16-.49.3-.82.38,0,.02-.02.03-.02.05.14.37.83.24.84.74.94.16,1.07-2.31,1.71-1.16.49,1.1.49-.62,0-.77.28-.39.98-.4.85-1.15-1.12.21-1.56,1.03-2.22,1.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1386.97,83.35c1.66-.96-1.41-.56,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1383.56,97.22c1.03-1.29-1.43.93,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1386.11,89.9c.31.69.77.06,1.28,0-.31-.69-.78-.06-1.28,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1402.74,79.5c-.46-.36-.13-1.42-1.28-1.15.45.36.13,1.42,1.28,1.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1342.22,72.95c-.41,0-.33.47-.43.77.42-.01.33-.47.43-.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1398.05,104.16c-.64-.08-.65.42-.8.79.37.04.64.16.38.75-.16-.05-.38-.05-.61-.04.52.24,1.72-.14,2.3.04.63-1.47-1.9-.08-1.28-1.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1431.29,92.22c1.68-.45-1.68-.45,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1430.86,95.68c.33-.34.46-.87.43-1.54h-1.7c.01.21,0,.39-.02.57.05.67.4,1.06,1.29.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1436.41,87.22s0,0,0-.01c-1.06.16-.03,1.49.85,1.16-.09-.29-.32-.45-.52-.64-.2.09-.45.07-.75-.13.17-.11.31-.24.42-.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1431.29,98.76c-.28-.25.18.16,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1437.68,87.59c1.59,1.04,1.64-2.61,1.71-4.24-1.39.74,0,3.14-1.71,4.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1439.81,89.91c-.3.17-.53.13-.69-.01-.36.24-.64.56-.59,1.16h1.28v-1.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1439.81,89.52s0,0,0,0c0,0,0,.02,0,.03v-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1426.18,94.14c1.68-.45-1.68-.45,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1429.16,95.68c-.33.03-.58,0-.78-.1-.56.25-1.28.82-1.77.87.67,1.75,1.52-.57,2.55-.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1427.5,99.95c-.2-.03-.4-.07-.58-.12.21.39.28.9.11,1.63,1.58.07.36-.86.47-1.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1439.81,82.58c-.06-.69.52-.81.43-1.54-.73.47-1.33.64-1.89.78-.13.21-.26.41-.23.76-.6-.22-1.16-.09-1.65.08.69.9,1.9-.61,3.35-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1431.29,93.76c1.11.11,1.83-.14,1.7-1.16-.31.61-2.09-.09-1.7,1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1425.75,98.76s.09.06.13.08c1.52.26,3.33.81,4.68.71-.26.08-.34.32-.41.56.48.1.91.26,1.14.58.7-.04.41-.98.97-1.14-1.97.15-4.9-1.09-6.51-.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1426.18,79.89c-.41.01-.33.47-.43.77.41-.01.33-.47.43-.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1424.05,87.98c.12.91,1.14-.44,1.7-.39-.42-1.18-1.14.44-1.7.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1424.9,103.39c1.68-.45-1.68-.45,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1436.4,81.04c-.08-.31-.43-.38-.43-.77.19-.34.37-.69.85-.77,1.06-1.4-3.17,1.41-.43,1.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1402.74,97.22c.41-.01.33-.47.43-.77-.42.01-.33.47-.43.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1403.16,82.97c.41-.01.33-.47.43-.77-.41.01-.33.47-.43.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1401.46,76.91c-.08.16-.03.43.01.71.64.04,1.39,0,1.26.73,1.16.28-.31-1.82.85-1.54.84-.48-.95-.19-2.13.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1405.29,89.52v1.14s0,.01.01.02h1.7c-.37-.56-.64-1.22-1.71-1.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1402.31,89.9c-.43-.25-.44-.89-1.28-.77,0,.77,1.16.49.85,1.54.46-.1.29-.77.85-.77.81-.27-.46-.6-.43,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1400.6,104.54c1.63-.75-2.59-.12,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1406.14,78.35c.19.47.55.79,1.28.77-.19-.47-.55-.79-1.28-.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1401.03,101.08c.42-.01.33-.47.43-.77-.42.01-.33.47-.43.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1443.22,86.05c1.03-1.29-1.43.93,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1410.41,78.73c-.62.17.04.34,0,.77.54-.09.43-.77,0-.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1445.36,89.9c.69.16.45-.51.39-1.02-.17.16-.34.31-.53.46.06.21.11.41.14.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1443.65,89.13c1.63-.75-2.59-.12,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1442.8,87.21h-.85v1.16h.85v-1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1446.22,88.36c.78.72.07.96,0,1.88.42-.16.95-.21,1.69.04.05-.96.8-1.19,0-1.93-1.16-.28.3,1.82-.85,1.54-.21-1.08-1.34-4.41-2.13-1.54h.97c.07-.03.18-.03.32,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1411.68,72.18c.18-.19.53-.23.83-.32.09-.27.23-.54.46-.82,0,0,0,0,0-.01-.93-.07-1.35.32-1.28,1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1421.06,70.26c-.62.14-1.22.3-1.78.44-.08.85.52,1.08.94,1.48-1.16.28-.86-.77-1.7-.77.79,1.74-1.53.67-1.71,1.54,2.16.26,1.68,2.7.85,3.85-1.99-.66-.43.22-1.68,1.13.49.07,1.02.1,1.67.02,1.31-.92-.31-1.82,1.7-1.16.83-1.15,1.31-3.59-.85-3.85.17-.87,2.5.2,1.71-1.54.85,0,.54,1.05,1.7.77-.48-.46-1.22-.7-.85-1.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1414.52,71.24c.27,0,.54-.03.81-.06-.22-.04-.45-.08-.67-.15-.06.07-.1.14-.15.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1437.62,91.06h-.5c.08.1.16.23.14.39.25-.04.36-.22.36-.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1354.15,72.18c-.48.06-.32.24-.01.45,0-.02,0-.04.01-.07v-.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1349.04,71.41c.18.16-.28-.25,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1350.74,86.44c.18.16-.28-.25,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1352.87,80.27c-.28-.25.18.16,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1353.72,72.95c.06.01.11,0,.15,0-.6-.59-.98-.97.27-.77v-.38c-1.02-.14-1.05.61-1.7.8-.03.22-.08.42-.42.36-.1-.19-.19-.3-.27-.36-.06-.01-.1,0-.17-.03.22.31.44.63.43,1.16.85.2.97-2.13,1.7-.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1361.39,72.18c-.18-1.67-2.47.41,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1357.4,74.58c-.17-.12-.42-.16-.71-.16.05.16.06.31.02.46.09-.09.36-.21.69-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1353.3,77.75c-.14.2-.3.39-.52.53.17.32.3.68.15,1.09.36.1.77.14,1.23.14-.06-.06-.19-.17,0,0,0,0,0,0,0,0,.13,0,.26,0,.41,0,.28-.53.04-.99-.18-1.38-.24.04-.57.08-1.09-.16-.01-.08,0-.14,0-.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1355.86,72.18c-.2-.03-.34-.04-.46-.05.06.05.11.1.17.15.03-.05.12-.08.29-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1354.15,82.2c-1.18.16-.02,1.21.85.77-.11-.42-.85-.26-.85-.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1352.89,83.07c-.76.03-1.43-.73-.43-.87,0,.18.1.28.23.35-.03-.27.01-.62.19-1.12-1.09.23-1.57,1.04-1.52,1.83.3.3.66.55.69,1.26.4.3.96.47,1.68.38.14-1.19-.49-1.37-.84-1.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1354.15,88.75c.41-.01.33-.47.42-.77-.41.01-.33.47-.42.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1354.15,95.68c1.16-1.17-1.3,1.05,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1354.57,97.99c.41-.01.33-.47.43-.77-.41.01-.33.47-.43.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1349.46,89.9c1.41-.56-1.66-.96,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1349.89,88.36c.52-.17.87-.49.85-1.16-.52.17-.87.49-.85,1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1351.16,92.22c.22-.06.35-.11.42-.15-.02-.05-.04-.1-.07-.15-.39-.09-1.46,0-.35.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1353.3,91.45c-.62.17.04.34,0,.77.54-.1.43-.77,0-.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1359.69,70.26h-.85c-.12.62.4.66.43,1.16.52.12,1.47-1.11.43-1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1343.07,69.87c-.15.25-.22.45-.26.63.17.21.18.4-.03.48.02.37.11.77-.13,1.59,1.14-.12.4-2.37,1.7-1.54.9-.12-.45-1.34-1.28-1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1341.36,75.26c.11.42.85.26.85.77,1.16.28-.31-1.82.85-1.54-.38-1.04-.95.88-1.7.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1345.64,69.1c.03.41.48.45.84.56-.06-.51-.51-.68-.42-1.33-1.29-.45-.45,1.03-1.47.84.1.16.18.33.2.57.16.08.36.12.58.14-.25-.28-.24-.62.28-.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1345.2,93.37c.42-.01.33-.47.43-.77-.41.01-.33.47-.43.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1342.64,77.58c.42-.01.33-.47.43-.77-.41.01-.33.47-.43.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1336.23,77.75c.07.11.09.29.02.6.97-.53,2.66-.42,2.56-1.93-.61.21-1.18.35-1.73.43-.1.47-.43.73-.85.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1336.68,99.53c.41,0,.33-.47.42-.77-.41.01-.33.47-.42.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1337.53,75.26c.12.79,1.89.09,1.7,1.15,1.26-.56-.51-1.55-1.7-1.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1340.51,99.15c1.69-.45-1.68-.45,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1347.33,98.38c.41-.01.33-.47.42-.77-.41,0-.33.47-.42.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1362.25,101.46c.35.05.63.03.86-.03-.02-.47.04-.86.19-1.17-.6.18-1.19.36-1.06,1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1362.25,98.38c-.5.06-.36.7-.43,1.16.5-.06.36-.7.43-1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1362.67,102.62c.44.4.66-.17.43-.39-.44-.4-.66.17-.43.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1362.25,79.5c-.09-1.72-3.1,1.46,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1347.33,69.1c-1.15.35.2,1.56,1.28,1.16.13-.89-1.23-.43-1.28-1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1346.48,92.6c.41-.01.33-.47.43-.77-.41.01-.33.47-.43.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1361.39,77.96c1.63-.75-2.59-.12,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1347.76,89.9c-.35-.2-.48-.34-.5-.43-.27.05-.57.18-.88.29.03.04.07.09.1.14-.25.13-.63.33-1.03.5.64.66,2.07-.17,2.72-.5-.04-.07-.08-.12-.12-.17-.06.05-.15.11-.3.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1357.56,77.19c.89.16,1.13-.26,1.71-.39.13-1.02-.59-1.26-1.71-1.16v.73c.02.13.03.26.01.43,0,0,0,0-.01,0v.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1372.05,104.16c.18.16-.28-.25,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1240.36,79.89c.17.25.33.52.51.76.21.18.41.37.6.57.28.18.63.29,1.11.28-.05-.13-.09-.27-.07-.47.21.04.38.06.54.06-.62-.65-1.35-1.21-2.68-1.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1373.33,96.84c1.68-.45-1.68-.45,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1368.21,100.31v.75s0,.01.01.02c0,0,0,0-.01,0v.38c.38-.3.96-.41,1.71-.38-.1-.68-.73-.88-1.71-.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1369.07,86.82c-.18-1.67-2.47.41,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1366.51,96.84c1.66-.96-1.41-.56,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1366.51,95.68c1.66-.96-1.41-.56,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1373.33,99.53c-.28-.25.18.16,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1366.51,98.38c1.66-.96-1.41-.56,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1369.07,85.28v-1.16c-.34.2-.69.4-1.28.38.08.31.43.38.43.77h.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1387.82,80.66c.2-.82-.61-.73-1.28-.77.08.31.43.38.43.77h.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1375.46,84.9c.73,1.24,1.15-.97,1.28-1.54-1.68-.62-.15,1.66-1.28,1.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1375.04,77.58v.77c.36-.07.4.15.43.39.83.15.62-1.75-.43-1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1386.11,79.12c-.21-1.21.93-1.51,0-2.31-1.06-.11-.44,1.29-1.51,1.18-.03.06-.05.12-.07.18.32.51.64,1.01,1.58.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1373.75,104.16c.41-.01.33-.47.43-.77-.42.01-.33.47-.43.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1375.88,73.34c-2.21.26-.97,2.15-1.7,3.08,1.38,1.22,1.22-2.22,1.7-3.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1374.61,79.12c-.28-1.15-.91.36-1.7,0,0,0,0,0,0,0,.08.31.43.38.43.77h.85c-.07-.45.09-.69.43-.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1373.75,80.27c-1.07.39.34,1.7,1.28,1.54.62-1.47-1.91-.08-1.28-1.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1363.52,103.39c-.71-.64-1.25-.92-2.03-.94,0,.23-.2.46-.52.16-.04-.04-.06-.08-.08-.13-.13.02-.27.04-.42.06.46.13.86.4,1.35.84-.61,0-1.11-.04-1.45,0,.25.59.64,1.07,1.44,1.16-.76-1.38.04-1.17,1.7-1.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1356.28,90.67c.48-.47.37-.79-.42-.77-.08.84.35,1.23,1.28,1.16.78-.3-.26-.41-.85-.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1357.56,104.54s.04-.02.06-.02c-.02,0-.03-.02-.05-.03,0,.02,0,.04-.01.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1359.69,84.9c-.62.55-1.35.3-1.28-.77-1.51.04.9,1.27-.42,1.16,0,0,0,0,0,0,.43.79,1.88,1.05,1.7-.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1358.41,79.12v-.77c-.91-.18-.81.55-.85,1.15.35-.07.43-.39.85-.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1383.56,81.81c.72.84,2.05-.23,2.45-1.16h-.74s0,0,0-.01c-.43.09-.67-.08-.85-.35-.03.19-.11.41-.24.63.21.34.16.63-.62.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1356.71,78.35s0,0,0,0c.26-.21.41-.74.27-1.31-.28.13-.58.25-1.12.15v-.41c-.21.07-.42.16-.57.28.09.37.05.73-.06.98.88.3,1.14-.23,1.48.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1356.71,80.27c-.28-.25.18.16,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1355.86,79.5c-.28-.25.18.16,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1364.27,99.98c.04-.15.07-.3.11-.45-.04.15-.13.26-.24.35.06.02.1.05.14.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1365.23,99.92c-.33.34-.46.87-.42,1.54h1.28c-.1-.68.43-1.93-.85-1.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1363.51,97.23s.01,0,.03,0c0,.02,0,.05-.01.07.01.09.02.19,0,.31.63-.33.62-1.24.85-1.93-.34.2-.69.4-1.28.39-.04.55.31.74.41,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1365.23,97.22c-.34,0-.35.32-.39.6.09-.02.17-.02.25-.02.08-.16.08-.4.14-.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1363.52,104.54c.42-.01.33-.47.43-.77-.42.01-.33.47-.43.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1359.98,104.24c.06-.21.02-.48-.09-.67-.08.13-.05.34.09.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1359.69,104.54c.05-.01.09-.04.13-.07-.37-.1-.64-.31-.84-.57-.02.37.21.76.71.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1355,75.65c1.68-.45-1.68-.45,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1356.71,71.8v1.34c.64.39,1.35.72,2.14.98-.25.01-.37.14-.45.31.58,0,1.05.19.86.85.98.12.47-1.11,1.28-1.16-1.57-.51-2.82-1.3-3.84-2.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1219.05,64.86c1.66-.96-1.42-.56,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1147.45,76.8c.41-.01.33-.47.43-.77-.42.01-.33.47-.43.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1142.76,50.99c-.57-2.26-2.02,1.4,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1147.02,78.73c1.41-.56-1.66-.96,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1157.68,82.58c-1.3.84.49,2.47,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1144.78,67.45c-.24.51-.66.85-1.19,1.1-.02.16-.02.34.02.55,1.34-.33,2.62-.71,2.98-1.92-.6.1-1.26.14-1.81.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1138.5,54.07h-1.19c.3.09.69.1,1.19,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1136.79,50.99c-.08.17-.16.36-.22.56.43.26.79.59,1.08.98-.5.13-1,.36-1.17.68.11.38.34.68.74.83-.11-.99.17-1.62,1.28-1.51.15.02.25.08.32.18.17-.07.34-.13.52-.18-.56-.78-1.4-1.3-2.56-1.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1140.2,52.53c-.77-.08-1.14.21-1.26.72,0,.27-.03.56-.01.82h1.7c-.03-.61.2-1.47-.42-1.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1139.47,49.16c.14.07.26.17.32.29-.41.07-.49.45-.62.78.41.04.62.26.98.35.15-.29.41-.48.65-.2.18-.35.2-.85.69-.93-.24-.49-1.31-.58-2.01-.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1148.73,62.16c-.75.09-.97.66-.85,1.54,1.28.39.75-.86.85-1.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1164.12,66.96c.11.8.36.74-.04,1.76,1.21-.32,1.45-1.51,2.13-2.31-.06-.76-.86.21-1.77.1-.11.14-.22.3-.32.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1155.12,66.4s.08-.08.12-.11c-.04.04-.09.08-.13.12,0,0,0,0,.01-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1166.2,70.64c-.28-.25.18.16,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1155.97,94.53c1.12.12,1.4-.53,1.28-1.54-1.12-.12-1.1.8-1.28,1.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1151.28,60.24h.85v-1.15h-.85v1.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1149.15,55.62c-.58.12-.35.96-.43,1.54.95.21.61-.73,1.28-.77-.1-.42-.85-.26-.85-.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1151.71,53.69c1.4-1.29-1.46-2-1.71-3.08-.48.13-.75.5-.86.97.82.63,1.81,1.24.87,2.11-.02-.23-.07-.46-.43-.39-.01.16-.01.33-.02.48.23.36.53.63.87.67.91.18.81-.55.85-1.16.36-.07.41.15.43.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1133.85,74.26c.15.06.28.14.39.23v1.12c.78.11,1.11.59,1.7.03v-1.15c-.49-.42-1.46-.54-2.09-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1147.45,58.7c.75-.09.97-.66.85-1.54-1.28-.39-.75.86-.85,1.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1125.29,61.01c-1.41.49-.19,1.78-.91,2.74-.07.11-.18.23-.36.34,0,0,0,0,0,0,0,0,0,0,0,0-.32-.13-.45-.34-.49-.59-.11-.06-.23-.12-.36-.18.44,1.44-.34,2.06-1.44,2.25,1.78.24,3.78-.13,3.14-2.25.38.17.76.34.85.77,1.37-.89-.91-1.72-.43-3.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1129.55,60.46s.09-.02.13-.02c.64-.86,1.82-1.23,2-2.51-1.84-.18-2.11,1.06-2.13,2.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1135.09,50.22c-.5.06-.36.7-.43,1.16.5-.06.36-.7.43-1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1132.53,50.99c-.63-.22-1.22-.17-1.71.07-.23,1.39-.9,2.39-1.65,3.32.02.54.14,1.09.38,1.62,1.15-1.53,2.63-2.76,2.98-5.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1124.01,84.9c1.21-.51-.33-1.71-.43-2.31-1.23.54.12,1.9.43,2.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1121.88,56c.06-.71,1.44-.24,1.7-.77-.32-1-.92.16-1.78.09-.04.04-.08.07-.14.1v.79c.15.12.34.19.64.17.08-.33-.16-.36-.43-.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1124.01,61.39c-.19.02-.35.05-.48.08.02.26.12.51.26.73.11-.31.22-.6.22-.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1122.31,64.09c1.07-.71.39-1.76.61-2.47-.06-.03.13-.26.24-.99-.89-.29-1.03-.21-1.49-.11v1c.16-.04.36-.08.65-.12,0,.69-1.15,2.24,0,2.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1121.66,92.91c.07.02.14.04.22.07-.07-.21-.15-.36-.22-.46v.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1122.36,85.61c.14.11.27.25.38.44-.55.06-.85.36-1.08.72v1.47c.07.04.13.08.22.12,1.44-.24,1.05-2.14,2.56-2.31-.5-.89-1.36-.85-2.07-.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1131.68,89.9c-.28-.25.18.16,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1131.68,90.67c1.68-.45-1.69-.45,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1132.11,81.04c.63-.71.82-1.83.85-3.08-1.68-.23-.5,2.12-.85,3.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1129.98,61.39c-.52.17-.87.49-.85,1.16.52-.17.87-.49.85-1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1132.96,77.19c-.33-.34-.45-.87-.43-1.54-.75-.12-.76,2.16.43,1.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1128.7,89.13c1.66-.96-1.41-.56,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1129.55,64.86c1.33.18,1.52-.97.85-1.54-.75.09-.98.66-.85,1.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1131.25,61.01c1.66-.96-1.41-.56,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1121.66,90.6c.17-.14.14-.46.22-.69-.1,0-.16.03-.22.08v.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1212.16,59.69c-.02.2,0,.44.04.71.09-.27.1-.52-.04-.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1212.05,58.7c-.54-.94-1.29-.47-.7,0,.21-.04.44-.04.7,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1211.8,72.95c.94.21.61-.74,1.28-.77-.17-.96-1.65-.02-1.28.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1212.23,54.84c.05-1.07-1.81-1.09-2.4-.85.42.14.73.4.71.85-.08.07-.18.13-.29.18.61.3,1.55.21,1.98-.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1212.23,66.79c-.58.12-.35.96-.42,1.54h1.28c.31-1.05-.85-.78-.85-1.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1210.1,69.1c-.36-.57-1.07-.83-2.13-.77-.03.13-.02.23-.02.34.18.12.34.25.45.43-.05.05-.12.08-.18.12.48.39,1.44.29,1.87-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1210.1,74.11c.41-.01.33-.47.42-.77-.41.01-.33.47-.42.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1208.39,52.92c.39.06.68.03.91-.05-.18-.1-.34-.2-.48-.33.23-.39.3-.81.31-1.24-.39.42-.65.94-.74,1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1210.52,56.77c.13-.89-1.23-.43-1.28-1.16-1.15.42.74,2.13,1.28,1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1210.95,69.87h-1.7c.02.16.02.3.02.43.47.2,1.08.26.83,1.11.75-.09.97-.66.85-1.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1205.41,38.28c1.69-.45-1.68-.45,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1203.15,70.97c-.09.01-.19.03-.3.06-.04.49.11.8.32,1.07.63-.19.36-.66-.02-1.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1205.67,46.78c-.11-.11-.3-.16-.69-.02.05.37-.02.64-.18.82.06-.01.12-.03.19-.05.25-.15.47-.42.68-.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1158.53,55.23c.52-.17.87-.49.85-1.16-.52.17-.87.49-.85,1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1202.83,69.87c-.51.04-.77-.13-.93-.4-.28.36-.23.9.1,1.17.49-.06.74-.34.83-.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1209.67,44.44c-.08-.05-.16-.08-.24-.09.06.04.12.08.17.12.03,0,.04-.02.07-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1205.84,39.43c-1.37.91,1.5,1.56,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1208.79,44.56c-.31.27-.59.76-.88,1.27.15.12.32.19.49.15-.27-.84.22-.98.39-1.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1213.48,51.76c-1.62.19-1.06-1.59-2.1-1.93.02,1.23.67,1.88.44,3.33.49.11,1.05.15,1.68.14.12-.63.07-1.11-.02-1.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1163.22,87.59c1.03-1.29-1.43.93,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1163.65,65.25c2,1.34,1.72-1.94,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1161.51,68.71c.52-.17.88-.49.85-1.16-.52.17-.88.49-.85,1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1164.07,82.2c1.75-.9.83-2.28.85-4.24-.76-.54-.25,3.36-.85,4.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1164.5,70.64c-.07-.06-.17-.15,0,0,.76-.08.95-.68.84-1.54-1.12-.12-1.4.53-1.28,1.54.16.02.3.01.43,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1160,84.45c-.05.02-.12.04-.19.06-.04-.14-.11-.25-.19-.34-.73.2.06,1.28.18,1.5.8-.04.46-.77.2-1.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1161.51,82.58h-1.7s0,0,0,.01c.08.43.78.31,1.27.37-.86.78.19.76.43,1.54,1.25-.33-.26-1.24,0-1.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1160.24,87.59h.85v-.77h-.85v.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1216.92,52.53c1.03-1.29-1.43.93,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1215.65,56c.51-.55,1.15-.97,1.29-1.85-.54.09-.93.11-1.26.11-.02.66-1.16,1.44-.03,1.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1212.66,47.14c.12-.62-.41-.66-.43-1.16-.82-.15-.62,1.76.43,1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1212.66,43.67c-.18.8.29,1.02.42,1.54.88-.39,1.17-1.7-.42-1.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1211.01,48.31c.19.06.44.08.81-.02-.35,1.45.73,1.61,1.34,2.2-.04-.21-.07-.42-.08-.66,1.04.34.46,2.15,2.13,1.93.34-1.98-2.22-1.34-1.71-3.47-1.21.32-1.1-.54-2.13-.39-.16.13-.27.26-.37.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1167.05,82.2c1.03-1.29-1.43.93,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1164.92,72.95c.05,1.09,1.82.74,1.7-.39-.77-.05-.9.47-1.7.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1208.82,71.8s.02.05.03.08c.11.07.22.15.31.23.16.03.35.04.51.08.08.33-.17.36-.43.39.07.51.42.31.81.04.04-.3.26-.57.52-.72-.57-.35-1.35-.49-1.76-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1217.77,58.31c.54-1.01,1.07-2.02,1.68-2.97-.75.01.06-1.39-.8-1.27-.11.93-.77,1.37-1.29,1.92-.4.69-.78,1.39-1.16,2.1.54.13,1.09.2,1.58.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1483.71,90.29c.11-.12.24-.21.36-.31-.13.06-.26.14-.36.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1594.95,70.64c-.26.34-.52.69,0,.77.54-.1.43-.77,0-.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1556.59,80.66c-.42.01-.33.47-.43.77.41,0,.33-.47.43-.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1541.24,70.26c-.09.68.34.89.88,1.01-.01-.08-.02-.15-.02-.24.22-.03.41-.03.59-.02-.28-.43-.63-.8-1.45-.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1538.69,68.33c1.63-.75-2.59-.12,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1538.69,70.26c1.63-.75-2.59-.12,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1593.67,69.1c-.79.68.19,1.13.43,1.93,1.27-.03,1.14-2.3-.43-1.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1658.27,81.21c.08.06.15.13.19.21,0,0,0,0,0,0,1.15-.03.85.64,1.7,0-.26-.53-1.24-.48-1.88-.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1657.72,81.65c-.07.18,0,.37.31.55.41-.01.33-.47.42-.76-.42.32-.55.3-.73.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1659.3,72.95c.43.25.44.89,1.28.77v-1.16c-1.06-.26-1.27.25-1.7.57v.59c-.84.11-.85-.52-1.28-.77.05.36-.06.59-.24.74.08.14.16.27.23.42.82-.16,1.83-.14,1.71-1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1660.58,82.58c1.68-.45-1.68-.45,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1492.91,82.92c-.09-.11-.14-.2.03-.28-.32.02-.55.11-.03.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1491.81,83.35c-.09-.18-.2-.31-.32-.41-.03,0-.06.02-.09.03-.5-.13-.55-.23-.42-.28-.38-.07-.82.01-1.3.15.17.11.32.27.44.51-.12.03-.26.04-.39.06.32.19.74.29,1.23.32.01-.37.52-.3.85-.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1490.95,84.9c.42-.01.33-.47.43-.77-.41.01-.33.47-.43.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1490.53,91.45c-.74-.14-1.23-.04-1.68.08.08.39-.23.62-.69.72,1.11.19,2.66.08,2.37-.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1494.79,82.58c-.62.17.04.34,0,.77.53-.1.43-.77,0-.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1496.07,86.82c-.13-.79-1.15-.76-1.28-1.54-1.14.45-.04,2.04,1.28,1.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1493.28,82.64c.08.05.13.12.15.21.25-.11.1-.18-.15-.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1495.22,88.36c-.31-.75-2.03.44-2.13,1.16,1.07-.29,1.35-.05,2.13-1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1659.3,78.35c.49-.57.49-.97,0-1.54-1.19.91.85,1.96.85,3.85.93-.06.92-.97.85-1.93-.76.05-.9-.47-1.7-.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1839.15,44.44c1.68-.45-1.68-.45,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1658.72,72.54c-.09-.41-.85-.3-.69-1.52-.38.44-.89.75-1.13,1.3.16.14.22.31,0,.77.05.04.09.09.14.14.52-.27.67-.88,1.69-.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1838.72,51.76c-.27-.04-.47,0-.61.08-.01.11-.03.21-.03.31.36,0,.57-.14.65-.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1834.34,44.43c-.23.81.19.75-.3,1.55h.45c.13-.23.31-.48.47-.72.55.18.51.43.34.72h.44c.55-.91-.06-.72.42-1.93-.59.14-1.17.29-1.82.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1840.66,44.68c-.14-.15-.29-.3-.44-.44.04.18.17.33.44.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1701.32,61.68s-.06-.01-.08-.02c.02.03.04.05.07.09,0-.02,0-.04.01-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1638.57,74.75c.03.15.11.32.27.51-.1-.17-.19-.34-.27-.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1202,76.8c.61-.09.15-1.15.85-1.16-.1-.55-1.27-.13-1.28-.77-1.41.58.89.94.43,1.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1837.45,51.38c1.03-1.29-1.43.93,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1488.4,91.39v-1.49c-.63.33-1.35.58-1.28,1.54h.38c.26-.05.55-.08.9-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1658.42,80.25s0,0,0,0c-.1-.09-.06-.05,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1658.87,75.65c1.68-.45-1.68-.45,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1658.45,70.26c-.25-.15-.47-.32-.67-.51.07.25.19.48.33.67.12-.04.23-.09.34-.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1656.28,74.04c-.11.02-.22.04-.33.06-.05.22-.07.54-.06.78-.83.02-.92-.31-1.2-.27-.02.27-.15.44-.28.61.12.22.22.47.2.81.6-.03,1.21-.06,1.28.38.48-.07.24-.39,0-.38-.17-.93.78-.84.43-1.93-.01-.03-.03-.04-.04-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1655.74,68.73c-1.14.17-.49-1.28-1.56-1.17-.65.89.3,2.01,1.56,2.59v-1.42Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "1654.19 74.88 1654.19 74.87 1654.19 74.88 1654.19 74.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1650.35,72.18c.42-.01.33-.47.43-.77-.42,0-.33.47-.43.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1328.15,72.57c.83.15.62-1.75-.43-1.15v.77c.36-.07.4.15.43.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M945.26,97.95c-.63,1.21-.41,3.11-2.37,3.23-.2-1.67,1.26-1.99.79-3.88-2.36.75-.1-2.29-1.97-1.94-.9,1.29.64,3.35.4,5.17-2.02.07-4.28-.06-5.13.97,2.05-.54,4.08.12,5.53.97-.1,3.52,2.23,6.86-2.37,7.43.78.09,1.04.62,1.54.94h.06c.36-.56.74-1.09,1.96-.94-.09.31-.14.63-.18.94h1.23c-.27-2.96-.42-5.82-1.05-9.35,2.19.5,1.23-1.58,3.16-1.29-.12.2-.98,1.24,0,1.29.09-.57.68-.74,1.58-.65-.94-1.06-2.53-1.6-3.16-2.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M532.73,109.59c-1.29-.47-.99-.72-.79-1.94-2.1.37-2.49,2.15-3.76,3.2h1.42c.13-.2.26-.4.37-.62-.09.27-.09.46-.03.62h3.25c.26-.34.69-.64,1.13-.94,0,.3.01.62.02.94h1.65c-.03-.86-.16-1.62-.48-2.23-.85.38-1.81.67-2.76.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M668.93,109.91c-.64.36-1.5.68-2.39.94h2.95c.1-.37.08-.63-.57-.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M685.51,110.24c.16.25.22.45.21.62h1.83c-.02-.1-.03-.2-.06-.29.22,0,.29.14.32.29h.89c-.11-.55-.32-1.08-.82-1.59-.36.68-1.16.99-2.37.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M672.73,110.86h.87c-.15-.17-.25-.39-.33-.62h.79c.04-.88-.66-.65,0-1.29-1.68-.43-1.92,1.16-1.33,1.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1091.19,13.24c-.06-.01-.1-.01-.16-.01.08.1.13.23.16.38v-.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1091.19,13.63c-.32.3-.6.38-.83.33,0,.14-.01.29-.02.44.34-.07.43-.39.85-.39v-.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1067.32,33.65c1.68-.45-1.68-.45,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1069.62,38.47c.4.04.73.03,1.05,0,0-.11-.02-.21-.03-.31-.44.02-.96-.02-1.02.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1079.22,38.36c-.25.37-.5.74-.82,1.07.6-1.06-1.73-1.03-2.08-.54.34.19.43.56.26.85.2.51.5,1.01.97.46,0-.51-.75-.35-.85-.77.79.03,1.3.32,1.54.86.15-.06.3-.12.45-.2-1.22-.41.44-.97.79-.32-.3-.48-.36-.96-.26-1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1092.9,13.62c-.1-.68-.73-.88-1.7-.77.25.79.82,1.6,1.7.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1074.75,43c.15,0,.28,0,.39-.02-.04-.09-.09-.17-.15-.25-.07.09-.15.18-.25.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1053.82,50.76s.06,0,.1,0c-.03-.04-.05-.08-.07-.13,0,.04-.02.08-.02.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1124.44,59.85c1.16-1.17-1.3,1.05,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1072.38,44.29c.29-1.41-.78.26-.79-.65.14-.74,1.73-.31,1.58-1.29-1.55-1.04-3.35.48-3.95,1.29-.02-.06-.06-.1-.08-.16-.1.13-.15.31-.11.57-1.01-.05-1.3-.64-1.64.23.22,0,.43,0,.65,0-.03.4.12.65.34.84.13-.3.33-.55.65-.68.14.33.12.71.05,1.08.05.02.09.04.14.06.85-.07,2.67-.94,3.75-.14,0-.2.07-.39.32-.61.06.06.1.14.14.21.21-.44.44-.85.92-1.07-.82-.7-1.28.04-1.97.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1057.5,38.34c-.32-.83-.92-1.47-1.7-.84.59.53-1.2,2.31-.03,3.53.63-.37,1.35-.66,2.18-.82-.61-.89-.88-.73-.45-1.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1064.88,41.06c.14-.02.27-.03.4-.04.04-.17.09-.34.14-.51-.34.05-.62.16-.54.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1067.62,45.73c0-.05.02-.09.02-.15-.07-.07-.15-.12-.24-.17.05.13.13.24.23.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1406.51,66.07c.72.32,1.4.93,1.77,1.48-.39,0-.66.1-.93.2.02.06.06.11.07.18,1.3.28,1.55-.39,2.55-.38-.68-1.01-2.37-2.19-3.47-1.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1414.66,60.97c.47.23,1.16.27,1.72.42.12-.69-.4-.79-.43-.39-.53-.09-.43-.77,0-.77-.08-.44-.43-.21-.43,0-.42-.01-.33-.47-.43-.77-.61.09-.15,1.15-.85,1.16.04.06.09.11.14.16.1-.04.21.02.27.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1414.67,61.78c-.42.01-.33.47-.43.77.42-.01.33-.47.43-.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1413.82,63.32c1.68-.45-1.68-.45,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1481.15,97.99c.86-.93-1.76.38-2.13.77.31.86,1.29-.85,2.13-.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1095.45,24.34c.01.14.01.29,0,.45,1.03.16.93-.7,2.13-.39.35-1.09-.6-1-.43-1.93-1.04-.23-.96.56-1.52.76.2.28.47.51.26,1.17-.17-.05-.31-.06-.44-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1401.43,70.19s.01.05.02.07c0-.02,0-.04-.01-.06,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1473.91,91.83c1.62-.75-2.59-.12,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1471.8,97.01c-.12.21-.32.38-.56.49.92.5,2.88-.04,2.24-1.43-.79.11-1.11.64-1.68.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1479.02,88.75c-.41.01-.33.47-.42.77.41-.01.33-.47.42-.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1280.42,43.29c.06-.69-.52-.81-.43-1.54-.75-.12-.76,2.16.43,1.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1279.14,50.61c-.06.1-.1.21-.15.32.36.26.55.67.59,1.22-.47,0-.79.14-1.06.32-.07.29-.14.57-.23.83,1.53.1,1.56-1.16,2.99-1.15-.08-1.08-.74-1.64-2.13-1.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1101.86,18.25c-.35,0-.5.18-.64.37.17.17.37.32.63.4,1.16.28.86-.76,1.7-.77-.33-.99-1.36-1.34-2.98-1.16,0,.02.01.04.01.06.65.16,1.09.52,1.28,1.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1096.31,29.42c.5-.06.36-.7.42-1.16-.5.06-.36.7-.42,1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1123.58,58.7c-.4.41-1.57.12-1.28,1.16.14.01.24-.01.36-.02.31-.28.66-.57.1,0,.6-.08.88-.45.82-1.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1326.45,66.79c1.16-1.17-1.3,1.05,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1369.49,75.65v.59c.36.16.65.39.79.75.57-.12.85-.05,1.77.2-.2-1.1-1.62-1.11-2.56-1.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1369.49,77.19c.16-.04.3-.08.43-.12-.17-.04-.3-.07-.43-.1v.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1175.02,79.1c.16.29.31.59.56.78-.08-.7.03-1.22.49-1.44-.14-.06-.29-.1-.49-.1.37-.31.25-1.06.85-1.16-.18-.13-.33-.28-.48-.44-.03.22-.09.43-.36.44.07-.21.06-.48.17-.64-.56-.62-1.08-1.28-2.31-1.29.42.39.33.56.18.82.24.24.46.5.7.74.12-.02.25-.03.4-.02-.06.09-.1.18-.14.26.05.04.1.09.15.13-.1.02-.18.06-.25.11-.28.87.57,1.08.54,1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1214.79,82.2c1.69-.45-1.68-.45,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1213.08,83.35c-.32,1.36,1.12,1.72,1.7,1.15-.67-.29-.64-1.22-1.7-1.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1217.34,60.62c-1-1.14-3.54-2.39-4.66-1.8,1.11.32,2.34,1.08,2.96,1.8.02.58-.03,1.1-.16,1.55.7-.1,1.27.05,1,1.14.66-.56.89-1.5.85-2.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1212.23,86.82v5.39c2.58-.11,1.76-4.82,0-5.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1214.36,63.32c.55.66.88,1.51,2.13,1.54-.9-.34-.74-1.64-2.13-1.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1214.72,62.35c-.17-.19-.47-.23-.81-.19.04.1.05.23.02.39.2-.03.48-.11.78-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1212.23,86.44c1.42-.56-1.66-.96,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1210.95,76.03c-.69.15-1.14.52-1.59.89-.23.45-.67.95-.8,1.37.19.31.49.51.8.71.55-.61-.34-.65-.1-1.81.7.03,1.07.26,1.26.6.41-.64,1.04-1.34.44-1.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1213.93,81.81c-.41,0-.33.47-.43.77.41-.01.33-.47.43-.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1242.53,56.07c-.17.47-.08,1.18-.02,1.85,1.4-.28.34-1.11.02-1.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1245.47,79.12c-.41,0-.33.47-.43.77.41-.01.33-.47.43-.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1244.63,67.17s-.08,0-.12,0c-.01.11.01.24.11.39.74.05.9-.44,1.65-.39-.02-.09-.04-.18-.07-.28-.35-.27-1.32-.27-1.61.09.03.05.05.11.04.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1248.98,60.56c.04-.17.12-.3.32-.31,0,0,0,0,0,0-.73-.24-.7-1.16-1.28-1.54-.47.16-.86.39-1.18.68.18.36.35.72.77.86-.86.59-.83,1.99-1.73,2.55,0,.05,0,.1.01.15,2.47.51,2.28-1.37,3.08-2.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1242.06,54.07c.83.15.62-1.75-.43-1.15v.77c.36-.07.4.15.43.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1432.99,88.36c.41-.01.33-.47.43-.77-.41.01-.33.47-.43.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1247.32,57.64c1.1.15,2.77.09,3.27-.87.41-1.4-1.91-.32-1.7-1.54,0,0,0-.01,0-.02-.22-.07-.4-.18-.56-.29-.27.29-.53.59-.77.92.59.18,1.62-.04,1.34.93-.27.52-.89.77-1.57.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1217.77,82.97c1.63-.75-2.59-.12,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1216.92,84.51h.85v-.77h-.85v.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1213.09,81.43h1.7c-.01-.37-.52-.3-.85-.38-.48-.35.03-.86-.85-1.54-.5.06-.36.7-.42,1.16-.87-.81.75-3.36-1.71-3.47-.25,1.23.8,1.19,0,1.93-.1-.02-.18-.05-.25-.08-.02.37-.04.74,0,1.05.11-.03.22-.06.3-.07.03-.26.11-.47.38-.51.88.68.37,1.19.85,1.54.33.09.84.01.85.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1200.47,76.74s-.1.06-.16.07c.02-.05.03-.09.04-.13-.2-.11-.38-.21-.48-.25-.33.07-.4.37-.41.73.39.24.58.37,0,.05,0,.26.01.53-.01.77,1.38.48.32-1.25,1.7-.77.9.5.02-.05-.68-.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1208.82,81.81c1.68-.45-1.68-.45,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1200.72,48.3c-.57-.27-1.04-.61-1.48-1-.94.71-.69.22-.25-.23-.74-.72-1.31-1.58-1.68-2.63-.68,0-1.14.2-1.45.53.65,1.47,1.67,2.61,3.17,3.32-1.29-.31-.85.93-.8,1.83.75-.18,1.18-.37,1.22.86,1.32-.09-.67-3.17,1.28-2.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1199.45,79.5h.85c-.08-.33.17-.36.43-.38.17-.75-1.94-.56-1.28.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1195.61,79.5c-.33.19-.53.5-.7.83.56.67.94,1.56.39,2.14.02.2-.01.48-.11.88,2.19.64,1.12-1.79,1.7-.77,1.08-.88-.42-2.68-1.28-3.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1195.18,66.79c1.3,1.05-1.17-1.17,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1195.18,58.31c-1.31.07-.9,2.07.43,1.93.92-.8-.05-1.25-.43-1.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1195.18,90.67c.16-.15.45,1.16.43,1.16.68.11.6-2.08-.43-1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1195.18,69.1c-.28-.25.18.16,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1196.46,76.03c0,.06.01.11.02.17.15.06.29.13.42.22.09.24.1.44.07.62.1.06.22.11.35.15-.07.4-.37.25-.42.05-.06.11-.14.2-.23.28-.04.31.54.43,1.1.3.03-.56-.12-1.29.41-1.4.1.04.28.14.48.25-.01-.08-.03-.16-.07-.25-.49-.32-1.14-.51-2.13-.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1201.62,82.17c.16.11.3.25.39.42-.08-.03-.17-.04-.27-.04.41.24,1.48-.12,1.96.04-.38-.66-1.44-.98-2.09-.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1208.35,70.72c-.13-.17-.36-.26-.58-.34-.36.31-.14,1.65.58.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1208.39,54.92s-.07-.05-.11-.07h-.75v.77h.85v-.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1209.67,74.49c-1.37-.34-.89,1-1.71,1.15.08.65,2.03-.18,1.71-1.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1208.4,50.72c.22-.16.44-.34.65-.55-.07-.7-.11-1.37.31-1.92.11-.44.43-.85.8-1.23-.26-.4-.15-1.13.37-1.03.01.21.11.34.21.46.53-.5.98-.97.94-1.41-.09.07-.19.13-.3.18-.09-.37-.35-.58-.44-.96-.13-.07-.26-.13-.43-.19.18.93-.78.84-.42,1.93-.16.04-.33-.03-.47-.14-.85,1.01-2.8,2.16-1.65,3.61-.8,1.07-1.82,1.76-2.84,2.03.74.2,1.55.12,2.35-.24.25-.26.55-.48.91-.64,0,.04,0,.07,0,.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1204.56,68.71c.36-.07.4.15.43.38,1.49-.65-.84-.99-1.71-.77,0,.02,0,.03.01.05.49.13.71.35.14.65.13.51.35.92,1.13.84v-1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1206,70.46c-.05-.07-.09-.14-.16-.2-.36-.07-.4.15-.43.38h-.85c.54.61,1.26,1.39-.07,1.52-.1.43-.24.84-.34,1.18-.02,0-.04,0-.06,0,.03.12.05.24.05.38.38-.3.96-.41,1.71-.39.18-.58.48-1.4.43-2.11-.37.26-.47-.45-.27-.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1204.98,79.12c1.49-1.43-1.16-1.96,0,0h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "1225.46 57.94 1225.45 57.93 1225.44 57.93 1225.46 57.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1242.91,64.09c-1.13,2.04.81-1.47,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1232.26,78.73c1.66-.96-1.41-.56,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1232.69,67.94c1.03-1.29-1.43.93,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1231.83,53.3c-.15.25-.34.47-.55.66.34.41.57.93.99,1.27-2.64-.37-3.55,2.09-4.51,3.8.3.73.33,1.48-.92,1.23,0,0-.02.01-.03.02,3.15,1.82,2.69-5.67,7.16-5.05-.75-.61-.88-1.77-2.13-1.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1224.59,66.02c.48-.8.46-.82-.43-.38-.23.8,1.66.82.43.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1233.12,50.22c-.86.69-.08-.03.21-.28-.28-.24-.62-.42-1.08-.5.07.42-.08.65-.37.75.02.03.05.06.07.08,1.04.42.95,1.85,2.43,1.87-.18-.87-.45-1.67-1.03-2.18-.05.06-.12.13-.24.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1226.29,55.23c.42-.01.33-.47.43-.77-.41,0-.33.47-.43.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1224.16,52.53c1.16-1.17-1.3,1.05,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1223.31,84.13c-.62.17.04.34,0,.77.53-.1.43-.77,0-.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1225.02,89.52v.02c.11.66.74.86,1.7.75v-1.54c-1.16-.28-.86.76-1.7.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1234.82,50.22c1.16-1.17-1.3,1.05,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1241.21,76.42c-.05-.73-1.41-.27-1.28-1.15-.08-.33.17-.36.43-.39-.4-.67-1.14.21-1.28,1.1.23.07.42.18.44.44-.2,0-.33.06-.43.15.05.26.18.48.43.62,1.17.28.86-.76,1.7-.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1239.5,69.1c1.41-.56-1.66-.96,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1239.82,81.26c-.61.46-.16,1.5.54,1.71,1.15-.23.82-.91.38-1.47-.38-.02-.68-.1-.92-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1238.23,53.3c1.41-.56-1.66-.96,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1235.67,70.64c-.28-.25.18.16,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1236.52,74.49c-1.27.4.16,1,1.07.83.04-.08.08-.15.13-.22-.29-.3-1.19-.05-1.2-.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1237.37,76.8s.05-.02.08-.02c-.04-.1-.07-.2-.09-.31-.42,0-.83.11,0,.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1229.7,74.11c1.29.14.88-1.26,1.28-1.93-.84.27-1.14,1.03-1.28,1.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1229.28,47.14c.89-.23,1.38-.81,2.13-1.16-.12-.89-1.14-.31-1.73-.14.01.04.03.09.04.14-.23.11-.44.23-.64.37.19.23.37.5.2.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1240.36,66.02c-.92-.35-.99,1.41,0,1.16.51-.13.34-1.03,0-1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1240.36,54.84c.5.06.36.7.42,1.16.04,0,.05-.02.09-.02.08-.16.18-.29.35-.37,0,.03.03.05.04.08.09-.4-.39-1.07-.48-1.23-.81-.08-1.17.23-1.27.79.08.23.1.44-.02.58,0,.06,0,.11.01.17.4-.28.65-.7.85-1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1228.42,45.21c-.32.04-.38.31-.4.61.11-.03.24-.08.37-.13,0-.16,0-.34.03-.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1222.88,86.05c.41-.01.33-.47.43-.77-.42.01-.33.47-.43.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1230.12,53.33s.02-.02.02-.03c0,0,.01,0,.02,0,.53-.29,1.04-.59,1.67-.78-.04-.26-.09-.52-.16-.77-.54-.49-.72-1.31-1.54-1.54.33-.09.5-.32.43-.77.25.04.46.13.66.22-.02-.66.22-1.25,1.04-1.76-.72-.36-1.29-.3-1.8-.04.04.02.07.02.1.04-1.87,1.16-.7,2.75-.43,4.62-.99.3-1.69.86-2.62,1.22,0,.1.02.2.05.32,1.1-.01,1.84-.36,2.54-.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1240.78,68.33c1.68-.45-1.68-.45,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1242.49,59.08s0,0,0,0c.02-.06.03-.14.02-.22,0,.07-.01.15-.03.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1242.49,66.79c.18.16-.28-.25,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1224.16,62.16c.36-.07.4.15.43.39.83.15.62-1.76-.43-1.16v.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1221.61,55.23c.59-.5.42-1.67.42-2.7-.68-.06-1.22.02-1.69.15,0,.47.03.95,0,1.39.99-.13-.24,1.75,1.27,1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1220.75,94.14c.41-.01.33-.47.42-.77-.41.01-.33.47-.42.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1221.08,90.1c.11.14.16.32.1.57-.2-.05-.36-.07-.5-.06-.03.14-.01.29.07.45,1.03.16.93-.7,2.13-.39.22-.98-1.1-1.02-1.8-.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1193.05,91.45c.3-.07.47-.26.66-.43-.08-.22-.16-.39-.22-.34.4-.36.65-.24.78.02.03,0,.04-.02.07-.02-.18-.96-1.65-.02-1.28.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1227.2,51.58c-.28.35-.63.62-.82,1.05.36-.28.76-.51.82-1.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1225.88,50.22c-.29.07-.5.1-.67.13-.06.09-.12.18-.19.25.41-.09.66-.13.86-.16,0-.08.01-.14,0-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1227.41,46.38c-.13-.17-.27-.31-.3-.44-.11-.12-.23-.23-.39-.34,0,.02-.01.04-.02.06-.01.25-.04.49-.19.62-.35,1.34-.51,2.85-1.18,3.9.42-.08.79-.25,1.13-.47.46-1.12,1.41-2.28.94-3.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1184.61,90.96c-.18-.06-.02-.14.24-.2.04-.03.07-.06.11-.09-.3-.34-1.71.04-2.32.86.46-.03,1.65-.45,1.47.3-.41.33-1.06.46-1.74.54,0,.08.01.15.03.23,1.14-.26,2.66-.16,3.41-.77.28-1.17-2.76.49-1.2-.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1183.14,83.76s.07-.02.11-.02c.03-.19,0-.32-.08-.42-.01.15-.02.29-.03.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1184.1,89.13c.35-.07.43-.39.85-.38-.08-.31-.43-.38-.43-.77-.34.07-.42.39-.85.38.08.31.43.38.42.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1183.26,82.58c-.04.19-.06.39-.08.59.24.15.54.06.92-.21-.59.5-.42,1.67-.42,2.7,1.39-.15,1.03-1.89,1.28-3.08h-1.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1181.12,81.43c1.3,1.05-1.17-1.17,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1179.84,67.94c-.41.01-.33.47-.43.77.41,0,.33-.47.43-.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1183.68,62.16c-.77-.05-.9.47-1.71.39.29-.8,1.92-2.34,2.55-1.54.32-.63.84-1.63.99-2.45-.17.05-.36.1-.55.13-.12-.12-.23-.27-.33-.43-.38.39-.74.79-1.09,1.21-.22.56-.51,1.12-.72,1.52-.09-.11-.2-.17-.32-.2-.36.48-.7.96-1.05,1.42.14-.05.31-.08.52-.07-.2,1.27-1.09,2.74-2.18,3.81-.1.38-.42.56-.8.68-.37.27-.74.47-1.11.61,2.07.99,5.37-2.48,5.78-5.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1185.76,62.58c-.29.21-.39.42-.38.59.11-.2.25-.4.38-.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1187.15,64.34c-.07-.03-.13-.06-.18-.09.03.08.06.15.11.23.03-.05.05-.09.07-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1184.95,65.02c.24-.02.51-.05.84-.08-.25-.08-.51-.22-.84-.46v.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1178.14,75.65c1.37-.91-3.29.06,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1178.14,65.63s0,0,0,0c0,0,0,.01,0,.02,0,0,0-.01,0-.02,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1178.14,56.77c.84-.17.76-2.7-.85-1.93-.37,1.23.67,1.19.85,1.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1176.43,54.46c-.19,0-.27.11-.31.24.09,0,.18.01.26.04.01-.1.03-.19.05-.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1178.56,69.1c1.68-.45-1.68-.45,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1177.28,77.19c.42-.01.33-.47.43-.77-.42.01-.33.47-.43.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1178.56,72.18c1.41-.56-1.66-.96,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1186.29,58.21c.11.18.23.36.37.49.29-.05.55-.12.79-.22.01-.29.14-.52.49-.55-.04.1-.03.21,0,.32.43-.26.73-.6.88-.96,0-.17,0-.35-.01-.51.04,0,.07.02.11.03.01-.68-.54-1.34-1.82-1.57-.3.06-.52.18-.71.33,1.21.66,1.04,1.92-.08,2.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1177.69,70.97s0,.04.02.05c0,0,0,0,0,0,0-.02-.02-.03-.02-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1193.18,51.45c-.04.05-.07.11-.09.18.08.04.19.08.39.13,1.05-.28.13-.38-.3-.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1196.89,53.69h.85v-.77h-.85v.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1195.21,46.87c0,.09-.02.18-.02.27.02,0,.03,0,.05,0,0-.08,0-.18-.02-.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1196.04,51.76c.93.7.47-.67.85-1.54.26.04.5.04.73.02-.31-.62-1.15.19-2.42-.02-.15.34-.17.76-.2,1.1.58-.47,1.92-.08,1.04.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1197.31,74.88c.34-.2.69-.4,1.28-.38-.24-.8-.66-.82-1.28-.39v.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1196.04,71.8c-.58.12-.35.97-.43,1.54.99-.11.98-1.03.43-1.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1200.3,50.61c-.28-.25.18.16,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1201.15,47.14s.42.03.43,0c.36-1.85-2.74,1.83-.43,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1201.57,73.72h-.85v.77h.85v-.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1192.62,65.63c1.86-.65.28-3.15.43-4.62-.79.09-1.28.45-1.62.94.2,1.07.66,2.31.25,3.09.32.34.57.62.95.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1187.7,60.53c.08.03.17.05.25.09-.53.41.11,1.88-.06,3.01.24.15.54.61,1.33.84.03-.03.04-.06.06-.09-.14-.1-.29-.21-.48-.29.24-.62.43-1.29.74-1.84-.1-.72-.22-1.37.1-1.62-.45-.3-1.1-.22-1.94-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1191.77,60.24c-.08-.31-.43-.38-.43-.77.36-.07.4.15.43.39.8-.63-.01-3.05-1.28-3.08.08,1.47-.24,3.3,1.28,3.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1196.89,57.16c-.13-.81-1.48.41-1.28,1.16.98.12.47-1.11,1.28-1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1193.91,55.62c-.32.15-.5.43-.67.72.13.26.23.53.24.82,1.46.16,1.28-1.15,2.13-1.54-.1-1.19-1.51-1.2-2.56-1.54-.14.13-.23.25-.3.37.61.19,1.1.48,1.16,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1190.04,59.66c-.04-.14-.14-.24-.39-.19,0,.15.06.25.13.34.12-.04.2-.09.26-.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1196.04,53.35v.33c.82-.22.42-.33,0-.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1194.35,51.17c.06.11.14.24.24.38.1-.17-.02-.3-.24-.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1176.37,70.43c.24-.38.04-1.15.49-1.33.17.09.29.21.38.36.21-.03.38-.09.54-.17-.32-.52-.83-.95-1.34-.97-.08-.33.17-.36.43-.39.66-.2.03-.4-.43-.38-.38.32-.44.94-.44,1.61.28.4.44.87.38,1.27ZM1176.86,69.1c-1.68-.45,1.68-.45,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1170.38,78.43c-.19-.17-.23-.39-.22-.65-.13.24-.08.64-.13.95.2-.02.29-.14.34-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1187.48,68.16c-.15-.05-.27-.21-.39-.61.73-.14.44-1.2,1.32-1.2.25-.39.47-.8.38-1.49-.75,0-1.27.07-1.69.12.06.73-.23,1.14-.5,1.57.07.17.11.37.07.63-.06.13-.25.31-.47.46-.01.16,0,.33.03.53.43-.03.89-.06,1.26,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1186.04,61.93s0-.05,0-.07c-.21.19-.33.33,0,.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1185.86,68.18c-.2-.04-.42-.06-.66-.05.16.06.39.06.66.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1187.61,68.19c.12.03.24.07.33.13-.02-.08-.01-.13-.02-.2-.11.04-.22.06-.3.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1187.08,91.06c1.63-.75-2.59-.12,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1183.25,89.13c-.41.01-.33.47-.43.77.41-.01.33-.47.43-.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1181.49,85.44c.13.1.27.19.48.23-.29.36-.72.59-1.14.82.06.26.17.54.11.78.45.14,1,.19,1.46.32.83-.58-.75-1.62.85-1.92-.08-.39-.22-.55-.39-.6-.16.32-.42.55-.88.6,0-.15,0-.31,0-.47-.28.04-.57.01-.86-.3.15-.4.46-.66.86-.84.03-.42.13-.79.37-1.03-.01,0-.03,0-.04,0-.55.35-.94.31-1.17-.41,0-.01-.02-.02-.02-.04-.14.11-.22.27-.26.47.44.04.78.17.69.69-.28.04-.54.09-.78.15-.02.28-.04.61-.08,1,.13.03.23.09.32.15.2,0,.37.08.48.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1181.12,89.13c1.66-.96-1.41-.56,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1199.87,72.95c.52.12,1.47-1.11.43-1.16h-.85c-.12.62.4.66.42,1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1191.35,91.45c-.18-.39.08-.81.42-1.03-.2-.12-.46-.18-.85-.13.85.26-.27,2.3,1.28,1.93.04-.49.04-.95-.06-1.3-.24.2-.42.44-.78.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1169.19,72.18c-.58.3-.62,1.08-.8,1.73.05.08.1.17.15.27.6.27.69.99,1.92.7-.37-1.78-1.29-1.05-1.28-2.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1190.92,88.36c.18.16-.28-.25,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1192.62,69.1c.07-.45.78-.32,1.28-.38-.27-1.13-1.01-.52-1.75-.16.02.05.04.09.06.16-.13.02-.28.02-.42.02.13.39.84.25.84.75.48-.07.24-.39,0-.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1187.08,82.58c0,.12,0,.25,0,.38,0,0,0,0,0,0,0,0,0,0,0,0,.02.53.08,1.1-.43,1.15.64,1.04,1.35-1.06,2.13-1.16-.37-.58-.64.11-1.71-.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1193.9,85.67c.18-.81-.29-1.02-.43-1.54-.75-.12-.76,2.16.43,1.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1189.21,91.83c1.03-1.29-1.43.93,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1189.21,90.67c.13-.04.22-.07.3-.1-.04-.1-.1-.18-.18-.23-.45-.02-1.03.09-.11.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1190.49,66.4c-1.26-.31-.96.79-1.54,1.09.07.17.15.33.27.45-.1-.02-.19-.01-.29-.01.36.67.81-.16,1.98.01-.33-.34-.46-.87-.43-1.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1179.84,69.1c-.34.2-.69.4-1.28.39.22.57.63.97.85,1.54.92.07.19-1.37.43-1.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1168.76,76.03c1.68-.45-1.68-.45,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1170.55,81.63c-.14.07-.13,0-.04-.09-.14-.31-.35-.56-.9-.49v1.54s0,0,.01,0h1.7c-.52-.08-.61-.55-.77-.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1170.04,80.27c1.41-.56-1.66-.96,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1170.04,68.33c.08.31.43.38.43.77h.85c.2-.82-.61-.73-1.28-.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1193.48,86.44c-.9.88.19,1.36-.43,2.7,1.62-.35.31-1.55.43-2.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1172.05,75.72c-.09-.03-.19-.05-.31-.07.09.15.14.3.18.45.08-.14.14-.25.13-.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1168.33,69.87c-.08.33.17.36.43.39h.85c-.41-.13-.36-.67-.37-1.16h-.47c0-.39-.34-.46-.43-.77.21.01.43.01.63.03-.13-.08-.33-.1-.64-.03-.58.88,1.1,1.45,0,1.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1169.19,50.61c-.41.01-.33.47-.43.77.41-.01.33-.47.43-.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1172.59,81.43c1.03-1.29-1.43.93,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1176,98.38c.41-.01.33-.47.43-.77-.41,0-.33.47-.43.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1176,99.92c1.63-.75-2.59-.12,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1175.58,101.08c-.01.06,0,.1,0,.14.2-.02.35.02.41.24,0,0,.01,0,.02,0,0,.02-.01.03-.01.04.02.09.03.2.02.35-.35.03-.72.22-1.09.4.64.95,1.82-.3,2.79-.4.06-1.38-1.09.04-2.13-.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1178.56,78.35c-1.12-.12-1.4.53-1.28,1.54-.21-.16-.35-.4-.48-.64-.13.36-.36.63-.55.93.4.24.76.52,1.46.48.24-.81,1.06-1.1.85-2.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1172.75,77.79c-.03-.14-.02-.31.05-.51.02-.16.03-.31.04-.46-.36.02-.64.13-.88.26-.12.85-.39,1.52,1.07,1.66-.26-.24-.3-.58-.27-.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1242.49,101.08c.41-.01.33-.47.43-.77-.41.01-.33.47-.43.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1178.14,82.2c-.11.9.1,1.51.95,1.55.02-.38.05-.67.13-.88-.14-.43-.39-.74-1.08-.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1172.59,79.89c1.66-.96-1.41-.56,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1797.63,61.1c-.24-.11-.27-.22-.25-.35-.19.13-.35.33-.42.53.18.26.45.33.67-.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1672.09,105.31c-1.3.85.49,2.47,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1628.61,88.75c1.66-.96-1.41-.56,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1629.47,89.52c.23,0,.3-.15.34-.33-.16.1-.26.15-.31.17,0,.06-.02.11-.03.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1628.61,74.88c.75-.09.97-.66.85-1.54-.63.2-1.07.57-1.71.77.11.42.85.26.85.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1625.69,91.79s0,.08-.01.12c.22.41,1.06.24,1.66.3.37-1.29-1.25-.71-1.65-.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1625.63,101.08h.85v-1.16c-.34.2-.69.4-1.28.39.08.31.43.38.43.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1629.04,96.84v-.77h-.85v.77h.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1629.52,89.23c.08-.1.21-.22.34-.33,0-.05.02-.11.03-.15-.29,0-.33.24-.37.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1630.75,81.05s-.09.08-.13.12c-.08.07-.17.14-.24.22-.05.05-.08.11-.12.17-.05.07-.1.13-.15.21-.48.8-.65,1.88-1.05,2.74-.05-.03-.1-.04-.14-.06-.09.16-.18.31-.29.45.26.93.66-1.15,2.13-.39.55-1.18.66-2.74,1.7-3.47.08-2.16-1.43,1.32-1.7,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1633.3,76.42c-.8-.06-1.2.24-1.26.85.47.91.92,1.93.04,1.67.09.19.13.41.05.67.07.04.12.07.13.11.42-.25.46,0,.93.12-.07-.22-.15-.43-.19-.61-.29-.2-.38-.47.29-.88.1.01.16.04.2.07.07-.02.14-.05.23-.07.06.22.15.43.21.63.9.12-.24-1.71-.65-2.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1634.16,98.38c-.18-1.11.41,2.59,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1630.32,90.67v.77c.36-.07.4.15.43.38.61-.09.15-1.15.85-1.16-.19-.57-.54.15-1.28,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1629.9,86.82s0,0,0,0c.55.65,2.02.47,2.12,1.53,1.01-.11-.49-1.03-.43-1.54h-1.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1631.6,89.13c1.03-1.29-1.43.93,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1619.05,72.31c.31.26,1.04.94.2.26-.11-.11-.18-.18-.23-.24-.07.05-.14.12-.21.24-.16-.66.33-.73.85-.77-.88-.36-.36-1.98-1.71-1.93.59.5.42,1.67.43,2.7.34.33,1.17.23,1.28.77.71-.03-.03-1.38-.62-1.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1615.83,91.06s.06-.02.09-.03c.03-.16.1-.28.26-.32.03-.14.04-.29.08-.42-.42.01-.33.47-.43.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1616.96,85.9c-.06.05-.14.1-.27.15-.48-.27-.56-.44-.47-.52-.52-.29-1.05-.63-1.58-.82-.13.1-.29.17-.5.19-.04-.13-.11-.24-.18-.33-.29-.02-.59.04-.88.2.94.38,1.87,1.18,2.77,1.29-.12.01-.24.02-.37.03.7.06,1.43.03,2.06-.03-.19-.02-.38-.08-.57-.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1618.39,86.05c1.41-.56-1.66-.96,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1617.53,91.45c.42-.01.33-.47.43-.77-.41.01-.33.47-.43.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1613.7,82.2c-.28-1.15-.91.36-1.7,0,0,0,0,0,0,0,.23.31.44.62.42,1.15.98.12.47-1.11,1.28-1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1615.4,88.36c1.66-.96-1.41-.56,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1613.34,104.11c.2.15.34.38.35.67.4.2,1.05.18,1.71.14.09-1.11-1.41-1.34-2.06-.82Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "1620.52 89.9 1620.52 89.9 1620.52 89.9 1620.52 89.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1620.93,88.93c-.21.25-.37.53-.4.86,0,.04,0,.07,0,.11.83-.63.54.04,1.7,0-.02-.15-.01-.28,0-.39-.26-.48-.88-.75-1.3-.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1623.07,99.15h.85c-.08-.33.17-.36.43-.39v-.77h-1.28v1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1622.45,86.71c.68.1,1.1.36.63.89-.07-.41-.53-.39-1.01-.24.04.32-.17.6-.46.88.37.21.73.51.86.78.41-.32,1.16-.04,1.45.5.96-.28-.6-1.47-1.28-1.54.27-.32,1.99-1.21,2.13-.39.82-.91-1.07-1.03-2.33-.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1634.6,71.62s.04-.07,0-.09c0,.03,0,.06,0,.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1625.63,97.99c1.68-.45-1.68-.45,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1620.09,75.65c1.68-.45-1.69-.45,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1651.2,105.31c.18.16-.28-.25,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1660.15,87.21c1.68-.45-1.68-.45,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1661,101.08c.28.52.91.72,1.71.77-.1-.68-.73-.88-1.71-.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1663.99,84.9c-.94.51-1.26,1.1-1.24,1.73.6,1,1.54,2.09,1.77,3.12.51.62.98,1.2,1.17,1.7,2.13-1.98-2.26-4.71-1.71-6.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1658.87,93.37c.07.45-.09.69-.43.77.1.42.85.26.85.77.81-.04-.34-1.44-.43-1.93-.48.07-.24.39,0,.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1654.61,102.23c-.2.82.61.73,1.28.77-.19-.47-.55-.79-1.28-.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1658.45,98.38c1.03-1.29-1.43.93,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1655.04,99.15c.1.68.73.88,1.7.77-.28-.52-.91-.72-1.7-.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1669.95,91.83c.18.16-.28-.25,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1674.57,71.71c-.01-.28,0-.56.05-.81-.24.21-.43.45-.82.51.08.45.45.47.78.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1672.09,77.58c1-.1.25-1.69,0-1.93h.85c-.42-1.18-1.44.17-1.71.39.18.6,1.34.33.85,1.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1667.4,86.44c1.69-.45-1.68-.45,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1669.95,86.44c.18.16-.28-.25,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1669.1,85.67c-1.29-1.42-1.43,1.17,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1654.19,87.59c-.7.28-1.85-.76-.85-.77-.41-1.06-1.01-.03-.94.79.03,0,.07,0,.1-.02,0-.21.35-.44.43,0-.27,0-.37.16-.45.33,0,.02.01.04.02.05.61-.43,1.04-.42,1.28.38.46-.09.29-.77.85-.77-.08-.44-.43-.21-.43,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1653.33,89.9c1.16-1.17-1.3,1.05,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1646.58,94.46s-.03-.03-.04-.05c-.33.29-.74.69-.03.12.03-.03.04-.05.07-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1646.51,98.76c-.44.14-.3.27-.02.34.18-.02.37-.04.55-.07-.18-.06-.36-.14-.53-.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1645.21,97.44c-.4.24-.5.78.88.56-.02-.16-.06-.28-.11-.38-.33,0-.64,0-.77-.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1640.04,97.64c.39.43.57,1.05,1.36,1.13.21-.52.34-1.04.42-1.54h-.41v-.77h.49c.15-3.22-1.9-5.95-2.63-8.09-1.71.27-2.1-.64-3.35-.79-.02,0-.03.02-.05.02,0-.01,0-.02,0-.03-.25-.02-.52-.03-.85.03.54.18,1.05.44,1.54.77.29.05.61.06,1.03,0,.18.51.43,1.06.71,1.65.87,1.12,1.46,2.48,1.61,3.88.32,1.17.44,2.42.15,3.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1648.65,104.54c-.55-1.29-.34-3.29-1.71-3.85.03-.11.09-.19.16-.26-.13-.12-.26-.23-.43-.32-.12.83.15,1.3-.15,2.51,1.74-.29.08,2.5,2.13,1.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1643.12,103.33c.09,2.8-2.45,4.85-3.85,7.52h1.7c1.46-2.78,4.16-4.88,3.85-7.85-.81-.11-1.19.16-1.69.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1612.42,88.36c1.03-1.29-1.43.93,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1651.2,101.46c-.25.19-.42.46-.55.77.17.15.25.36.13.77-.11.08-.24.13-.38.18-.02.19-.05.39-.06.59.56-.39,1.57-.38,2.13-.77.37-1.24-1.11-.8-1.28-1.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1635.43,78.35c-1.34.27-.56,1.03-.43,1.93,1.17-.48.65-1.12.43-1.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1652.48,98.76c-.28-.25.18.16,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1650.35,105.7c.18.16-.28-.25,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1647.37,104.93c-.36.96.53.8,1.28.76-.15-.14-.06-.06,0,0,.15,0,.3,0,.42,0-.28-.52-.91-.72-1.71-.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1650.78,99.92c-.25-1.25-1.21-1.01-2.26-.86.26.13.47.38.56.86-.56-.08-.77,0-.82.14.53.24.78.72,1.24,1.02,2.01.41-.86-1.45,1.28-1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1628.61,98.38c-1.06.06-.12,1.3,0,1.54,1.28-.25-.41-.82,0-1.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1583.86,82.97c-.15-.51-.75-.61-.85-1.15-.26.03-.45.12-.58.24-.02.03-.04.05-.06.07-.28.34-.16.88.22,1.23.34-.2.69-.4,1.28-.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1583.44,94.91c1.03-1.29-1.43.93,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1581.73,93.37c.5-.06.36-.7.42-1.16-.5.06-.36.7-.42,1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1581.41,83.09c.27.29.29.19.23-.06-.08.02-.16.04-.23.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1580.46,92.99s-.04.01-.06.02c-.03.11-.07.21-.15.27.08.12.23.26.21.48.54-.1.43-.77,0-.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1581.73,78.35c-.52.17-.88.49-.85,1.15.52-.17.88-.49.85-1.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1578.93,81.08c.14.07.24.17.25.35-1.04.29-.09,1.15.43.39.05.51.8,2.12,0,1.15-.4-.44-.65-.52-.81-.44.29.51.7.91,1.23,1.21.17,0,.11-1.07.49-1.22,0-.16.06-.3.17-.42-.33-.08-.48-.49.19-.68-.04-.67-1.12-.39-1.95-.35Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "1581.3 81.82 1581.31 81.82 1581.31 81.81 1581.3 81.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1588.73,78.23c-.94-.14-1.52-.09-2.08.12.12.2.24.42.19.77.79-.44,1.29-.75,1.89-.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1613.06,75.74c-.3.33-.83.23-1.19-.09-.3.34-.56.71-.3,1.55.95-.08,1.22-.77,1.49-1.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1586.04,86.61c.03.08.07.15.12.22.09,0,.17,0,.26,0,.33-.18.09-.23-.39-.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1587.8,83.32c.16-.11.23-.46.29-.83-.11.02-.24.04-.39.09-.06.33-.01.56.1.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1584.72,93.37c.95,1.2,1.13-1.52,1.28-2.31-2.76-.29-.81,2.15-1.28,2.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1585.14,96.07c1.3,1.05-1.16-1.17,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1588.98,85.67c1.16-1.17-1.3,1.05,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1590.68,86.82c.41-.01.33-.47.43-.77-.42.01-.33.47-.43.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1588.13,81.81h.05c.06-.35.15-.49.38,0h.84c-.26-.8.69-2.68-.85-2.31.89,1.49-.64.63-.43,2.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1590.26,83.74v-1.93c-.59-1.23-.26,1.51-.85,1.54-.45-.11-.47-.62-.84-.8v1.16c.49.08,1.11.04,1.7.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1587.27,86.05c.18.16-.28-.25,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1590.64,92.43c.12.09.25.17.47.17.04.08.06.16.07.22.14-.31.36-.5-.07-.61-.21.03-.36.1-.48.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1589.41,87.98c-.04.13-.05.23-.05.32.2.12.37.26.49.45-.06-.01-.13-.01-.19-.02.47.15,1.37-.09,1.89.02-.36-.57-1.07-.83-2.13-.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1590.26,76.03c.19.64-.17.79-.48.98-.03.37-.18.78-.3,1.14.43,0,.94.05,1.63.2.3-.91.98-2.44-.85-2.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1586.42,84.13c-1.1-1.33-1.03,1.98,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1583.44,78.35c1.81.02.53-2.76.43-3.47-.66.45-.62,3.51-.43,3.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1583.86,82.2c.42-.01.33-.47.43-.77-.42.01-.33.47-.43.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1589.83,72.18c-1.06.06-.12,1.3,0,1.54,1.28-.25-.41-.82,0-1.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1587.71,77.58c0-.77,1.16-.49.85-1.54.36-.03.62.01.8.1.69-.32,1.77-.28,1.32-1.64h-1.7c.29.85-.04,1.15-.49,1.33-.15.45-.38.83-.92.94-.06.07-.12.15-.19.23.16.26.24.45.25.58.02,0,.04,0,.07,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1583.01,81.43c1.41-.56-1.66-.96,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1585.5,86.87c.01-.09.04-.17.08-.24-.22.02-.46.04-.71.06,0,.03-.04.07-.14.13-.86-.07-1.42.13-1.86.45.02.16-.11.26-.37.3-.12.12-.24.23-.35.36.09.84,1.17.78,1.29,1.59.72-.25.27-.89-.43-.77.83-.62,1.24-1.63,2.49-1.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1607.31,89.52c-1.28-.39-.75.86-.85,1.54.75-.09.97-.66.85-1.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1604.76,91.06c.03-.22,0-.5-.02-.77-.48-.02-.77-.09-.93-.19.13.23.21.5.09.96-.29.16-.52.35-.73.51,1.01.96,1.35.11,2.42-.51.09-.34.06-.58-.01-.77-.09.43-.34.71-.83.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1603.04,98.76c-.06-.95-1.42-.12-1.7,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,.19.34.37.69.85.77-.1.42-.71.37-1.28.37,0,0,0,0,0,.01-.04,0-.07,0-.1-.01-.06,0-.12,0-.18,0-.05.01-.08.03-.11.06.24.32.44.64-.03.72,0,.03,0,.05.01.08.19.61,1.14-.6,1.26.69,1.16.28-.31-1.82.85-1.54-.37-.68-1.59-1.34.43-1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1601.76,96.84v.24c.1.1.11.21,0,.32v.6h1.28c-.08-.31-.43-.38-.43-.77.36-.07.4.15.43.39,1.37-.44-.41-1.1-1.28-.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1598.36,96.84c-.27.15-.43.45-.48.77.02,0,.04,0,.07,0v.78c.21.62.78,1.1,1.7.76v-1.54c-.86.13-1.33-.08-1.28-.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1600.91,95.68h.85c-.23-.31-.45-.63-.43-1.16-.46.1-.29.77-.85.77-.08.33.16.36.43.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1601.35,90.29c-.46.1-.76.08-.96,0h-.31c.03.07.04.16.05.26.07.34.17.65.3.93.22-.49,1.18-.3.94-1.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1600.07,87.59c-.03.37-.42.53-.66,1,.13.41.32.76.64,1,.06-.79.7-1.92.03-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1588.13,87.59c.12-.62-.4-.66-.43-1.15-.83-.15-.62,1.75.43,1.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1892.29,61.01c.12.2.09.42-.32.73.92.07.9-.26.73-.67-.17-.01-.31-.04-.42-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1612.25,70.77c-.2-.03-.42-.07-.68-.13.08-.26.33-.36.56-.48-.41-.16-.05-.24.3-.24.12-.16.16-.4-.01-.82-.15-.03-.26-.02-.38-.01-.02,0-.02.01-.04.01,0,0,0-.01,0-.01-.94.07-.78,1.13-1.14,1.73.52.06.89.02,1.38-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1608.16,101.85c-1.29-1.43-1.44,1.17,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1607.73,85.67h.85v-.77h-.85v.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1610.29,75.26c-.11-.23-.18-.6-.26-1-.42.06-.76.32-1.01-.54.24-.21.47-.42.7-.64-.16-.41-.37-.76-.71-.9.06-.27.2-.46.4-.59-.39-.17-.85-.24-1.25-.17-.19.33-.35.69-.44,1.11.4.52.54,1.4.68,2.09,1.03.1,1.36-.31,1.88.65ZM1608.59,72.57c.1-.3.01-.76.43-.77-.1.3-.01.76-.43.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1610.29,90.67c.42-.01.33-.47.43-.77-.41.01-.33.47-.43.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1590.61,100.75c-.04.18-.11.32-.34.33.03-.1.05-.22.06-.33-.41.04-.67.28.35.72.63-.43.31-.66-.08-.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1588.98,94.53c.37,0,.56-.17.68-.4-.16.08-.38.12-.67.09,0,.1-.02.2-.01.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1590.58,89.69c-.54-.49-1.26-.81-2.22-.91-.12,0-.23-.01-.32-.03-.24-.01-.49-.02-.76,0,0,.05,0,.09,0,.14.91.22,1.56.66,2.03,1.28.14,0,.29,0,.45,0,.56-.14,1.01.01.82-.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1589.41,92.6s0,0,0,0c-.11.23-.21.48-.29.74.29-.07.53-.2.3-.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1587.94,90.16c.19.05.4.06.65.05-.22-.03-.44-.05-.65-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1588.21,92.95c.32-.11.5-.34.74-.52-.11-.08-.21-.18-.38-.21-.22.15-.31.43-.36.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1593.67,94.53c1.47-1-2.19-.93,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1592.4,92.22c0,.05.01.1.03.14.1-.07.23-.12.39-.14.51.13.1.37,0,.81.03.09.04.21,0,.35h1.7c.01-.06.01-.11.01-.17-.64-.39-.72-1.3-2.14-.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1594.95,99.53c-.28-.25.18.16,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1597.08,103.39c-.34.2-.69.4-1.28.38,0,.18.02.34.04.49.41.22,1.04.25,1.67.28v1.04c.51.02,1.09,0,1.7.12v-1.16c-1.09-.04-2.19-.07-2.13-1.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1591.96,79.5s-.05-.04-.06-.06c.02.02.04.04.06.06,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1591.1,93.21c-.31.28-1.23.02-.84.93.5.13.83.11,1.07,0-.19-.21.06-.33.36-.34.08-.13.14-.28.19-.43h-.76c-.01-.06-.01-.11-.02-.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1591.96,101.08c.42-.01.33-.47.43-.77-.41.01-.33.47-.43.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1777.78,62.16h-.85c.08.33-.17.36-.43.39-.17.75,1.94.56,1.28-.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1673.79,79.12c-.59-.09-1.04.23-1.41.62.3.6.6,1.18.57,2.08-.84.11-.85-.52-1.28-.77-.21.92,0,2.75-.37,4.37.33.16.85.26,1.64.26.12-.42.19-.86.23-1.29-.2-.1-.31-.28-.22-.64.1,0,.18.02.27.03.06-1.09.01-2.11.15-2.72.43.25.44.89,1.28.77.04-1.2-.52-1.84-.85-2.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1819.97,55.23c-1.44-.18-1.37-.2-2.34-.08.18.02.38.05.64.08.15,1.58,1.35,2.22,2.62,2.78.28-.19.91-.11,1.39-.14-1.15-.54-2.18-1.19-2.31-2.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1824.23,53.3c-.61.09-.15,1.15-.85,1.16.19.84,1.88-.73.85-1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1810.66,64.66c.01-.08.05-.15.09-.22-.12-.08-.24-.16-.33-.26-.59.91-1.4.81.24,1.13-1.11.06-1.04.96-1.06,1.52.57-.6,1.14-1.25,1.85-1.57-.04-.24-.17-.41-.33-.54-.11.02-.25.02-.46-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1807.1,67.56c.6.02,1.04.1,1.37.22.27-.16.52-.36.76-.6-.9-.22-1.62-.35-2.13.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1822.34,57.9v.62c-.13-.02-.21,0-.26.04.5.25.97.54,1.32.92-.42.54-1.23.73-2.19.78,1.64.06,3.23.06,3.88-.78-.68-.74-1.76-1.12-2.75-1.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1809.29,68.86c-.03.57-.37,1.26-.57,1.9.06.09.1.2.18.27.25-.01.37-.15.45-.32.04-.43.25-.82.66-1.1-.19-.3-.39-.58-.72-.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1827.33,57.12c.26.09.46.23.53.43-.36.52-.72.4-1.07.18,0,.06.01.12,0,.2-.23.05-.41.13-.58.23,0,.17.03.35.14.54,1.06.06,1.32-.6,2.13-.77.06-.73-.56-.94-1.16-.81Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "1591.97 81.43 1591.96 81.42 1591.96 81.43 1591.97 81.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1831.48,52.92c1.62-.76-2.59-.12,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1810.66,63.69s-.02.05-.03.07c.06,0,.12,0,.18,0-.04-.02-.09-.05-.16-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1832,65.21c.06-.21.1-.43.11-.65-.15.15-.12.46-.19.68.04,0,.06-.02.09-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1828.07,63.71c.5-.06.36-.7.43-1.16-.5.06-.36.7-.43,1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1827.22,74.49c1.68-.45-1.68-.45,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1824.66,71.03c1.66-.96-1.41-.56,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1787.17,74.37c.08-.05.15-.1.22-.15-.17.04-.28.1-.22.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1787.58,71.41c1.08,1.52-.67.59-1.28,1.93-.18-.06-.26-.13-.29-.22-.74,1.24-1.5,2.08-1.97,3.18h.55c.62-.58,1.33-1.09,2.05-1.58.48-.7,1.02-1.44,1.52-2.44-.05-.03-.11-.05-.16-.09.09,0,.14-.02.22-.02.22-.45.43-.95.63-1.52-.43.25-.44.89-1.28.77ZM1786.31,74.49c-2.59-.12,1.63-.75,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1784.55,71c-.3-.46-.62-.9-.92-1.36-.22-.35-.42-.73-.58-1.14-.47-.06-.97-.4-1.86-.55.38,1.59,1.47,2.53,2.13,3.85.7,0,.63-.7,1.23-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1781.19,67.18c-.32-.49-.37-1.21-.85-1.55-.52.29-.85.6-1.13.93.26.7.52,1.39,1.99,1-.02-.14-.02-.26,0-.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1772.41,63.84c.28.18.59.32.92.42.35-.31.7-.62,1.04-.94-1.34-.59-1.48-.23-1.96.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1803.94,59.81c-.13,1.07-1.72-.85-1.97.32.47.16.89.34,1.18.65-.78.54-.5-.03-1.58,0-.02.44.19.71.4.97-.3.04-.57.11-.85.17.17.12.23.29.23.47.94-.04,1.86.08,2.19,0-.76-1.4,1.46-2,.39-2.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1776.13,62.74c-.16.19-.5.28-.8.26.05.66-.42,1.14-.95,1.39.48-.02,1-.13,1.54-.39-.46,1.68-.21,2.93.31,4.01.4-.35.68-.7.94-1.03.08-.38.08-.7-.24-1.35.72-.18.93.11,1.08.44.18-.15.38-.3.63-.44.1.07.18.16.25.25.04-.95-.59-1.76-.68-2.18-1.46.83-1.27-.45-2.08-.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1433.42,92.6c.42-.01.33-.47.43-.77-.42.01-.33.47-.43.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1798.54,63.76c.09.08.19.16.27.25,0,0,0,0,0-.01-.06-.1-.12-.2-.17-.31-.04.02-.07.05-.11.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1798.09,62.7c.44.08.75.26,1.09.41.34-.38.87-.58,1.46-.66,0-.13,0-.27,0-.41-.83.24-1.6.52-2.55.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1795.68,64.48c-1.16.04-.86-.64-1.7,0-.05-.2-.05-.39-.02-.57-.26-.12-.41-.34-.45-.65-.29.65-.57,1.3-.38,2.38.43,0,.51.31.85.38.61-.01,1.2-.05,1.61-.25.12-.46.3-.83.53-1.12,0-.06,0-.11-.01-.17.06,0,.11,0,.17,0,.08-.09.17-.16.27-.22.12-.31.35-.63.52-.91-.07-.15-.09-.34.01-.63.36-.06.65-.06.9-.03-.3-.13-.57-.29-.83-.45-.67.6-1.29,1.33-1.46,2.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1791.42,70.64c-.71-.51-.14-2.18-.85-2.7.21-.07.46-.12.73-.16-.55-.1-1.18-.08-1.71,0,.44.92.98,2.24.03,2.73.04.04.06.09.11.12-.08-.04-.16-.05-.24-.07-.06.02-.12.05-.19.07.06.86,1.07-.5,2.13,0ZM1790.36,68.53c.17-.13-.26.21,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1793.55,66.02c-.78-.15-1.3-.08-1.73.09-.72,1.72.06.97,1.09,1.67.94.15,1.69.62,1.49,1.72.58-.12.35-.96.43-1.54-1.15-1.02-2.12.05-1.28-1.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1790.6,71.45c.17.08.31.19.4.34-.14.02-.22.07-.26.13.12.06.23.13.33.2.41-.22.82-.45,1.22-.68-.47-.23-1.16-.27-1.72-.42.03.16.03.3.03.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1829.35,77.96c1.03-1.29-1.43.93,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1878.08,78.52s0,0,0,.01c.02,0,.04.02.07.02.21-.05.13-.06-.08-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1878.66,77.59c-.14.02-.28.09-.39.19.12-.01.25-.07.39-.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1875.56,79.16c.15.26.3.5.41.68.04-.01.06-.03.08-.04,0-.09,0-.17.02-.25-.08-.17-.21-.36.15-.43.03.03.05.05.07.08.32-.31.88-.5,1.33-.6-1.05-.13-1.97.04-2.07.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1875.8,75.65c1.68-.45-1.68-.45,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1877.4,77.47c.14-.18.22-.39.21-.63-.37-.1-.72-.17-1.03-.21-.17.17-.27.4-.37.63.52-.04.9.07,1.2.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1871.28,70.12c.05.08.13.13.26.14-.08-.07-.15-.15-.21-.23-.02.03-.04.06-.05.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1882.62,72.18c-.18-1.67-2.47.41,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1877.06,77.78c-.12-.16-.32-.33-.86-.51-.15.34-.33.66-.82.69.11.3,1.06.24,1.68-.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1881.34,71.03v-.77c-.38.24-.76.47-.85,0-.76.28-.06.7,0,1.16.34-.07.42-.39.85-.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1833.26,64.14c.19.1.41.17.69.19-.11-.17-.14-.31-.12-.44-.23-.06-.45-.07-.57.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1888.18,73.36c.03.18.11.38.25.67-.28.03-.62,0-.92.02-.04.11-.07.21-.11.31.54.16.46.83,1.43.64.13-.58.37-.7.62-.76.11-.12.24-.24.38-.36-.18-.15-.34-.29-.47-.42-.37.33-.74.49-1.17-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1889.53,72.06c-.07-.02-.13-.05-.19-.07-.44.19-.77.41-1.01.64-.13.3-.18.49-.15.69.41-.46.87-.88,1.36-1.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1882.9,73.71c-.02-.08-.04-.16-.06-.25-.71.81-1.58,1.2-1.92.26-.43.51-.79.93-1.09,1.32.9.16,1.66.37,1.09.93.69-.19,2.32.39,2.37-.32-1.19-.39.06-1.41,1.18-.97-.22-1.07-.34-1.41-1.58-.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1884.02,69.24c-.48.08-1.09.14-1.39.63.56.07.9.31,1.07.63.31-.16.69-.29,1.17-.35.07.1.12.2.17.3.01-.19,0-.37-.01-.54-.33.03-.62-.46-1.01-.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1886.5,64.08c.34-.06.66-.15.83-.36,0,0-.01,0-.02,0-.41,0-.5.28-.81.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1848.1,61.49s0-.06,0-.1c-.37-.1-.66-.27-.89-.49.2.2.46.6.89.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1851.94,72.6s-.1.06-.15.09c.1.02.2.04.32.05,0-.01,0-.02,0-.03-.06-.03-.11-.07-.16-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1844.27,73.72v.51c.17.19.3.42.44.64-.16,0-.3,0-.44.02v.75c.16-.03.3-.09.42-.15.39-.81,1.79-1.63,1.14-.57.13-.03.27-.05.42-.05.04-.01.08-.03.12-.05-.38-.66-.8-1.29-2.1-1.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1849.38,69.48c0,.13-.02.24-.05.35.09-.1.17-.2.24-.33.81.09.78.87,1.58.97-.29.3-.72.49-1.18.65,1.05-.15.68.3.33.84.02.06.04.12.05.17.19.12.39.23.62.33-.07-.24.07-.48.27-.74-.23-.59-.17-1.28.28-1.84-1.2.32-1.1-.54-2.13-.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1841.71,75.09s.05.09.08.14c.34-.12.52-.38.79-.56v-.5c-.26-.05-.59-.03-.86-.06v.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1834.46,62.76v.37c.2-.15.29-.27,0-.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1860,61.1c-.02-.14-.02-.27-.02-.39-.13.23-.27.45-.41.67.44.63.82,1.31,2,1.33v-.65c.24-.02.47-.05.4-.32-.98.05-1.92.06-1.98-.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1870.66,66.27s.07.04.1.06c-.03-.02-.07-.04-.1-.07,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1871.23,63.83c-.31.17-.61.36-.57.82.05.29.3.41.61.48,0-.41.43-.78-.04-1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1853.37,73.87c0-.32.06-.64.27-.92-.42.07-.78.02-1.11-.08,0,.06,0,.11-.01.16.07.01.13,0,.21.03.08.2.09.34.08.47.02.17,0,.31-.07.4.21-.03.42-.04.63-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1871.46,71.49c.03-.15.06-.31.09-.47-.17-.04-.33-.06-.48-.06,0,.29.12.5.39.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1854.92,67.56c.19.45.51.78.95,1.01-.17-.57-.39-1.11-.65-1.63-.13.18-.23.38-.3.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1852.9,74.68c.45,1.09.78.52.4,1.92.07-.07.18.02.33.17.2.08.38.12.54.15.09-.55-.34-1.33-.61-2.12-.21-.04-.43-.09-.66-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1823.38,48.68c-1.11-.11-1.83.14-1.71,1.15.81-.16,1.84-.14,1.71-1.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1687.97,68.13c-.05-.04-.11-.09-.17-.14.02.1.04.21.05.34.04-.06.08-.13.11-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1689.63,63.26c.04-.08.1-.14.18-.19-.18-.09-.46-.09-.68-.14,0,.25.25.3.5.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1690.33,65.01c-.25.2-.5.41-.77.62-.1-.3-.01-.76-.43-.77.13.47.41.8.72,1.1.23-.25.51-.45.79-.66-.09-.06-.2-.17-.31-.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1688.71,69.87c-.26-.73-1.01.4-1.75.7.02.02.04.05.05.07-.04-.02-.08-.03-.12-.04-.11.04-.21.05-.31.04.36,1.13,1.07-.5,2.13,0-.26-.34-.52-.69,0-.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1687.68,67.56h.56c.77-2.05-.17-4.66,1.74-5.4-.08-.44-.43-.21-.43,0-1.64-.5-.02-.79.05-1.87-.18-.05-.37-.13-.56-.19-.31.1-.69.15-1.13.13,0,.02,0,.04,0,.06.69.59-.15,1.24.19,1.62.05,0,.09.04.13.1.11.06.25.11.47.15-.28.24-.48.55-.63.9.12.05.21.11.21.26-.09-.02-.2-.04-.31-.05-.18.53-.24,1.18-.13,1.98-.36-.13-.66-.32-.89-.57-.09,1.19-.07,2.56-.8,3.65.7-.34,1.21-1.46,1.52-.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1685.73,67.33c.05.41.17.76.42,1,0,0,0,0,0,0-.1-.75-.24-1-.43-.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1685.98,65.16c.06.03.12.06.18.08-.02-.12,0-.22-.02-.34-.03.11-.08.2-.16.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1698.15,67.24s.08-.01.13-.02c0-.02-.01-.04-.02-.06-.04.03-.06.05-.11.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1695.78,65.3c.57-.75.34-2.3-.32-3.5-1.18-.08-1.02-1.36-1.63-1.95-2.04-.18-3.34.32-3.41,1.93,1.68-.94-.32.43.85.77-.02-.66.33-.99.85-1.16.37,1.22-.2,2.15-1.18,3.08.26.58.47,1.21.74,1.79h.38v.65h-.02c.16.24.34.46.57.65-.45-.12-.75-.37-1.01-.65h-.34v-.38c-.19-.22-.38-.43-.63-.59-.1.2-.15.39-.17.58.38.36.72.77.79,1.41-.07-1.09,2.63.32,2.56-.77-.03-1.44-.32-3.12,1.71-2.7-.88.73-.72,1.55-.63,2.43.55-.59,1.07-1.01,1.67-.96-1.39-.09,1.39-.87,0-.97-.09.25-.33.38-.79.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1686.18,63.76c.12-.68.39-1.22.84-1.6-.34-.06-.52-.15-.61-.26.05.48-.25,1.08-.68,1.42.2.41.33.5.45.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1696.07,68.59c.42.91.59,1.55.54,2.4.27-.71.34-2.08-.54-2.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1693.82,69.1s.03.07.05.1c.11,0,.22,0,.33-.02-.01.11-.05.21-.11.31.08.1.16.2.15.38-.19.34-.37.69-.85.77.08.44.43.21.43,0,.49-.06.75.08.85.37.07-.03.14-.05.2-.08.3-.28.05-1.06.66-1.06-.1-.68-.73-.88-1.71-.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1696.17,67.24c-.5-.21-.93.3-1.23.35,0,.37-.07.74-.26,1.12.38.01.65-.07.89-.18-.06,0-.11-.01-.18,0-.29-.88.78-.65.79-1.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1692.03,74.09c.1.05.18.13.19.26.05.11.08.19.12.29.04-.01.08-.02.13-.04-.05-.2-.09-.41-.12-.64-.11.04-.21.08-.32.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1695.93,60.72c-.03.16-.06.34-.05.53.07.07.16.13.29.17-.2-.25-.24-.49-.24-.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1686.38,61.4c-.07,0-.14-.01-.23,0,.08.07.13.15.18.23,0-.07.03-.15.05-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1782.81,65.28c-.58.04-1.34.26-.13.34.08-.1.12-.21.13-.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1676.77,81.43c.17.96,1.65.02,1.28-.77-.95-.21-.61.74-1.28.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1676.42,69.78c.43-.33.59-.9,1.63-.68-1.56-1.21,2.64-4.74-.85-5.39-.02.57-.14,1.07-.29,1.53-.16,1.32-1.57,3.08-.56,3.87-.64-.14-.95.03-1.19.25-.03.17-.08.33-.09.52.06.02.1.03.16.04.27-.19.63-.34,1.13-.42.02.1.04.19.06.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1674.64,83.74c-.11.44.08.62.38.69-.08-.27-.22-.49-.37-.69,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1678.05,69.48c-.8.13-1.25.43-1.51.83.29,1.11.61,1.75.66,2.64-.35.08-.59.22-.76.39.07.7.02,1.32-.46,1.68-.03.29-.08.59-.19.87.28.34.69.57.97.91,1.72-1.2.1-3.38,2.13-3.85-.06-1.09-.53-1.78-.85-3.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1675.92,77.96c1.3,1.05-1.16-1.17,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1687.41,62.87s-.02.04-.03.05c.01,0,.03,0,.04.01,0-.02,0-.05-.01-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1687.01,59.67s-.08-.11-.09-.19c-.05.06-.1.1-.16.15.08.08.15.15.23.22,0-.06,0-.12.01-.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1677.63,84.51c-.43-.25-.44-.89-1.28-.77.11.15.22.31.3.49.31.1.58.4.56.67.59-.02,1.21-.07,1.27.39,1.15-.34-.36-1.71-.85-.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1688.68,58.58c-.06-.29-.3-.41-.52-.55.23.14.38.33.52.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1678.9,99.15c1.16-1.17-1.3,1.05,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1698.91,64.19c-.48-.3-.55-.95-1.56-.82.68,1.11-.69,2.45.39,3.56.09-.24.23-.33.36-.34,0-.06-.02-.11-.03-.17,1.48.35.66-1.38.83-2.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1675.28,83.85c.26.17.37.48.63.65-.12-.3-.32-.52-.63-.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1712.36,62.39c-.05.19-.1.33-.16.43.16-.02.33-.03.52-.02-.03-.21-.12-.37-.36-.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1789.29,66.02c.38-.08.41-.48.41-.91-.22.15-.49.22-.83.14.13-.27.26-.52.38-.77h-.82c-.49,1.21.67.94.85,1.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1792.52,62.26c-.02-.06-.03-.12-.02-.19.03,0,.04-.02.07-.02.22-1.01.48-2.01.99-2.6-.02-.13-.05-.25-.09-.37h-.34v.08h-.79v-.65h.43c.05-.1.12-.19.17-.26-.1-.11-.21-.22-.33-.33-.09,0-.2,0-.34,0,.25,3.74-.57,5-1.7,7.32,1.29.3,1.6-1.31,1.95-2.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1794.47,62.07c-.28-.15-.21-.22-.06-.32,0-.02,0-.04,0-.06-.11-.1-.24-.2-.43-.3,0,.37-.05.68-.13.96.24.08.5.03.62-.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1789.62,66.34c-.34.02-.77.34-1.18.44,0,0,0,0,0,0,0,0-.02,0-.02,0-.13.03-.26.04-.39,0,0,0-.01,0-.02,0,.04.13.09.23.15.3.6-.15,1-.48,1.46-.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1794.45,62.84c-.2-.07-.46-.09-.72-.11-.01.03-.02.06-.03.09.19.09.39.18.65.21.04-.06.07-.12.11-.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1790.88,62c-.02.07-.03.14-.05.21.05-.02.11-.04.16-.05-.05-.05-.08-.11-.11-.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1787.16,71.03c.18.16-.28-.25,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1786.7,66.79c.15-.03.3-.1.45-.16v-.99c-.34.2-.69.4-1.28.38.08.31.43.38.42.77h.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1783.88,68.22c.8.3,1.2.58,2-.27-.32-.39-.45-.78-.51-1.15h-.76c0-.39-.35-.46-.43-.77.5.01.82-.13,1.12-.29-.05-.56-.22-1.01-1.13-1.25.77,1.07.08,1.29-.55,1.68.02.55.05,1.18.56,1.79-.11.11-.2.2-.3.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1786.45,72.33c.17-.23.32-.49.36-.77-.12.27-.24.53-.36.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1795.25,59.47c1.81-.5-.04-1.91.43-3.47-1.7-.64-.86,1.03-1.69,1.18.05.21.12.42.18.61.48.45.96.9,1.08,1.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1786.75,71.08s0-.03-.02-.05c-1.14-.27-.88.72-1.67.76-.27.76-1.24,1.28-.46,1.55.61-1.34,2.36-.41,1.28-1.93.48.07.69-.12.86-.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1786.74,68.71s0,0,0,0c.45.36.13,1.42,1.28,1.15.89-.52-.37-.89.28-1.12-.05-.16-.11-.31-.18-.47-.44-.1-1.18.34-1.38.42,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1789.8,63.32h-.51v.77h.15c.13-.26.25-.52.36-.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1714.54,64.93c-.2.04-.41.04-.63-.02,0,.03.02.04.02.07-1.5.17-1.11.31-2.37.97-.55-.08-.45-.71-.79-.97,1,.34,2.25-.68,1.19-.97-.1.76-1.74.19-1.97,0v1.94c-1.07-.94-2.21,1.35-3.16.56-.11.27-.26.47-.44.61-.21.68-1.38,1.58-.75,1.74,1.57-1.14,3.16-1.48,4.74-1.94.53.32.79.86,1.18,1.29,1.24.15,1.54-.46,2.37-.65v.97c.67-.28,1.39-.47,2.13-.62-.17-.25-.33-.51-.51-.75.82.2.87-.28.93-.77-1.11.04-2.07-.17-2.55-.78.3-.19.48-.43.61-.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1704.79,66.4s-.08.1-.12.14c-.05.08-.06.15-.04.22.09-.01.17-.02.25-.04.05-.06.15-.11.27-.14.24-.17.41-.4.57-.64-.39.08-.73.26-.93.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1723.26,67.26c.05,0,.1-.01.16-.02,0-.04-.03-.06-.05-.1-.04.04-.07.08-.11.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1719.92,65.73c.43.43.96.54,1.53.51.05-.06.12-.11.2-.15-.5-.13-1.01-.24-1.4-.46-.11.04-.22.07-.33.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1796.34,61.66c-.1-.08-.19-.15-.29-.23,0,.02-.02.04-.03.06.05.08.09.18.08.29.11-.02.18-.06.24-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1709.83,63.95v-.58c-.34,0-.56.04-.7.1.17.22.36.7.37,1.12.15-.18.25-.4.33-.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1710.62,63.95c1.07-.3,2.7-.29,3.18.57.34-.14.63-.31.94-.46.02-.3,0-.6-.02-.88-.45.26-.95.41-1.44.48-.08.03-.19.04-.32.04-.54.05-1.07.03-1.56,0,0-.28.08-.47.21-.6-.4-.13-.91-.46-1.63.28h.63v.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1765.85,66.02c.18.62-1.59,1.29-1.7.39.13-.14.3-.23.49-.32-.11-.12-.21-.26-.35-.35-.2.2-.37.43-.47.73.52.68,1.25.78,2.24.46.69.66-.29.63.4,1.29.67-.08.89-.59,1.12-.8.07-.27.08-.59-.01-1.01-.87.77-1.14.1-1.71-.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1768.62,67.29c.16-.42.36-.81.58-1.19-.46.37-.79.74-.58,1.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1765.49,65.64c.3-.22.49-.54.36-1.16-.17.19-.37.35-.57.5.08,0,.14,0,.22,0v.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1762.44,65.63c-1.58,1.17,1.29,1.3,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1756.9,67.17c-.42.18-.29.85-.45,1.26,1.07.38.31.23.78-.66-.16-.16-.29-.35-.33-.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1609.44,86.05v.77h1.28c.12-.62-.4-.66-.43-1.16-.34.07-.43.39-.85.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1567.49,93.91c-.58-.11-1.09-.23-1.1-.16-1.26-.34.99-.58.43-1.54-1.09-.05-1.21.77-1.26,1.65.78.16,1.81.36,1.94.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1566.82,95.68c.19-.24.51-.42.88-.53-.26-.09-.56-.13-.87-.13.02.2.02.42,0,.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1568.38,89.57c-.45-.19-.91-.38-1.89-.07.49.2.92.44,1.89.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1529.31,98.38c.5-.06.36-.7.43-1.15-.5.06-.36.7-.43,1.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1563.33,86.46c.71.15,1.47.24,2.21.36-.91-.84-2.35-1.22-4.26-1.16.06.05.14.09.21.13.72.12,1.33.34,1.84.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1567.24,83.74c-.42.01-.33.47-.43.77.42,0,.33-.47.43-.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1568.1,91.45s.04-.04.06-.06c.07-.28.22-.5.37-.71-.1-.02-.18-.03-.27-.05.07.2.04.47-.17.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1530.77,101.5c.14.07.24.17.25.35-.1.1-.26.17-.43.24.62.31,1.74.14,2.13-.24-.04-.67-1.12-.39-1.95-.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1563.41,103.77c.5-.32,1.14-.51,2.13-.38-.08-.15-.13-.28-.19-.41-.24-.15-.48-.3-.72-.46.02.03.03.07.06.1-.42,1.06-.41-1.09-1.21-.08.09.25.21.53.37.85-.16-.02-.29-.02-.44-.02v.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1558.3,85.28c-.31.04-.5.18-.66.36.11.21.18.47.23.8,1.34.18,1.13-1.04,2.13-1.16-.59-1.39-2.7-1.42-4.26-1.93.1.19.21.37.36.52.98.25,1.86.59,2.21,1.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1559.57,87.59c1.69-.45-1.68-.45,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1559.57,90.39c.19.04.29.07.33.07-.05-.01-.18-.04-.33-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1564.23,99.71c-.09.57-.12,1.11-.04,1.62.42-.12.76-.31.94-.64-.19-.43-.49-.75-.9-.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1562.13,92.22h-.85v.77h.85v-.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1559.15,90.29c.06.01.11.02.16.04-.13-.03-.25-.06-.33-.07.04,0,.09.02.17.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1513.12,106.17v2.31c.96-.16-.06-2.11,1.28-1.93-.07-.45-.78-.33-1.28-.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1518.66,88.36c-.63-.79-1.51,1.44-1.7,2.31,1.96.49.68-1.95,1.7-2.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1517.81,78.35c-.66-.31-1.3.1-1.7.24-.07.29-.4.5-.79.63.39.39,2.71.07,2.5-.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1514.82,89.13c.17-.75-1.94-.56-1.28.39-.36.07-.4-.15-.43-.38,0,0-.01,0-.02.01-.78.67,1.03,2.14,1.3,3.06,2.45-.6-1.29-2.11.42-3.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1527.18,99.53c-.69.11-.73-.36-1.28-.38.17-.74,1.95-.03,1.28-1.54-1.01.12-.79,1.34-2.13,1.15-.03.36.07.6.23.78.06,0,.13,0,.2-.01,0-.21.34-.44.43,0-.29-.07-.42.01-.46.17.5.4,1.29.54,1.3,1.38,1.16.28-.31-1.82.85-1.54-.08-.44-.43-.21-.43,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1502.46,109.17c-1.73-.2-2.9-.45-4.19-.3.74.07,1.53.19,2.5.3-.3,1.01.14,1.35.57,1.69h1.7c-.43-.34-.87-.68-.57-1.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1506.4,103.13c-.79.35-1.82.49-3.08.35.68.68,1.01,1.68,1.34,2.67,1.36-.58,1.98-1.74,1.74-3.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1508.43,107.32c-.43-.25-.49-.85-.54-1.45-.81.46-1.39,1.12-2.01,1.75.11.15.17.34.22.54,2.5.32,4.83.87,5.74-2.39.99.12,1.64-.06,2.13-.39-1.59-.66-4.92.43-5.54,1.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1525.9,103.77c.42-.01.33-.47.43-.77-.42.01-.33.47-.43.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1525.48,110.32c-.49.14-.18.27-.05.53h.38c.1-.23-.04-.53-.32-.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1526.76,102.62c1.3,1.05-1.16-1.17,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1525.9,101.85c.05-.78-.12-1.13-.39-1.4.06.4.07.75-.45.63-.01-.73-.61-.93-1.09-1.23,0,.92.64,2.29,1.94,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1521.21,104.54c.42-.01.33-.47.43-.77-.42.01-.33.47-.43.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1520.47,100.53c.31.1.57.27.75.54-1.78-.43-2.9.59-3.89,1.11,1.53,1.11,2.68-1.53,5.24-1.17-.07-.13-.12-.26-.17-.4-.51-.25-1.2-.24-1.93-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1545.96,83.81c.49.35.86.95,1.26,1.47.78.2.39.23-.3.31-.04.17-.15.36-.39.64.49-.45,1.52-.58,2.2-.66.22-.16-.16-.43-.22-.85-.62-.84-1.29-1.61-2.57-.98,0,.03.02.04.03.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1549.78,79.12c-.17.93.78.84.43,1.93-1.76-.1-1.71.46-1.28,1.54-.33-.09-.62-.07-.88-.03.6.4,1.13.08,1.79-.01.26-.14.42-.37.57-.61-.15-.65.13-.97,1.49-.89.35-1.09-.6-1-.43-1.93-2.62.69-1.52-1.96-3.84-1.54.37.54.58,1.04.69,1.49.31.18.74.24,1.45.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1498.68,110.58c0-.06,0-.11,0-.17-.12.03-.15.09,0,.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1545.93,72.18c-.39-.67-.79-1.34-2.13-1.16-.06,1.08,1.04,1.11,2.13,1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1544.23,91.83c-.49-1.35-2.11-1.69-3.41-2.31.76,1.11,1.86,1.91,3.41,2.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1556.33,87.47c.3-.25.41-.67.51-1.1-.17.06-.38.1-.66.06-.02-.14-.05-.25-.08-.37-.96.22.05.66.13,1.22.04.07.08.13.11.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1555.31,83.35c-.84-.66-1.82-1.18-2.13-2.31-.66.08-.87.57-1.15,1,.32.38.73.68,1.14.98.81.02,1.68-.01,2.14.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1553.69,90.99c.33.35.62.72,1.2.84-1.97,0,.71.69.42,1.54-.14,0-.26,0-.37.01.12.13.23.26.37.37-.09.24-.41.53-.8.78.38.62.86,1.43.38,2.3-.21-.06-.38-.07-.52-.06.03.15.04.31.09.45,1.03.16.93-.7,2.13-.39,1.04-1.89-2.43-3.49.42-3.47.28-.85-2.39-1.54-.42-1.54-1.15-.25-1.2-1.49-2.56-1.54,0,.33-.15.54-.34.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1558.29,91.06c-.62.17.04.34,0,.77.54-.09.43-.77,0-.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1538.27,91.06c-.09.01-.19.02-.29.03.08,0,.16.01.24.02.02-.02.03-.04.05-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1541.24,83.74c1.69-.45-1.68-.45,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1536.56,93.37c-1.46,2.25,1.03,2.72,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1536.55,89.74c0-.34.14-.54.43-.61-.04-1.19-1.66,1.18-1.7,0,0,0,0,0,0,0-.19.28-.2.55-.08.78.55.03,1-.03,1.36-.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1538.52,91.13c.49.02.98,0,1.44-.07-.48.47-.37.79.43.77.12-1.39-1.68-1.04-1.7-2.31-.4.26-.91.42-1.61.41.27.59,1.08.69,1.44,1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1541.24,86.82c1.69-.45-1.68-.45,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1551.91,84.51c.39-.03.68.04.89.17.26-.27.41-.58.38-.94-1.34.14-1.4.44-1.84.62-.19.34-.54.63-.95.85.13.23.21.37-.2.46,0,0,0,0,0,0,0,0,0,0,0,0,.03,0,.06.03.09.03.3.05,1.08-.12,1.75-.48-.1-.19-.17-.41-.14-.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1550.34,86.99c-.12.12-.15.17.02.04,0-.01-.01-.02-.02-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1552.34,90.29c.28.01.49.08.68.17.04-.17.05-.34.01-.54-.96.12-.8-.79-1.6-.82.44.11.69.55.53,1.93.21-.17.38-.38.38-.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1549.77,90.29c-2.08.33-.6,1.48-.43,2.7,1.66-.39.07-1.33.43-2.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1551.05,97.22c-.15-.51-.75-.61-.85-1.16-.4.23-.44.77-1.09.78.11.11.2.22.25.38-.02,0-.04,0-.07.01.46.37.9.15,1.76-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1548.92,89.13s0-.02,0-.03c-.14.01-.28.03-.42.03.18-.03.29-.12.38-.24-.29-.44-1.82-.2-1.24.63h.85c-.08-.33.17-.36.43-.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1551.9,85.67c-.28,1.05.29,1.35.4,2.05.2.46.37.94.55,1.41,1.17-.19.76,1.06,2.03.78-.58-1.15-.83-2.59-1.68-3.48,0,0,0,.01-.01.02-.84,1.27-.29.44.01-.02-.33-.35-.74-.62-1.3-.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1552.75,93.76c.37.07.57-.01.69-.17-.17-.17-.33-.36-.49-.54-.13.18-.2.41-.19.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1558.06,87.54c-.06.02-.11.04-.18.05-.86-.23-.41-.34.02-.33-.01-.02-.02-.03-.03-.05-.89-.21-.9,1.5-.43.38.74.36.87.4.62-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1552.76,97.61h1.7c-.17-.23-.33-.46-.39-.78-.42.14-.6.5-1.3.39,0-.02,0-.05-.02-.08.01.14.01.29,0,.45,0,0,0,0,0,.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1557.87,99.15c.07-.96-.66-1.21-1.28-1.54-.5.02-.85.14-1.1.32.41.24.74.56.69,1.22-.47.51-1.06.84-1.64,1.03-.02.05-.05.09-.08.13.81.23,2.39-.05,3.41-1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1554.29,84.59c-.19-.06-.41-.1-.69-.08-.08.84.35,1.23,1.28,1.16.02-.23,0-.43-.06-.59-.23.02-.49.09-.78.2-.06-.36.07-.55.25-.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1554.88,86.44s0-.01.01-.02c0,0,0,0,0,0,0,0,0,.01-.01.02h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1554.46,87.08h0s-.03.04,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1469.65,109.94c-.18-1.67-2.47.41,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1459.42,103.39c.34,0,.35-.32.39-.59-.09-.03-.19-.07-.28-.1-.02.19-.05.4-.11.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1457.71,104.54c.75-.09.97-.66.85-1.54-.57.25-.8.82-.85,1.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1459.6,101.8c.07.03.15.04.25.04.12-.27.17-.54.2-.8-.07,0-.13,0-.21.03-.15.34-.21.54-.24.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1451.33,83.84c.22-.02.45-.08.74-.17-.21-.08-.44-.18-.74-.31,0,.15,0,.32,0,.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1451.32,87.59c1.16-1.17-1.3,1.05,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1460.27,84.51h.85v-1.15h-.85v1.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1454.73,83.35c-.98.31-1.43.5-1.9.49-.25,1.26,2.41,1.01,1.05,1.82-.03-.23-.06-.46-.43-.39-.31.08-.58.36-.83.68.21.38.16.82-.46,1.24,1.29,1.14,1.87-1.63,2.98-1.93.36-.07.4.15.43.39,1.51-.9-1.97-.49-.85-2.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1462.4,94.53c-.41.01-.33.47-.43.77.41-.01.33-.47.43-.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1449.96,86.52c-.04.15-.12.26-.3.29.53-.15.5-.24.3-.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1470.08,103.39c.71-.61.11-.78-.26-1.23-.29-.02-.63,0-1.03.07,0,.02-.01.04-.02.05.6.21.96.65,1.3,1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1461.98,107.24v.75s0,.01,0,.02c0,0,0,0,0,0v.38c.89.16,1.13-.26,1.7-.38-.1-.68-.73-.88-1.7-.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1462.41,102.62c-.04.12-.05.27-.08.41.26.04.55.04.92-.02.04-.61-.2-1.47.43-1.54.08-.33-.17-.36-.43-.38-.12-.3-.28-.53-.41-.8-.33.19-.66.21-.86-.36.36-.05.58-.18.69-.34-.01-.16,0-.34.02-.55-.06-.18-.19-.36-.34-.54-1.18.37-.48,1.38-.61,2.62.18.03.3.12.24.36-.57.06-.43.77-.42,1.35.16.06.33.11.51.16.04-.19.11-.34.35-.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1462.43,97.6c1.4.15,3,2.08,1.25,2.32.42,1.18,1.44-.17,1.71-.39-.43-1.54-1.82-2.21-2.56-3.47-.45.2-.68.61-.79,1.12.13.14.26.27.39.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1464.11,102.62c-.41.01-.33.47-.43.77.42-.01.33-.47.43-.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1434.28,104.22c.14.09.29.19.43.33-.26-.12-.51-.13-.74-.1-.04.03-.08.06-.12.1.39,1.05,1.33-.54,2.56,0-.73-.7-1.46-.73-2.12-.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1436.83,94.14c-.83.04-1.36.36-1.58.95.25.19.64.26.74.59-.34-.07-.62-.07-.85-.04,0,.01,0,.02,0,.04.76.72,1.08-.31,2.56,0-.18-.6-1.34-.33-.85-1.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1440.67,96.45c1.03-1.29-1.43.93,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1437.68,99.53h.85v-.77h-.85v.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1436.4,97.22c1.41-.56-1.66-.96,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1449.62,86.82s0,0,0,0c.03-.1.05-.22.06-.33-.44-.01-.96.1-.07.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1435.08,100.61c-.15.45-.66.58-1.15.72.25.95.92,1.52,2.05,1.68,1.32-.39-1.21-.38-1.28-.77-.03-1.31,2.19-.59,2.13-1.93-.96-.24-1.37.02-1.75.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1465.69,105.99c-.09.04-.19.07-.3.09-.51-.43-.77-1.1-2.13-.77,1.86-.92-.9-.53-.85-1.93-.46.5-.42.93-.25,1.33.03.03.05.07.04.1.06.14.14.28.21.41.66.07.9.52,1.29.85.54-.08.87-.6.85.39-.9.01-1.61.04-2.21.09-.09.1-.2.19-.36.29,1.04-.21,2.11-.36,4.26-.38,0-.1,0-.18,0-.26-.19-.05-.37-.13-.54-.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1446.64,92.22c-.69-.18-.53-.29-.21-.32-.46-.14-1.05-.09-1.49.08.34.17.54.47.44.95.51.37,1.09.6,1.69.06.1-.38,0-.66-.18-.84-.07.02-.14.05-.24.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1439.39,91.83c-.09.08-.16.18-.21.29.18.19.27.46.22.86-.16-.04-.32-.04-.46-.02-.11.41-.28.77-.83.79.86,1.12,1.58-1.11,2.98-.77.13-1.01-.59-1.26-1.7-1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1443.88,90.63c-.09.13-.17.28-.23.43,1.14.83,1.48-.34,2.51-.79-1.14-.37-1.78-.04-2.28.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1448.34,92.22c1.69-.45-1.68-.45,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1441.53,94.14v.02c.37.56.64,1.21,1.7,1.14v-1.54c-.89-.16-1.12.26-1.7.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1441.13,88.93c-.02-.05-.03-.11-.04-.18-.83-.15-.62,1.76.43,1.16.09-.47-.19-.61-.34-.86-.1-.03-.11-.07-.05-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1515.43,77.6c.08.12.15.24.24.36.06-.25-.06-.33-.24-.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1511.26,89.34c.04-.08.08-.15.16-.21,0,.02,0,.04,0,.05.41-.5-1.65-.15-.44.33.11-.07.2-.12.27-.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1507.58,80.27c.18-.81-.29-1.02-.43-1.54-.75-.12-.76,2.16.43,1.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1510.56,90.29c-.72.65-.34,2.26,1.28,1.93.09-1.1.05-2.1-1.28-1.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1507.15,71.41h-.85v.77h.85v-.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1513.55,82.58c1.22-.88-.6-2.26,0-3.85-.75-.09-1.31,0-1.75.18-.15.55-.03,1.07.12,1.55.59.66,1.51,1.03,1.62,2.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1512.25,74.98c0,1.77.22,3.34,2.15,3.37-.26-.15-.53-.42-.75-.76-.03,0-.06,0-.09-.01,0-.04,0-.08.01-.11-.24-.39-.42-.84-.44-1.26-.41-1.63.37-2.6.54-1.1.19-.11.43-.19.73-.23.19-.86-1.32-2.09-.43-2.31-.28-1.15-.91.36-1.7,0,0,0,0,0,0,0,.02.32.02.66.01,1.01.23.42.51.9.43,1.3-.17.02-.32.06-.45.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1507.15,81.14c1.72.98,2.14,3.14,4.7,3.37-.52.08-.26.43,0,.77h1.7c-.26-.34-.52-.69,0-.77-3.23-.29-3.04-3.68-6.4-3.85v.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1513.12,99.62c-1.7-.72-3.16-.17-3.41-1.54-.52.43-.77,1.1-2.13.77.52.83.67,1.67.5,2.4.31.98,1.4.77,2.75,1.16.19-.04.38-.08.59-.09-1.06-1.6.75-1.88,1.7-2.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1500.27,107.19c-.01-.13.23-.16.47-.12.28-.15.59-.45.87-.98-1.76.34-1.82,1.05-1.34,1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1501.61,107.24c-.82,0-.57.97-1.6.78-.02.03-.04.06-.06.09.33.72,2.43.36,1.67-.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1466.66,108.01c1.66-.96-1.41-.56,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1496.5,107.24c-1.3.85.49,2.47,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1502.36,107.56c-.08-.17-.18-.33-.28-.49-.18.05-.2.2.28.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1503.32,94.53c.31-1.05-.85-.78-.85-1.54-1.04.24-.22,1.95.85,1.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1508.54,90.89c.04-.22.15-.42.31-.58-.19-1.5-1.25-4.21-3.29-3.15.81.51,1.32,1.73,1.52,2.7.43.39.92.73,1.46,1.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1471.35,101.08c-.47,1.49,1.51,1.37.42,2.31-.26-.35-.54-.69-.93-.93.1.38.21.74.52.93-1.4-.28-1.25,1.98-1.59,2.66.37-.22.65-.58.73-1.12.89.22.9.6.42,1.15,1.14,1.01.28-3.06,2.13-2.7-.84-.53-.27-2.32-1.7-2.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1479.45,110.32h.85v-.77h-.85v.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1478.17,103.77c1.68-.45-1.69-.45,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1477.74,105.7h.85v-1.16h-.85v1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1534.86,104.54c.15-.31.15-.61.1-.89-.25-.53-.64-.95-1.38-1.03-.18,1.32.13,2.2,1.7,1.93-.02-.06-.04-.12-.05-.18-.11.05-.23.11-.36.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1469.42,106.21c-.06-.03-.12-.07-.19-.13.48-.55.46-.94-.43-1.15-.09.66-.49,1.06-1,1.25.52.17,1.11.2,1.61.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1515.43,77.6c-.05-.08-.11-.17-.16-.25-.01.08-.01.14-.03.23.06,0,.13.01.18.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1515.28,77.35c.64-5.05-1.58-2.8,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1494.79,107.25s0,0,0,0c.03.14.05.27.06.38h.78v-.77h-.85v.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1490.1,106.08c-.08-.33.17-.36.43-.38-.03-.09-.07-.14-.11-.18-.06.06-.15.12-.31.18-.06-.04-.1-.07-.15-.1-.19.08-.42.16-.71.1.02.24.12.41.28.53,0,0,0,0,0,0,.38.29,1.1.28,1.85.24-.07-.45-.78-.33-1.28-.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1497.54,109.61c.24.08.49.1.76.09-.2-.1-.46-.11-.76-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1492.66,106.86c1.69-.45-1.69-.45,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1491.81,105.7c1.41-.56-1.66-.96,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1624.35,62.55c-.52.17-.88.49-.85,1.16.91.18.81-.55.85-1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1609.01,70.26c-.19.23-.37.46-.55.7.16.05.34.08.55.07.19-.17.27-.43.35-.7-.39-.54-.66-1.21-1.63-1.22.08.33-.17.36-.43.39v.32c.18.24.33.5.53.72.26.01.37-.29,1.17-.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1620.94,72.57c1.3,1.05-1.16-1.17,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1614.56,71.41c-.3,1.35-.83,3.38.15,4.37.18-.16.31-.44.27-.9.46.1.29.77.85.77-.53.57-1.19,1.03-1.95,1.39-.16.44-.25.95-.46,1.36.36.13.69.28.71.72,1.75-.22.81-2.86,2.56-3.08-1.37-.86-.76-3.16-.43-4.62-.73.14-.8-.3-.85-.77-.78.04-1.26.11-1.68.16.06.4.19.74.83.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1620.94,79.5c.42,0,.33-.47.43-.77-.41.01-.33.47-.43.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1622.22,72.95c-.42,0-.33.47-.43.77.41-.01.33-.47.43-.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1615.4,83.35c-.86.78.19.75.42,1.54,1.24-.07,1.03-1.83-.42-1.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1621.8,77.58s.04-.01.06-.02c.02-.48-.03-1.03-.07-1.58-.02-.07-.03-.15-.02-.22,0-.03,0-.07,0-.1-1.19.33.28,1.24.03,1.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1613.9,75.86c.07-.07.16-.14.23-.21-.56,0-.39-.67-.85-.77.01.16,0,.29-.02.41,0,0,0-.02.01-.03.13.28.37.49.63.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1610.29,72.55s0,.01,0,.02c0,0,0,0,0,0,0,0,0-.01,0-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1608.58,66.4c-.28,1.41.92,1.48.85,2.7.84-.42.73-3.2-.85-2.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1622.65,82.97c.17-.09.26-.14.3-.16-.23.12-1.92,1-.3.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1612.85,79.5c-.31,1.05.85.78.85,1.54.56.19.19-1.91-.85-1.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1614.12,68.33c-.41.01-.33.47-.43.77.42,0,.33-.47.43-.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1614.12,70.26c1.68-.45-1.68-.45,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1621.37,74.88c-.1-.68-.73-.88-1.7-.77.28.52.91.72,1.7.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1629.04,87.59c.18.16-.28-.25,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1626.06,78.73c.34.2.69.4,1.28.39v-.76c-.12-.02-.25-.04-.42-.01,0-.13.01-.26.01-.39h-.88v.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1628.19,86.82c.35-.07.43-.39.85-.38v-.77c-.91-.18-.81.55-.85,1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1631.6,78.35c.09.08.17.16.25.25.06-.1.03-.21-.25-.26,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1627.34,81.43c-.81.04-.3,1.27-1.28,1.16-.33.06-.39-.12-.42-.33v.64c.38.34,1.08.64,1.7.46v-1.93Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "1632.02 79.89 1632.02 79.89 1632.02 79.89 1632.02 79.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1624.78,71.8c-1.3.46.46,2.04,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1624.35,79.5c.48-.08.56-.28.5-.52-.18-.07-.34-.16-.49-.25v-.74c-.04-.15-.02-.27.13-.34-1.37.21,1.35-2.99,1.14-1.61.92.07.19-1.37.43-1.93-.67.51-1.04.74-1.72.63.07.62.26,1.35-.4,1.3.07-.44-.16-.41-.46-.18.09,1.16.28,2.42-.4,2.88.1.55,1.27.13,1.28.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1623.91,82.21s.01-.01.02-.01c0,0,0,0,0,.01.14,0,.28,0,.42-.01.34-.85.85-1.54,2.13-1.54-.18-.47-.54-.79-1.28-.77-.22.18-.43.31-.62.42.08.1.15.22.2.35-1.27,0-1.79.69-2.13,1.54-.04,0-.07,0-.11,0,.41.04.89.03,1.36,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1623.5,74.49c-.01.05-.01.11-.02.17.07-.03.14-.06.21-.1-.06-.02-.12-.04-.19-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1592.09,90.07c.06.12.15.2.31.22.59-.02.94.18,1.28.38.1-.66.01-1.15-.18-1.54h-1.52s0,.01,0,.02c.49.75.42.87.12.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1626.95,85c-.03.21-.01.46-.05.67.34-.04.38-.34.4-.68-.16.16-.26.22-.35,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1623.93,85.67c.34.2.69.4,1.28.38v-1.15h-1.28v.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1599.14,95.67c-.1-.01-.2-.03-.27-.07-.04.15-.04.33-.09.47.26,0,.32-.19.35-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1596.46,91.75c-.11.56-.2,1-.31,1.4.22.16.49.26.92.22-1.86.62,1.03.98-.85,1.16.28.39.98.4.85,1.16.29-.89.48-1.48.64-2.03-.06.03-.12.07-.21.11-1.88-.09-.19-.44.27-.34.19-.71.34-1.43.57-2.74-.57.39-1.29.64-1.71,1.16-.08-.02-.14-.05-.19-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1597.08,102.62c.18.16-.28-.25,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1598.36,90.29c.07-.3.04-.52-.02-.7-.25-.19-.42-.45-.53-.76-.77.45-.96,1.62.55,1.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1534.92,97.23c.07.17.31.31.79.38-.05-.19-.19-.3-.3-.44-.16.03-.32.05-.49.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1598.78,81.43c1.41-.56-1.66-.96,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1601.34,82.2c.68.11.6-2.08-.43-1.16.16-.15.46,1.16.43,1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1600.49,84.39c0-.08-.01-.16,0-.26h.22c.28-.45.32-1.11,1.05-1.16-.15-.6-.75.34-.85-.38-.5.58-1.23.94-1.28,1.93.41.08.67.01.85-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1592.81,83.74s.06-.07.08-.11c.03-.1.07-.2.12-.29-.25.11-1.23,1.07-.2.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1601.35,92.58c.43.26.98.41,1.7.41v-1.32c-.32.24-.59.4-.92.32.02.08.03.14.07.23-.35.02-.46-.17-.48-.44-.11-.08-.23-.19-.36-.33v1.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1592.39,80.66c-.38.01-.35.39-.41.69.02.02.04.04.06.06.31-.08.26-.47.35-.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1594.95,81.43c1.68-.45-1.68-.45,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1593.62,81.3s-.04.02-.06.03c.03.03.06.06.1.1.71.58.29.17-.04-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1595.38,84.51c.03.41-.02.75-.12,1.05.42.21.8.45.97.88.63-.33.92-.97.85-1.93-2.1.62-.86-.41-.43-1.54-.34.27-1.17.6-1.28,0-.22,0-.37.07-.49.17-.1.21-.21.42-.33.61-.08.31-.14.65-.31.89.11.1.44.08,1.13-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1596.11,91c.13-.22.22-.47.26-.71-1-.02-1.01-.75-.55-1.24-.22-.14-.49-.25-.87-.3.36.45.56,1.03.43,1.93-.21-.13-.44-.25-.71-.32-.08.4-.28.8-.56,1.09.43,0,.51.31.85.38.29-.36.73-.59,1.16-.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1605.17,66.4c-1.15.46,0,2.01,0,2.7,1.29-.58-.35-1.69,0-2.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1607.73,82.2c-1.37.91,1.5,1.56,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1604.32,73.34c1.46,1.72.83,3.04,2.56,4.62,1.98-1.01-2.16-3.12,0-3.08-.02-.1-.05-.18-.1-.26-.22-.02-.45-.05-.75-.13-.02-.12-.03-.23-.04-.35-.63-.21-1.28-.39-.82-1.58-.95-.21-.61.74-1.28.77.08.44.43.21.43,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1607.31,87.98c.63-.17-.17-.49,0-1.16-1.04-.27-1.25.22-1.63.54.14.31.37.5-.06.62-.06-.32-.44-.26-.86-.07v1.95c.03-.23.15-.38.41-.4-.05-.18-.07-.4.01-.71.34-.38,2-1.47,2.13-.77Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "1607.31 70.26 1607.31 70.26 1607.31 70.26 1607.31 70.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1606.45,83.74c1.68-.45-1.68-.45,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1606.03,86.44c-1.29-1.43-1.44,1.17,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1603.63,89.81c0-.4.58-1.02.67-1.68-.36.22-.7.47-.83.62-.14.52,0,.8.15,1.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1601.59,87.96c.09-.11.16-.22.17-.37.31.04.34.31.27.66.15-.06.33-.14.59-.27-.01,1.17-1.8,2.22.43,2.31v-2.7c.11.02.2,0,.3,0,.04-.22.09-.47.12-.77-.93.17-1.29.17-1.71.13-.06.43-.13.77-.16,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1598.98,86.35c-.07.04-.12.09-.18.13.06.12.12.24.16.37,1.14.07,1.28.21,2.32.05-.29-.03-.66-.07-1.22-.08.31-.36.78-.58,1.28-.77,1.01-.64-1.53-.03-2.36.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1604.28,74.14s.03-.02.05-.03c-.05,0-.09,0-.14,0,.03,0,.06.02.09.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1599.21,93.76c1.63-.75-2.59-.12,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1603.04,84.13h-.85c-.12.62.4.66.43,1.16.52.12,1.47-1.11.43-1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1629.47,75.31c.59.09,1.06.3,1.28.72-1.04-.15-1.62.52-2.15.97.05.4.04.86,0,1.34.49-.06.76.08.85.39,1.01-.11-.49-1.03-.43-1.54.22.16.42.21.6.19.07-.06.15-.12.26-.19,0,.03,0,.06.01.09.18-.1.36-.25.55-.42.09-.16.22-.27.4-.34.41-.32.89-.59,1.59-.49-.41-.79-1.64-.83-2.98-.77,0,.02,0,.03,0,.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1596.65,95.68c-.41.01-.33.47-.43.77.41-.01.33-.47.43-.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1559.11,103.99c-.19.25-.66.25-1.66-.22-.36,1.23.67,1.19.85,1.93h1.7c-.17-.69-1.07-.71-.89-1.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1557.32,100.77c-.11.08-.2.16-.29.26.09-.05.19-.14.29-.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1560.41,95.22c.31-.1.52-.29.69-.51-.06-.22-.23-.5-.25-.95-1.2.32-.53.57-.44,1.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1559.99,99.99c-.07.3-.03.69-.41.7.09-.3.02-.75.42-.77h0c-.03-.92-1.16,1.66-1.57,1.03.29.99.88,2.23.76,2.84,3.46,1.59.6-2.45.8-3.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1555.71,102.32s.03-.05.03-.09c-.09.02-.15.03-.22.05.06.01.13.03.18.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1552.76,104.54c0-.13-.04-.22-.1-.3-.18-.09-.43-.13-.77-.09.1.52,0,.86-.28,1.03.06.15.14.29.23.41.41-.02.89-.17,1.76.1-.28-.32-.37-.81-.62-1.16h-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1554.46,104.54h.77c-.28-.1-.6-.16-.86-.29.05.08.09.16.09.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1571.93,97.22c1.68-.45-1.68-.45,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1569.8,91.83s.04-.03.06-.04c-.02,0-.04,0-.06-.01,0,.02,0,.04,0,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1568.1,101.46c.58-.49.58-1.82,0-2.31,2.1,1.23,1.27-1.87.43-2.31-.64-.08-1.13-.02-1.54.11.78.7,1.38,3.35-.58,2.2.37.31.5.96.4,1.52,0,0,.01.02.01.03,0,.01-.02.02-.03.04-.06.3-.19.57-.39.73,2.21.05,2.39,1.95,3.41,3.08-.19-.02-.31.02-.41.07.33.32.62.66.83,1.08.81-.04.3-1.27,1.28-1.16-1.02-1.13-1.2-3.03-3.41-3.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1570.24,93.76s0-.05-.01-.08c-.51-.28-1.06-.52-1.7-.69.7.61.79.9.57,1.02.67.42,1.3.89,1.99,1.29-.59-.12-.99-.07-1.31.04.24.17.41.41.45.73.76-.34,1.08-1.08,2.56-.77-.86-.49-1.61-1.09-2.47-1.57-.03.01-.05.03-.08.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1561.28,100.69c.41-.01.33-.47.43-.77-.41.01-.33.47-.43.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1565.57,95.33c-.06.03-.11.06-.16.1-.15.57-.32,1.13-.49,1.67.3-.15.65-.26,1.08-.28-.09-.33.04-.75.39-.75-.21-.3-.67-.38-.82-.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1563.84,94.91c-.01.07,0,.13,0,.19.08-.34.12-.66.12-.96-.04,0-.07,0-.11,0,.01-.2.02-.39.04-.58-.02-.06-.02-.13-.05-.19-.73.48-.81,1.54-1.73,1.84-.03.1-.06.2-.09.3,1.37,1.05-.31,1.35.54,2.86.29-.66.71-1.55,1.02-2.44.1-.34.19-.68.26-1.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1563.88,104.74c-.03.37-.18.63-.45.78,0,.06-.02.11-.02.17,1.46.16,2.43-.12,2.13-1.54-.55.76-1.21.43-1.66.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1551.9,103.77c.46-1.44-1.06-1.1-.85-2.31-.47.29-.72.79-.95,1.3.17.21.27.5.11,1.02-.3-.04-.49-.05-.61-.04-.05.07-.1.13-.15.2.12.24.61.61-.1.61,0-.23-.08-.33-.19-.35-.12.09-.26.17-.42.23-.12.13-.22.29-.26.47.38.19.9.25,1.38.34.18-.08.28-.23.33-.42,0,0,0-.02,0-.03.04-.18.05-.38,0-.63.26-.04.45,0,.62.04.04,0,.07.01.1.03.15.07.27.17.36.29.62-.15-1.08-1,.63-.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1632.02,69.48c-.42.01-.33.47-.43.77.41-.01.33-.47.43-.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1540.74,97.1c-.31.37-.94.45-1.19.89,1.78.28,2.16-.7,3.04-1.24.04-.18.03-.39-.06-.69-.34.58-1.03.84-1.79,1.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1544.42,98.05c-.07-.2,0-.35.09-.31.06-.42-.1-.77-.09-1.06-.41.22-.72.53-1.07.81-.04.25-.13.45-.39.5-.03-.1-.06-.15-.09-.19-.06.03-.11.06-.17.08,0,.13.06.32.27.5h1.28c.08-.11.14-.22.18-.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1535.85,96.24c.15.13.26.32.29.59-.11.11-.26.18-.43.25.67.25,1.69.17,2.13-.25-.1-.98-1.17-.94-1.99-.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1544.63,98.35c-.11.03-.24.04-.39.03h.42s-.02-.02-.03-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1537.85,104.16c-.12-.01-.21,0-.27.04.39,0,.5.28.55.62.24-.29.42-.52-.27-.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1539.01,105.7h-.75c.42.15.64.13.75,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1547.82,101.96c.17.43.29.87.24,1.43.02,0,.03-.02.05-.02.35-.69.57-1.5,1.24-1.91-.05.28,0,.46.09.62.28-.44.58-.86,1.18-1-.34-1.24-1.55-1.68-2.13-2.7-1.09,1.67-.1.45-1.69,0,.58,1.01,1.79,1.46,2.13,2.69-.55.13-.85.49-1.1.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1546.79,98.39s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1548.49,109.94c1.03-1.29-1.43.93,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1547.64,97.99c.09-.29.09-.51.05-.68-.15-.09-.3-.24-.47-.47.07.01.13,0,.2,0-.24-.24-.54-.41-.63-.78-1.42.41-.03,1.17-.85,2.31.77.05.9-.47,1.7-.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1547.21,94.53c1.5.8.15-2.33-1.7-1.93-.09,1.24,1.52.94,2.13,1.54.08.33-.17.36-.43.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1543.8,103c.04,1.44.48,1.1,0,2.31.98.23,1.55-2.67,0-2.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1545.51,81.81c.28.07.47.06.63,0,.28-.55.52-1.12.58-1.77-.47-.38-1.15-.57-2.06-.55.2.36.51.61.72.96.04.07.11.12.14.2-.01,0-.02.01-.03.01.12.28.15.64.02,1.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1539.97,103.39c-1.22-.18-1.14-1.54-2.13-1.93-.71-.42-.86.32-.97.65.36.53.6,1.16,1.41,1.28-.55.28.24.69.81,1.26,0-.3.08-.53.46-.49,1.01.2.17.6-.03,1.11.05.14.06.28.03.43h1.7c.23-1.14-2.13-1.88-1.28-2.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1644.38,92.99c.24-.1.35-.19.37-.27-.21-.12-.45-.22-.7-.3-.24.03-.32.2.33.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1643.96,96.45h-.85v.77h.85v-.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1640.97,100.31c.41-.01.33-.47.43-.77-.42.01-.33.47-.43.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1640.53,102.63c.06.4-1.36.46-.4.76.68.14,1.07.03,1.44-.11-.44-.28,1.47-.34.26-1.05-.57.11-.97.25-1.3.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1644.33,86.62c.43-.52.59-1.24.05-1.73-.68.03-.84.52-.87,1.14.37.05.63.28.81.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1643.97,89.13c.09.25.15.45.2.62.32.15.69.22,1.07.15-.45.41-.48,1.21-.44,2.06,1.07.41,2.62.62,2.18,1.11.16.12.3.26.44.4.45-.07.87-.25,1.18-.33.5-.43-.42-.65-1.39-.93-.51,0-1.02,0-1.11-.37.01,0,.02-.02.04-.02-.21-.11-.38-.22-.47-.36.38-1.13.38-1.18,0-2.31-1-.5-.79.05-2.13-.38.22-.31.44-.62.43-1.16-.82.22-.95.79-.69,1.32.17,0,.36.05.69.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1636.29,77.58c.41-.01.33-.47.43-.77-.42.01-.33.47-.43.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1646.09,87.59c.08.33-.17.36-.43.39,1.02,1.18.91-2.32-.85-1.93-.37,1.24.66,1.21,1.28,1.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1635.31,72.9s.07.04.14.06c.1-.59.7-.06.85.38-.53-.13-.89-.1-1.16,0-.04.13-.1.24-.12.39.5-.06.76.08.85.39.51-.44.77-1.1,2.13-.77-.15-.44-.75-.98-.85-.38-.63-.17.17-.49,0-1.16-.88.12-1.49.5-1.83,1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1633.98,71.04c.46-.03.56-.38,1.03-.4.73.12-.55,1.34,1.28,1.16.12-.69-.4-.79-.43-.38-.63-.17.17-.49,0-1.16-.51.11-1.41-.13-1.89.02.06,0,.13,0,.19-.02.09.34-.08.6-.18.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1637.14,82.2c.88.34,1.91-1,.85-1.16.19-.34.37-.69.85-.77-.08-.44-.43-.21-.43,0-.5-.06-.36-.7-.43-1.15-.63.71-.82,1.83-.85,3.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1641.83,98.76c-.28-.25.18.16,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1637.56,87.59c.55-.03.02-2.3-1.28-1.92-.2,1.21,1.15,1.02,1.28,1.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1648.22,89.9c.08.31.43.38.43.77h.85c.28-.94.86-1.98-.85-1.93.08.31.43.38.43.77-.01.37-.52.3-.85.38ZM1649.51,89.52c-.28-.25.18.16,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1656.32,85.67c-.07-.45-.78-.32-1.28-.39v1.16c.95.21.61-.74,1.28-.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1665.69,82.58c1.16-1.17-1.3,1.05,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1651.2,89.52c.18.16-.28-.25,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1651.2,95.68c.18.16-.28-.25,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1649.92,96.84c.08.31.43.38.43.77-.09,0-.16,0-.24-.01.09.13.17.26.25.4-.26.25-.69.35-1.18.38,1.11.01,2.34.13,2.88-.38-.39-.68-.79-1.34-2.13-1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1645.66,82.2c-.41.01-.33.47-.43.77.41-.01.33-.47.43-.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1649.5,92.22c-.12-.89-1.14-.89-1.7-.39.13.52,1.07.32,1.7.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1570.23,89.52c-.83.35-1.27.27-1.66.12.08.44.29.76.57,1.01.27-.08.61-.09,1.1.02-.12.17-.24.35-.32.56.14.09.28.19.41.29.47-.12.82.27,1.62.3-.36.31-.26,1.05-.84,1.15,0,0,0,0,0,0,0,0,0,0,0,0-.08.33.17.36.43.38.36-.07.4.15.43.39.46-.1.29-.77.85-.77-.04-1.89-2.38-1.7-2.56-3.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1569.8,86.44c.14.03.26.08.39.12,2.04.45,4.02,1.8,4.97,3.41.53.2,1.15.32,1.89.32-1.13-2.33-4.52-4.2-7.25-3.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1649.08,93.76c-.66-.17-1.01-.05-1.24.16.28.32.54.66.81.99.76-.34.54-1.56,2.13-1.15.19-1.2-.67-.43-1.67-.29,0,.08,0,.17-.02.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1648.99,96.84c-.2-.31-.39-.63-.77-.77-.46.76-.73.46-1.05.59.32.48.56,1.02,1.48.95,0-.39-.34-.46-.43-.77.3-.04.55-.03.76,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1121.33,36.85c.07-.19.19-.34.33-.47v-1.44c-.55.06-1.05.16-1.52.29-.08.93-.05,1.76,1.18,1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1121.33,37.5c-2.03.78,1.36.84,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1117.78,36.21c-1.04.1-.31-1.25-1.58-.97-.49.98,1.31,1.68,1.58.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1116.59,37.18c-1.56.37,1.56.37,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1115.04,35.86s-.02.02-.03.03c0,0,0,0,0,0,.02-.01.02-.01.02-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1106.72,36.85c.09.61-.45.71-.39,1.29,1.15.09,1.52-1.25.39-1.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1085.41,33.62c-.36,1.18,2.61.74,2.37,0-.92.1-1.63.63-2.37,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1084.22,33.3c-1.56.37,1.56.37,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1068.43,38.47c1.1-1.55-1.29-.78,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1065.27,36.85c.09.25.01.64.39.65-.09-.25-.01-.64-.39-.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1051.85,33.3c-.06.8.2,1.34.79,1.62.66-1.03.84,1,2.37.32v-.97c-1.19,0-1.55-.35-2.37-1.29-1.63-.25-2.03.5-3.55.32-.33,2.18,2.67,1.1,2.76,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1051.46,42.35h-.79v.65h.79v-.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1047.9,32.97c-1.22.24-.76-.89-1.97-.65-.5,1.09-1.04,1.88-.4,2.59.26-1.07,1.78-1.13,2.37-1.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1047.11,28.77c-.73.05-1.32.21-1.58.65.7.6,1.22-.08,1.58-.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1044.74,40.09c-1.56.37,1.56.37,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1042.77,34.27c.35,1.04-1.02.67-1.18,1.29,1.67.46,2.73-.99,1.18-1.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1040.4,35.88c-.7.19-1.64-.95-1.97,0,.24.19,1.87.76,1.97,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1036.06,34.91c-.93-.23-2.5-.74-2.37.65,1.05,0,2.32.18,2.37-.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1028.16,34.91c-.09-.25-.01-.64-.39-.65.09.25.01.64.39.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1026.98,36.85c1.2-1.09-1.46-.98,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1024.22,24.89c-1,.04-1.53.47-1.58,1.29,1-.04,1.53-.47,1.58-1.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1004.87,41.7c-1.56.38,1.56.38,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1004.08,44.94c-.09-.25-.01-.64-.4-.65.09.25.01.64.4.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1002.5,39.44c-.35.68-1.2.95-1.18,1.94.99.03,1.93-1.62,1.18-1.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1000.14,29.74c.11-.2.98-1.24,0-1.29-.12.2-.98,1.24,0,1.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M998.56,22.63c-2.76.55-4.69,1.76-4.34,4.85,3.53.09,4.18-2.18,4.34-4.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M988.69,38.47c-1.56.37,1.56.37,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M988.69,40.41c-1.54.81,1.31.47,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M986.32,41.38c-.29-.99.4-1.18.39-1.94-.54.01-.87-.15-1.18-.32-.52,1.07-2.2,2.33.79,2.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M980,44.29c-1.03-1.58,2.95-2.24-.39-3.23-1.17.88-1.26,3.25-1.18,4.53.59-.38.46-1.34,1.58-1.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M976.06,43.64c-.31-1.12.44-1.37.79-1.94-1.64-.67-1.48,1.76-.79,1.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M970.53,43.64c1.1-1.55-1.29-.78,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M962.24,46.88c-.26.21.17-.14,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M958.29,42.03c1.5-1.58-1.39-1.19,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M953.16,59.48c-1.54.8,1.31.47,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M953.16.65c-.09-.25-.01-.64-.39-.65.09.25.01.64.39.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M951.58,49.78c.43-.32,1.48-1.76.4-2.26-.57.74-1.78,1.63-.4,2.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M951.18,80.82c-1.56.38,1.56.38,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M950.79,70.48c-1.56.37,1.56.37,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M948.82,70.8c1.45.11,1.19-1.18,1.58-1.94h-.79c-.24.02-.47.05-.4.32.22,0,.45.26,0,.32-.02-.2-.06-.38-.39-.32.23,1.03-.74,1,0,1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M950,72.42c.32-.11.48-.86,0-.97-.91-.21-.85,1.26,0,.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M949.61,53.66c-2.4.1,1.5.63,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M949.61,58.51c-.12.44-.56.62-.4,1.29,1.1.52,1.09-1.39.4-1.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M949.61,62.39c.09.25.01.64.39.65-.09-.25-.01-.64-.39-.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M947.63,70.8c.52,0,.36.57.79.64.15-.46.47-.55,0-.97-.31.07-.78,0-.79.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M948.42,53.34h-.79v.65h.79v-.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M947.24,68.53c-1.56.38,1.56.38,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M946.84,13.25c.31-.22.88-1.8,0-1.94.11.57-1.11,1.61,0,1.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M943.68,49.14s-.24,1.09-.39.97c.95.78,1.02-1.06.39-.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M942.11,61.42c-1.24.06-2.18-1.76-2.76-.32.64.84,1.82,1.2,2.76.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M941.32,30.71c.17-.14-.26.21,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M937.37,43.32c-1.54.8,1.31.47,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M931.45,13.25c-.33.38-.52.87-.4,1.62,1.22.13,1.61-1.56.4-1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M928.29,13.25c.96-.97,1.27-2.18.79-3.56-1.97-.34-2.19,3.16-.79,3.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M921.97,11.96c-.63.58-1.38,2.73-.4,3.56.02-1.08,1.51-2.62.4-3.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M921.97,19.4c-.23-.57.48-1.9-.4-1.94-.45.62-1.52,1.99.4,1.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M918.81,53.02c.54-.44.75-2.26-.39-2.26-.78.81-.92,1.78.39,2.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M915.26,37.82c-1.54.8,1.31.47,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M913.29,25.86h-.79c0,.32-.32.38-.4.65.62-.03,1.37.04,1.19-.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M904.21,27.8c1.73-.58,1.49-4.15.39-5.17-2.58.28-3.35,4.78-.39,5.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M904.21,52.69c-.13.44-.56.62-.4,1.29,1.1.52,1.09-1.39.4-1.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M904.21,59.48c-1.56.38,1.56.38,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M898.68,60.13c-.06-.38.07-.92-.4-.97.06.38-.07.92.4.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M896.71,41.06c1.29-.1.98-2.44-.39-2.26-1.01.32-1.13,2.31.39,2.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M896.71,30.07c.46-2.07-1.2-.71,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M894.34,42.03c-.6.59-.6,2.64,0,3.23,2.2.03,2.84-3.44,0-3.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M889.21,53.02c.96.51,1.69,1.21,3.55.97,2.34-.68,1.8-4.62-1.18-4.52-1.97.22-2.22,1.85-2.37,3.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M891.18,32.01c1.55-1.57.06-5.15-2.37-5.5-1.8,2.15-.25,5.06,2.37,5.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M887.63,52.05c-.06-.38.07-.92-.39-.97.06.38-.07.92.39.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M881.31,50.11c-.09.61.45.71.39,1.29,3.06.31.74-3.15-.39-1.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M879.73,37.82c1.14-.96.83-3.12.39-4.53-1.92.4-2.08,3.83-.39,4.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M879.34,50.11c2.05-.46.96-2.83-1.18-2.59-1.09.93-.61,2.38,1.18,2.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M869.86,48.81c1.37.15.22-1.75,1.18-1.94,2.26-.13,2.26,1.6,4.74,1.29,2.84-.78,3.18-4.29,2.76-6.79-4.17-1.67-9.41.7-12.63-2.26-2.67,4.07,1.66,7.57,3.95,9.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M877.76,58.19c-.24-.02-.47-.05-.39-.32h-.79c-.61.8,1.34.95,1.18.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M876.18,60.78c.09.25.01.64.39.65-.09-.25-.01-.64-.39-.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M876.18,62.39c-.36-.57-.14-1.61-.79-1.94.24.67-.64,2.25.79,1.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M872.23,52.69c-.02.56.3.83.79.97-.04-.51.05-1.12-.79-.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M871.84,29.42c-.06-.38.07-.92-.39-.97.06.38-.07.92.39.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M870.26,63.04c.07-.81-.61-1.01-1.18-1.3-.11.85.14,1.39,1.18,1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M869.07,69.51h-.79v.65h.79v-.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M868.68,31.68c-.09-.25-.01-.64-.39-.65.09.25.01.64.39.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M866.7,73.06c.02-.2.06-.38.39-.32v-.65c-.75.07-.87-.36-1.58-.32-.07.81.88.78,1.18,1.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M866.31,34.59c.81-.98.07-2.92-.39-3.88-.65,1.13-1.38,3.33.39,3.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M865.52,67.24c-1.56.38,1.56.38,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M863.55,68.53c-.31-.72-.23-1.75-1.18-1.94-.02.98-.23,2.13,1.18,1.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M861.57,64.66c-1.32-.78.95,1.08,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M861.57,68.53c-.02.42-.51.45-.4.97-1.17-.54-3-.27-3.55,0,.85.6,2.89.22,4.34.32-.07-.48.14-1.19-.39-1.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M861.18,70.48c-.77.8-1.16,2.84.4,3.23-.97-1.43.74-3.14-.4-3.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M861.18,67.89c.54-.41.61-1.58-.39-1.62.21.47-.46,1.67.39,1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M859.6,77.59c.16-.55.51.07,1.18,0-.02-.56.3-.83.79-.97-.24-.88-.78-1.51-1.58-1.94.08,1.68-1.77.81-2.37,1.29,1.22.08,1.21,1.16,1.97,1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M859.99,59.81h-.79v.65h.79v-.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M859.99,62.07c-.09-.25-.01-.64-.39-.65.09.25.01.64.39.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M859.2,73.39c-.03-.56.09-1.01.39-1.29h-1.58c-.11.85.14,1.39,1.18,1.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M855.26,58.84c1.57,1.13-.14,4.52,3.55,4.52-.16-1.3-1.61-2.81-.79-3.88-.66-.43-1.32-.86-2.76-.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M856.83,66.6c.27.86.62,1.65,1.18,2.26.45-.46.08-2.22-1.18-2.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M857.23,75.32c0-.32.32-.38.4-.65-.64-.88-1.33.47-.4.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M856.05,51.73c.12-.75-.06-1.24-.4-1.62-1.5-.24-.85,2.09.4,1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M854.86,67.89c-1.56.38,1.56.38,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M855.26,69.83v-.65c-.4,0-.47-.26-.79-.32.04.51-.05,1.12.79.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M854.86,74.36c.11-.85-.14-1.39-1.18-1.29-.07.81.61,1.01,1.18,1.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M853.28,58.84c2.03.9.97-1.54,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M852.89,60.78v1.94c1.51.07,1.33-1.87,0-1.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M852.89,65.3c-1.32-.78.95,1.08,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M851.31,63.69c-.09-.25-.01-.64-.39-.65.09.25.01.63.39.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M849.73,59.16c.59-.52.59-2.38,0-2.91-1.57-.04-.78,2.8,0,2.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M849.73,66.27c.37-.36-.23-1.22-.39-1.29-1.27-.55-.11,1.79.39,1.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M849.73,76.94c-.95.13.22-1.47-1.18-.97-.1.56.74,1.91,1.18.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M848.94,68.53c-.09-.25-.01-.64-.39-.65.09.25.01.64.39.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M848.15,72.42c-2.4.1,1.51.63,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M847.76,75h-1.18c-.58.94,1.76.94,1.18,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M845.78,27.15c-.06-.38.07-.92-.39-.97.06.38-.07.92.39.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M844.99,51.08c.8-.97.38-3.18-.79-3.56-.11,1.07-.53,2.88.79,3.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M844.6,74.68c-.26.21.17-.13,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M842.23,77.59c1.14.15.93,1.39,1.97,1.62.31-1.14-1.24-2.41-1.97-1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M843.41,12.61c.62-.6.49-2.55-1.18-2.26-.09,1.15.27,1.94,1.18,2.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M842.62,50.43c-1.15-.05-1.2,1.31-.79,1.62,1.59.05,1.04-.83.79-1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M840.26,77.91c-2.4.1,1.51.63,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M838.68,75.65c.16-.14-.26.21,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M836.31,69.83c-.09-.25-.01-.64-.4-.65.09.25.01.64.4.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M830.78,68.53c.46.72,2.83,1.54,3.55.97-.59-.28-.57-1.04-.79-1.62-.78-.1-.78.44-1.18.65-.73.31-1.32-.97-1.58,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M833.15,77.59c.12-.66,1.07-.63,1.18-1.29-1.2-.4-2.05,1.07-1.18,1.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M831.57,71.77c.04.36-.57.5,0,.65.4,0,.5-.57,0-.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M831.17,77.26c-1.31.47,1.54.8,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M830.78,66.92c-1.56.37,1.56.37,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M824.46,71.77c.53.1.75.46,1.58.32.24-.57-1.16-1.34,0-1.62,1.13-.08,4.44,1.44,3.55,0,.19.42-1.96.14-1.58-.65-2.89-.14-2.95.76-3.55,1.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M825.65,73.06c-.29.88.79.65.79,1.29,1.32-.59,2.36-.87,3.55,0-.33-1.32-.06-1.11,0-2.59-2.23.06-1.44,2.63-4.34,1.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M829.2,67.24c-1.32.78-.28,2.01.4,2.91-.24-.88.5-2.57-.4-2.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M829.2,76.94h-.79v.65h.79v-.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M828.02,74.03c-.02.42-.51.45-.39.97h.79c.97-.04.08-1.07-.39-.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M827.62,71.77c-3.05-.05,1.27.76,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M827.23,65.95c-.26.21.17-.13,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M827.62,75.32c-.31-.07-.46-.27-.4-.65-1.04-.1-1.29.45-1.18,1.29.73-.05,1.32-.21,1.58-.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M827.23,65.3c-.54.01-.87-.15-1.18-.32v.97c.68.02,1.01-.25,1.18-.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M826.83,78.88c.4,0,.5-.57,0-.65.04.36-.57.5,0,.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M826.04,68.53c-1.47.34-1.27-.68-1.97-.97-.07.38-.62.35-1.18.32-.15,1.18,2.86,1.81,3.16.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M823.67,78.88c1.28-.03,2.13-.41,2.37-1.29-1.86.35-1.13-1.11-.4-1.29h-1.58c-.05.8-.06,1.56.39,1.94-.48.04-.94.1-.79.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M825.25,75c-.46.05-1.12-.06-1.18.32.24.02.47.05.39.32.48-.04.94-.1.79-.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M823.28,72.09c-1.31.47,1.54.8,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M822.89,70.15c-1.56.37,1.56.37,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M820.52,73.06c-.01.92,2.45,1.21,2.37.32-.93,0-1.16-.56-2.37-.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M820.52,74.03c.09,1,1.4,1.01,2.37,1.29.14-1.19-1.44-.98-2.37-1.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M822.1,72.42v-.97c-1.29.06-1.9-.76-1.97.65.92-.1,1.52.05,1.97.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M821.31,68.86c0-.32.32-.38.39-.65-.78.1-.78-.44-1.18-.65-.66.64.04.41,0,1.29h.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M819.33,74.36h.79v-.65h-.79v.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M819.73,66.6c-.4,0-.47-.26-.79-.32-.02.41-.51.45-.39.97.68.02,1.01-.25,1.18-.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M816.57,0h-.79v.65h.79v-.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M810.25,62.07c-1.56.38,1.56.38,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M809.46,62.39c-.61-.08-.27-.71,0-.97-1.63-.55-.56,2.39,0,.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M809.07,64.98c-.36-.57-.14-1.61-.79-1.94.04,1.02-1.06,1.93.79,1.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M807.49,62.39c.02-.41.51-.45.39-.97-.97-.5-1.16,1.1-.39.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M807.09,63.69c-1.31.47,1.54.8,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M805.91,66.27v.65c.57.36.96.35,1.18-.32-.24-.02-.47-.05-.39-.32h-.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M802.75,65.95c-.33.38-.52.87-.39,1.62,1.59-.2,3.74,2.15,4.74.32-2.15.58-1.22-1.38-2.37-1.62-1.28.54-1.27.83-1.97-.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M807.09,69.51h-.79v.65h.79v-.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M806.31,61.75h-.79v.65h.79v-.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M804.73,56.25c.02-.56-.3-.83-.79-.97-.02.56.3.83.79.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M803.15,54.96c.31-2.57-1.19-5.19-3.16-4.85.4,1.66.18,4.49,3.16,4.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M802.36,64.66c-1.56.37,1.56.37,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M800.38,61.1c.09.25.01.64.4.65-.09-.25-.01-.64-.4-.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M798.41,61.42c.68.02,1.01-.25,1.18-.65-.62.03-1.37-.04-1.18.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M798.8,50.43c-1.56.37,1.56.37,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M798.8,62.39c-1.56.38,1.56.38,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M798.41,66.27c-1.56.38,1.56.38,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M792.49,67.24c.51.44,2.36.56,2.37-.32-.69.19-2.32-.39-2.37.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M794.07,60.78h-1.18c-.58.94,1.77.94,1.18,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M792.88,53.66c-.75-.04-.27-1.07-1.18-.97.61,1.36-2.19-.07-1.58,1.29,1.4-.27,2.37.94,2.76-.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M783.41,47.52c-.09-.25-.01-.64-.39-.65.09.25.01.64.39.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M779.86,60.13c.06-.91-1.12-1.05-1.58-.65.12-.52-.53-.87-.79-.32.74.96,1.48.69,2.37.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M769.99,60.78c.03.56-.09,1.01-.39,1.29,1.1.52,1.09-1.4.39-1.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M769.59,57.87c-2.4.1,1.5.63,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M760.51,62.72c.63,1.82,5.5,1.52,6.32.65-1.26-.61-1.65.08-3.16-.32.57-1.22-1.08-.62-.79-1.62.81.37,1.88-.51.79-.65-.9.93-1.66-2.16-2.76-.32.57.72.96-.41,1.18.32-.4.75-.87,1.45-1.58,1.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M765.25,58.84c-.4.64-1.75.51-1.58,1.62.66,0,1.32,0,1.97,0-.21-.47.46-1.67-.39-1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M765.25,61.75c.4,0,.5-.57,0-.65.04.36-.57.5,0,.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M753.8,58.51c.09-.25.33-.38.79-.32.09.25.01.64.39.65.11-.67,1.47-.31,1.58-.97-.61-.09-.27-.71,0-.97-1.08-.03-.79.54-1.58,0-.16.56.59.83,0,.97-.65,0-.22-.9-.79-.97.3.72-1.82,1.03-.39,1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M749.46,45.58c.17-.14-.26.21,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M748.27,53.66c1.27.28,1.24-.5,1.58-.97-.24-.19-1.87-.76-1.97,0,.46.06.43.51.39.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M744.33,53.34c-.06-.38.07-.92-.39-.97-.07.38-.62.35-1.18.32.02.44-.19.71-.39.97.95.13.86-.59,1.97-.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M743.93,57.87c-.98-.05-1.92-.06-1.97.65.98.05,1.92.06,1.97-.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M737.22,64.01c.09.25.01.64.4.65-.09-.25-.01-.64-.4-.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M736.43,60.13c.09-.25.33-.38.79-.32-.06-.38.07-.92-.4-.97,0,.53-1.09.18-1.18.65.52,0,.36.57.79.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M723.01,65.3c1.88-.12,2.86.7,3.95-.32-1.2.2-3.4-.41-3.95.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M726.17,57.55h-.79c0,.32-.32.38-.39.65.62-.03,1.37.04,1.18-.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M724.98,63.69v.65h.79v-.65h-.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M723.8,67.89c.08-.39.44-.2.79,0,.13-.44.56-.62.4-1.29-.75.07-.87-.36-1.58-.32.22.47-.46,1.67.39,1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M723.4,64.01v-.65c-.4,0-.47-.26-.79-.32.04.51-.05,1.12.79.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M721.43,59.48c.08-.39.44-.2.79,0-.63-1.09,1.67-1.38.39-1.94-.42.43-2.5,1.15-1.18,1.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M721.43,67.89c.04-.61,1.31-.23,1.18-.97-.53-.1-.75-.46-1.58-.32.07.48-.14,1.19.39,1.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M720.25,67.56c-1.56.38,1.56.38,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M719.85,61.1c.11-.74-.09-1.22-.79-1.29-.2.82-.67,1.25.79,1.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M719.06,65.95h-.79v.65h.79v-.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M715.9,60.45c-.1-1.12,1.53-.39,1.58-.32.29.99-.4,1.18-.4,1.94,1.5-.48.08,1.44,1.58.97.68-1.06-1.89-1.56,0-1.62-.19-1.28-.29-3.05-2.76-3.23.94,1.37-1.07,1.29,0,2.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M717.88,63.36c.23,1.05-.27,1.5-.39,2.26,1.37.18,1.68-2.17.39-2.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M715.9,61.75c-.12.44-.56.62-.4,1.3,1.35.24,1.54-1.24.4-1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M715.11,61.75c-.09-.25-.01-.64-.4-.65.09.25.01.64.4.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M713.93,61.42c.33-.38.52-.87.4-1.62-1.22-.13-1.61,1.56-.4,1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M711.56,65.63v.65c.02.2.06.38.4.32.02-.2.06-.38.39-.32.09.25.01.64.4.65.11-.85-.14-1.39-1.18-1.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M710.38,64.33c.12.63-.53.64-.79.97.95-.13-.22,1.47,1.18.97-.23-.57.48-1.9-.39-1.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M709.19,61.42c-.22.93-.62-.5-1.18-.32-.71,1.32,2.71,1.09,1.18.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M704.45,61.75c1.22-.24.76.89,1.97.65-.08-.61-1.02-2.14-1.58-1.29.7.16-.17.34-.39.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M704.45,64.98c.07-.37.62-.35,1.18-.32.09.25.01.64.4.65.74-1.37-.65-1.64,0-2.59-1.18.73-2.42-.47-2.76.65.92.1.38,1.41,1.18,1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M703.27,58.84h-.79v.97h.79v-.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M701.69,63.36c1.03.09,1.7-.12,1.58-.97-1.03-.09-1.7.12-1.58.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M702.88,62.07c.03-1.61-1.16-.21-1.97-.97v.97c.98-.04,1.22-.61,1.97,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M701.3,66.27c.22-.66,1.19-.63.39-1.29-1.1-.52-1.09,1.4-.39,1.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M700.11,63.04c-.86.67-.81,1.21.4,1.62v-2.26c-1.49.47-.76-.89-1.97-.65v.97c.53.79,1.19-.58,1.58.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M698.14,64.33c-.26.21.17-.14,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M697.35,61.75c-.09-.25-.01-.64-.39-.65.09.25.01.64.39.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M696.95,66.92c-.24-.02-.47-.05-.4-.32h-.79c-.61.8,1.34.95,1.18.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M693.8,47.52h.79v-.65c-.24-.02-.47-.05-.39-.32h-.79v.65c.24.02.47.05.39.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M694.22,61.72s-.01,0-.03.02c-.19.15-.02.02.03-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M693.4,48.81c.19-1.34-1.4-.84-1.97-.32.95-.13.86.59,1.97.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M691.82,60.45c.05.6.26,1.08.79,1.29.11-.74-.09-1.21-.79-1.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M691.82,46.88c-1.54.81,1.31.47,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M691.43,46.23c-1.14-.93,1.14.93,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M689.45,52.69c.68.02,1.01-.25,1.18-.65-.62.03-1.37-.04-1.18.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M690.64,65.95h-.79c0,.33-.32.39-.4.65.62-.03,1.37.04,1.18-.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M686.3,46.55c-.07,2,2.01.89,3.95,1.62-.17-1.05-1.33-1.28-1.97-1.94.07.7-1.4.15-1.97.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M689.85,61.75c1.2-1.09-1.46-.98,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M687.87,50.43c1.26-.19,1.22.61,1.97,0v-.97c-.54-.01-.87.15-1.18.32-.98-.27-2.11-.42-3.55-.32v1.94c-1.07-.68-.98.73-2.37,0-.88,1.89,2.63,1.24,1.58,2.26,2.65-.36,2.67-.08,3.55.65.75-1.49.64-2.29,0-3.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M689.85,63.04c-1.25.16-.15-1.61-1.58-1.3-.13.75.06,1.24.4,1.62.47-.05,1.12.06,1.18-.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M689.06,53.34c-.26.21.17-.14,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M688.66,39.12h-.79v.65h.79v-.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M685.51,43c.74.07,2.62.83,3.16,0-2.13.13-2.29-1.36-3.16-2.26.11,1.34-.52,1.26,0,2.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M687.08,40.09c-.38-.6,1.18-1.08,0-1.29-.11.2-.98,1.24,0,1.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M686.3,62.39c-.35,1.04.61,1.01,1.18,1.29.07-.81-.61-1.01-1.18-1.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M685.51,43.97c-.21,1.14.34,1.66,1.18,1.94.15-1.09-.68-1.38-1.18-1.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M685.11,38.47c-1.5-.89-1.73,1.18,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M684.72,42.03c.1-.56-.74-1.91-1.18-.97,1.14.18-.6.51-.39.97h1.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M684.32,45.58c.09.25.01.64.39.65-.09-.25-.01-.64-.39-.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M683.93,50.43h.79v-.97h-.79v.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M684.32,65.95c1.32.78-.95-1.08,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M684.32,67.56c-1.04-.38-1.23-.28-.79-1.29-1.55-.39-1.06-1.01-3.16-1.29-.29,1.86,3.04.75,2.37,2.91.59-.06,1.46.12,1.58-.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M683.93,46.23c-.31-.07-.46-.27-.4-.65-2.41-.19.08,2.24.4.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M682.35,50.76c-2.4.1,1.51.63,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M680.37,44.61c-3.05-.05,1.27.76,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M679.58,38.15c-.09-.25-.01-.64-.4-.65.09.25.01.64.4.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M678.8,64.33c-.54.01-.87-.15-1.18-.32-.04.88.66.65,0,1.29.86.06,1.26-.26,1.18-.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M678.01,49.78c-1.41-.19-1.2.96-1.18,1.94,1.2,0,.98-1.14,1.18-1.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M678.01,52.05c-1.58-.05-2.38,1.7-1.97,2.26,1.86.23,1.73-1.17,1.97-2.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M678.01,89.87h-.79v.65h.79v-.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M676.82,64.01c-.26.21.17-.14,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M676.43,62.39c-.29-.1-.43-.15-.5-.17.27.1,1.95.68.5.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M675.24,67.56c-1.56.38,1.56.38,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M674.85,55.28c-.76.46-.71,1.57-1.18,2.26,1.28.16,2.13-1.68,1.18-2.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M675.24,68.53c-.47-.04-.9-.57-1.18,0,.47.05.89.58,1.18,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M671.29,49.14c-.12-.85,1.53-.25,1.18-1.29-.9-1.1-2.42.74-1.18,1.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M672.08,68.53c-.09-.25-.01-.64-.39-.65.09.25.01.64.39.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M671.29,39.12c-1.56.37,1.56.37,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M670.9,64.33c-.19-1.25-.96-2.02-2.37-2.26.74,2.46-1.39.57-1.97,1.94,1.77-.16,2.96.16,4.34.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M668.53,42.03c-1.06-.22-.76.67-1.18.97,1.03.19,1.42-.13,1.18-.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M667.35,61.75c-1.56.38,1.56.38,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M666.56,64.98c-1.31.47,1.54.81,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M663,65.95c-.35-1.14,1.01-1.66-.39-1.94-.09.25-.01.64-.4.65-.02-.2-.06-.38-.39-.32.04.82.72,1.13,1.18,1.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M661.82,84.7c1.14.06,2.17-1.09.79-1.29.49,1.05-1.28.25-.79,1.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M662.21,69.18c.42-.82-.83-1.84-1.18-.97.75.04.27,1.07,1.18.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M656.69,81.47c1.59,2.95,2.42,2.83,5.53,1.94-1.89-.4-2.98-3.15-5.53-1.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M661.03,66.27c-.69.02-1.23-.07-1.58-.32-.17,1.21,1.18.99,1.58.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M659.06,63.69c-1.22.24-.76-.89-1.97-.65-.47.96,1.66,1.39,1.97.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M658.66,68.21c-1.56.37,1.56.37,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M652.74,70.8c-.38,1.59,1.94.46,1.97.97-.55.09-.45.71-.79.97.7.28,1.22,1.08,1.58,0-.64,0-.79-4.87,2.37-3.88.06-.8.07-1.57-.79-1.62-1.76.88-2.02,4.15-4.34,3.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M657.48,66.27c-.09-.25-.01-.64-.4-.65.09.25.01.64.4.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M653.92,84.05c1.67-.4,2.54.22,3.55-.32-.64-.55-1.2-1.18-1.18-2.26-1.44.33-1.83,1.52-2.37,2.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M656.29,65.63c-.09-.25-.01-.64-.39-.65.09.25.01.64.39.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M655.9,66.27c-.52,0-.36-.57-.79-.65-1.06.66.5,1.95.79.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M654.71,74.36c.09.25.33.38.79.32-.09-.25-.33-.38-.79-.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M654.71,43c-1.56.38,1.56.38,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M654.71,67.89c-2.4.1,1.51.63,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M653.92,62.07c-.57.18-2.04-.38-1.97.32.5.44,1.93.5,1.97-.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M653.53,70.48c-.09-.25-.01-.64-.39-.65.09.25.01.64.39.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M651.95,76.29h.79v-.97h-.79v.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M649.19,60.78c.24.09,1.52.8,1.58,0-.24-.09-1.52-.8-1.58,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M649.58,61.75c-1.31.47,1.54.8,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M649.19,56.25c-1.56.37,1.56.37,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M646.82,62.72c.2-1.22.5-1.47-.79-1.94.05.58-.39.76-1.18.65.14,1.45,1.18.93,1.97,1.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M645.63,53.66c.4,0,.5-.57,0-.65.04.36-.57.5,0,.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M645.24,55.6c-.74.04-1.32.21-1.58.65.9.09,1.48-.08,1.58-.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M645.24,68.86c-.51-.45-1.86-.2-2.37-.65-.3.78-.31,1.56.39,2.26.08-.39.44-.2.79,0-.19-1.02,1.06-.86,1.18-1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M642.87,66.6c.24.02.47.05.39.32-.48.04-.94.1-.79.65,1.38.06,1.24-1.14,1.97-1.62-.74.05-1.32.21-1.58.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M643.66,67.24v.97c1.15.47,1.15-1.45,0-.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M643.27,70.8c-.86-.06-1.26.26-1.18.97.86.06,1.25-.26,1.18-.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M642.48,62.07c-1.56.38,1.56.38,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M639.32,53.34c.1.85.81,1.06-.79.97-.28,1.2,1.38.81,1.97,1.29.22-.47-.46-1.67.39-1.62.52,1.1-.88,2.26,0,2.59.25-.66,1.99-.09,1.58-1.29-1.71-.11-.74-2.41-3.16-1.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M637.74,53.02c.31-.71,2.44.06,1.97-1.29-2.41-.4-3.12-2.19-5.53-2.59.58,2.03,4.07,1.82,3.55,3.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M638.92,57.55c-1.56.37,1.56.37,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M638.92,65.3c-.26.21.17-.14,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M638.92,74.68c-1.56.38,1.56.38,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M638.53,53.34c-1.56.37,1.56.37,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M636.95,51.4c-2.29-.34-.16,1.4,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M635.76,54.96c.17-.14-.26.21,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M634.97,65.3c-.35.86-.54,2.33.79,1.62-.24-.02-.47-.05-.39-.32,1.52.25.73-1.72-.4-1.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M635.37,54.31c-.71,0-2.3-.87-2.76,0,.62.65,2.2.93,2.76,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M634.58,56.57h-.79v.65h.79v-.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M633,52.37v-.97c-.59.05-1.46-.12-1.58.32.31.07.46.27.39.65h1.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M631.82,50.76c-.02-.45.19-.71.39-.97-.27-.25-2.2-.72-2.37,0,1.05,0,.86,1.02,1.97.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M631.03,44.94c-1.56.37,1.56.37,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M630.24,43.64c.02.44-.19.71-.39.97,1.23.15,1.48-.87.39-.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M624.71,69.51c-.54.41-.54,1.53,0,1.94,2.09-.36,3.05-.98,2.37-2.91.48-.04.93-.1.79-.65-.81-.18-2.96.1-1.58.65.02-.19.06-.38.39-.32-.36,1.36.24,1.85-1.18,2.59-.55-.2-.06-1.24-.79-1.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M623.92,72.42c.9.09,1.48-.08,1.58-.65-.69.02-1.23-.07-1.58-.32v.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M622.34,63.69v1.62c1.48.24.86-1.23,1.97-1.29.04.45,1.01.34.79-.32-.66-.57-1.32.29-2.76,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M624.71,64.66c.09.25.01.64.39.65-.09-.25-.01-.64-.39-.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M623.13,67.89c.87-.25.99-1.13,1.58-1.62-1.37.26-1.52-.48-2.76-.32-.47.42-.19,2.05,1.18,1.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M623.13,61.42c0-.43.69-.3.79-.65-.7-.1-1.55-1.71-2.37-.65,1.01.03.56,1.26,1.58,1.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M619.58,32.97c-1.56.37,1.56.37,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M619.18,66.6c-.06-.38.07-.92-.39-.97.06.38-.07.92.39.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M617.21,61.1c.24.02.47.05.39.32-.31.07-.78,0-.79.32.24.02.47.05.4.32h.79c.34-.66-.34-2.01-.79-.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M617.6,70.8c.17-.14-.26.21,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M616.03,60.78c-.28-.88,1.86.23,1.58-.65-.85-.56-2.71-.09-1.58.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M617.6,65.63c-.98-.05-1.64.17-1.97.65.75-.14,2.38.44,1.97-.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M616.81,69.51c-1.09,1.23,1.45,1.42,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M616.81,59.48c-.09-.25-.01-.64-.39-.65.09.25.01.64.39.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M616.81,62.39v-.65c-.39,0-.47-.26-.79-.32.04.51-.05,1.12.79.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M616.81,64.33c-1.98.23-1.83.2-3.95.32v1.62c1.86-.64,2.35,1.5,3.55.32-2.65-.37.18-1.41.39-2.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M615.63,40.09c0-.64,1.08-.41.79-1.29h-1.18c.07.48-.14,1.19.39,1.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M615.63,71.12c-.26.21.17-.13,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M614.05,59.48c.68.02,1.01-.25,1.18-.65-.68-.02-1.01.25-1.18.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M612.87,53.99c-.02.56.3.83.79.97.09-.46.65-.55.79-.97-.54.02-.87-.15-1.18-.32-.02.2-.06.38-.4.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M613.66,71.77c0,.53-1.09.18-1.18.65.53.1.75.46,1.58.32v-.65c-.02-.2-.06-.38-.4-.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M613.26,62.72c.06-.38.7-.73,0-.97-.31.86-1.86-.72-1.98.65.93.42.73-.04,1.98.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M610.5,65.3c.99.04,1.24.62,1.58-.32-.68-.44-1.55-1.04-1.58.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M611.29,66.92c.02-.2.06-.38.4-.32v-.65c-.59.06-1.46-.11-1.58.32.56.08.67.53,1.18.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M610.5,61.1c-.02.2-.06.38-.4.32v.65c.97.5,1.16-1.1.4-.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M610.5,39.12c-.07-.48.14-1.19-.4-1.29-.51.43-.52,1.2.4,1.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M609.71,49.78c-1.54.8,1.31.47,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M607.34,64.33c.31.07.46.27.39.64,1.78.46,3.36-1.1,1.58-1.62.23,1.24-1.62-.27-1.97.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M608.53,38.79c.17-.14-.26.21,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M608.13,34.59h-1.58c-.31,1.24,1.89,1.24,1.58,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M607.74,62.39c-.26.21.17-.13,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M606.16,66.92c-1.56.37,1.56.37,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M605.76,54.96c-.09-.25-.01-.64-.39-.65.09.25.01.64.39.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M604.97,38.47c-1.56.37,1.56.37,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M604.58,39.12c-3.05-.05,1.27.76,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M603.39,65.95c-1.32-.78.95,1.09,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M602.21,52.05c-1.24.15-1.04-.87-1.97-.97-.85,1.82,2.78,2.15,3.16.97-.56-.13-.67-.39-1.18,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M602.6,37.5c-1.56.38,1.56.38,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M602.6,40.09c.4,0,.5-.57,0-.65.04.36-.57.5,0,.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M603,42.67c-.86-.06-1.26.27-1.18.97.86.06,1.26-.26,1.18-.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M599.84,47.52c1.11.27,1.02-.46,1.97-.32-.98-.97.6-2.35-.79-2.59-.09.25-.33.38-.79.32-.05.93.22,2.12-.39,2.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M601.03,43c-1.31.47,1.54.8,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M599.05,40.73c.21-.48.58-.81.79-1.29-2.1-.22-2.97-1.45-3.95-2.59-.98-.05-1.22.51-1.97.65.43,2.84,2.43,2.39,5.13,3.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M595.1,52.05c-.62.03-1.37-.04-1.18.65.81-.09.33.74,1.58.97.41-1.1-.45-1.96,1.58-1.29-.09-.61.44-.71.4-1.29-1.21-.12-4.16-1.64-4.34.32.24.56,1.87-.02,1.97.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M597.08,28.77c-.86-.06-1.26.27-1.18.97.86.06,1.26-.26,1.18-.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M596.68,54.63c-.69.02-1.23-.07-1.58-.32-.1.94,1.53,1.24,1.58.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M596.68,64.01c-.59.05-1.46-.12-1.58.32.53.42,1.19.2,1.58-.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M592.74,68.53c.03-.56-.09-1-.4-1.29,1.12-.34,1.65-.34,2.76,0,.11-.66,1.07-.63,1.18-1.29-1.76.26-2.63-.22-3.55-.65-.1.92-1.93,1.29-.79,2.26-2.09-.28-.06.79-1.58.97-.72-.07-2.24-.08-2.76.97,1.35.52,3.83-.42,5.13-.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M594.71,45.26c-.29-.88.79-.65.79-1.29-1.7.42-1.25-.92-1.97-1.29-.59,1.03-.59,2.63,1.18,2.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M593.52,49.14c-.84,1.19,2.01,1.46,1.58.32-.75.07-.87-.36-1.58-.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M593.13,71.44c-1.54.81,1.31.47,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M589.18,71.77c1.01-.04,1.38-.59,1.97-.97-.78.1-.78-.44-1.18-.65.57,1.22-1.09.62-.79,1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M589.58,50.76c-.09-.25-.01-.64-.39-.65.09.25.01.64.39.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M585.23,67.56c-.32.6-.66,1.18-.79,1.94,2.2,1.49,4.21-2.23.79-1.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M586.42,40.73c-1.37.28-1.35-.5-.79-.97-2.51.06-4.6,1.96-3.55,3.88,1.82-.67,3.62-1.35,4.34-2.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M585.63,74.36c-1.56.38,1.56.38,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M576.55,69.83c1.69-.13,1.94-1.43,3.55-1.62-.96,2.16,1.84,1.33,2.76,2.59-.6-1.03-.14-1.42,0-2.59-1.22.24-.76-.89-1.97-.65-2,.78-4.13-.22-4.34,2.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M580.5,35.56c-1.83,1.3-4.89,1.6-4.34,4.85,3.01-.12,4.55-3.17,4.34-4.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M578.52,61.42c-1.2,1.09,1.46.98,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M578.13,72.42c-.26.21.17-.14,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M574.97,45.58c.32-.61.66-1.18.79-1.94-1.08.06-2.13,1.8-.79,1.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M574.58,75c.21-.68.69-1.22-.39-1.62,0,.43-.69.29-.79.65.91-.1.44.93,1.18.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M574.18,70.15c1.2-1.09-1.46-.98,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M573.39,33.3c-.09-.25-.01-.64-.39-.65.09.25.01.64.39.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M572.6,72.09c-1.56.37,1.56.38,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M572.6,80.82c-.62-.03-.31-.82-1.18-.65-.35.66,1.02,1.45,1.18.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M571.81,26.51c-3.01.06-5.76,2.9-3.95,4.85,2.83-.38,3.41-2.59,3.95-4.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M571.42,78.88c.06.38-.07.92.39.97-.06-.38.07-.92-.39-.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M571.42,70.8c-.09-.25-.01-.64-.39-.65.09.25.01.64.39.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M570.23,70.8c.87-1.21-1.87-1.58,0-1.62.06-.8-.2-1.34-.79-1.62-.02.2-.06.38-.4.32-.24.02-.47.05-.39.32.43.08.95.53.39.65-.34-.47-.59-1.03-1.58-.97-1.44,1.76,1.24,2.54,2.76,2.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M569.05,82.76c-2.4.1,1.51.63,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M568.65,54.96c-.76.14-1.7.12-1.58.97,1.03.09,1.7-.12,1.58-.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M568.26,74.36c.17-.14-.26.21,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M567.86,73.06s-.24,1.09-.39.97c.95.78,1.02-1.06.39-.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M567.08,80.82c.4,0,.5-.57,0-.65.04.36-.58.5,0,.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M567.08,82.76c-1.31.47,1.54.8,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M566.68,73.71h-2.37c.25,1.22,2.19,1.03,2.37,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M564.31,77.26c-.05.58.39.76,1.18.65.06.38-.07.92.39.97.63-.48.29-1.32-.39-1.62-.16.55-.51-.07-1.18,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M565.5,71.77c-.09-.25-.01-.64-.4-.65.09.25.01.64.4.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M563.92,78.23c-1.32-.78.95,1.09,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M560.36,76.62c.05.82.07,1.66,1.18,1.62-.05-.82-.07-1.66-1.18-1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M560.76,80.82c.17-.14-.26.21,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M558.39,45.26c.17-.62,1.13-.58.79-1.62-1.17-.38-1.7,1.36-.79,1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M558.79,64.33c-2.17-.06-3.98,1.56-2.76,3.23,2.31.06,2.47-1.64,2.76-3.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M554.84,73.06c0-.43.69-.29.79-.65-.46-.05-.43-.51-.39-.97-1.45-.31-1.57,1.59-.39,1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M553.26,85.99c-.26.21.17-.13,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M551.68,49.14c.35-.68,1.2-.96,1.18-1.94-1.19-.19-2.24,1.36-1.18,1.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M552.07,97.31c-1.33-.78.95,1.08,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M548.52,51.4c-.09-.25-.01-.64-.39-.65.09.25.01.63.39.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M545.76,52.37c.4,0,.5-.57,0-.65.04.36-.57.5,0,.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M544.18,73.06c-1.56.38,1.56.38,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M543.78,46.55h-.79v.65h.79v-.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M541.41,75.32c.52,0,.36.57.79.65.02-.41.51-.45.39-.97-.47.05-1.12-.06-1.18.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M541.02,81.79c.26-.57,1.95-1.6.79-2.26-.09.25-.01.64-.4.65-.07-.38-.62-.35-1.18-.32.67.88-.62,1.51.79,1.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M541.41,73.71c-1.56.37,1.56.37,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M541.41,46.88c-.09-.25-.01-.64-.39-.65.09.25.01.64.39.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M539.84,74.36h.79v-.65h-.79v.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M540.23,76.62c-.26.21.17-.14,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M539.84,44.61c-1.54.8,1.31.47,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M540.23,46.88v-.97c-.59.06-1.46-.12-1.58.32.79,0,.5.88,1.58.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M537.47,51.4c.22-.79,1.53-.69,1.18-1.94-1.23-.23-1.85,1.68-1.18,1.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M537.47,77.91c-.68-.08-2.34.61-1.18.97-.16-.77,1.8.18,1.18-.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M537.07,81.47h-1.58c.91,2.04-2.37.65-1.97,2.26h1.97c-.25-1.39,1.65-1.02,1.58-2.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M535.89,80.17c-2.14-1.54.73,1.55.4,0,0-.02-.37.02-.4,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M534.7,76.62c0-.53,1.1-.18,1.18-.65-.8-.28-2.45.28-1.18.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M533.91,74.03v.65c.02.2.06.38.4.32,0-.43.69-.3.79-.65-.24-.02-.47-.05-.4-.32h-.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M526.02,82.44c.25.93,1.5,1.67,0,2.26,1.4-.5.24,1.1,1.18.97,1.89-.82,3.52-1.86,4.74-3.23-.35-.1-1.73-.88-.79-.97.47.59,2.06.25,2.76.65.88-.85,1.18-1.95-.79-2.26-.16.78.72.7.39,1.62-1.93-1.91-4.96.87-7.11.32,2.44-.55,1.14-2.36,4.34-1.94.38-1.63,2.4-1.91,2.76-3.56-.78.1-.78-.44-1.18-.65-1.44.86-2.59,2.23-3.95,2.26-.38,1.17,1.77.27,1.58,1.29-1.18-.44-4.65-1.57-7.5-.65.27,1.61,1.38,2.54,1.58,4.2.95.13.86-.59,1.97-.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M534.31,65.3c-2.29-.34-.17,1.4,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M532.73,84.38c.56.08.67.53,1.18.65-.02-.44.19-.71.4-.97-.59.06-1.46-.12-1.58.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M533.91,50.11c.33-.92-.56-.84-.39-1.62-1.5-.24-.85,2.09.39,1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M533.91,79.2v-.65c-.24-.02-.47-.05-.39-.32h-.79v.65c.24.02.47.05.39.32h.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M526.81,87.29c.74.31,1.32-.97,1.58,0-1.22,2.03,2.13,2.08,3.95,1.29-.17-1.54.47-2.42,1.18-3.23-2.47.03-5.63-.49-6.71,1.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M529.97,95.05c.57.18.96.5,1.18.97.98-.16,1.62-.61,2.37-.97-.81-.2-.11-1.64-1.58-1.29-.06.38.07.92-.4.97-.59.05-1.46-.12-1.58.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M531.15,68.21c.7-.18,1.64-.17,1.97-.65-.81-.69-1.88-.17-1.97.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M532.34,72.74c.13-.75-.06-1.24-.39-1.62h-1.58c.06,1.34-1.76,1.14-1.58,2.59,1.98-.38,1.94-.41,3.55-.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M531.55,45.58c1.2-1.09-1.46-.98,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M531.55,92.46c-1.54.8,1.31.47,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M529.57,69.83c.04-.51,1.01-.25.79-.97-.81-.28-1.77.84-.79.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M528.78,75.32c-2.03.78,1.36.84,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M527.2,59.16c-.09-.25-.01-.63-.39-.65.09.25.01.64.39.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M526.81,61.42c-.97-.5-1.16,1.1-.39.97.02-.41.51-.45.39-.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M524.83,72.42c1.73-.31,2.03-1.79,1.97-3.56-1.82.27-3.56,2.44-1.97,3.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M526.81,101.84c-1.07-1.02-.33-2.27-.79-3.23-1.43.83-2.37.05-3.55.97.12-.85-.82-.83-1.58-.97-2.69-.04-1.88,2.77-4.74,2.59-.5.98,1.35,1.64.39,1.94-.63-.45-1.01-1.11-1.18-1.94-2.74-.48-6.54-.59-8.29.65.02,2.09-1.21,5.01.39,6.46,1.05-.97,2.96-1.24,4.74-1.62.19-.94-1.64-1.86-.79-2.26.49.68,1.1,1.26,1.58,1.94,1.53.17,1.93-.58,3.55-.32,1.21-.65-.28-1.5,1.58-1.62-.03.56.09,1.01.39,1.29.93-.32,2.51-.1,2.37-1.29-.53-.79-1.19.58-1.58-.32,3.41-.7,4.19-2.63,7.5-2.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M525.23,45.58c.17-.14-.26.21,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M525.62,85.99c-.62.03-1.37-.04-1.18.65.68.02,1.01-.25,1.18-.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M525.23,83.08c-1,.04-1.53.47-1.58,1.29.54-.01.87.15,1.18.32-.33-.91.56-.84.4-1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M524.44,49.14c.4,0,.5-.57,0-.65.04.36-.58.5,0,.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M523.65,69.83c-1.56.38,1.56.38,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M522.07,90.2c-.47.87-2.06,0-2.76,0,.16,1.7,2.59,1.54,3.95,2.26-.09-.61.44-.71.39-1.29-1.26.28-.82-.84-1.58-.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M519.7,43.32h3.55v-.97c-1.39.15-3.8-.53-3.55.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M523.26,50.11v-1.29c-1.27-.28-1.24.5-1.58.97.53.1.76.46,1.58.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M522.47,56.9c.12-.38,1.59-1.22.39-1.62-.56.42-1.87,1.34-.39,1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M522.86,63.69c.31-.23.88-1.8,0-1.94,0,.43-.69.3-.79.65,1.07-.23-.28,1.53.79,1.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M523.26,67.89c-.24-.02-.47-.05-.4-.32h-.79c-.61.8,1.34.95,1.19.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M521.32,38.44s-.05.04-.08.06c.01-.01.02-.02.04-.04.02-.02.03-.02.03-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M520.89,92.78c-.68-.02-1.01.25-1.18.65.5.02.55.41,1.18.32v-.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M520.1,14.87c-.23.68-.98.92-.79,1.94,1.33.41,1.63-1.64.79-1.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M518.91,77.91c.53.1.75.46,1.58.32v-.97c-.73.04-1.32.21-1.58.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M517.33,99.89c.07-1.34,2.08-1.09,2.37-2.26-1.92-1.51-4.66,1.33-2.37,2.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M519.7,107.01v-.65c-.24-.02-.47-.05-.4-.32h-.79v.65c.24.02.47.05.4.32h.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M518.91,91.81c-2.4.1,1.51.63,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M517.73,107.01v1.94c1.91.14,1.14-1.89,0-1.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M518.52,67.56c-.62-.03-.31-.82-1.18-.65-.35.67,1.02,1.45,1.18.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M514.18,107.01c.4,1.61,1.23,2.87,2.76,3.56.51-1.02.1-2.03,0-3.88-1.37-.26-1.52.48-2.76.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M515.36,73.71c-.73.57.17.94.39,1.62.68.02,1.01-.25,1.19-.65-1.27.28-.54-1.07-1.58-.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M516.54,36.85c-.81-.37-1.88.51-.79.65,0-.43.69-.29.79-.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M515.75,46.23c-.09-.25-.01-.64-.39-.65.09.25.01.64.39.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M514.96,67.56c-1.56.38,1.56.38,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M510.62,88.26c2,.09,2.63,1.3,4.74,1.29.05-.8.06-1.56-.4-1.94-1.46.2-4.06-.53-4.34.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M514.96,34.59h-.79v.65h.79v-.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M514.57,41.38c.84-.66-.11-1.28-.4-1.94-1.24-.15-1.11.81-1.58,1.29,1.37-.55,1.38-.12,1.97.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M512.6,58.19h2.37v-.97c-1.2-.01-2.6-.19-2.37.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M512.2,46.23c.75.14.99.7,1.97.65.47-.96-1.66-1.39-1.97-.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M512.99,98.92c-.62.8,1.34.95,1.18.32-.24-.02-.47-.05-.39-.32h-.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M513.78,47.2c-1.24.15-1.04-.87-1.98-.97.18,1.17,1.01,1.57.4,2.59,1.11-.06,1.68-.56,1.58-1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M510.62,50.43c1.39-.14,1.68-.68,1.19-1.62-1.23-.15-1.26.69-1.19,1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M512.2,67.24c-1-.34-1.75,1.09-.79,1.29-.28-.88.79-.65.79-1.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M511.81,42.35c-.06-.38.07-.92-.4-.97.06.38-.07.92.4.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M511.81,75.97c.42-.82-1.33-1.43-1.58-.65.31.07.78,0,.79.32-.94.2-2.86-.41-3.16.32.86.07,2.12,1.46,2.76.65-1.27-.36.38-.92,1.19-.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M509.44,50.11c-1.54-1.6,2.35-1.52,1.58-3.56-1.79.59-3.01,1.63-3.95,2.91.99-.14,1.57,1.69,2.37.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M510.62,72.42c-.26.21.17-.14,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M509.44,62.07c-1.14-.93,1.14.93,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M507.86,53.34c.1-.46.65-.55.79-.97-.46-.05-.43-.51-.4-.97-1.14-.18-.69-.23-1.97-.65.36,1,.69,2.02,1.58,2.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M493.65,69.83c-1.2.52-1.7,1.62-3.16,1.94.12-.52-.53-.87-.79-.32,1.33,2.42,4.98-.28,8.29.97-.11-1.31-2.99-.36-3.55-1.29,1.88-3.31,5.69-5.04,10.26-6.14.25,1.2-.51,3.22.4,3.88.47-1.42.1-2.66.4-4.52,1.1-.29,2.4-.4,3.16-.97-.8-.1-1.05-.65-1.58-.97-.34.48-1,.7-1.97.65.17-.72.91-1.75-.4-1.94v2.26c-2.07.68-3.72,1.69-5.92,2.26-1.24.16-.29-1.48-1.18-1.62-.11,2.71-2.03,3.94-3.95,5.17-.33-.48-1.27-.47-1.97-.65-.27,1.2,1.69.56,1.97,1.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M507.07,54.31c-.06-.38.07-.92-.4-.97.06.38-.07.92.4.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M506.68,79.2c.17-.14-.26.21,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M506.28,57.55c.37-.27.84-2.06,0-2.26-.53,1-1.85,1.73,0,2.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M505.89,54.96v-.65c-.4,0-.47-.26-.79-.32.04.51-.05,1.12.79.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M504.7,18.75c.23-.2.92-1.53,0-1.62-.23.19-.92,1.53,0,1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M504.31,84.38c-.06-.43,1.61-.98.39-1.29.06.43-1.61.97-.39,1.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M501.54,57.87c.8.1.77.87,1.58.97.17-.71-1.18-1.78-1.58-.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M501.54,17.13c.72-.66,1.25-2.62.39-3.56-2.01-.1-2.16,3.34-.39,3.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M500.36,78.56c.53.42,1.19.2,1.58-.32-.59.06-1.46-.11-1.58.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M501.15,52.69c-.26.21.17-.14,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M499.97,66.92c-.54.42-.69,1.93.39,1.94.04-.83,1.69-.34,1.19-1.62-.75.07-.87-.36-1.58-.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M500.36,53.66c.4,0,.5-.57,0-.65.04.36-.57.5,0,.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M499.97,72.09c-2.4.1,1.5.63,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M497.99,88.58c.81-.2,2.74.52,2.37-.65-.54-.45-2.38-.31-2.37.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M499.18,79.2h.79v-.65h-.79v.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M499.18,70.8c.04.36-.58.5,0,.64.4,0,.5-.57,0-.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M498.78,81.14c-1.79.18,2.26,1.85.4.32-.19-.15.07-.37-.4-.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M499.18,53.99c-.74.05-1.32.21-1.58.65.7-.07,1.97.33,1.58-.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M498.78,78.88v-1.62h-.79c.17.61-.54,1.95.79,1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M497.2,83.73c.59-.06,1.46.11,1.58-.32-.52-.42-1.47-.43-1.58.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M498.39,85.02c-1.55-.24-2.39-1.06-2.76-2.26-.94,1.08-2.31-.19-3.55.65,2.23.16,4.73,3.02,6.32,1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M497.99,63.04c-1.14-1.56.82-5.39-.39-5.82-.28,1.96-1.51,4.34.39,5.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M495.23,85.99c.65,0,.22.9.79.97.34-.66-.34-2.01-.79-.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M495.62,65.3c-.09-.25-.01-.64-.4-.65.09.25.01.64.4.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M494.83,15.84c-.25,1.09-1.13,1.66-.79,3.23,1.34,0,1.59-2.56.79-3.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M494.83,23.6c.21-.71.95-2.09-.39-2.26-.54.44-.75,2.26.39,2.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M493.25,73.06c-1.32-.78.95,1.08,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M492.07,54.63c-1.35-.02-1.17,1.2-1.18,2.26,1.65,0,1.78-1.26,1.18-2.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M492.07,63.04c-1.56.37,1.56.37,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M491.67,70.48c-1.33-.98-1.2,1.2,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M491.28,75c-.26.21.17-.14,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M491.28,68.21c-1.64.06-2.17-.56-3.16.32,1.16-.08,1.22.73,2.37.65.09-.46.65-.55.79-.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M488.52,42.35c-.09-.25-.01-.64-.4-.65.09.25.01.64.4.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M487.73,59.81c-.09-.25-.01-.64-.4-.65.09.25.01.64.4.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M486.94,70.15c-.09-.25-.01-.64-.4-.65.09.25.01.64.4.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M486.54,30.07c-.52,0-.36-.57-.79-.65-.02.2-.06.38-.39.32v.65c.46-.05,1.12.06,1.18-.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M486.15,62.39c-1.56.38,1.56.38,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M486.15,65.63c.09.25.01.64.39.65-.09-.25,0-.64-.39-.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M485.36,34.59c0-.33.32-.39.39-.65-.7-.29-.65-1.19-1.58-1.29-.28.99.4,1.18.4,1.94h.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M484.57,58.84c-.24-.02-.47-.05-.4-.32h-.79c-.61.8,1.34.95,1.19.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M482.99,61.75c-.07-.48.14-1.19-.4-1.29-.51.43-.52,1.2.4,1.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M478.25,61.1c.58.7,2.53.89,2.76-.32-.53-.44-2.76-.61-2.76.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M477.07,31.68c1.98-.53,2.3-4.72,0-5.17-1.96.31-2.51,4.98,0,5.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M477.86,56.57c-1.56-.22-1.29,1.36,0,1.29v-1.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M474.31,72.09v-.65h-.79v.65h.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M471.15,37.18c-.06-.38.07-.92-.39-.97.06.38-.07.92.39.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M470.36,44.94c.3-1.21.49-2.3-1.58-2.26-.42,1.3-.52,2.33,1.58,2.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M469.17,32.65c.12.75-.06,1.24-.4,1.62,1.45.31,1.57-1.59.4-1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M467.99,49.14c1.1-.35,1.69-2.26.79-3.23-2.52-.51-2.57,3.01-.79,3.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M467.59,63.36c-.08.36-.44.5-.79.65-.99-.04-1.23-.62-1.58.32,1.6-.45,1.4.58,1.97.97.66-.36,1.95-1.62.4-1.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M462.07,57.55c1.72.06,3.23.66,4.74,0,1.61-1.49.19-3.91-1.58-4.53-2.61.23-3.35,2-3.16,4.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M464.44,35.88c.87-2.08.13-5.44-2.76-5.5-1.1,2.39-.11,5.33,2.76,5.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M460.88,49.78c-1.56.38,1.56.38,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M460.09,70.15c-.61.8,1.34.95,1.18.32-.24-.02-.47-.05-.4-.32h-.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M455.75,55.6c.8-.62.92-1.3.4-2.26-2.32-.45-1.78,2.21-.4,2.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M453.78,60.45c-1.56.38,1.56.38,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M453.38,37.18c-2.23.03-1.68,3.23-1.18,4.52,2.36-.54,1.06-2.65,1.18-4.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M451.01,51.4c-1.14.96-.57,2.63,1.58,2.59,1.97-.68.94-2.94-1.58-2.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M451.41,56.25c0,.32-.32.38-.4.65.24.02.47.05.4.32.3-.07.78,0,.79-.32-.48-.07-.24-.36,0-.65h-.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M449.83,58.19c1.39.74-1.07,2.75.39,3.55.06-1.63.68-2.11,1.97-3.55-.69.09-1.97-.91-2.37,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M451.41,66.92c1.39-1.31-1.27-.76,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M450.22,62.39c-1.56.38,1.56.38,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M449.83,54.96c-.26.21.17-.14,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M448.64,63.04c-.17,1.83,1.5.47,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M448.25,61.75c-.26.21.17-.13,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M445.09,33.3v-.65c-.4,0-.47-.26-.79-.32.04.51-.05,1.12.79.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M442.72,53.99c-1.54.8,1.31.47,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M441.93,34.91h-.79v1.29h.79v-1.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M439.17,38.47c.78-1.08.95-3.09-.4-3.88-.09,1.26-1.81,3.54.4,3.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M435.22,53.66c-.4.04-.8-1.39-1.19-.32.41-.04.8,1.39,1.19.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M434.43,58.84c-.11-1.27-1.74.06,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M432.46,55.93c-.93,0-1.16.56-2.37.32.07.48-.14,1.19.39,1.29-.25-1.67.82-.48,1.97-.65v-.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M431.27,53.99c-1.32-.78.95,1.09,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M429.7,43.97c.81.28,1.77-.84.79-.97.12,1.01-1.14-.82-1.18.32.31.07.46.27.39.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M426.93,48.17c.02.44-.19.71-.4.97.98.05,1.64-.17,1.98-.65-.69.02-1.23-.07-1.58-.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M424.17,53.99h-.79v.65h.79v-.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M422.59,52.37c-.09.46-.65.55-.79.97.81.28,1.77-.84.79-.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M420.62,44.61c-1.2,1.09,1.46.98,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M419.43,46.23c.02-.41.51-.45.4-.97-.97-.5-1.16,1.1-.4.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M418.25,42.03c.47.05.89.58,1.18,0-.47-.05-.9-.57-1.18,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M418.64,30.39c-1.32-.78.95,1.08,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M416.67,16.16c.19-1.23-.17-2.02-1.18-2.26.05,1.03-.39,2.47,1.18,2.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M413.91,42.35c-1.56.38,1.56.38,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M411.93,38.79c-.26.21.17-.14,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M397.32,44.61c-.55-.93,1.08-1.64,0-1.94-.39.68-2.41-.63-2.37.97,1.52-.73,1.78.13,2.37.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M389.43,4.52c-.09-.25,0-.64-.39-.65.09.25,0,.64.39.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M387.06,44.29c-.12-.63.53-.64.79-.97h-1.18c.06.38-.07.92.39.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M385.48,48.49v-.65c-.4,0-.47-.26-.79-.32.04.51-.05,1.12.79.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M383.9,60.45c-.57-.08-.67-.53-1.19-.65.19,1.02-1.06.86-1.18,1.62,1.01-.15,1.81-.45,2.37-.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M383.51,52.37c-.74-.07-.87.36-1.58.32v.65c.5.02.55.42,1.18.32-.03-.56.09-1.01.39-1.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M381.53,45.58c.16-.14-.26.21,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M380.75,60.45c1.18-.56-.57-2-1.19-.97.91-.1.44.93,1.19.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M379.56,62.39c-.26.21.17-.13,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M375.61,58.84c1.91-1.55-.37-4.72-2.37-5.17-.12,2.47.47,4.36,2.37,5.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M376.4,64.33c-.48-.07-.24-.36,0-.65-1.65-.51-.43,1.98,0,.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M372.85,43.97c-1.12-.27-1.02.45-1.97.32v.65c.5.02.55.41,1.18.32-.45-1.01.62-.78.79-1.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M371.66,45.91c.95-.13-.22,1.47,1.18.97.42-.82-.83-1.84-1.18-.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M372.45,49.46c.08-.93.05-1.77-1.18-1.62.13.75.4,1.39,1.18,1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M370.08,68.53c.09.25.01.64.4.65-.09-.25-.01-.64-.4-.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M369.69,57.22c.11-.74-.1-1.22-.79-1.29.09.57-.4,1.62.79,1.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M368.51,65.95c-3.05-.05,1.27.77,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M366.93,67.56c.68.02,1.01-.25,1.18-.65-.68-.02-1.01.25-1.18.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M366.53,65.63c-1.66-.06-1.46-3.31-3.16-2.26.27,1.19,1.06,3.65,3.16,2.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M365.35,43.97c-1.56.37,1.56.37,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M363.37,64.01c-1.28.4-.3-1.05-1.58-.65.09.61-.44.71-.39,1.29.75-.15,2.38.44,1.97-.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M359.43,64.01c.02.44-.19.71-.4.97.57-.17,2.04.38,1.97-.32-.31-.07-.46-.27-.39-.65h-1.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M359.82,53.34c-.7.18-1.64.17-1.97.65.81.69,1.88.17,1.97-.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M359.03,44.61c-1.56.38,1.56.38,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M357.45,64.33c.99.04,1.24.62,1.58-.32-.59.05-1.46-.12-1.58.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M358.24,60.78c-.59.06-1.46-.11-1.58.32.29.23,1.93.8,1.58-.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M353.51,63.69c.11-1.2,1.66-2.39-.79-2.59.6.39.1,3.34.79,2.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M351.93,60.13c-.95-1.66-1.02,1.11,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M351.53,62.07c-.26.21.17-.14,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M346.4,54.96c.31.07.46.27.39.65.69-.02,1.23.07,1.58.32-.03-.56.09-1.01.39-1.29-1.2.13-2.01-.85-2.37.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M348.77,63.36c-1.06-.22-.76.67-1.18.97.86.06,1.25-.27,1.18-.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M347.98,65.3c-1.22-.23-.76-.23-1.97,0-.02-.44.18-.71.39-.97-1.46.04-.99.47-.79,1.29.69-.19,2.32.39,2.37-.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M347.58,37.5c-.66.06-.28-2.29-1.18-.97.53.22-.11,1.98,1.18.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M347.19,38.79h-1.58v.97c1.03.09,1.7-.12,1.58-.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M346.79,42.67v-1.29c-1.52-.25-1.52,1.55,0,1.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M346.79,63.04c-2.17-.84-2,1.14,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M344.43,65.3c-1.15.08-1.36-.61-1.97-.97-.08.39-.44.2-.79,0,.05.6.26,1.08.79,1.29.02-.2.06-.38.4-.32v.65c.9.09,1.48-.08,1.58-.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M343.24,54.63c-.26.21.17-.13,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M342.45,46.88c-.26.21.17-.13,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M340.08,41.06h1.58v-.97c-1.03-.09-1.97-.11-1.58.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M339.69,66.6h1.97v-.65c-.24-.02-.47-.05-.39-.32-.74-.02-.84.25-.4.65-.48-.1-2.44.05-1.18.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M340.08,51.4c-.26.21.17-.13,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M340.08,57.87c.12-.2.98-1.24,0-1.29.38.6-1.18,1.08,0,1.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M340.08,63.69c-1.32-.78.95,1.08,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M340.08,37.18c-2.29-.34-.16,1.4,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M339.69,46.23c-3.05-.05,1.27.77,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M339.69,65.63c-.26.21.17-.14,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M339.29,40.09c-1.01.04-2.03.06-1.97.97,1.13.06,2.15.04,1.97-.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M338.5,53.02c.35-.57,1.1-.82.79-1.94h-1.58c.36.57.13,1.61.79,1.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M336.53,37.18c-3.61-.15.96.84,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M331.79,39.12c-.26.21.17-.13,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M326.66,54.96c.17-.14-.26.21,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M325.08,35.56c-.7-.28-1.22-1.08-1.58,0,.73-.31,1.32.97,1.58,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M322.32,54.31c0,.97.71,1.36,1.58,1.62-.09-.61.44-.71.4-1.29-.95.13-.86-.59-1.98-.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M323.5,41.7c.19-.73-.99-1.94-1.58-.97.76.13.31,1.25,1.58.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M322.71,56.25c-1.56.37,1.56.37,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M321.13,45.58c-1.56.37,1.56.37,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M320.34,39.44c-1.56.37,1.56.37,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M319.95,46.23c-1.56.38,1.56.38,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M319.56,48.17c-.93,0,.14.88.79.65.06-.8-.2-1.34-.79-1.62-.02.2-.06.38-.39.32-.09-.25-.01-.64-.4-.65-.45,1.02.62.79.79,1.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M317.98,51.4c.58.17.99.48,1.58.65.02-.41.51-.45.39-.97-.5-.44-1.93-.5-1.97.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M317.98,41.7c-1.56.38,1.56.38,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M317.98,53.99c-.09-.25-.01-.63-.4-.65.09.25.01.64.4.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M317.19,58.51c-1.47.35-1.13-.8-2.37-.65.62.84-.9,2.45,1.58,2.26-.34-1.03.62-1,.79-1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M316.4,48.49s-.24,1.09-.39.97c.95.78,1.02-1.06.39-.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M312.05,52.37c1.8-.03,3.44-.2,4.34-.97-.6-.66-3.55-.5-4.34.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M316.4,55.6c-.46-.05-.43-.51-.39-.97-1.03.19-1.42-.13-1.18-.97-1.48-.25-1.34.85-1.97,1.29,1.62-.09,2.31,1.07,3.55.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M312.85,58.51c1.31.13,2.2-1.74.79-1.94-.23.68-.98.92-.79,1.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M312.05,46.55c-.09-.25-.01-.64-.39-.65.09.25,0,.64.39.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M310.87,50.76c-1.56.37,1.56.37,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M310.87,43.32c-.09-.25-.01-.64-.39-.65.09.25.01.64.39.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M308.9,43c-1.56.38,1.56.38,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M308.11,53.66c-.26.21.17-.13,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M306.53,47.2c-.12-.75,1.14-.36,1.18-.97-1.12-.44-2.37.58-1.18.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M302.97,55.93c1.48.08,2.08,2.07,2.37,4.85,1.29-.86.85-3.74.79-5.82,1.03.09,1.98.11,1.58-.97-1.94.62-1.06-1.07-2.37-.97,1.05,2.46-2.61,1.67-2.37,2.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M305.34,45.26c-.26.21.17-.13,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M305.34,50.76c-1.54.8,1.31.47,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M304.55,63.69c-1.56.37,1.56.37,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M304.55,60.13c-1.12-.44-2.37.58-1.18.97-.12-.75,1.14-.36,1.18-.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M304.16,63.04s-.04.04-.06.05c.05-.04.15-.13.06-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M303.76,51.73c.17-.14-.26.21,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M303.76,50.43c-1.39.28-2.03-.83-2.37.32.66-.04,2.51,1.05,2.37-.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M301.79,58.84c-.78.1-.78-.44-1.18-.65v.97c.47-.05,1.12.06,1.18-.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M297.05,50.11c.15,1.06.92,1.62,1.58,2.26.92-.85-1.13-1.23-1.18-2.26.87-.69,3.49.06,3.55-1.29-2.21.13-4.11.51-5.92.97-.38-.6,1.18-1.08,0-1.29-.41.85-1.57,1.09-1.98,1.94,1.34-.09,2.27-.51,3.95-.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M299.03,52.69c-.09.25,0,.64-.39.65-.02-.2-.06-.38-.39-.32-.06.91,1.11.81,1.58,1.29.82-.64.01-1.38-.79-1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M300.21,54.63h-.79v.65h.79v-.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M297.84,53.02c.02-.56-.3-.83-.79-.97-.02.56.3.83.79.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M296.66,52.37c-1.04.1-1.02-.67-1.18-1.29-2.13-.05-.23,1.32-1.18,1.94,1.48-.32,2.32.36,2.37-.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M295.47,56.25c.42-.82-1.33-1.43-1.58-.65.62.14.34,1.02,1.58.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M293.89,57.22c-1.56.37,1.56.37,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M293.5,52.69c-.68-.02-1.01.25-1.19.65.68.02,1.01-.25,1.19-.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M286.79,61.75c-.26.21.17-.13,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M285.61,55.6c-1.89-.66,1.99.7,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M285.21,56.57c-.52-.42-1.47-.43-1.58.32.59-.06,1.46.11,1.58-.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M283.24,53.66c-3.6-.15.96.84,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M278.5,55.28c1,.6,3.23,1.86,4.34,1.29-1.28-.57-2.84-.91-3.55-1.94-.67.74-3.01.12-4.34.32-.96.6,2.6.22,3.55.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M282.45,58.19c-.95-.92-1.45-.32-3.16-.32.21,1.47,2.33,1,3.16.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M282.05,64.66c-1.56.37,1.56.37,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M279.68,60.78c-.09-.25-.01-.64-.4-.65.09.25.01.64.4.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M277.71,58.51c.05.6.26,1.08.79,1.29-.09-.57.4-1.62-.79-1.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M275.34,62.72c.52.42,1.47.42,1.58-.32-.99-.04-1.24-.62-1.58.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M274.19,58.16s-.04.03-.06.05c0,0,.01-.01.03-.02.02-.02.03-.02.03-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M273.76,54.96c.17-.14-.26.21,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M272.97,54.63c-3.6-.15.96.84,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M271.79,44.29c-1.03-.19-1.42.13-1.18.97,1.06.22.76-.67,1.18-.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M267.45,55.28c.34.36,2.83-.25,3.55-.65-1.09.29-3.7-.66-3.55.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M270.21,56.57c-.24-.1-1.52-.8-1.58,0,.74-.31,1.32.97,1.58,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M268.63,57.55c-1.56.37,1.56.37,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M265.87,57.55c-1.56.37,1.56.37,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M264.29,60.13c-1.56.37,1.56.37,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M260.73,54.31c.58,0,3.23.12,1.97-.32-.58,0-3.23-.12-1.97.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M263.1,60.78c-.09-.25-.01-.64-.39-.65.09.25.01.64.39.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M259.94,53.66c-2.74.25-3.73-.95-5.92-.32,1.56.24,4.26,1.24,5.92.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M258.37,51.4c.12.75-1.14.36-1.18.97,1,.34,2.25-.68,1.18-.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M251.66,53.34c-.57.18-2.04-.38-1.97.32.58.17,1,.48,1.58.65.02-.41.5-.45.4-.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M249.29,53.99c-.09-.25-.01-.63-.4-.65.09.25.01.64.4.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M248.89,51.73c-.09-.25-.01-.64-.4-.65.09.25.01.64.4.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M248.1,53.66c-3.05-.05,1.27.76,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M247.71,56.57c.09.25.01.64.4.65-.09-.25-.01-.64-.4-.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M247.71,59.81c-1.56.38,1.56.38,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M246.92,55.6c-1.33-.98-1.2,1.2,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M246.13,47.2c.16-.14-.26.21,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M244.94,62.07c-.31.07-.78,0-.79.32.31-.07.78,0,.79-.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M243.76,51.08c-.06-.38.07-.92-.39-.97.06.38-.07.92.39.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M243.37,56.25c-1.56.37,1.56.37,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M242.58,63.69c-1.31.47,1.54.8,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M240.6,54.63c.98.05,1.92.06,1.97-.65-.75.15-2.38-.44-1.97.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M239.42,68.53c1.56.42.95-.94,1.97-.97.16.78-.72.7-.39,1.62,2.04-.46.42-1.09,1.18-2.59-.75.07-.87-.36-1.58-.32.44,1.44-1.04,1.3-1.18,2.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M240.6,46.88c-.26.21.17-.13,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M239.42,70.48c.68.02,1.01-.25,1.18-.65-.68-.02-1.01.25-1.18.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M238.63,71.77c.53.42,1.47.43,1.58-.32-.59.06-1.46-.11-1.58.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M239.81,54.31c-.7.07-1.98-.33-1.58.65.9.09,1.48-.08,1.58-.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M237.05,67.89c.59-.06,1.46.12,1.58-.32-.53-.42-1.47-.43-1.58.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M236.26,72.09c1.22-.24.76.89,1.97.65.12-1.01-1.83-1.72-1.97-.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M237.44,54.63c-.7.07-1.98-.33-1.58.65.73-.04,1.32-.21,1.58-.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M236.26,69.18c.02.2.06.38.39.32.1-.46.65-.55.79-.97h-1.19v.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M237.05,69.83c-.26.21.17-.13,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M236.65,55.6c.04.36-.57.5,0,.65.4,0,.5-.57,0-.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M237.05,61.1c.11-.74-.1-1.22-.79-1.29-.2.82-.67,1.25.79,1.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M235.47,66.6h.79v-.65h-.79v.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M236.26,71.44c.07-.81-.61-1.01-1.18-1.29-.71.56.12,1.27,1.18,1.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M234.29,70.8c-.05-.6-.26-1.08-.79-1.29-.11.74.09,1.22.79,1.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M231.52,53.34c-.02.2-.06.38-.39.32v.65c.97.5,1.16-1.1.39-.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M229.55,58.51c-.9-.09-1.48.08-1.58.65.58.51,1.76.36,1.58-.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M227.18,64.98c-1.56.38,1.56.38,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M226,64.98c-1.56.38,1.56.38,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M223.63,57.55c1.06.22.76-.67,1.19-.97-.86-.06-1.25.27-1.19.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M222.44,51.73c-.61.79,1.34.95,1.18.32-.24-.02-.47-.05-.4-.32h-.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M223.23,66.27c-1.32-.78.95,1.09,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M222.44,49.14c-.09-.25-.01-.64-.4-.65.09.25.01.64.4.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M219.68,51.08c-1.54.8,1.31.47,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M218.1,53.02c.02-.2.06-.38.39-.32v-.65c-.54.01-.87-.15-1.18-.32-.11.74.09,1.22.79,1.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M218.1,57.87v-1.29c-1.23-.03-1.13,1.02-2.77.65-.12.85.83.83,1.58.97-.27-1.07.82-.52,1.19-.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M216.13,51.73c.12-.44.56-.62.4-1.29-1.1-.52-1.09,1.39-.4,1.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M211.78,53.66c-.96.18-1.44.76-1.97,1.29.98.76,2.48.13,1.97-1.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M211.39,56.25c-1.31.47,1.54.8,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M210.6,57.87c.65.14-.03-1.21-.39-1.29.46.85-1.22,1.39.39,1.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M209.02,54.96c.4,0,.5-.57,0-.65.04.36-.57.5,0,.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M208.62,58.19h.79v-1.29h-.79v1.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M209.02,52.05h-1.18c-.58.94,1.76.94,1.18,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M207.84,54.31c-2.29-.34-.17,1.4,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M205.07,58.19c.16-.14-.26.21,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M203.89,47.2c.43-1.71-1.2-.38,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M203.49,60.45c.16-.14-.26.21,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M202.71,61.1c-.16-1.06-.34-2.09-1.58-2.26-.18.89,1.83,1.81-.4,1.62-.05,1.3,1.01.86,1.98.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M201.91,42.35c-2.4.1,1.51.63,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M201.91,64.01c.4,0,.5-.57,0-.65.04.36-.57.5,0,.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M200.73,61.75c-.26.21.17-.13,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M200.34,56.57c-.13-.75.06-1.24.39-1.62-1.7-.4-2.19,1.85-.39,1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M198.76,63.04c.72-.02,1.34,1.66,1.97.65-1.23.1,1.01-.93-.39-.97.17.91-1.47-.81-1.58.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M199.94,49.46c.4,0,.5-.57,0-.65.04.36-.57.5,0,.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M199.94,61.75c-.26.21.17-.13,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M198.76,43c1.39-1.31-1.27-.76,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M196.78,54.96c.31.07.46.27.39.65.92-.11,1.85-.21,1.58-1.29-.93.1-1.48.51-2.76.32-.51.76.05.6-.39,1.62,1.63.08.53-1.26,1.18-1.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M198.36,45.91c-.09-.25-.01-.64-.39-.65.09.25.01.64.39.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M198.36,61.1c-.09-.25-.01-.64-.39-.65.09.25.01.64.39.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M197.18,63.36c.09.25.01.64.39.65-.09-.25-.01-.64-.39-.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M196.78,49.14c.16-.14-.26.21,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M196.78,58.84c.16-.14-.26.21,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M194.81,65.3c.93.42.73-.04,1.97.32-.56-.72-.82-1.7-1.97-1.94-.24,1.03.74,1,0,1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M195.6,74.68c.03-.83,1.69-.34,1.18-1.62-1.33-.42-2.09,1.27-1.18,1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M195.2,53.02c-.26.21.17-.13,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M193.62,69.51c-.63,1.11-1.85,1.02-2.37,0-.09.25-.33.38-.79.32.85,1.25,1.66,2.52,2.37,3.88,1.24-.16,1.61.76,1.97-.32-2.27-.48,1.31-2.56-.79-2.26.47-.16.89-.34,1.18-.65-.8-.1-.77-.88-1.58-.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M194.41,56.25v-1.94c-1.12.16-1.13,1.23-1.58,1.94h1.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M192.44,58.51c-.63.9,1.71.89,1.58.32-.53-.1-.76-.46-1.58-.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M194.02,62.39c-.57-.36-.96-.35-1.18.32.54-.02.87.15,1.18.32v-.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M193.62,64.66c.17-.14-.26.21,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M193.62,65.3c-1.56.37,1.56.37,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M191.25,69.18c1.24.37.96-.51,1.58-.65.4,0,.47.26.79.32.18-1.01-.34-1.44-1.58-1.29.3,1-1.36.4-.79,1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M191.65,63.69c.8.56.77-.24,1.58.32v-.65c-.4,0-.47-.26-.79-.32,0,.42-.69.29-.79.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M192.83,39.12h-.79v.97h.79v-.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M192.04,41.38c.49,1.05-1.28.25-.79,1.29,1,.34,1.75-1.09.79-1.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M192.44,43.97h-1.18c-.58.94,1.77.94,1.18,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M192.04,56.9c-1.31-.1,1.54-1,0-1.29-.11.67-1.75.08-1.58.97.53-.05,1.19,1.32,1.58.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M190.07,67.24c.09-.25.01-.64.4-.65.82.71,1.28-.28,1.97.32-.06-.38.07-.92-.4-.97-.32.28-3.45-.08-1.97,1.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M190.86,63.69c-1.56.37,1.56.37,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M190.86,73.06c.06-.8.07-1.57-.79-1.62-.82.65-.01,1.38.79,1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M188.89,51.08c1.44.21,1.55-.67,1.58-1.62-1.14.04-1.88.4-1.58,1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M190.07,48.17c-.06-.38.07-.92-.39-.97.06.38-.07.92.39.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M190.07,53.02c-1.33-.98-1.2,1.2,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M189.68,69.51c.33-.38.52-.87.39-1.62h-.79c-.84.11.06,1.41.4,1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M189.28,46.23c-.09-.61.44-.71.4-1.29h-1.18c.05.6.26,1.08.79,1.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M189.28,55.6c-1.31.47,1.54.8,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M189.28,54.63h-.79c0,.32-.32.38-.39.65.62-.03,1.37.04,1.18-.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M189.28,61.75c-.06-.38.07-.92-.4-.97.06.38-.07.92.4.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M189.28,62.72c-.09-.25-.01-.64-.4-.65.09.25.01.64.4.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M187.7,58.19h.79v-.97h-.79v.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M188.1,53.34c-.2-.81.01-1.95-1.18-1.94-.21,1.14.33,1.66,1.18,1.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M186.91,59.16c-.02.56.3.83.79.97-.04-.51.05-1.12-.79-.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M187.31,44.61c-.09-.25,0-.64-.39-.65.09.25,0,.63.39.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M186.52,53.66c-.26.21.17-.13,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M185.73,42.03h-.79v.65h.79v-.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M185.33,46.23c-1.56.38,1.56.38,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M184.94,44.94c.7-.98-.61-2.6-1.98-2.91.07,1.45,1.25,2,1.98,2.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M183.36,45.58h.79v-.65h-.79v.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M184.15,48.17c-1.24.16-.3-1.48-1.18-1.62.3.99-1.08.62-.79,1.62.98-.42,1.64.95,1.97,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M182.57,49.46c-1.56.37,1.56.37,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M182.57,54.63c.09.25.01.64.39.65-.53-1.94-1.01-2.23-.79-3.55-.8.42-.54,1.71-1.58,1.94.57-.47.3-1.02-.79-.97-.24,1.59,1.96,1.19,2.76,1.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M181.39,49.46c.11-.74-.09-1.22-.79-1.29-.5.38-.32,1.34.79,1.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M179.02,47.2c-.42-.83,1.2-1.54,0-1.94-.48.73-1.14,1.42,0,1.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M178.23,55.6c-.06.8.2,1.34.79,1.62-.17-.61.54-1.95-.79-1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M177.44,52.69v.97c.86.06,1.26-.26,1.19-.97h-1.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M177.05,57.87c.59-.06,1.45.11,1.58-.32-1.33.12-.71-1.36-1.98-1.29-.32.91.56.84.4,1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M177.44,48.17c.17-.14-.26.21,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M177.44,54.96v-.65c-.39,0-.47-.26-.79-.32.04.51-.05,1.12.79.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M173.1,56.9c.2-.78,2.58-1.43.79-1.94-.12.58-2.09,1.26-.79,1.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M171.52,73.39h-.79v.65h.79v-.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M167.96,67.56h-.79c0,.33-.32.39-.4.65.62-.03,1.37.04,1.18-.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M167.18,57.55c.16-.14-.26.21,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M166.39,58.51v-.65c-.59.05-1.46-.12-1.58.32.56.08.66.53,1.18.65.02-.2.06-.38.4-.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M164.81,65.95c0,.43-.69.3-.79.65.46.79,1.86-.36.79-.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M163.23,69.83c-1.56.38,1.56.38,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M160.07,50.11c.97.5,1.16-1.1.39-.97-.02.2-.06.38-.39.32v.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M158.49,63.69c.16.78-.72.7-.4,1.62.71-.04.93.32.79.97,1.81-.67.92.66.79,1.29,1.11.05,1.14-.79,1.18-1.62-1.48-.18-1.26-1.77-2.37-2.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M160.46,68.53c-1.54.8,1.31.47,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M160.86,73.71c-.8-.56-.77.24-1.58-.32.12.63-.53.64-.79.97,1.05,0,2.32.18,2.37-.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M160.07,60.78c.09.25.01.64.39.65-.09-.25-.01-.64-.39-.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M160.07,47.52h-.79v.65h.79v-.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M159.28,56.57c1.2-1.09-1.46-.98,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M158.49,50.76c-.1.46-.65.54-.79.97.81.28,1.77-.84.79-.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M157.31,54.96h1.18c-.06-.38.07-.92-.4-.97-.09.46-.65.55-.79.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M158.09,69.18c.09.25.01.64.4.65-.09-.25-.01-.64-.4-.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M157.7,74.03c-1.32-.78.95,1.09,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M156.52,50.11c1.33.12.66-1.4,1.18-1.94-2.13-.05-.23,1.32-1.18,1.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M157.7,69.83c-.09-.25-.01-.64-.39-.65.09.25,0,.64.39.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M157.31,73.39c.4,0,.49-.57,0-.65.04.36-.58.51,0,.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M156.91,63.69c-1.31.47,1.54.8,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M156.12,61.1c-.24-.02-.47-.05-.4-.32h-.79v.65c.24.02.47.05.39.32h.79v-.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M154.15,73.39c1.65.29,3.02-2.24.79-2.26-.97.78-1.16.95-.79,2.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M154.94,51.08c.03-.51,1.01-.25.79-.97-.81-.28-1.77.84-.79.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M155.33,66.6c-1.31.47,1.54.8,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M154.94,56.57c-.09-.25-.01-.64-.4-.65.09.25.01.64.4.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M154.54,61.1c-.09-.61.45-.71.4-1.29-1.1-.52-1.09,1.4-.4,1.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M154.54,45.58c.11-.74-.09-1.22-.79-1.29-.11.74.09,1.22.79,1.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M151.38,51.73c.86.06,1.25-.27,1.18-.97-1.06-.22-.76.67-1.18.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M149.8,51.73c1.17-.66,1-2.42,2.37-2.91h-2.37c1.73,1.34-1.07,1.65,0,2.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M150.99,54.63c-1.06.45-1.48,1.18-.79,2.26,1.46.42,1.57-1.91.79-2.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M149.41,54.63c-1.56.37,1.56.37,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M149.02,60.45c.4,0,.5-.57,0-.65.04.36-.57.5,0,.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M147.83,50.43c.09-.46.65-.55.79-.97-.81-.09-.09-1.43-1.18-1.29.34,2.2-.92.51-1.97.32-.14,1.4,1.61,1.27,2.37,1.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M148.22,51.08h-.79v.97h.79v-.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M147.04,56.25c1.35-.09,1.87-3.16.39-3.56.58,1.88-2.55,2.28-.39,3.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M146.25,43.64c-.09-.25-.01-.64-.4-.65.09.25.01.64.4.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M143.88,53.66v1.62c2.09.2,1.69-1.73,0-1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M145.07,63.04c.51-.43.52-1.2-.4-1.3.07.48-.14,1.2.4,1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M144.67,65.95c-.24-.77-.57-1.47-.4-2.59-1.29-.02-1.51-.92-3.16-.65-.33.91.56.84.4,1.62.78.1.78-.44,1.18-.65.21.48.58.81.79,1.29-.68-.02-1.01.25-1.18.65.31.07.46.27.39.65,1.35-.13.5-.87,1.97-.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M142.3,44.29c-1.09,1.23,1.45,1.42,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M142.3,58.19c.43-1.71-1.2-.38,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M140.73,73.71c-.09-.25-.01-.64-.39-.65.09.25.01.64.39.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M139.93,62.07c0-.76.68-.95.4-1.94-1.26-.46-1,1.93-.4,1.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M139.54,72.42c.09.25.01.64.39.65-.09-.25-.01-.64-.39-.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M138.36,64.01c-.02-.45.19-.71.4-.97-.54.01-.87-.15-1.18-.32-.11.74.1,1.22.79,1.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M137.17,73.06c.9.09,1.48-.08,1.58-.65-.7-.6-1.22.08-1.58.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M137.17,57.55c-1.31.47,1.54.8,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M136.38,59.16h.79v-.65h-.79v.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M135.99,54.63c.1-.46.65-.55.79-.97-.44-.07-.61-.36-.79-.65,0-.32.32-.38.4-.65-1.31-.4-.96,2.19-.4,2.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M136.38,55.93c.09.25.01.64.4.65-.09-.25-.01-.64-.4-.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M135.2,73.39c.82-.65.01-1.38-.79-1.62-.06.8-.07,1.57.79,1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M135.2,48.49c-.09-.25-.01-.64-.4-.65.09.25.01.64.4.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M134.8,57.87c.52-.99.1-2.54-1.18-1.62.92.1.39,1.41,1.18,1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M134.8,53.34c-.09-.25-.01-.64-.4-.65.09.25.01.64.4.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M134.8,54.96c-.09-.25-.01-.64-.4-.65.09.25.01.64.4.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M134.41,68.53c-.26.21.17-.13,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M134.41,47.2c-.06-.38.07-.92-.39-.97.06.38-.07.92.39.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M133.22,54.96c-1.1.14.31-1.76-.79-1.62.29.99-1.08.62-.79,1.62.24.09,1.52.8,1.58,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M132.44,52.69c-1.56.38,1.56.38,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M128.09,60.78c1.12-.06-.48,2.12,1.19,1.62-.4-1.62,1.23-1.58,1.18-2.91-1.58-.21-1.16,1.21-2.37,1.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M128.49,55.93c-1.54.8,1.31.47,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M126.91,64.33c.17-.14-.26.21,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M126.91,55.6c-.82-.19-1.28-.68-1.97-.97v1.29c.57-.18,2.04.38,1.97-.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M125.33,66.27h1.18v-.65c-.62.03-1.37-.04-1.18.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M125.73,52.05c-.4.79-.13.69-.4,1.94,1.26.46,1-1.93.4-1.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M124.15,55.6c-.38-.6,1.18-1.08,0-1.29-.12.2-.98,1.24,0,1.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M120.2,50.43c-.07-.48.14-1.19-.4-1.29-.51.43-.52,1.2.4,1.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M118.62,49.46c-.26.21.17-.13,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M117.43,55.93h-.79v.65h.79v-.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M114.67,54.31v1.29c1.52.25,1.52-1.55,0-1.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M114.27,57.22c-.19-1.01,1.36-.85.4-1.62-1.6-.19-1.25,1.33-.4,1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M113.09,51.73c-.06-.38.07-.92-.39-.97.06.38-.07.92.39.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M112.7,52.69c-.09-.25-.01-.64-.39-.65.09.25.01.64.39.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M109.54,66.27v-1.29c-.9-.09-1.48.08-1.58.65.78,0,.5.88,1.58.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M109.14,57.55c-1.38-.06-1.24,1.14-1.97,1.61,1.38.06,1.24-1.14,1.97-1.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M104.8,66.92c-1.56.37,1.56.37,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M104.8,72.74v-.97c-1.15-.47-1.15,1.45,0,.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M103.62,57.55c-.09-.25-.01-.64-.4-.65.09.25.01.64.4.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M101.25,64.66c-1.56.37,1.56.37,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M101.25,69.83c.04.36-.57.5,0,.65.4,0,.5-.57,0-.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M99.27,73.71c-.29.79,2.56,1.32,1.97.32-.95.13-.86-.59-1.97-.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M89.41,60.13c.05.6.26,1.08.79,1.29-.09-.61.44-.71.39-1.29h-1.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M89.01,63.36c.37-2.03-1.23-2.44-1.97-3.56,1.09-.26.98-1.93,0-2.26-1.61,2.22-1.09,5.03,1.97,5.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M87.43,46.88c-1.56.37,1.56.37,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M87.04,53.66c-1.32-.78.95,1.09,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M86.25,48.17c.17-.14-.26.21,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M84.67,61.75c-.26.21.17-.13,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M84.27,52.37c.19-1.01-.49-1.32-1.18-1.62-.77.62-.41,1.98,1.18,1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M81.51,56.57c.73-.04,1.32-.21,1.58-.65-.9-.09-1.48.08-1.58.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M82.69,61.75c.02-.41.51-.45.4-.97-.97-.5-1.16,1.1-.4.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M82.69,47.85c-.76.14-1.7.12-1.58.97.99.06,1.24-.5,1.58-.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M82.69,59.16c.43-1.71-1.2-.38,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M81.51,65.63c-2.4.1,1.5.63,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M81.51,58.51h-.79v.65h.79v-.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M79.14,55.28c.56-.4.75-1.11.79-1.94-.84-.02-2.16,2.21-.79,1.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M76.77,60.45c-1.32-.78.95,1.09,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M75.19,64.33c-.02-.45.19-.71.4-.97-1.31.33-1.71-.18-2.37.97.66,0,1.32,0,1.97,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M75.19,66.6c-.09-.25-.01-.64-.39-.65.09.25.01.64.39.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M73.61,66.92c.57.08.67.53,1.19.65.35-.66-1.02-1.45-1.19-.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M73.61,51.4c-.69.02-1.23-.07-1.58-.32v.97c.74-.04,1.32-.21,1.58-.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M70.85,66.27c-.09-.25-.01-.64-.4-.65.09.25.01.64.4.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M70.06,62.39s-.24,1.1-.4.97c.95.78,1.02-1.06.4-.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M70.06,68.21c-.92-.21-.85,1.26,0,.97.32-.11.48-.86,0-.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M68.09,66.92c.24.09,1.52.8,1.58,0-.52,0-.36-.57-.79-.65,0,.43-.69.3-.79.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M66.93,67.86s-.01.01-.03.03c-.19.16,0,0,.03-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M65.32,63.36c-1.54.81,1.31.47,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M64.14,67.56c-.09-.61.44-.71.4-1.29-1.34-.24-1.54,1.24-.4,1.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M60.19,63.04c-.16-.78,1.8.18,1.18-.97-1.08.23-.79-.64-1.58-.65.22.47-.46,1.67.4,1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M60.19,63.69c-1.27.04-1.76.71-2.77.97,1.15.85,2.34-.24,2.77-.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M59.01,63.04c-.76.19-3.57-1-3.55.65,1.11.09,2.47.1,3.55-.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M54.67,63.36h-.79v.65h.79v-.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M53.09,65.3c.88-.14.31-1.71,0-1.94-1.51-.07-1.32,1.87,0,1.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M51.11,61.75c-2.4.1,1.51.63,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M49.53,61.1c-.24-.02-.47-.05-.4-.32h-.79c-.61.8,1.34.95,1.18.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M47.95,38.79c-.09-.25-.01-.64-.39-.65.09.25.01.64.39.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M46.37,40.41c-.1.46-.65.55-.79.97.82.28,1.77-.84.79-.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M45.98,61.75c-.38-.6,1.18-1.08,0-1.29-.08.39-.44.2-.79,0-.2.82-.67,1.25.79,1.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M42.43,61.1c-.4,0-.47-.26-.79-.32,0,.33-.32.39-.4.65.4,0,.47.26.79.32,0-.32.32-.38.4-.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M40.06,41.38c.17-.14-.26.21,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M38.08,57.87c-.09-.25-.01-.64-.39-.65.09.25.01.64.39.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M37.3,37.82s0,0-.02.01c.02-.02.04-.03.05-.04,0,0-.01.01-.03.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M36.9,58.51c-.24-.02-.47-.05-.4-.32.31-.07.78,0,.79-.32h-1.18c-.45.66.62,1.54.79.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M35.32,66.27v.65h.79v-.65h-.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M35.32,48.49c-.09-.25-.01-.64-.4-.65.09.25.01.64.4.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26.24,59.81c1.61-1.69,3.45,1.16,4.73-.32.04.51,1.01.25.79.97.94-1.32,2.27.81,2.76-.65-1.85.11-1.38-1.68-2.76-1.94-.03.85-2.12,1.68-2.76.97.07-1.02,2.12-.41,1.97-1.62-2-.21-2.92,1.73-4.34.97.16.78-.72.7-.39,1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M34.14,66.27s.02-.01.02-.02c0,0-.01,0-.02.02,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M32.95,50.43c-.02.2-.06.38-.4.32v.65c.97.5,1.16-1.1.4-.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M30.98,47.2c-.09-.25,0-.64-.39-.65.09.25.01.64.39.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M30.19,61.1c-1.56.38,1.56.38,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M29.01,56.57c-1.54.8,1.31.47,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M29.01,61.1c.16-.14-.26.21,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M27.45,43.95s-.07.06-.09.08c.01,0,.03-.02.07-.06.01-.01.02-.02.02-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M27.45,67.22s-.07.06-.09.08c.01,0,.03-.02.07-.06.01-.01.02-.02.02-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M25.85,52.69s-.01.01-.02.02c.01-.01.03-.02.04-.03,0,0,0,0-.02.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M25.83,52.71c-.05.04-.11.09,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M25.85,53.99c-1.14.15-1.8.68-1.97,1.62,1.34.02,1.47-.95,1.97-1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M25.45,41.06c-.09-.25-.01-.64-.4-.65.09.25.01.64.4.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21.11,59.48c1.37-.52,1.84-.75,2.77.32-.32-1.12.44-1.37.79-1.94-2.53.3-1.79-.4-2.76-.97.48,1.47-1.08,1.27-.79,2.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.53,61.1c1.24.15,1.11-.81,1.58-1.29-1.11-.05-.99.92-1.58,1.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.14,59.81c.44-.03.61.47.79,0,0-.32-.69-.41-.79,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.56,56.57c.75.04.27,1.07,1.18.97.09-.25.33-.38.79-.32-.78-1.15-.51-.64,0-1.94-1.16.02-1.46.74-1.97,1.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.35,49.14c-1.32-.78.95,1.08,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.95,54.96c.17-.14-.26.21,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.56,53.66c-.26.21.17-.13,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.37,52.69c.35-.57.95-.94,1.18-1.62-1.43-.5-2.19,1.18-1.18,1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.48,55.6c1.37.38.73-.15,1.18.97,1.44,0,1.77.92,2.77,1.29,1.46-.84.86-.04,3.16-.65v-1.62c-2.79,2.2-4.86-1.92-7.11,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15.19,60.13c-1.04-.23-.38-1.85-1.58-1.94-.04.51.05,1.12-.79.97.07.94,2.08,2.15,2.37.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14.01,62.07h.79v-.65h-.79v.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.61,54.96c.17-.14-.26.21,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.66,53.34c.68.02,1.01-.25,1.19-.65-.62.03-1.37-.04-1.19.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.66,60.13c-1.56.37,1.56.37,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.66,35.56c-.24-.02-.47-.05-.39-.32h-.79v.97h1.18v-.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.87,61.42c-1.54.8,1.31.47,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.27,66.27c-.95-1.66-1.02,1.11,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.48,49.46c1.08-1.64-1.38-1.2,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.9,63.36c.58.51,1.76.36,1.58-.65-.9-.09-1.48.08-1.58.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.69,49.78c-.26.21.17-.14,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.9,68.53c.31-.07.46-.27.39-.65-.31.07-.46.27-.39.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.11,58.51c-2.4.1,1.51.63,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5.71,57.22c-.36-.57-.14-1.61-.79-1.94-.75.61-.05,1.68.79,1.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4.53,52.37c.17-.14-.26.21,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4.53,40.41c-.09-.25-.01-.64-.4-.65.09.25.01.64.4.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4.13,53.02c-.09-.25-.01-.64-.39-.65.09.25.01.64.39.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3.74,56.25c.17-.14-.26.21,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4.13,62.07c-.06-.38.07-.92-.39-.97.06.38-.07.92.39.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2.95,58.84h.79v-.65h-.79v.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M.98,50.11c.23-.74-.52-.68-.98-.85v.6c.19.19.51.29.98.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M.58,45.58c-.25.03-.43.13-.58.24v1.16c.28-.4.38-.94.58-1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M746.3,59.81c-.02-.44.19-.71.39-.97-.52.05-1.47-1.09-1.58-.32,1.05-.1-.37,1.81,1.18,1.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M708.01,67.56c.81-.05,2.44.09,4.34.32-.77-.99-2.32-1.33-3.55-1.94-.11.49-1.7,1.36-.79,1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2.56,70.8c-.7-.44-1.22-1.87-.39-2.59-1.72.91,1.14-2.24-.79-2.27.25-.79,1.85-.05,1.97.32,1.54-.43.08-1.44.79-2.26-1.7-.98-1.34-3.65-1.97-5.5-1.22.23-.76.23-1.98,0-.08,0-.13.04-.19.07v12.09c.74.09,1.56.16,2.56.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3.34,56.57c-.17-.51-1.24-.28-.79-1.29.67.12.74-.25.79-.65.39,0,.31.4.4.65.32-.06.39-.32.79-.32.11-.52-.37-.56-.4-.97-.96.29-1.71.75-3.16.65.69-1.81-1.56-2.36-.39-3.56,1.08.3.9,1.63,1.18,2.59,1.45-1.39-.07-2.5-1.77-3.23v7.03c.92-.35,1.39-.55,3.34-.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M243.38,70.2s.03-.03.05-.04c-.03,0-.03,0-.06-.01,0,.02,0,.04.01.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M241,71.12c-.96.32.77,1.43-1.19,1.29.06,1.47.33,1.27,0,2.59.46.65,2.61-.31,1.19.97-.12.85,1.53.25,1.18,1.29,1.47-.39.82-3.35,0-3.88-.64.06.64,1.54-1.18,1.29.11-1.67,2.1-2.45,2.37-2.26.26-.42.21-1.4.01-2.21-.73.68-1.42,1.35-2.38.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M466.01,68.21c-.4-.61-1.82-.1-.79.32.17.07.91-.13.79-.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M447.07,59.16c-.22-.47.46-1.67-.39-1.61-.46,1.05-.45-.87-.4-1.29-1.31-.4-2.25,1.13-1.58,1.29-.05-.35,1.74.48,1.97.97-1.51.77-3.54.37-4.74,1.94.7.21,1.96,1.59,2.77.65-.53-.21-.74-.69-.79-1.29,1.34-.95,1.5-.17,3.16-.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M366.93,64.66c.65-.35,2.82-1.11,3.55-.32-.46.48-.46.81,0,1.29-.68-.02-1.01.25-1.18.65,2.22-.46,1.04-1.72,2.37-2.91-1.25.16-1.39-.58-2.76-.32.12,1.32-.82.17-1.58.32.06.43-1.33,1.2-.39,1.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M286,60.78c.9-.44,1.48.84,1.58,0-.55-.08-.45-.71-.79-.97,1.59.01,2.89.03,3.16.32.03.56-.09,1.01-.39,1.29,2.74.11,2.58.34,3.16,1.94,1.9-1.32,4.75,1.26,5.53,2.91,1.36-.26,1.67.36,2.37.65-.05-.81-.76-1.01.39-1.29.46.48.49,1.32,1.18,1.62-.05-1.55.68-2.93-1.97-3.23.12.63-.53.64-.79.97.44.07.61.36.79.65-.8.56-.77-.24-1.58.32.28-.99-.68-.95-.39-1.94,1.44-.16,2.4-.29,3.55-1.29-.31.73.44,2.16.79,1.29-.58-.4.96-.94-.39-1.62.46-.8,1.64.78,1.58-.65-1.88.37-3.36-.86-3.94.32-.58-1.53-.41-1.89-1.18-2.91h1.18c-.67-.75.63-1.95-.79-1.29,1.05-.83-.76-.46-.79-1.29,1.65-.27,1.86.63,3.16.65,1.13-.99-.02-.87,1.97-.32-.11-.99-1.77-.71-1.97-1.62-.72-.07-1.44.7-3.16.65.02-.61-.31-.69-.79-.32.59-.59,1.06-1.09,0-1.62-.22.67-.62.69-1.18.32.08,1.45,1.38,1.89,1.98,2.91-1.9.14.47.12,0,.97-1.73-.34-1.3,1.09-2.77.97.21-.48.58-.81.79-1.29-.59.05-1.46-.12-1.58.32.31.07.78,0,.79.32-.04.51-1.01.25-.79.97,1.2.87,2.28.55,3.55,0-.46.48-.46.82,0,1.29-1.27-.62-2.04.52-2.37.97.31.65,2.56-1.52,3.55-.32-.55.2-.06,1.24-.79,1.29-1.05-1.2-2.42.09-2.37.65-1.1.05-1.29-.91-.79-1.29-1.26.1-3.2-.74-2.37-1.94.57.08.67.53,1.18.65-.27-1.2-.19-.84-.4-2.26-1.48.53-3.38,1.81-4.74.32-1.23.67-3.72,1.02-3.55-.97-1.13-.06-2.15-.04-1.97.97,1.26.21,3.71.6,2.37,1.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M284.82,57.55c1.75-.46,1.03,1.09,2.37.97-.11-.74.09-1.22.79-1.29-.19,1.01,1.06.85,1.18,1.62.69-.03,1.23.07,1.58.32-.69-2.55-4.9-3.1-5.92-1.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M215.73,53.34c-1.67-.06-3.6,1.35-2.37,2.59-.36-1.81,1.67-1.65,2.37-2.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M201.52,65.95c.02.34.51.26.39-.32-1.38.26-1.3.91-2.37,0v1.29c1.56.42.96-.94,1.97-.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M155.33,62.72c1.04-1.71-.75,1.23,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1111.86,39.12c-1.08.98,1.2-.88,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1100.8,38.79c.93.1.73,1.12,1.97.97.35-.1,2.01-.65.79-.97-.51.62-1.88.11-1.97,0,.93-.09-.04-1.2-.4-1.29-.87.46.5.79-.39.97-.22-.47-.62-.79-1.18-.97.32,1.25-2.55-.04-1.58.97,1.39-.91,1.36,1.51,2.76,1.62.38-.6-1.18-1.08,0-1.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1057.77,35.88c-.31.07-.46.27-.39.65h2.37c.06-.38-.07-.92.39-.97-.36,1.17,2.61.74,2.37,0-1.15.08-1.36-.61-1.97-.97-.6,1.76-2.27,1.07-3.95.65-.35,1.51,1.3-.22,1.18.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1042.38,14.55c-1.08.98,1.2-.88,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1025.8,34.91c-2.05,1.42,1.26-.59,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1007.64,31.68c-1.78,1.17-5.77,2.1-4.34,4.85,3.23.06,4.43-3.26,4.34-4.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1001.72,36.53c-1.08.99,1.2-.88,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M992.24,25.54c-1.08.98,1.2-.88,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M983.95,41.38c.23-1.05-.27-1.51-.4-2.26.22,0,.45-.26,0-.32-.08.39-.44.2-.79,0,.77,1.03-.62,2.16,1.18,2.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M943.29,61.1c-.76-.13-.31-1.25-1.58-.97-.1.66,1.53,1.5,1.58.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M912.1,30.39c-.76-.03.68-1.26-.79-1.29-.31.73.44,2.16.79,1.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M887.23,61.1c.9-.44,1.48.83,1.58,0-.56-.08-.67-.53-1.18-.65,0,.64-1.08.41-.79,1.29,1.15.46.44.25.4-.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M866.31,64.98c.66,1.54-1.47.36-.39.97.34.96.59-.75,1.58-.32-.1-.46-.87-.37-1.18-.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M869.47,65.3c-1.06.19-1.18-2.01-1.97-.97.64-.23.64,1.52,0,1.29.64.77.3,2.34,1.58,2.59-.21-1.02-.69-1.8-1.18-2.59.59-.06,1.46.11,1.58-.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M868.68,70.8c-.72,1.47-.86-1.8-1.58-.32.69.3.87,1.01.79,1.94.96.21,1.48-1.54.79-1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M865.92,62.39c-1.04-1.71.75,1.23,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M860.39,71.12c-.65,0-.22-.9-.79-.97-.95.36.62,1.68.79.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M852.89,59.81c-1.2-.88,1.08.99,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M839.86,74.36c1.88-.25,1.75,1.15,3.55.97.45-.92,2.13-.84,3.16-1.29-.24-.42-1.08-1.78-2.37-2.26-.24.58,1.16,1.34,0,1.62-.54-.86-2.61-2.16-3.55-1.62,1.53.73-.01,1.93-.79,2.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M834.33,72.09c.79.24,3.2.8,3.55.32-.69-.08-.9-.56-.79-1.29.4,0,.47-.26.79-.32.59.38,1.11.81,1.58,1.29.19-1.02-1.21-.73-.79-1.94-.68-.13-1.01.48-1.18,0,.09-.41.62-.66-.4-.65-.88.14-.16,1.59-.39,2.26-.69.19-2.32-.39-2.37.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M838.28,76.94c-.06-.38.07-.92-.39-.97v1.29c.82.17,2.39-1.14.79-.97-.09.25-.01.64-.4.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M835.12,75.97c.11-.67,1.75-.08,1.58-.97-2.17-.16-2.16-2.11-3.95-2.59.33.91-.56.84-.4,1.62.68.13,1.01-.48,1.18,0,.12.85-.82.83-1.58.97-.12.85.82.83,1.58.97.07-.48-.14-1.19.39-1.29.46.05,1.12-.06,1.18.32.16.55-.59.83,0,.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M833.94,70.15c-.86-.06-1.26.26-1.18.97h1.58c-.54-1.41,1.53-.69,1.18-1.94-2.09-.28-.05.79-1.58.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M828.41,75.97c-1.08.98,1.2-.88,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M822.89,76.94c-.05.39-.12.76-.79.65-.43.93.42,2.41,1.18,1.29-.58-.06-.36-.78-.39-1.29,1.3.24.6-.64,0-.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M822.1,69.83c-.75-.07-.87.36-1.58.32-.17,1.35,1.18-.15,1.58-.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M817.75,61.42c-1.08.98,1.2-.88,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M816.17,62.07c-.68-.1.36-1-.79-1.29-.78.75.1.36.39.97-1.03-.09-1.7.12-1.58.97.98.05,1.92.06,1.97-.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M811.44,62.72c1.94-.92-1.28.61,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M807.88,69.83c-.47.48-.34,1.44-1.58,1.29-.52-.32-1.47-.31-1.58-.97.62-.03,1.37.04,1.18-.65h-1.18c.02,1.27-.83,1-1.18,1.29,1.52.32,1.67.54,1.18,1.94,1.18-.11.74-1.54,2.76-.97-.28-.81,1.74-1.33.39-1.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M804.33,63.69c-1.7-.1-1.03,1.49-.79,1.62.45-.39,1.13-.59.79-1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M803.54,68.53c-2.89-1.38-4.8-1.93-7.5-1.29.46.06.43.51.4.97,3.8-.07,5.55.14,7.5,1.94.16-.78-.72-.7-.4-1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M802.36,70.15c-.54.02-.87-.15-1.18-.32-.63.24.09,1.58-1.18,1.29.02-.34-.19-.82-.39-.32.15.46.47.54,0,.97h1.58c-.51-1.28,1.15-.78,1.18-1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M798.8,64.98c.69-.6,1.52.08.79.65.78-.1.78.44,1.18.65.04-.61,1.31-.22,1.18-.97-1.27.28-1.24-.5-1.58-.97-.77-.16-2.52.46-1.58.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M792.88,53.99c-.12.66-.79.86-1.18,1.29,1.69.6,1.04,2.08,0,2.91,1.4-.26,1.45-1.62,2.76-1.94.58.89.83.68.39-.32,1.16-.37,1.47-.19,1.97.65-.44.03-.61-.47-.79,0,.46.05.43.51.4.97,1.7.15.51-.87,1.18-.97.31.07.78,0,.79.32-.04.61-1.31.23-1.18.97.25.18,1.19,1.31,1.58.32-.44-.07-.61-.36-.79-.65,1.26.27,1.5-.28,1.97-.65,0,.18.32.37.39,0-.8-1.31-2.14-1.71-3.31-1.68,1-.33.4-1.88.15-2.53,1.27-.27.82-.27,1.58.32.79-.81-.59-1.91-1.97-1.94.57,1.24-.11,2.22-1.97,1.62-.02.44.19.71.39.97-.93,0-1.16.56-2.37.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M796.44,66.6c.95-1.02.26-1.37.79-2.59-.99.41-1.24-.17-1.58.32,1.49.34-.01,1.92.79,2.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M788.15,56.25c1.15.14,2.84.81,1.97,1.62h1.18c.09-.97-1.46-1.1-.39-1.94-.76-.14-1.7-.12-1.58-.97.44-.03.61.47.79,0-.57.17-.96-1.26-1.18-.32.61.08.06.53-.39.65-.44.03-.62-.47-.79,0,.46.06.43.51.4.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M785.38,61.1c.35-.67-1.3-1.22-1.18-.65.62.03.31.82,1.18.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M783.8,59.48c-.2.48-.58.82-.79,1.29.96.31,1.31-1.45.79-1.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M782.22,55.93c-1.29.48-1.14-.08-1.97-.65,0-.32.32-.38.39-.65-1.56-.41-1.02.88-1.58,1.29.75.14.99.7,1.97.65.47-.16.9-.34,1.18-.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M771.57,58.19c-1.2-.88,1.08.98,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M749.85,59.48c.77.15,2.02-.87,1.18-.97-.08.36-.44.5-.79.65.02-.44-.19-.71-.39-.97,1.05-.38,2.32.62,2.37,0-1.59-.87-3.22-.55-2.37,1.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M747.09,51.08c-.12-.64.53-.64.79-.97-.81-.28-1.77.84-.79.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M745.51,56.57c-1.08.99,1.2-.88,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M744.72,59.81c-1.08.99,1.2-.88,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M742.75,62.07c.26-.78,1.16-2.28,0-1.62,1.17.08-1.58,1.2,0,1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M737.62,57.55c-1.2-.88,1.08.98,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M734.46,59.48c-2.08.85,1.5-.61,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M725.38,68.21c-1.2-.88,1.08.98,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M710.38,62.39c-.68.68-2.45.09-1.58.97.59.21,3.55-2.1,4.34-.65-1.06.32-1.24,1.35-1.58,2.26,1.98-.54,1.97,1.53,1.58,1.94.76-.72,1.23-1.24,3.55-1.29.33-1.79-3.43-1.55-1.98-3.23-.48-.04-.93-.1-.79-.65-1.34-.42-2.75.72-3.16,0-.61-1.36,2.19.07,1.58-1.29h-3.16c.79,1.22,1.23-.19,1.18,1.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M697.74,63.69c.09-.61-.44-.71-.4-1.29-.59.06-1.46-.12-1.58.32,1.47-.34,1.28.68,1.97.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M695.77,84.05c-1.53-.01-3.14,1.07-3.95.65-.35.9-1.47,1.17-1.58,2.26,1.21.23,1.16-.56,2.37-.32-1.07-2.6,3.1-.91,3.16-2.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M694.98,63.69c-1.08.98,1.2-.88,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M692.22,51.73c-.22,0-.45.26,0,.32-.02-.99.74-1.01,1.18-2.26-.93,0-1.16.56-2.37.32v1.29c.46.05,1.12-.06,1.18.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M692.22,63.04c-1.08.98,1.2-.88,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M687.87,41.38c0,.32-.32.38-.39.65.53.04,2.18.61,1.18,0-.24-.02-.47-.05-.4-.32.24-.02.47-.05.4-.32-.57.17-.96-1.26-1.18-.32.24.02.47.05.39.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M686.69,67.24v-1.94c-2.18.6-.39-2.05-1.97-1.94-.04.51.05,1.12-.79.97-.65-1.05-1.09-1.58-1.18-2.59-1.7.81-4.49-.72-5.13,1.3,1.37-.44,1.86,1.45,2.76.32-.4,0-.5-.57,0-.65.4,0,.47-.26.79-.32,1.3,1.74,3.6,2.66,5.13,4.2-.03.45.09,1.24.39.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M682.35,50.11c-.89-.13.06-1.77-1.18-1.62.15.84.23,2.11,1.18,1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M678.4,39.76c.05-1.34.26-.06.79,0,.51-.43.24-.98-.39-1.29.06.43-1.61.98-.4,1.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M674.06,60.45c-1.33.21-2.88.23-3.55.97,1.55.49,2.74-.95,3.16-.32-.39.43-.65.98-1.18,1.29-.36-.5-1.45-.17-1.58,0,1.61.15,2.51,1.25,2.37,1.94,1.19-.62,1.4.82,1.58,1.61.92.1,1.52-.05,1.97-.32-1-1.56-1.34-1.85-1.58-4.2-1.03.19-1.42-.13-1.18-.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M675.24,66.27c-.9.44-1.48-.83-1.58,0,.48.07.24.36,0,.65.7-.07,1.98.33,1.58-.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M674.06,75c-.02.2-.06.38-.4.32,0-.18-.32-.37-.39,0,.35.65,2.01.08.79-.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M673.66,64.98c-.9.45-1.48-.83-1.58,0,.98-.12-.12,3.07.79,1.94-.42-1.21.98-.92.79-1.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M671.69,73.39c.1.45.87.37,1.18.65.15-.98-1.29-.67-1.97-.97.06.38-.07.92.39.97.09-.25.01-.64.4-.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M670.5,57.22c-1.08.98,1.2-.88,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M665.37,63.36c-1.2-.88,1.08.98,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M664.19,65.95c-1.08.99,1.2-.88,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M662.61,67.89c1.09.08.14,1.82,1.58,1.62.29-1.02-1.28-2.15-1.58-1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M662.21,71.12c.12-.38,1.59-1.22.4-1.62.21,1.65-3.19.69-3.16,1.29.56.07.67.53,1.18.64-.12-1.32.82-.17,1.58-.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M661.03,65.63c-.35-.96.25-2.48-.79-1.94,1,.23-.95,1.85.79,1.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M650.77,66.6v.97c-.59.06-1.46-.12-1.58.32.83.21,1.75.86,2.37.32-.08-1.77-.91-2.92-2.76-3.24-.19,1.24,1.4,1.01,1.97,1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M650.37,58.84c-.78-.54-.5.03-1.58,0,.02-.41.51-.45.39-.97h-1.97c.08.92,2.33,1.73,3.16.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M649.58,71.44c.26-1.26-1.56-2.81-1.95-3.17.67,1.53-.52,2.9,1.95,3.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M647.63,68.27s-.01-.04-.02-.06c-.11-.06-.07-.03.02.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M648,72.09v-.65c-.24-.02-.47-.05-.39-.32h-.79v.65c.24.02.47.05.39.32h.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M646.03,69.83c-1.2-.88,1.08.98,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M645.63,65.95c-1.04-1.71.75,1.23,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M642.87,58.19c1.49-1.97-1.66,2.18,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M642.87,63.04c-1.2-.88,1.08.98,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M640.5,63.69c.02-.2.06-.38.39-.32.02-.56-.3-.83-.79-.97-.09.61-.65-.18-.79.32.75.04.27,1.07,1.18.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M637.34,57.22c.09-.25.33-.38.79-.32-.03-.65-1.36-1.86-1.97-.97.4.32.8.64,1.18.97-.22,0-.45.26,0,.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M632.61,47.85c-.22,0-.45.26,0,.32.36-.88.88.74,1.58.65.74-.62-.23-.59,0-1.62-1.23.36-1.41.21-.79-.65-.46-.05-1.12.06-1.18-.32.42-.02.31-.41-.39-.32-.19,1.02,1.21.73.79,1.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M633.4,64.66c-2.25-.11-.25.75.4,0,.09-.55-.44-.8-.4,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M629.45,61.42c-.48-1.07,3.23-.33,1.97-.97-1.23-.33-2.82.67-1.97.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M628.66,68.53c-.23,1.05-.83.61-1.18.97.91,1.27,2.05-1.86,1.18-.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M623.92,63.04v-.65c-.08-.36-.44-.5-.79-.65-.15,1.5-2.97.8-2.37,2.91h1.18c.49-1.05-1.28-.25-.79-1.29,1.73.14,1.3-.99,2.76-.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M622.74,56.25c1.16.43-2.56-.95,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M620.76,61.75c-1.2-.88,1.08.99,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M615.63,57.22c-1.2-.88,1.08.98,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M614.84,70.15c-1.38.05-2.53-.09-3.16-.65,1.97-1.77-1.76,0-.79-1.62-2.48.27-.14,1.37.39,1.94-1.66-.05,0,.5,0,.97-3.11.34-2.94-.69-4.74.97,1.13-1.46-.72-2.1,0-3.23-2.26.45-3.34-2.29-5.13-3.23.64-.76-.25-2.42-1.18-2.91.16-.84,1.18-.97,1.18-1.94-.66-.92-3.12-2.1-3.95-.97.48.68,1.48.94,1.58,1.94-.58.37-.99.37-1.58,0,.11,1,2.18,2.07,1.18,2.91-.04-.4-.12-.77-.79-.65-.64-.14-1.32,1.2-.39,1.29.09-.95,1.47-.44,1.97,0-1.87.57-.28.82-2.37.97.73,1.87.39,1.61,0,3.56.29.52,1.93-.07,1.58.97-.58-.17-.99-.48-1.58-.65-.35.57-.95.95-1.18,1.62,5.28-.16,11.41,3.32,17.37,3.88-.5-.81.2-1.01-.4-1.29.17.52-1.47,1.09-1.58.32.79-.33,1.69-.56,1.98-1.29-1.21.23-1.16-.56-2.37-.32-.83.29-1.17.99-2.37.97-.93-.95.76-1.2,0-1.62,0,.18-.32.37-.39,0,.82-.94,2.31-.4,3.55,0,.49-2.22,2.31-.84,3.16-1.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M613.66,50.43c-1.43.01-1.73.95-1.58,2.26-2.63,1.17-6.54,2.72-5.53,5.82,4.43-1.01,5.08-5.1,7.11-8.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M611.29,48.17c-1.2-.88,1.08.98,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M609.71,40.09c-1.68,0,3.79.47,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M606.55,40.41c.11-.67,1.75-.08,1.58-.97-.99.16.95-1.48-.39-1.62.09,1.06-1.85,2.12-1.18,2.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M599.84,42.35c-1.08.98,1.2-.88,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M595.1,43.32c1.69-.2,1.61,1.05,3.16.97.57-.18.96-.5,1.18-.97-.69-.09-1.97.91-2.37,0,3.4-.43-2.52-1.7,0-2.59-1.17.44-2.44.41-3.16-.32,0,1.34,1.5.75,1.18,2.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M595.1,70.15c-1.08.98,1.2-.88,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M589.58,70.15h-1.18c.49,1.05-1.28.25-.79,1.29.74-.36,1.81-.45,1.97-1.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M580.1,72.74c.05.33-1.7.65-.39.97-.21-.46,1.54-.79.39-.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M575.76,75c.75,1.23-1.04-1.71,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M571.02,82.11c-1.2-.88,1.08.98,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M567.47,76.29c-1.08.98,1.2-.88,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M556.81,70.8c2,1.61-2.97,4.48.4,5.82,2.7.36,4.83-3.62,5.13-1.29.17-.62,1.13-.59.79-1.62-.68-.13-1.01.48-1.18,0,1.03-.85.58-2.4,1.58-3.88-.05.58.39.76,1.18.65-.38-.6,1.18-1.08,0-1.29-1.25,1.52-2.05-1.73-3.16-.32.49,1.21-4.3,2.3-4.74,1.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M562.73,80.17c2.09.85-1.5-.61,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M562.34,81.14c-1.2-.88,1.08.98,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M561.94,76.62c-1.2-.88,1.08.98,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M561.55,79.2c-.74-1.05,1.12,1.59,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M560.76,82.44c-.12,1.2-2.98.15-2.76,1.62,1.25-.44,1.32-.07,2.76,0-.93-.95.76-1.2,0-1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M559.97,82.11c-.31.29-2.77-2.17-3.55-.32.92.1,1.52-.05,1.97-.32.07.48-.14,1.19.4,1.29-.12-.86,1.53.86,1.18-.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M551.28,81.14c-.37,2.14.48,1.59,1.18,1.62-.78,0-.5.88-1.58.65.82,2.46,2.08-.7,2.76-1.29-.59-.06-1.46.12-1.58-.32.88-1.23,2.68.02,3.16.97.35-.58,1.1-.82.79-1.94-1.98-.28-2.76-.28-4.74,0,.03-1.21.3-2.61-1.58-2.26.06,2.62-3.91,2.67-1.97,4.2-.83-.68-1.48.42-1.97.97,2.23-1.06,4.5-.34,5.53-2.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M540.23,74.68c-1.47-.34-.62,1.21-1.97.97,0-.18-.32-.37-.4,0,.53.21.74.69.79,1.29,1.25-.15,2.34-1.48,1.58-2.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M536.68,47.2c.73.28,1.71.37,3.16.97-.32-1.66-2.91-3.09-3.95-2.26,1.07-.23-.28,1.53.79,1.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M539.44,82.76c-.16.41-.51.66-1.18.65-.91-1.01.72-.91,0-1.29-.8.75-1.8,1.33-2.37,2.26.87.34,1.31-.01,2.37.65.09-.81,2-1.78,1.18-2.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M532.73,73.06c2.12-.23,1.73,1.6,3.55,1.62.1-.98,3.82-1.01,1.58-1.94-.87.47.5.79-.39.97h-.79c.76-.52-2.04-2.04-2.37-1.62,1.27.56-2.05,0-1.58.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M535.49,48.81c-.06-.43,1.33-1.2.39-1.29.06.43-1.6.98-.39,1.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M533.13,87.61c-.27,1.83-1.66,2.74-3.55,3.23-1.36-.28-2.59-.68-3.16-1.62.8.16,1.61-1.78.79-.97-.39.72-1.18-1.93-2.37-.65-.35,1.04,1.3.44,1.18,1.29-1.54-.09-2.61-.56-3.45-1.22.04.44.02.94-.1,1.54,2.2.89,5.02,1.28,5.92,3.23-2.16-.55-2.07,0-2.37.97-1.01-.03-.56-1.26-1.58-1.29-.57,1.22,1.08.62.79,1.62-.22.46-.62.79-1.18.97-.05-.82-.58-1.25-1.58-1.29-.1,1-1.42.99-1.97,1.62.31.07.78,0,.79.32-.46.8-1.64-.79-1.58.65,2.41.77,7.57-.57,7.1-2.91,2.11.02,2.68-.72,2.76-1.62,1.51,1.29,4.91-3.05,4.74-4.2-.07.38-.62.35-1.18.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M522.47,87.61s.07.05.1.07c0-.03,0-.05-.01-.08-.03,0-.06.01-.09,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M523.65,85.35c-.19.38-.42.73-.79.97-.55-.41-.17-1.58-1.18-1.62.26,1.05.77,1.78.88,2.9.65.02.81-.36,1.49-.32-.23-.57.48-1.9-.4-1.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M533.52,68.21c-.62.25-.59,1.02-1.58.97v.97c1.2-.26,1.69-1.33,1.58-1.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M531.55,74.68c.4,0,.47-.26.79-.32.45-.66-.62-1.54-.79-.65.31.07.46.27.4.65-.42-.02-1,.15-.4.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M524.44,54.63c.73-.8.95-2.02,1.58-2.91,1.61,1.58-1.2,4.34-2.37,4.53,1.17.28-.91.48-.39,1.29,1.65-.11,3.06,1.13,4.34.32-1.89-1.58,1.75-3.03.39-5.17,1.16-.02,1.47-.74,1.97-1.29-2.35-1.11.81-2.02,1.18-2.91-3.15.71-5.02,3.26-8.29,2.91,1.88.47.32,2.91,1.58,3.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M519.31,59.16c-.22,0-.45.26,0,.32.11-.76,1.47.03,1.58.32-.12.38-1.59,1.22-.39,1.62.7-.94,3.36-.27,3.16-1.94-1.1.64-4.08-.32-2.37-.97-.89-.56-2.6-.21-2.76,0,.44.07.62.36.79.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M511.81,80.17c2.61.65,5.01-1.15,7.11-1.94-1.66.39-1.73-.52-2.76-.65-1.28.14-1.25,1.34-2.37,1.62-.8-.29-2.51-.52-1.58.32-1.08-.36-2.13-.98-3.55-.32,1.33.67-.25,1.13-.79,2.26-.95-.21-2.33-1.73-3.16-.97.8.87-.02,1.25,0,2.26,3.11,1.74,5.45-1.16,7.11-2.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M512.99,78.23c1.09.14.37-1.2,1.18-1.29.02.2.06.38.4.32.35-1.13-1.29-.55-1.58-.32-.02.44.18.71.39.97-.82-.17-.83,1.26-.39.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M510.62,62.07c-.02-.2-.06-.38-.39-.32.57,1.76,2.23-.86,1.97-.97.8.28,2.45-.28,1.18-.65-.18.39-1.7-.08-1.97.97.94.1-.71.65-.79.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M513.39,75.32c1.5-.62-2.09.85,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M510.62,69.18c-.59-.23-1.66-.25-1.97,0,.24.19,1.87.76,1.97,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M505.49,78.56c-.24-.45-1.52-.05-1.58-.65,1.57-.89-.77-3.36,1.18-4.2.73.04,1.32.21,1.58.65-.31.07-.78,0-.79.32,1.5.68,2.6-.23,3.95.32-.76-1.7-6.1-.81-5.13-2.91-.34.47-.59,1.03-1.58.97.16,1.81,1.28,4.04,0,5.17.78.27,1.97,1.61,2.37.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M505.49,57.87c.55,2.06-1.33,1.17-1.98,1.62.9,1.47,3.31-.49,1.98-1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M501.15,83.73c.39-1.57,1.09-2.91,3.16-2.26-.35-.95-.35-.99,0-1.94-1.08.23-.8-.64-1.58-.65-.43.83,1.2,1.54,0,1.94-1.28.4-.3-1.05-1.58-.65-.58.48.69,2.46-.79,2.91-.1-.67-1.73-.09-1.97-.65-.32,1.69,2.9.15,1.61,1.59,0,.08-.74,1.79-1.61,2.29,1.75.57,3.94-1.01,5.13-1.94-.54-.4-.22-.94.4-1.62-1.96-.53-1.26,1.12-2.77.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M496.02,80.82c.91-.64.44.08,1.18.32,0-.53,1.1-.18,1.18-.65-.52,0-.36-.57-.79-.65-.02.2-.06.38-.4.32,0-.33.32-.39.4-.65-1.21-.31-2.16,2.21-1.58,1.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M484.17,47.52c-1.2-.88,1.08.98,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M479.83,64.66c1.35.19.23,2.4,1.18,2.91-.02-.56.3-.83.79-.97,0,.49,1.08,1.06.79,0-.06-.8-1.33-.09-1.58,0,.28-1.01-.21-3.03-1.18-1.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M479.83,64.98c-1.06-.75-2.35-1.3-3.95-1.62.91,1.27,1.07.81.79,1.94.46-.42,2.59.19,3.16-.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M475.09,70.48c-.62-.51.45-2.2-.39-1.62-.09.25-.01.64-.39.65-.58-.46-1.25-.25-1.18.65,1.11-.27,1.02.46,1.97.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M467.99,66.27c-1.08.98,1.2-.88,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M460.09,54.63c.18-1.47,2.98-.79,2.37-2.91-1.27.68-2.14,1.69-3.16,2.59-.12-.89-1.37-.68-1.18.32,1.22-.23.76-.23,1.97,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M460.49,58.19c-.79-2.03-.18-1.29.4-3.23-1,.04-1.53.47-1.58,1.29,1.21.6-1.74.48-1.18,1.62,1.21-.23,1.44.33,2.37.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M458.91,46.23c-1.08.99,1.2-.88,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M454.17,49.46c-.06-.44,2.01-.65.79-.97.07.44-2.28.42-.79.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M447.07,56.25c.12-.99,2.09-.45,2.37-1.29-.58-.65-3.1.94-2.37,1.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M447.86,60.45c-.41.04-.8-1.39-1.18-.32.57-.17.96,1.26,1.18.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M444.3,55.93c-1.2-.88,1.08.98,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M432.85,54.96c-1.2-.88,1.08.98,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M432.06,57.55c-1.2-.88,1.08.98,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M424.96,54.31h2.37c.39.96.56,1.6.79,1.94-.04-.72,3.02-.5,1.58-1.29-.05.82-1.29-3.03-2.76-1.94,1.87,1.04-3.17.81-1.98,1.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M420.62,48.49c1.13,1.59-.74-1.05,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M416.67,48.17c.42-.44,2.49-1.16,1.18-1.94-.18.64-1.93,1.62-1.18,1.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M404.43,45.26c.28-.48.3-1.36,0-1.62-.23.2-.92,1.53,0,1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M389.18,49.58c.14-.07.5-.24.72-.34-.1.05-.25.12-.47.22-.13.06-.2.09-.25.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M389.9,49.24c.25-.12.18-.09,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M386.67,54.96c-1.29,2.95,1.07-.23,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M384.3,47.2c-.67-.13-1.77-1.52-2.37-.65,1.07-.2,1.85,1.46,2.37.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M383.11,58.19c.09-.25.01-.64.39-.65.09.25.01.64.4.65-.03-.56.09-1,.39-1.29-.9.44-1.48-.83-1.58,0,.31.07.46.27.4.65-.4,0-.5.57,0,.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M380.75,61.75c-.31-.07-.78,0-.79-.32.22,0,.45-.26,0-.32-.54,1.19-1.97-.34-2.37.97,1.37.11,2.1.38,3.16-.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M374.82,62.39c-.47-.37-.71-.92-1.97-.65.63,1.27-1.71.11-1.58.97,2.77.02-.66,2.92.4,2.26.48-.36.72-.92,1.97-.64.2-1.94,2.19-.52,3.16-1.94.06.38-.07.92.39.97-.11-.88,2.36.57,1.18-.32-1.3-.21-1.38-.93-1.58-1.3-1.11.86-2.13-.45-1.98.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M364.56,49.14c-2.05,1.41,1.26-.59,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M362.98,50.43c-1.08.98,1.2-.88,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M346.4,50.76c-.17.51-1.24.27-.79,1.29.96.31,1.31-1.45.79-1.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M344.43,66.27c-1.08.98,1.2-.88,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M342.06,61.75c.06,1.02-2.2.14-1.58,1.62,1.26.25,2.26-1.35,1.58-1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M340.48,48.17c.28.54-1.45,2.15-.79,1.62.51-.55,2.36,0,2.37-.97-1.28.4-.3-1.05-1.58-.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M327.45,55.6c1.8-.42,1.25.04,2.37.65.29-1-1.08-.62-.79-1.62-.76.14-1.7.12-1.58.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M328.24,39.12c-1.2-.88,1.08.98,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M326.27,51.4c-2.12.23-2.66-.84-3.95-1.29-.09.25-.33.38-.79.32.21.47-.46,1.67.39,1.62,1.65-1.75,3.6,1.48,5.13.65-.73-.05-.24-1.09-.79-1.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M321.54,42.55c-.17-.09-.38-.19-.53-.26.04.02.07.03.12.06.17.08.3.15.4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M314.82,50.11c0,.32-.32.38-.39.65h.79c0-.33.32-.39.39-.65-1.12-.06-1.65-.59-2.76-.65.13,1.14,1.03.84,1.97.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M313.63,44.61c.4-.43.65-.98,1.18-1.29,0,.18.32.37.4,0-.31-.07-.46-.27-.4-.65-.99.38-1.77.92-2.76,1.29.79,0,.5.88,1.58.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M312.05,50.43c-1.08.98,1.2-.88,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M308.5,56.25c.69-.42,3.13.12,3.95-.97-1.35-.08-1.9-.82-3.55-.65-.09.25,0,.64-.39.65,0-.18-.32-.37-.39,0,1.23-.1-1.01.93.39.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M311.66,53.99c-2.05,1.42,1.26-.59,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M309.69,57.55c.74-1.05-1.13,1.59,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M302.97,66.27c1.22.24.48-1.11,1.98-.65.06-.91-1.12-.81-1.58-1.29-.1.46-.65.55-.79.97.46.05,1.12-.05,1.18.32-.44.07-.61.36-.79.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M300.21,60.78c.75.07.87-.36,1.58-.32.05.39.12.77.79.65.3-1.11-1.6-.41-1.18-1.62-1.76.02-.5.74-1.18,1.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M293.1,57.87c.75,1.23-1.04-1.71,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M291.92,54.96c-1.2-.88,1.08.98,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M285.61,52.37c-1.96.43-.62,1.53,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M282.45,58.84c-.71.28-1.09.83-1.97.97,0-.18-.32-.37-.4,0,.66.43,1.32.86,2.76.65-.2-1.01.93-1.32-.4-1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M267.84,49.14c.07-.38.62-.35,1.19-.32-.37-1.41,2.64-2.87,0-3.23.54,1.75-1.99,2.67-1.19,3.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M256.79,54.96c-1.2-.88,1.08.98,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M247.71,49.46c-1.2-.88,1.08.98,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M243.76,54.31c.97-.04,1.9-.05,2.37.32-.16-.56.58-.83,0-.97-.18.45-2.12-.99-2.37.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M244.15,51.73c-1.2-.88,1.08.98,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M243.37,64.33c-.09.25-.33.37-.79.32v.97c.9.09,1.48-.08,1.58-.65-.31-.07-.78,0-.79-.32.22,0,.45-.26,0-.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M239.42,67.24c-1.08.98,1.2-.88,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M230.73,67.89c-1.08.98,1.2-.88,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M229.55,69.51c-.59,0-1.62-1.2-1.97-.32.88-.25,1.26,1.49,1.97.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M227.18,66.6c1.28.61-1.94-.92,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M224.42,58.84c1.45-.99,1.4-.23,2.77.32v-1.29c-.92.1-1.52-.05-1.98-.32.49,1.05-1.28.25-.79,1.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M225.2,67.24c.58.17,1,.48,1.58.65.38-.79-1.77-1.07-1.58-.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M222.84,50.76c1.27.37-2.56-.76,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M214.59,57.61c0,.07-.02.24-.05.58-.05.71.03-.38.05-.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M206.26,58.84c-1.2-.88,1.08.98,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M198.76,64.98c-.54.02-.87-.15-1.18-.32.13.75-.06,1.24-.39,1.62.99-.41,1.24.17,1.58-.32-.44-.07-.61-.36-.79-.65.3-.07.78,0,.79-.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M195.2,63.04c.64-.02,1.1-1.84,2.77-.65-.31.07-.78,0-.79.32h1.18c-.21-1.24-1.54-1.76-2.76-1.29.33.91-.56.84-.4,1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M195.2,72.74c1.83.25.62-1.98.79-2.26-.08.94-1.55,1.6-.79,2.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M190.86,61.1c.82.09-.59.88.79.97,0-.43.69-.29.79-.65-.99.43-1.23-1.28-1.58-.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M191.65,51.73s0,0,0,0c-.08.14-.19.34-.28.5.06-.12.15-.27.27-.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M191.66,51.72c.16-.28.11-.19,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M189.28,63.69c-1.2-.88,1.08.98,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M187.7,56.25c.29-.72-1.45-1.33-1.58-.65,1.28-.4.3,1.05,1.58.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M183.36,52.69c.02.44-.19.71-.4.97.92-.48,1.7.11,1.98-.32-1.26-.27.7-.42,1.18-.32-.07-.48.14-1.19-.39-1.29.23,1.16-1.17.98-2.37.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M179.41,56.25c.38.33.78.65,1.18.97-.63-.87.36-2.71-.39-2.26.49,1.05-1.28.25-.79,1.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M175.64,55.31c.02.07.08.34.21.94.12.51-.17-.76-.21-.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M173.49,57.55c1.23.16.66-1.79,0-.65.24.02.47.05.39.32-.42-.01-1,.15-.39.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M169.54,57.55c.7-.98,1.54,1.19,2.37,0-.32-.89-3.21-.61-2.37,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M169.54,69.51c.4,0,.47.26.79.32.07-.71-.32-1.03-1.19-.97.06.43-1.33,1.2-.39,1.29.08-.36.44-.5.79-.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M163.62,62.72c.41-.02.31-.42-.4-.32-.72,1.1-.21,1.53.4.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M160.86,64.01c.04-.43.74-1.78,0-.97-.06.38-.7.73,0,.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M160.07,62.39c1.5-.62-2.09.85,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M159.28,52.05c-1.2-.88,1.08.98,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M158.49,62.07c-1.08.98,1.2-.88,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M155.33,58.84c.25,1.14,1.61,2.74,1.58,2.26.2-.24.28-1.52,1.58-.65-.23-.57.48-1.9-.4-1.94-.5.67-.63,1.64-1.97,1.62-.09-.57.4-1.62-.79-1.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M157.7,63.04c1.94-.92-1.29.61,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M144.67,61.1c-.3-.72,1.82-1.03.4-1.62.12.85-.55,1.06-1.58.97v-1.29c-1.14.15-1.8.68-1.97,1.62,1.72-.41,1.76-.09,3.16.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M141.91,67.24c.22-1.65-1.87-1.77-.79-3.23-1.07.21-1.84,1.7-1.58,3.88h1.58c-.35-1.41-.18-1.55.79-.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M141.12,56.9c-1.08.98,1.2-.88,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M139.15,52.37c.07.71-.33,1.03-1.18.97.02-.34-.18-.82-.4-.32.1.57.68.74,1.58.65.56-.43.56-1.83,0-2.26-1.03-.09-1.7.12-1.58.97.74.31,1.32-.97,1.58,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M121.78,54.31c-.34.48-1.27.47-1.98.65-.05,2.18,2.93-.29,1.98-.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M119.41,54.63c1,.24,1.85-1.23,1.18-1.29,0,.42-1.1.41-1.18,0,.16-.41.51-.66,1.18-.65-.05-.6-.26-1.08-.79-1.29.18,1.01-.99.91-1.58,1.29-.34,1.25,1.72.53,1.19,1.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M98.88,60.13c-.21-1.31,1.4-.03,1.18.65,1.61-.78,1.95.55,3.95.32-.35,1.79,2.1,1.29,2.37,2.59,1.47-1.08-1.28-2.61-.39-5.17-1.6-1.54-5.48.52-6.32-1.29.38,1.36-1.94-.53-1.97.97,1.04.11.36,1.65,1.18,1.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M95.33,72.74c-.02-.09-.03-.15-.05-.22.09.43.17.83.05.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M95.27,72.49c-.21-1.04-.11-.52,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M92.17,63.69c-.68,2.14,1.01-2.62,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M87.04,50.11c1.2-.53,2.12-1.28,2.76-2.26-1.24-.15-1.54.46-2.37.65,0-.18-.32-.37-.39,0,1,.25-1.11,1.13,0,1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M86.95,51.12c-.1.05-.17.08-.2.09.03-.02.11-.05.2-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M87.04,51.08c.34-.16.51-.24.59-.28-.12.06-.45.21-.67.32.03-.01.05-.02.08-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M82.69,65.95c-1.08.99,1.2-.88,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M81.9,52.37c-1.07-.29.4-1.13.4-1.62-1.4-.17-2.03.27-2.37.97.79-.07,1.69,1.37,1.97.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M75.19,67.24c1.04.84.31-.52,1.58-.32v-.65c-.39,0-.47-.26-.79-.32.45,1.02-.62.79-.79,1.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M68.88,63.69v-.65c-.39,0-.47-.26-.79-.32.61,1.36-2.19-.07-1.58,1.29,1.2.09,1.54-1.04,2.37-.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M66.51,65.95c-.86-.06-1.25.27-1.19.97.74.02.84-.25.4-.65.31-.07.78,0,.79-.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M63.35,62.39c-1.04-1.71.75,1.23,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M39.27,59.16c-2.25-.56-1.44,1.11,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M36.9,45.58c-1.08.98,1.2-.88,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M35.71,58.84c-.46-.1-.99-1.71-1.58-.65.7-.09,1.22,1.52,1.58.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M29.01,49.78c-.06-.91,1.19-.75,1.18-1.62-.83,0-2.05,1.3-1.18,1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21.11,46.55c-.42-.83,1.7-1.13.4-1.62,0,.48-1.47,1.32-.4,1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.77,58.84h-1.18c-.8,1.16,1.83,1.6.79.97-.24-.02-.47-.05-.4-.32.48-.04.94-.1.79-.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14.79,47.2c-1.08.98,1.2-.88,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.29,55.6c.09-.25.33-.38.79-.32,0-.86.22-1.9-.79-1.94-.93.74-1.59,1.64,0,2.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1786.31,74.49c1.63-.75-2.59-.12,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1399.76,70.26s0-.04-.01-.06c0,0,0,0,0,0,.01.02.01.05.02.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1883.91,67.56c.01.37.52.3.85.38-.01-.37-.52-.3-.85-.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1886.47,66.02c1.69-.45-1.68-.45,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1278.72,43.29c.05-.69-.52-.81-.43-1.54-.75-.12-.76,2.16.43,1.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1167.49,50.61c-.41.01-.33.47-.43.77.41-.01.33-.47.43-.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1176.86,69.1c1.68-.45-1.68-.45,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1539.55,86.82c1.69-.45-1.68-.45,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1608.59,72.57c.42-.01.33-.47.43-.77-.41.01-.33.47-.43.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1649.51,89.52c.18.16-.28-.25,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1920,118.97v-47.04c-.73-.23-1.34-.26-1.57.27-.78-.44-.21-1.98-.79-2.59-.54.1-.33.81-.4,1.29-1.24.05-.77-1.31-1.58-1.62.39,1.23-1.53,1.53-.79,2.91-.82.14-1.04-.22-1.58-.32-.22-.72.76-.46.79-.97-.43-.74-2.48-.12-1.97.97-1.22-.23-.76-.23-1.98,0-.15-1.2,1.9-.6,1.98-1.62-.18-.83-.55-1.49-1.18-1.94-.62.03,1,2.97-1.18,2.59.05-1.77,1.17-3.71-1.97-3.88.1-.95-.89-.99-.79-1.94,2.18.45,3.01-1.73,3.95-3.23-.12-.44-.99-.27-1.58-.32-.06-3.56-1.96-5.49-3.95-.97-1.22-.11,1.04-1.65-.4-1.94.59-.49,1.18-.97,1.58-1.62-.03-.95-.14-1.82-1.58-1.62,2.58-.18,4.16-.27,4.34-2.91-1.21.19-.95,1.6-1.58,2.26-2.62-.36-5.19.05-8.29-.32-.54.32.17.53-.79.97.95.96,1.63-1.02,3.55-.32-.02.03-.04.05-.06.07-.24.05-.31.3-.22.47.02.19.22.33.67.43.58-.39.38-1.41,1.97-.97.02,1.3.03,2.37.39,2.59-.99.66-3.54.4-2.37,1.94-.78-.14-3.63.13-1.58.32-.57.95-1.59-.39-1.18-1.29-1.06.21-1.18,1.19-1.97,1.62-.96-.5-.38-2.44.79-2.26-.1-.67-1.73-.09-1.97-.65-.75.04-.27,1.07-1.19.97.71.5,1.19,1.19,1.58,1.94.34.68-2.01-.47-.79.32-.12,1.14-1.07-1.14-1.18,0-1.11-.32-.04-1.49.39-1.62-.33.06-.37-.13-.39-.32-.75,1.03-1.22,1.03-1.97,0-1.19.39.21,1.29.79,1.29-.04.5-.55.41-.99.25-.1-.32-.32-.53-.75-.58-.09.36-.22.64-.23.85-.21-.22-.43-.47-.4-.85-.86-.05-.18,1.15-.4,1.62-1.24.37-.96-.51-1.58-.65-.32.06-.39.33-.79.32.09.57.68.74,1.58.65-.19.25-.6.31-.75.59-.12.01-.25.03-.38.04-.04-.19-.02-.43-.06-.63-.35.2-.71.39-.79,0,.03.13-.03.4-.09.72-.29.03-.61.05-1.02.08.06.14.09.26.12.38-.67.07-1.06.4-.97,1.16-.71.13-1.5.19-1.29,1.16.62-.35,1.09-.58,1.44-.47.2.34.3.78.63,1.02.02.08.04.14.06.22-1.1.58-3.16-.39-4.26.39.48.51,2.6-.04,3.41.39-.06.06-.13.1-.19.15-.3.13-.63.24-1,.3,0,.06,0,.1,0,.15-.46.14-.47.18.76.94-.19.47-.54.79-1.28.77.03.05.05.1.07.14-.1-.06-.2-.11-.3-.17.22-.16.23-.45-.2-1.13-.55.79-1.76.98-2.13,1.93-.61-.47-.81-1.33-.85-2.31-.36-.07-.4.15-.43.38-.36.07-.4-.15-.43-.38-.1.65-.89,1.64-1.37,2.96-.16.03-.28-.02-.33-.26-.76.28-.06.7,0,1.16.03,0,.06-.03.09-.04-.1.49-.16,1.01-.1,1.58.38.3.96.41,1.71.38-.23.31-.45.62-.43,1.16-1.33-.37-1.06-1.04-1.65.27-.07-.02-.13-.04-.19-.06-.22-.69.4-3.13-1.14-3.29,1.08,1.59-1.22,2.39.43,3.47-1.54-.41-1.28-2.44-3.41-2.31.36-1.13,1.07.5,2.13,0,.49-1.21-.67-.94-.85-1.54-.51.44-.77,1.1-2.13.77-.23.85.81.55.85,1.16-.21.33-.43.5-.67.58.06-.32.2-.58.39-.8-1.11-.27-1.02.46-1.97.32.22-.97.97-1.1.56-1.96.1-.1.19-.2.29-.3h1.92c.14-.76-.48-.89-1.05-1.07.25-.44.35-.89.11-1.4.12-.81,1.14.56,1.71-.39-.04.61.2,1.47-.43,1.54.1,1.23,2.41-1.22,2.13.77.61-.09.15-1.15.85-1.16,1.41.58-.89.94-.43,1.93,1.22-.44,1.58-1.65,1.7-3.08-1.21.32-1.1-.54-2.13-.38.48.55.46.94-.43,1.16-1.09-1.23-1.75-2.49-.85-4.24,0-1.08-1.16.92-.85-.77-.6,1.32-2.15.24-3.55.03.18-.1.35-.21.44-.37-1.54-.37-2-3.16-.79-3.88-.68.07-.87-1.81-1.18-.97-.75-.03.1-1.38,1.18-.97.05-.58-.48-.68-.39-1.29-.91,0-2.38,1.36-1.58,0-.94.84-1.22.84-2.41.94-.14-.29-.36-.58-.52-.62.46.85-1.22,1.39.39,1.29.25.05.3-.11.25-.34.33.35-.12.7-.88.99.17.4.51.67,1.18.65-.91.88-1.52,1.26-2.37.32-.97.04-.08,1.07.4.97-.35.23-1.86.35-2.37,1.29-1.32-.8.86-1.42,1.18-1.94-.1-.35-.78-.22-.79-.65-1.12.75-.39,1.33-1.58,2.27-.37-.18-.59-.9-.79-.32-.98-.05-.12-1.09,0-1.29-.54.06-.78.37-.81.86-.49.38-.82.27-.8-.42-.19.08-.41.15-.64.22,0-.01,0-.02,0-.03,1.72-.31-.73-1.76,1.46-2.56-1.32-.75-1.8.22-2.3,1.18-.17-.1-.37-.18-.62-.21-.06.28.1.57.28.82-.24.38-.52.69-.91.8,0-.86-.22-1.9.79-1.94-.05-.71-1.67-.14-2.37-.32-.07.92,1.33.63.79,1.94-1.01-.04-1.38-.59-1.97-.97-.88.05.07.91.04,1.36-1.12-.36-2.1-1.05-2.64-2.21-.34.23-.72.42-1.11.54,0,0,0,0,0-.01-.53-.1-.76-.46-1.58-.32-.06.09-.09.17-.1.24-.21-.11-.42-.24-.61-.44.1-.99.73.53,1.71,0-.35-.53-.62-1.14-1.54-1.15.05-.06.11-.14.15-.26-1.31-.1,1.54-1,0-1.29-.11.67-1.75.08-1.58.97.36-.03.79.59,1.14.67-.32.4-.35,2.15-.74,1.07-.4.51-.44,1.75.3,2.52-.11-.06-.2-.02-.31.27.82.09-.59.88.79.97,0-.26.26-.31.48-.4-.16.88-1.4,1.11-.46,1.98,0,0,0,0,0,.01-.35-.22-.69-.39-.78.02,0,0-.01,0-.02,0-.02,0-.03,0-.04.01-1.38-.14.08-1.04-.8-1.15-.32.35-.55.74-.73,1.14,0,0,0,0,0,0-.62-.46-.31-.18-.02.06-.76,1.79-.47,3.88-1.8,4.97.58-.19,1.07-.22,1.53-.19.14.4.5.86.68.98.19-.21.32-.47.39-.79.37.1.75.21,1.14.29.02.06.02.11.06.18.43.13.67.1.83.02-.19.22-.31.52-.35.87-.19-.13-.35-.32-.48-.57-.09.25-.33.38-.79.32.43.63.85,1.27,1.25,1.93-.89-.32-1.92-.75-3.4-.73.25,1.23-.8,1.19,0,1.93-1.31-.33-1.27-1.3-1.28.74-.03,0-.07,0-.1,0-1-.21-.1-2.14-1.6-1.91,1.63-1.11-1.02-1.81.85-2.7-.28-.39-.98-.4-.85-1.16-.95-.21-.61.74-1.28.77-.28-.21-.43-.43-.52-.64,0-.06,0-.12,0-.18-.02,0-.04,0-.06,0-.13-.42-.12-.81-.51-1.11.05-.29.02-.66-.2-1.13,0,0,0,0,.02,0,.35.24.88.34,1.56.31.16-.77-1.8.18-1.18-.97.57-.72.96.41,1.18-.32-.8-.7-.72-1.11-.39-2.59-.97-.29-2.24-1.3-1.18-2.26-1.22.53-3.05,1.76-4.43,2.74-.57-.02-1.25.04-1.83.03-.07-.67-.02-1.42-.05-2.12-.92.41-.86,1.15-.64,2.03-.37-.1-.64-.3-.67-.7-.25-1.16,1.8-2.19,2.56-1.16.63-.33.62-1.24.85-1.93-.79-.18-1.11-.43-1.14-.84.54,0,1.15.05,1.26-.31-.67.06-.85-.29-1.02-.64.02-.05.03-.09.06-.13-.04.01-.08.01-.11.02-.15-.3-.34-.57-.9-.54-.03.09-.04.16-.05.23-.18-.08-.25,0-.21.68-.72-.42-.74-.73-.6-1.25.02.1.05.21.08.35.07.29,0,0-.08-.35.05-.19.12-.41.18-.68,1.36-.23,1.32.72,2.13,0-.23-.31-.45-.63-.43-1.16.47-.49,1.27-.68,2.22-.74.1.22.28.38.52.49-.11.18-.17.39.25.64.13-.18.26-.31.38-.41.54.15,1.13.25,1.49.55.02.04.05.07.07.11.06.24.03.56.37.58.32.5.67.97,1.1,1.11.08-1.1.05-2.1-1.28-1.93.43-.64,1.81-.42,2.56-.77-.04-.28-.15-.49-.3-.67.38-.04.88-.05,1.09,0-.07-.48.14-1.19-.39-1.29.14.73-.36.93-1.06.97-.89-.6-2.32-.69-2.32-2.09.43-.47.74.83,1.7-.38-.35-.33-.7-.51-1.04-.57,0-.05-.1-.11-.44-.19-.58.14-.51.22-.28.26-.27.1-.54.26-.79.5,1.17-1.03-.31-1.35-.43-2.31.8.73,1.49.69,2.16.37.42.21.73.45.92-.11-.26.03-.41-.03-.52-.12.42-.27.84-.61,1.27-.91-.23.31-.44.62-.43,1.16.61-.42.87-1.1,1.05-1.8.24-.02.39-.09.05-.2.26-1.03.41-2.04,1.35-2.26.06.25.03.56.38.57-.07-.2-.05-.49-.23-.59.23-.03.49-.02.82.04-.07-.45.09-.69.43-.77-.44-1.43-3.23-.02-2.98,1.54-.12-.02-.22-.04-.32-.06.27-.57-.01-1.28-.56-1.86.02-.13.03-.26.03-.4-1.52-.56-3.16-1.3-3.84,0-.5-.58-1.23-.94-1.28-1.93,1.08.09,2.48-1.23,3.41,0,.74-.52,1.95-2.58,3.41-1.16,1.42-1.06-2.07-.93-2.13-1.93-2.23.92-2.77,1.3-5.11.77-.36,2.25-5.33,2.36-5.97,3.08-.71.41,1.09,1.17,0,2.31.57.28,3.25,1.79,1.28,1.93.56.48,1.15.28,1.75.26-.01.04-.02.07-.03.12h.72c.18.08.37.19.55.39-.59.5-.42,1.67-.43,2.7,1.75-1.03,2.62,1.04,3.41,1.16-.18.25-.35.51-.4.88-.07.06-.14.12-.21.18-1.23-.52-1.19.84-2.06,1.4h-.1v.06c-.17.09-.38.15-.63.17.51-2.26-4.9-3.1-1.7-5.78-.53-.63-3.59-.2-5.11.38.1.42.85.26.85.77-2.54.26-5.62-.18-8.1-.77.49-.46.48-1.36.43-2.31,1.64.9,3.79-.78,3.84,1.16,2.44-1.17-1.21-1.81-.85-3.47-2.44.37-4.58,3.04-6.39,2.7-.44.8,1.78,2.49,2.13,3.85-.1.78-.58.64-1.07.53.22-.34.11-.92-.36-.84-.02.2-.06.38-.39.32v.56c-.14.09-.25.27-.31.59-.49-.12-2.17-1.34-.43-1.16-.64-1.27-1.2.66-1.71.77.28.22.53.46.77.7-.18.31-.59.44-.71.8.44.15.91-.1,1.1-.39.85.95,1.54,2.04,2.24,3.13-.36,1.13-1.37-.23-2.13,0v-1.93c-1.37.66-2.75-.41-3.84,0,1.46.07,2.29.89,2.71,1.9-.19.15-.39.29-.47.53h.65c.2.74.2,1.54.1,2.2.76.72,1.08-.31,2.56,0-1.03,1.03-.73,3.01-.9,4.73-.37.22-.73.41-1.06.5.33.85-.54,1.46-1.32,2.25-.07-.13-.1-.29-.1-.48.17-.02.23-.11,0-.29,0-.19,0-.39-.01-.56-.51.06-.92.22-1.37.33-.69-.72.62-.87.85-1.9-.04-.19-.3-.29-.56-.31v-.34c-.24-.02-.47-.05-.4-.32h-.43c.18-.18.44-.35.7-.53.45.67.94,1.15.92.86.2-.24.28-1.52,1.58-.65-.23-.57.48-1.9-.4-1.94-.5.66-.63,1.63-1.95,1.62.34-.27.62-.57.54-.97-.25-.05-.41-.04-.54,0-.03-.3-.2-.5-.81-.33.07.3.21.63.39.95-.05.13-.11.26-.23.34-.62-.57-.96-1.37-1.58-1.94-.51.59-.19,1.19-.4,2.59-1.11.27-1.02-.45-1.97-.32,1.4-2.08-1.07-2.62,0-4.2-.07,0-.12.02-.18.03.22-.61.06-1.45-.38-1.65-1.06.45-1.48,1.18-.79,2.26.23.06.42.06.58,0-.06.28-.05.61-.02.96-1.56-1.46-2.36,1.48-4.74,1.29.14-.55-.31-.61-.79-.65.31-.29.43-.73.39-1.29-1.12.16-.57,1.69-2.37,1.29-.17.52,1.47,1.09,1.58.32.56.55-1.11.76-.79,1.62-.22,0-.4-.04-.56-.09v-1.2c-.52.07-.92.22-1.24.45-.22-.05-.51-.03-.96.2.07.11.11.21.14.3-.36-.25-.74-.14-1.12.02-.39-.13-.63.02-.75.28-.23.05-.46.02-.67-.17.38-.43.95.02,1.71-.77-.98-3.95,1.02-2.55.85-6.16h-1.71c.01.38.52.3.85.39-.18.6-1.34.33-.85,1.54-.63-.45-1.07-.45-1.7,0,.23-.31.44-.63.42-1.16-1.3.07-.89,1.12-1.19,1.8-.22.05-.32.2-.38.39-.05.02-.09.05-.15.07-.03-.2-.07-.4-.34-.41.05.14.06.32.12.46-.26.05-.59.05-1.03,0,.04.5.73.42,1.23.51-.1.23-.3.38-.8.26.13.17.28.32.44.47-.45.22-.8.52-.45,1.46h-.84c-.27-.84,1.21-1.23-.43-1.16.03.47.05.9.05,1.3-.94.15-1.75.41-2.19,1.01.48,1.02,1.65-.52,2.13-.77.02.01.03.02.05.04-.03,1.2-.2,2.11-.47,2.93-.52.16-1.06.27-1.28.11-.2.23-.37.5-.52.77h-.75v.77h.29c-.09.13-.18.26-.28.38h-.86c-.12.3-.14.51-.1.67-.11.04-.21.08-.34.11-1.59-.86,1.08-1.03.43-2.31-1.36.82-1.26.56-2.56,0,.08.87-.5,1.32-1.54,1.59-.05-.02-.1-.03-.15-.05.02.03.03.05.05.07-.6.15-1.33.24-2.19.31v-1.15c.66-1.38,2.67.45,2.56-1.93.72.18,1.19.13,1.54-.02-.05.47-.03.88.8.64-.23-.96.24-1.34.66-1.76.57.38.85,1.02,1.27,1.54,1-.67-.41-3.36,2.56-3.85-.42-1.18-1.44.17-1.7.38-.48-1.73,1.37-1.37,1.66-2.41.76.2.32,1.39,1.08,1.58.5-.96.13-2.43-1.06-1.69,0-.06.02-.11.02-.17h-1.7c-.06,1.95-2.02,2.85-.85,3.85-.32.33-.62.39-.93.33.11-.19.19-.41.18-.7-.6-.08-.91.08-1.13.31-.48-.23-.97-.38-1.53.06-.81.74.64.1,1.35.16-.25.34-.44.72-1.05.77.1,0,.17.01.24.04-.91.17-1.96.22-1.81,1.35-.87-.11-.84-1.04-1.7-1.16.63-1.05,1.54-2.57.85-4.24-1.69,1.13-.02,5.22-2.98,6.55-.25-1,.17-1.39,1.28-1.16-1.38-1.6.3-4.33.43-5.39-1.53-.01-2.47,3.6-5.11,2.31-1.06,1.16,1.11,1.81,2.56,1.15.07,1.71-1.21-.18-1.7.77.24.87.66-.47,1.28.39-1.05,1.02-3.03.35-3.84.77-.54-.1-.43-.77,0-.77-1.51-1.58-.68,1.88-1.28.77-1.11.29.19.83.1,1.62-.45-.3-.84-.67-1.16-1.07-.34.78-.78,1.46-1.22,2.15-.54.02-1.07.02-1.13-.39-.58.12-.35.97-.43,1.54-3.49.28.93-2.2-2.56-1.93,0-1.03,1.35-.84,1.28-1.93-1.25.35-1.31.35-2.56,0-.2.82.61.73,1.28.77-1.27.52-1.75,1.76-2.13,3.08-.54-.8-1.1-1.57-2.13-1.93-.1-.53.17-.73.35-1.01.19.15.34.34.4.6.69-.5.45-1.11.1-1.87.47-.23,1.16-.27,1.72-.42v-1.54c-.36-.07-.4.15-.43.38-.36.07-.4-.15-.43-.38-.59.38.18.63-.85,1.15-1.31-1.82,1.58-4.02-.43-5.01,1.36-1.33,2.5-.74,2.98-3.08-.07-.45-.78-.33-1.28-.39.14-1.03,1.06-1.35,1.28-2.31-.38.3-.96.41-1.7.38,1.03,1.44-.67-.28-.85,1.16-1.36-.26-.8-1.28-1.28-1.54.1-.68.73-.88,1.71-.77-1.39-1.71-1.55-2.9-1.71-6.16-2.17.07-.55,3.18-2.13,3.47.46,1,.27,2.58,1.28,3.08-.39,1.29-.79.19-2.13.39,1.44.98,1.16,4.5-1.28,4.24.06.96,1.44.11,1.7,0,.89.22-.61,1.45-.43,2.31-.91.94.61-.43.85-.77.73.51-.12,1.17-.6,1.97-1.25.09-2.4.14-2.81-.75.38,1.36-1.94-.53-1.97.97,1.04.11.36,1.65,1.18,1.94-.21-1.31,1.4-.03,1.18.65,1.61-.78,1.95.55,3.95.32-.04.22-.04.4,0,.56-.41.17-.75.54-.5,1.66.57-.18,1-.5,1.54-.71.06.03.13.05.19.08.36,1.32-1.22.88-1.74,1.4.13.52,1.07.32,1.7.38-1.63.58-1.44,2.81-2.98,3.47-.05,0-.09,0-.12,0-.09-.05-.18-.11-.27-.16-.3-.42,0-1.47.82-1-2.73-1.53-3.66.1-6.82.39.14,1.87,4.61-.81,4.04,1.05-.02,0-.03,0-.04-.01,0,.04.01.07.01.1-.04.12-.1.25-.18.4.12.03.21.03.3.03.13.21.35.36.65.44-.1.17-.24.29-.43.39-.05-.15-.08-.3-.1-.47-1.26-.27-1.54.35-2.48.38-.12-.26-.17-.57-.15-.94-1-.34-2.25.68-1.19.97-.4.65-2.64-1-1.58-1.62h-3.16c-.05-.58.48-.68.4-1.29-1.07.2-.98,1.35-2.37,1.29.44-1.02.04-.73,0-1.94-2.15-.23-4.89.18-6.71.65.48.47,1.51.49,1.97.97-.12.2-.98,1.25,0,1.29-.43.59-3.11-2.35-2.37-2.26-1.02-.61-5.37,2.29-4.74-1.29.47.36.72.92,1.97.65.75-.95-.76-1.21.39-2.26-.91-.17-.64-.23,0-1.29-1.04-.1-1.02.68-1.18,1.29-1.25-.84-1.55-.51-3.55-.32.43-.66,1.89-1.32.79-2.26-.23,1-1.66,1.01-1.58,2.26-.75-.61-.99-.04-1.97,0v-1.62c-1.24-.52-1.36,1.99-1.58.32-.47-.04-.68.12-.84.33-.03,0-.07-.01-.11,0,0,0-.01.11-.05.24-.19.3-.41.58-1.14.45v-.05c-.09,0-.17-.02-.23-.04-.14-.97,1.2-.71.79-1.9-.32-.81-2.08-.45-2.76-.97-.81.09-.09,1.43-1.18,1.29-.19,1.02,1.96.12,1.58,1.29-1.8-.4-1.55.89-3.16.65-.22-.72.75-.46.79-.97-.25.05-1.07.16-1.42-.12-.06-.1-.11-.18-.15-.24-.04-.21.06-.5.38-.93-1.67.42-1.54,3.52-2.76,2.26-1.07.48.69,1.35,1.18,1.62-.33.62-1.73.88-2.37.32-.02-.35.01-.65.06-.94.24-.22.44-.46.56-.68-.15,0-.28.02-.41.04.07-.23.14-.46.22-.71.05.02.11.03.19.03-.16-.78,1.8.18,1.18-.97-.71.16-.83-.17-1.06-.42.01-.08.03-.15.04-.23-.09.02-.15.05-.21.09-.09-.05-.2-.09-.35-.09.1.21.02.56-.03.89-.13.19-.38.28-1,.08-.03.18-.02.41,0,.67-.25,0-.59-.06-.95-.12.09-.27.2-.51.56-.55-.17-.51-1.24-.28-.79-1.29-1.53-.28-.65,1.41-2.37.97.13-.75-.06-1.24-.4-1.62-1.23.18-1.24,1.35-2.76,1.29.21-.26.41-.53.39-.97-.63.09-1.12.33-1.54.64-.05-.46-.13-.97-.26-1.57-.83,1.56-.65,2.43-3.41,2.7.07.45.78.32,1.28.38-.36.7-1.1,1.06-1.75,1.49-.2-.01-.4-.04-.63-.09.35-1.01,1.07-1.71,1.58-2.59-2.12.21-1.72,2.47-3.95,2.59,0,.02,0,.04,0,.06-.09-.07-.19-.14-.31-.19.75-1.11,1.49-1.9,2.22-2.48.09,0,.18.02.29.02-.04-.07-.06-.13-.06-.2.73-.54,1.46-.88,2.2-1.1.21-1.64-1.4,0-1.19-1.29-1.18.21.38.69,0,1.29-.36-.06-.63-.04-.84.03-.04,0-.07-.02-.11-.03-.01.05-.04.07-.06.1-.05.03-.1.07-.14.11-.16.02-.37-.08-.59-.21-.1.39-.24.68-.23.9-.65-.31-.7,1.98-2.37,1.69.02-.58,0-1.27-.18-1.9,0-.01.02-.02.02-.04-.01,0-.02,0-.03,0-.28-.94-.89-1.7-2.17-1.7-.04-.11-.1-.21-.22-.32-.52.36-.95.45-1.33.4.18-.06.38-.16.59-.32-.8-.2-1.21-.11-1.35.03-.48-.32-.9-.78-1.36-1,.31-.05.72-.02.73-.31h-1.18c-.04.06-.06.13-.08.19-.22,0-.46.07-.72.25.27-2.08-.47-3.84,0-5.01-1.71.06-1.13-.99-.85-1.93-3.66-.8.93,5.63-2.56,5.78-.15.52.05.72.3.87-.12-.07-.27-.13-.44-.16,0,.18-.12.36-.28.52,0-.03,0-.05,0-.08-.21.04-.32.19-.37.38-.24.15-.52.26-.81.33-.19-.27-.35-.56-.49-.86.58-.15,1.25-.24,1.16-.95-.56-.06-1.02.05-1.45.22-.06-.2-.12-.41-.17-.62,0,0,0-.01,0-.02-.47-2-.35-4.41-.43-6.59,0-.17,0-.34-.02-.51.03.02.05.05.1.07-.06-.91,1.19-.75,1.18-1.62-.46,0-1.03.4-1.31.81-.22-6.27-.28-12.1.04-18.41-.14-.9-.51-1.59-.85-2.31.97-2.08-.41-4.56.43-6.16-.55-.66-.88-1.52-2.13-1.54-.32.73-1.27.27-.43,1.16-4.79,1.9-.66,8.14-3.41,13.1,1.24,4.9.69,9.91,0,14.64.61.09.15,1.15.85,1.16-.49,1.99-2.05,3.03-3.41,4.24.11,1.24,1.73,1.12,2.07,2.15-.04-.03-.09-.06-.14-.09.3.9-.17,1.17-.52,1.55-.22.05-.43.11-.56.25.11.03.22.08.32.14-.07.17-.1.37-.04.65.21-.08.39-.15.56-.21.53.65.53,1.6-.84,1.73.49.97.25,2-.32,3.06-.22-.16-.53-.28-.95-.36-.06,1.55-.71,2.56-1.28,3.64-.77,1.08-1.46,2.18-1.71,3.29h-1.71c1.77.31-.58,1.92-.43.39-.48,1.1.2,3.27-.45,4.62-.17.17-.32.33-.4.39.01.04.04.07.06.11-.42.43-1.1.7-2.2.66-.94,2.86.13,1.62-.85,3.85-1,0-1.25-.66-2.56-.39-.02,1.39-1.06,1.87-1.28,3.08.69.11.73-.36,1.28-.39.41,1.39-1.68.54-2.56.77.51-1.15.12-1.31-.43-2.31.69-.5,1.59-1.65.85-2.31.11-.42.85-.26.85-.77.43.25.44.89,1.28.77-.79-1.27.38-2.59-.85-3.85-.26.4-.64,1.98-1.28,3.08-.54-.1-.43-.77,0-.77-.07-.45-.78-.33-1.28-.39,1.47-.83.11-.62-.85-1.16,3.29-1.92,1.93-3.79,2.13-6.94-1.09.04-.84,1.29-.85,2.31-.76.05-.9-.47-1.7-.39.23-2.1.77-3.7-1.32-4.17.11-.49.04-.9-.66-.91.25-.79,1.85-.05,1.97.32,1.54-.43.08-1.44.79-2.26-1.7-.98-1.34-3.65-1.97-5.5-1.22.23-.76.23-1.98,0-.23.02-.33.14-.39.3v5.62c.57.1,1.11.29,1.58.55-.63.78-.15,2.46-1.58,2.59v.34c-.43-.32-1.35-.2-1.13-1.12-1.6,1.4-2.24-.22-3.84.39.23.31.44.62.43,1.15-.61.43-1.04.42-1.28-.39-1.05.33-1.26,1.43-2.13,1.93.1,1.07,1.35,1.09,1.7,1.93,0,.16-.22.17-.53.15.06-.16.06-.37.11-.53-.3,0-.34.26-.37.51-.86-.1-2.08-.28-1.77,1.03,2.78-1.22,2.62.82,4.69,1.16-.55-1.51.57-2.13,1.71-3.85.77.59.34,2.26,1.71,2.31-.28.52-.91.72-1.71.77,0,.57.15,1.02.29,1.48-.5-.14-.47-.44-1.13.06.23.31.44.62.43,1.16.34-.02.66-.03.91.04,0,.22-.01.46-.06.73,1.3-.02,1.66.81,2.56,1.16-.55,1.49.54,3.32-2.13,3.47.13,1.3,1.89,1.12,2.13,2.31.85-.64,3.16.03,3.83-.77.43.77,1.58.88,2.13,1.54-2.15,1.62-4.85-1.04-8.52-.38-.38.44-.46.78-.26,1.17-.05,0-.11,0-.16-.01v.32c-1.15-.12-1.58.41-1.29,1.6-1.11-2.59-3.33-4.18-5.12-6.16-.5,1.21-2.33.76-2.98,0,1.46-.51.2-1.65-.85-.77.18-1.8.55-3.97.43-5.39-.91-.18-.81.55-.85,1.16-.57-.08-.79-1.6-.85,0-.62-.47-.65-1.47-1.28-1.93-.34.27-1.17.6-1.28,0-.58.14-.76.36-.7.65.09.17.17.34.27.51-.17-.19-.24-.36-.27-.51-.71-1.42-.96-2.9-1.43-5.27,1.75.4,2.25-.07,3.84.77.79-1.68-1.09-3.06-1.7-4.62.67-.29.64-1.22,1.7-1.16-2.75-.64-3.01-4.55-3.41-6.16-.88.1-.1,1.71-1.28,1.54,1.83,3.06,1.17,6.09,2.56,9.25-1.1.54-1.97-.24-2.98.39.07-1.09.78-1.6.85-2.7-.76.34-.54,1.56-2.13,1.15.08.31.43.39.43.77-.37,1.14-.64-.89-1.7-.39.33.34.46.87.43,1.54-1.12.12-1.4-.53-1.28-1.54-1.16.1-1.21,1.21-2.18,1.48.02-.11.03-.22.06-.32-.25,0-.31.17-.35.37-.03,0-.05.01-.09.01-.33-.61-1.35-.58-1.28-1.54-1,0-1.25.66-2.56.39.51.51.16.61,0,1.16-.4-.24-1.57-.9-1.28.39-.68-.64-.9-4.13.43-4.24,1.32,1.12,3.51,1.45,4.26,3.08.38-.3.96-.41,1.71-.38-.97-1.11.61-1.28,1.7-.77-1.08-1.08-1.34-2.9-3.41-3.08.02,1.11-.97.91-.43,1.93-2.78-.44-2.58-3.58-4.26-5.01h-2.56c.58-1.67.2-2.44,0-4.24-2.78-.32-3.66-2.34-5.11-3.85-.38.86-1.82,1.78-.85,2.7.79-.06.26-1.3.85-1.54,1.04,4.83,7,7.3,4.26,15.03-2.24-1.25-3.13-.52-4.69-1.16v1.21c-.12-.04-.25-.06-.42-.05.12.1.2.24.27.39h-1.13c-.91-.12.61-1.19.85-1.54-.42-1.28-.84.43-1.28.38-1.2-.9,1.01-3.44-.43-4.62-1.86.29.49,2.16-.85,3.08-.28-2.51-3.62-3.65-2.98-5.78.13-.52,1.07-.32,1.7-.39-.08-.31-.43-.38-.43-.77-.36.07-.4-.15-.43-.39-.59.39.18.64-.85,1.16-.73-.49-.53-1.83-1.7-1.93.15-.44.75-.98.85-.38,1.06-.26-.63-1.17-.85-1.54-.65.57.27,2.09-1.7,1.93,2.22,1.55-.59,1.39,2.13,3.08-.46.88-1.29-1.11-2.56-.77.62,1.36,1.89,2.14,1.7,4.24-.29-1.36-1.36-2-2.98-1.16,1.24-.62.47-.95.43-2.31-.38.3-.96.41-1.7.38-.65,1.18-.77,2.32-.86,3.48-.76.32-.47,1.14-.21,1.84-.11.65-.3,1.31-.63,1.99.79-.1.97,1.02,1.28,2.31-.05,0-.22.06-.46.12.01-.04.02-.08.04-.12-.46-.1-.61.07-.73.28-.55.09-1.14.08-1.41-.28-.81.04.34,1.44.43,1.93.42-1,.99-.19,1.2-.69.28.42.46.81.6,1.2-.07.21-.04.41.18.53.08.24.16.49.25.73-.1.13-.15.29-.11.55-1.76-1.7-.96,2.01-2.56,2.31-.94-.05-.18-1.63-.43-2.31-.21-1.22,2.11-.14,1.7-1.54-.5.06-.76-.09-.85-.39-.96.22.52.6-.43,1.16-.77-.46-.33-2.01-.85-2.7-.88.23-1.77.74-.85,1.54-.73.02-1.1-.29-1.28-.77.49-1.23,1.66-1.84,2.56-2.7-.12-.91-1.14.44-1.71.38,1.07-.92.41-1.02.43-2.7,1.62-.57.08,1.72,1.7,1.16-.38-.94-.74-3.07-1.7-2.31-.54-1.9,1.07-1.86,2.13-2.31-.33-1.71.57-2.31.43-3.85h-3.41c.28-.39.98-.4.85-1.16-2.58-.06.54,2.75-2.13,2.31-.14,2.01-.55,5.95,1.28,5.39.07.96-.67,1.19-.85,1.93-.5-1.38-2.49-2.02-1.7-3.47-2.23.87-1.49-1.38-2.13-2.31,1.39.04-.08-1.1,1.28-1.93-.18-.61-1.34-.33-.85-1.54-1.78-.46-.76,1.62-1.71,1.93-1.48-2.9-1.81-6.84-5.54-7.7-.48,2.84,1.03,8.74.85,10.4,1.63.87,2.9,2.07,3.97,3.45-.04,0-.08,0-.13.02-.79.68.19,1.13.43,1.93.36,0,.61-.21.74-.47.03.04.05.08.08.12-.25.33-.47.65.03.73.14-.03.24-.1.3-.18.67,1.16,1.27,2.39,1.82,3.65-.59,1.21-2.1-.53-2.56.39.48.98,1.89,1.12,3.41,1.15-.23-.31-.44-.62-.43-1.15.73-.08,1.1.66,1.28,0,.87,1.95,0,3.63.85,6.16-.33.05-.59.04-.81-.02,1.28-.54-1.59-.92-.09-.02-.71-.24-.78-1.04-.81-1.89-1.33.41-2.61.88-2.98,1.16-.85-3.85-1.61-7.79-3.84-10.4-.54.1-.43.77,0,.77-.13.52-1.07.32-1.7.39,1.11.7,1.2,1.33.92,1.98-.06-.3-.76-.72-.48-1.22-1.06.06-.12,1.3,0,1.54.2-.04.32-.09.39-.14-.15.29-.37.59-.6.91h-.65c-.37.53-.38,1.39-.78,1.9-.46-1.53-.22-3.69-.94-4.98-1.19-.17.33,2.1-.85,1.93-.95-.17-.17-1.9-.43-2.7-2.3.38.17-1.15-2.13-.77.37-2.52-.79-3.65-1.28-5.39-1.17,0-1.01,1.82-.43,2.31-.73,1.12-2.45-.07-2.13-1.16-1.48.88,2.77,4.42,0,6.55.08,1.08,1.39,1.05,1.7,1.93-1.92-.02-5.05.67-3.84,3.08-.73.08-1.1-.66-1.28,0-.8.86,2.43,2.54,2.23,3.89-.19,0-.37,0-.51-.04.03.23.08.44.14.64-.22.18-.54.36-1,.51-.31,1.05.85.77.85,1.54-1.91.06-3.35-.31-4.26-1.15-.76.28-.06.7,0,1.15-1.21-.83-1.37-2.62-2.98-3.08.08-.44.43-.21.43,0,.76-4.97,1.47-8.4,1.7-14.25-.81-.17-1.07-.83-2.13-.77-.4,2.42.04,4.7-2.98,5.39,1.39,1.44,2.1,3.5,2.13,6.16-.37,1.14-.64-.89-1.7-.39-.24.68.52,2.26-.43,2.31,0,1.08,1.16-.92.85.77-.1.49-1.27.51-1.28,0-1.17.6-.04,2.31.43,2.7.26-.67,2.02.03,2.13-.77,1.38.45-.01,1.01,1.28,1.54-.31.36-.78.58-1.28.77-2.61-1.71-8.27-4.09-8.95-9.25h-1.7c1.48,2.34,1.01,6.12,1.28,7.71-.92,1.06-1.96-.38-2.98.38-.38-1.24,1.39-.54,1.7-1.15-1.77-4.03-1.45-5.47-2.98-10.79.52.43.87.33.85-.39h-1.28c-.8.69.35.98,0,2.31-.99-.13-1.84-.39-2.13-1.16-.67,1.01.04,4.06,1.71,4.24-.86-1.34.19.03.43-.77.23.11.42,1.7.85,0,.5.06.36.7.43,1.15-.39,1.06-1.57-.75-1.7.77-2.97-2.19-4.38-5.8-8.1-7.32v-1.93c1.23.91,1.41.75.85-.77.11-.77,1.74-.16,2.09-.72-.69-.22-2.59-.51-2.09-1.21-1.75-.33.51,1.73-.85,2.31-.5-.06-.36-.7-.43-1.16-1.86,1.46,1.21,3.27-1.28,3.47-1.25-.33.55-.97,0-1.93-1.17-.74-2.35-1.47-4.26-1.54v1.54c-.85,0-.54-1.05-1.7-.77-.02-.66.32-1,.85-1.16-.04-1.25-2.54-.27-2.13-1.93-.98.7-1.14,2.48-.85,4.08,0,0,0,0,0,0,.11.64.3,1.24.52,1.75-.51.07-.91.25.16.32.18.34.39.62.6.78-2.42-.21-2.93-.41-3.41,1.54-1.08-.18-.71-1.67-1.71-1.93-.33.39-.27.96-1.28,1.54.83-.06,2.37.73,2.56,2.31.55-.91.71-2.18,1.28-3.08.54.53,2.01.53,2.56,0,1.59,2.31,3.09,4.88,5.97,7.7-.07.18-.14.3-.22.4-.07,0-.13-.01-.2-.01.02.04.05.08.08.13-.63.48-1.53-.96-2.65-.13.4.41,2.3,1.24,2.91.46.1.12.2.24.29.37-.02.37-.21.89.21,1.48-.23.79-2.02.09-.85,1.15-1.58-1.3-1.69.21-3.41-.38.64-.45,1.04-1.11,2.13-1.16-1.29-.68-3.11,1.18-4.69-.38.64,1.35.51,2.39-1.28,1.54.22.57.63.97.85,1.54-.73.14-.8-.3-.85-.77-1.31,1.46.62,3.27,2.13,3.47-1.19-1.27.23-2.5.85-2.31-.11.81-.32,1.19,1.7,1.54v1.93c-.41-.01-.33-.47-.43-.77-.5.06-.36.7-.43,1.16-2.09-2.49-3.92-.26-5.76,1.11-.11,0-.19-.1-.2-.34-.14.21-.18.4-.15.58-.38.26-.76.47-1.14.57-1.03-.22-.95-1.46-1.28-2.31-.68,2.09-1.7.13-3.84.38.55,1.56,1.97,2.33,2.98,3.47-4.2,1.47-7.58.2-10.66-1.16.33-.34.46-.87.43-1.54.76-.05.9.47,1.71.39-.43-1.36-.74-.71-1.71-1.16.33-.34.46-.87.43-1.54.85,0,.54,1.05,1.7.77-.55-.51-.26-1.16.43-1.54-.72-.37-1.1-1.06-.85-2.31,1.69.12-.48,1.34,1.28,1.16-.64-1.22-.53-3.03.85-3.47.07-.84-1.51-.17-2.13-.38-.12.62.4.66.42,1.16-2.76-1.41,2.12-2.05,2.13-3.47-1.51-.38-2.3.91-2.98,1.93-.49-.32-1.14-.51-2.13-.39.23-.56-.5-1.99.43-1.93-.69-1.48-2.5.05-3.41-.77,1.31-2.07-2.45-5.04,1.28-5.39-.07-2.16-2.09-.39-3.41-.39-1.09-.04-.69-1.44-1.28-1.93-1.08.93-1.07-1.3-2.98-.77.46,1,1.54,1.43,1.7,2.7-.7.28-1.86-.77-.85-.77-2.63-.74-5.99-.37-8.1,0,2.04,1.04,2.57,4.96,2.93,7.71-.24,0-.4.26-.44.57-.8-.02-1.74-1.19-2.06.58.74-.02,1.59.02,2.21.27.09.13.22.22.4.22.12.09.22.2.29.32-.11-.01-.22-.03-.34-.04v1.32c-.21-.09-.48-.24-.86-.16,1.42,1.44.83,2.31.85,5.01-2.59-.67-2.74-5.4-5.54-4.62,1.21,1.86,3.43,2.81,2.99,6.16.55.01.9-.16,1.11-.45.37.88.93,1.58,1.63,2.16.07.47.13.95.25,1.37-1.71-.93-3.39-1.09-4.26-1.93-1.26,2.57-2.83,6.53-6.39,5.78-2.84,1.33-2.6,7.36-7.67,5.39.56-1.66.23-3.35,0-4.62-.63.2-1.07.57-1.7.77.65,1.09,1.17,2.54.43,3.85,1.66-1.94.03,1.3.85,1.54-.91,1.96-3.77-.13-4.69,1.93-1.34.19-1.5-.69-2.98-.39-.58-.38-.55-1.3-1.28-1.54.62-.91,1.13,1.52,2.98.77.55-.51.55-1.42,0-1.93-.76.28-.06.7,0,1.15-.69.11-.73-.36-1.28-.38.15-.51.75-.61.85-1.16,1.07-.07,1.34.59,1.7,1.16.4-.65,1.58-1.35,1.28.38,2.14-.54.03-3.01,2.13-3.08-.19-.56-.37.04-.85,0-.5-.06-.36-.7-.42-1.16-.75.35-.78,1.35-1.28,1.93-1.5-2.01.47-4.19,2.56-4.24.09-1.24-.75-1.63-.42-3.08.61.74.99,1.67,1.28,2.7.32-.25,1.04-.54,1.23-.11-.02-.45,1.41-1.58.04-1.43.19-.34.38-.69.85-.77.59,1.01.49,2.64,1.71,3.08-.38,1.05-.96-1.17-1.71,0,.47,3.29,4.47-1.96,2.56-1.93,1.07-1.72,2.9-.23,5.11-.77-.75-1.31.14-1.44,1.28-1.93-.71-1.68-3.61-.36-2.99,1.54-1.46-.08-1.28-1.27-2.13,0-.7-.44.51-2.11,1.71-1.16.27-1.42.96-2.47,1.28-3.85.37.69.93,1.21,1.7,1.54.98-1.92,1.84-.48,3.41,0-1.1-2.93-5.24-4.04-5.11-6.93.6-.62,1.47-.98,2.55-1.16-.31.36-.77.58-1.28.77,1.65.56,2.45,1.9,3.84,2.7.58-.31-1.55-1.4-2.13-1.93,1.46-.81-.2-1.45.43-1.93-.21-.43-1.85-.23-2.13-1.54-.41.01-.33.47-.43.77-1.18-.85-1.01-1.77-2.98-1.15,0-2.06,4.52-.03,3.84-2.7,2.17-.29.97,2.46,2.98,2.31-1.78-3.02,1-4.83,1.28-8.09-1.58-.24-4.38.63-4.69-.77-.12.51-.79,1.19-1.7,1.93-.9-1.24-1.59-2.67-2.56-3.85-.15.92.91,4.05,2.99,4.24-.81.97-1.5-.36-2.56.39.61.56.33,1.22-.85,1.16-.17.93.78.84.43,1.93,1.67.03,3.74-.3,3.41,1.54-.48.28-1.83-.76-3.41,0,1.37.94.38,1.13-1.28.77.86.79-.19.76-.43,1.54-1.59-.1-.58-2.55-2.98-1.93,1.01.89,2.14,1.66,2.56,3.08-.18.86-2.34.37-2.13-.39-1.41.58.73,1.09.85,1.54-.28.52-.91.72-1.71.77-.25.69,1.25,1.6,0,1.93.37.12,1.04.11,1.72.34,0,.02,0,.03,0,.05.03,0,.05-.02.07-.03.26.09.52.22.77.41v-1.16c.5.06.36.7.43,1.16-.52,1.18-1.63-.56-2.13.39,1.15,1.54-.96,1.74,0,3.47.3.62-2.01.62-1.71,0-.95.18.94,1.11.01,1.2v-.43c-.24.13-.5.25-.72.4-.05,0-.09,0-.14-.01.02.03.04.05.06.08-.3.23-.51.54-.47,1.08h.84c.18.64-1.59-.03-1.7-.39.08-.44.43-.21.42,0,.81-.16-.18-1.39-.92-1.08-.12.1-.25.2-.36.31.1-.17.23-.26.36-.31,1.41-1.17,3.33-1.29,3.9-3.92-1.34-.65-2.53.01-1.7-1.93-1.23.17-1.94.81-2.13,1.93.88.23,1.61.6,1.28,1.93-1.49.02-2.86,1.54-5.12,1.93-.9-.31-1.17-2.03-.42-2.7.57.08.79,1.6.85,0,.91-.18.81.55.85,1.16.86-.51,1.44-1.26,1.7-2.31-1.85-.82-2.24.2-2.56-.77-1.07,1.05-2.57,2.42-3.48,3.86.02-.13.04-.27.07-.39-.41.01-.33.47-.43.77.07,0,.11-.03.16-.06-.45.79-.7,1.59-.59,2.37.86-.25.28-1.8,1.28-1.93.57.26-.37,1.17.85,1.54.09,1.5-4.82.76-2.98-.39-2.58-1.26-4.69-.04-5.97,1.16-1.45-.15-.7-1.19-1.7,0-.84-.29,1.16-1.23.43-2.7.68,1.6,3.75-1.44,2.13-3.08-1.12.15-1.19,1.23-2.99.77.86,1.34-.19-.03-.43.77-.08,1.48.35.14,1.28.38-.67.29-.63,1.22-1.7,1.16-.27,1.96,1.02,2.95-.85,3.47.34.85,2.64-.07,2.13,1.54-.28,1.15-.91-.37-1.71,0,.49,1.69,0,1.27-.43,2.7,2.87-.57.97.92,2.56,1.15.86-1.2-1.03-2.65.85-3.08-.07.34.17,1.08.61,1.82-.17.06-.37.1-.6.1.19.27.56.42.97.45.93,1.25,2.36,2.19,3.71.7.93.06.91.97.85,1.93,1.67.1,1.58-1.39,3.41-1.16.21,1.26-2.12.82-.85,1.93-.77.05-.9-.47-1.71-.39-.25,1.23.8,1.19,0,1.93-1.23-.3-2.45-.61-2.98-1.54.23-.59.44-.03.43.38,1.31-.84-.6-2-1.7-1.93.43,1.16-.95.68-1.71.77-.08.34-.03.58.05.78-.02,0-.03,0-.04,0-.07.21-.08.38-.07.53-.33-.11-.74-.16-1.22-.14-.21-1.92-3.88-3.55-2.98-7.71-1.51-.36-2.33-.26-3.41,0-.02-1.17.39-1.96,1.28-2.31-.61-.6-1.72-.76-1.28-2.31.39-.67,1.33-.85,2.56-.77.08-.33-.17-.36-.43-.38-.08-.33.17-.36.43-.39-.36-1.13-1.07.5-2.13,0-1.7-.64-.48-3.93-.85-5.78-2.43.27-2.81-1.31-3.84-2.31,1.41-1.62.71-2.74,1.28-5.01-.54-1.06-2.64-.69-2.98-1.93-1.29.63-1.04,2.65-1.71,3.85.75.35,1.25.93,2.13,1.16-1.04.6-.59,2.55-2.56,2.31.96,1.21,2.5-.28,2.56-1.15,1,.56-.89,1.73-1.28,2.31-2.21.07-2.48-3.23-4.26-2.31,1.09.49.86,1.3-.85,1.15.27,1.42,1.94-.3,2.56,1.16-.36.57-1.37.56-2.13.77.01-.38.52-.3.85-.39-.49-1.25-2.26,1.05-1.7-1.16-.79,1.81-4.21.99-7.25,1.54-.79-.06-.26-1.31-.85-1.54.36-.57,1.37-.56,2.13-.77.76.28.06.7,0,1.16.67,1.19.34-1.71,1.71-1.16.87-.12-.09,1.11-.43,1.16.89,1.03,1.89-1.09,2.13-1.93-1.61.3-2.04-.47-3.41-.39,1.88-.21,4.71-.21,5.54.39.88-.11.85-1.03,1.28-1.54.85,0,.54,1.05,1.71.77,1.24-.79,1-2.68-.43-3.08-.61.47-.65,1.47-1.28,1.93-1.47.31-1.8-.72-2.55,0-1.86-1.53-2.28-4.37-6.82-3.47-.28.63-.25,3.64,1.28,3.85-1.53.93-7.6,1.73-7.67-.77h-1.28c1.33,1.61-1.87.81-.43,2.31-.34-.2-.69-.4-1.28-.39.23-.31.45-.63.43-1.16-1.44.74-2.61,1.38-3.84,3.08-.34-.2-.69-.4-1.28-.39.4-1.13.64-1.43.85-1.93-.83.13-.81-1.5-2.98-1.16.33-.34.46-.87.43-1.54-.46.09-.29.77-.85.77-.88-.11-.1-1.71-1.28-1.54,1.21-.82.6-2.15,2.13-1.93-1.63-1.66-1.17-3.1-1.28-4.62-1.98-.23-4.09.26-5.97-.77-.09,1.24,1.52.94,2.13,1.54-3.6,2.42-6.12-1.92-9.8-.77,1.44-.63,1.49-2.5,2.13-3.85,1.94.43,2.44,2.16,4.69,2.31-.64-.82-1.35-2.31.43-2.7-.12-.79-1.14-.77-1.71-1.16,1.01-1.65,4.76-.84,4.26-3.85-1.94.06-1.67.32-3.41,0-1.05-.54-.75-1.33-.42-2.31-1.3.28-1.25-.67-2.56-.38,1.54,3.1-1.99,1.62-1.28,3.85-.38-.3-.96-.41-1.7-.39.98,2.52-1.44,3.46-2.13,6.16-1.73-.36-2.94-1.93-4.69-1.16.57.5,1.02.94,1.27,1.41-.31.06-.6.22-.83.52.27.33.66.56.94.88-.1.31-.26.65-.52,1.05.56.39,1.57.38,2.13.77.67,1.67-.76,3.17,1.7,3.47-.21-1.68,1.31-.82.43-2.31,1.43-.06,1.49.32,1.53.81-.5.12-.73.49-.67,1.12.2-.21.59-.24.9-.34.08.12.2.23.37.34-.9.1-4.05,2.42-2.56,4.62-1.61.56-.82-1.06-2.13-.77-.04-.55-.07-1.09.43-1.16-.57-.62-1.81,1.42-3.41,1.16-1.44-.16,1.13-1.49-.85-1.16-.08-.84.35-1.23,1.28-1.16-.77-.33-1.33-.85-1.7-1.54.07-.45.78-.32,1.28-.39-2.01-.99.15-1.93.43-3.08-.19,0-.4-.04-.62-.11-.22-.06-.43-.16-.66-.27-.05.32,0,.73-.14.96,0,.01,0,.03-.02.04-.06.08-.14.13-.27.14-.03-.23-.06-.46-.43-.39.05-.46.13-.89.83-.77,0,0,0,0,0,0-.08-.04-.17-.1-.25-.15-.13-.08-.26-.16-.4-.25-.09-.06-.18-.13-.27-.2-.13-.1-.26-.21-.39-.32-.08-.07-.16-.14-.23-.21-.2-.19-.39-.39-.57-.61-.03-.03-.05-.07-.08-.1-.15-.19-.3-.39-.43-.6-.05-.08-.09-.15-.13-.23-.1-.18-.2-.36-.28-.55-.04-.08-.07-.15-.1-.23-.1-.26-.19-.52-.25-.79-1.46.4-3.34,1.2-1.7,2.31.63-.17-.17-.49,0-1.16.2.06.4.15.59.26.06.03.11.08.17.11.14.08.27.17.4.27.06.05.12.1.18.15.13.11.25.22.38.35.05.05.1.11.15.16.13.14.25.29.38.44.04.05.07.1.11.15.13.17.26.36.38.55.02.04.05.08.07.12.12.21.24.43.36.66.01.02.02.05.03.07.12.25.23.5.33.76,0,.01,0,.02,0,.03.1.28.19.56.27.84-.05-.1-.15-.15-.26-.2-.04-.01-.08-.02-.13-.03-.09-.02-.19-.04-.3-.05-.05,0-.11-.01-.16-.01-.13,0-.27-.01-.4-.02.18.47.54.79,1.28.77.02-.1.03-.18.03-.25.04.16.08.32.11.48,0,.03.01.06.02.09.04.21.07.41.08.62,0,.06.01.11.01.17.02.19.02.37.02.55,0,.08,0,.16,0,.24,0,.16-.02.32-.03.48,0,.1-.03.2-.04.3-.02.14-.05.28-.08.41-.03.12-.07.23-.1.35-.04.11-.07.23-.11.34-.06.14-.13.26-.19.39-.04.08-.08.17-.13.25-.13.21-.27.4-.43.59-.21-.2-.31-.48-.36-.79.34-.06.28-.47.37-.75-.35,0-.35.34-.4.62-.15-1.24.58-2.96.39-3.32-.84.01-1.71-1.63-4.26-1.16-.33-1.8,2.61-.86,2.98,0,.71-.39.46-1.64.85-2.31-2.46.24-2.81.01-5.54,0,1.61,1.15-2.13,1.92-2.56,1.16-.29.23-.31.62-.35,1.32-.21-.15-.5-.21-.92-.17-.04.29-.06.57-.04.82-.87-.3-1.27-.29-2.52-.43-.15,1.18,1.34,2.33,2.3,3.63.15.66,0,1.14-.17,2.15.42-.2.62-.6.79-1.02.15.44.2.91.05,1.4-1.47.3-1.88-.36-2.13-1.16-1.29.61-.84,2.07.85,1.93-.13.52-1.07.32-1.7.38-.58-.12-.35-.96-.43-1.54-1.88.89-2.89-2.12-2.98-.38-.35-.07-.43-.39-.85-.39-.37-1.23.66-1.21,1.28-1.54-.92-.33-2.1-.04-2.98-1.16.12-.79,1.14-.77,1.7-1.16-.62-1.67-.95.41-2.56,0-.41-1.53,1.24-1.2,2.13-1.54-1.6-1.99-3.87-1.29-6.82-2.31.77.69,2.2,2.05,2.98,1.54-.69,1.88-3.4,4.07-5.11,2.7.29,1.04-.88.75-1.28,1.16-.02.1-.03.19-.03.29-.79.53-.4,1.61-.62,2.4-.07,0-.13.01-.2.01-1.44-.83.56-1.77.43-2.7-.87-.77-.84.17-1.7.39,1.07-1.72,4.87-1.27,6.39-3.47-1.04-.29-5.06-.2-4.26-1.16-1.4-.76-.4,1.5.43,1.93-1.37,1.51-2.48-.86-3.41,1.54-.21-.5-.45-.8-.85-1.93.97-1.51.64-2.07,2.13-2.7-.37-.56-.64-1.22-1.7-1.15.95-.31,2.09-1.01,4.69-.77-.74-2.73-3.51.31-5.54,0,.24.81,1.06,1.1.85,2.31-.37,1.14-.64-.89-1.71-.39-.66,1.37,1.45.23,1.28,1.16-.19.57-.55-.15-1.28,0,1.07,1.68-2.82,1.93-1.7,3.85-.47-.99-1.67-1.32-2.13-2.31-1.44.14-.54,1.15,0,1.93-.08.31-.43.38-.43.77-.79-1.35-1.29.02,0,.39-.5.24-1.11.2-1.7,1.16.31.38,3.25-.12,4.26-.38.06,1.21-1.09,1.32-2.13,1.54,1.05.34,1.4,1.31,2.13,1.93.65-1.09.89-2.79.42-3.85.82.16.34,1.49,1.71,1.16-.22.2-.31.38-.36.57-.17-.05-.33-.11-.48-.18v1.54c.29-.08.52-.14.71-.18.14.38.25.81.14,1.34,1.79-.39,2.1.54,2.81,1.13.1.11.18.22.18.41h.84c.02.29-.16.4-.43.42,0-.01,0-.02.01-.04-.04.01-.07.03-.1.05-.5.02-1.24-.18-1.62-.05.02,1.27,1.82.92,1.7,2.31.39-.21.65-.52.7-.83.2.07.41.09.59.06.06-.14.08-.24.09-.34.24.12.48.25.75.34-.39.67-.79,1.34-2.13,1.15-.05-1.66-2.77-.52-2.13-1.54-.9-1.03-1.32,1.61-1.71,2.31-1.34.19-.96-1.18-2.56-.77-.52,1.48-.75.83-1.28,2.31-.29-1.07-3.23-.96-1.28,0-1.57.13-1.29-1.4-1.71-2.31.77,1.18,3.43,1.63,3.41-.77-1.87-.2-1.4-.12-2.99-.38.94.12,2.21-2.41,2.13-.77.75-1.69-2.97-2.55-1.28-5.39-.63,1.07-1.9-.81-1.7.77-.94-1.44,2.84-4.49.85-5.78.75.55.97.35.85-.77.68.03,1.63-.18,1.7.39.77-1-.12-1.3.85-2.31-1.31.27-.82.27-2.13,0-.18.73-.92.97-.85,1.93-.34-.27-1.17-.6-1.28,0-.61-.46-.65-1.9-1.28-.39-1.1-.09.59-.66,0-1.54-1.47.73-1.09.73-2.56,0,.31,1.18-.44,1.41-.43,2.31-1.22-.91.42-2.18-.43-3.08-3.35,1.84-4.88-1.82-2.56-2.31.75.87,2.57.76,3.84,1.16.09-.66-.73-1,0-1.16-.24-.8-2.76-.48-2.56.39-1.43-.35-.21-.72-.43-1.93-1.65.82-3.41,1.54-2.98,4.24,1.6.66,3.15.99,2.13,3.08.98.12.47-1.11,1.28-1.16,1.15-.27.82.8,1.28,1.16-1.81,1.08-4.19-.72-5.11,1.16.45-1.59-3.14-2.23-2.13-4.24-2.49.25-4.35.81-5.11-1.16.27.65-1.67,2.44-2.98,1.54.07-.45.78-.32,1.28-.38-2.17-2.19-1.75,3.87-3.84,4.24-.66-.46-1.66-1.23-2.56-.38,1.08-.8,1.69-1.61-.43-1.93,1.06-.17,2.65-1.83,2.98-.39.89-1.3-2.63-1.04-3.41-.77-1.03.9.67,1.03.85,1.93.17.93-.78.84-.43,1.93-1.69.5-.87-1.27-2.56-.77.5-1.25,1.11.01,1.7-1.16-.88-1.41-2.71-.13-4.26,0,.35,1.09-.6,1-.43,1.93,1,.5.95-.2,1.71.77,0,1.15-2.01.49-2.56,1.16.18.16.29.38.35.64-.12.08-.24.14-.35.13.12.34.26.44.42.43.03.42,0,.89-.01,1.35-.19.26-.42.48-.84.53.08.31.43.36.84.37,0,0,0,.01,0,.02h-.85c-1.1-.29.31-2.85-1.28-2.7.82-.99,3.54-2.85,1.28-4.24.59-.21,2.16-1.22,3.41-1.93-.05-.98-1.43-.76-2.56-.77.15.51.75.61.85,1.16-.97-.53-1.65-1.33-2.56-1.92-1.27,0,.6,2.85-1.28,2.31.4.8.42,1.4.25,1.91-.16-.12-.38-.15-.67.02v.77c.12-.02.2,0,.26.03-.48.74-1.12,1.46-1.12,2.67.89.84,1.38-.34,2.13.39.12.62-.4.66-.43,1.15-1.56.13-2.19-.59-2.56-1.54-.84,0-.54,1.05-1.7.77-.12-.69.4-.79.43-.38,1.51-.04-.91-1.27.43-1.16-.1-.68-.73-.88-1.7-.77-.15-.77.08-1.21.85-1.16-.52-.56-1.86-.37-1.28-1.93-.56.14-.67.68-1.28.77-.71-.74,2.22-2.66-.85-3.08-.17,1.25-1.67,2.02,0,2.31-.66,1.18-1.48-.67-1.7-1.16.03-.99,1.99-.55.85-1.54,2.42-.2,3.19.24,4.26-.77,1.49.11-.04,1.04.85,1.15-.3.52-1.14-.19-2.13.39-.45,1.44,1.6.61,1.28,1.93.5-.32,1.14-.51,2.13-.39.86-.79-.19-.76-.43-1.54,1.25-1.44,3.76-1.84,6.4-.77-.04-2.22-6.94-2.08-6.4-.38-.82-.16-.04-1.77-1.7-1.16.68-.58.62-2.2-.85-1.93-.14.89.07,1.48.43,1.93.3,1.05-2.01-.28-1.71.77-.64-.79-1.34-2.65.43-2.7-.55-1.54-.88.11-2.13,0,.21.88.85,1.97,0,2.7-.52-1.07-1.35-1.86-3.41-1.54.05.29-.05.53-.2.74-.07,0-.13,0-.21.03.04.04.06.08.09.12-.43.47-1.07.78-.74,1.1-.34.16,0,.5.49.67-.45.2-1.65-.27-1.13.81-1.1-1.02.66-2.73.85-3.85-.69-.11-.73.36-1.28.39.33-2.03,2.97-.72,4.69-.77.57-1.44-3.77-.4-2.13-1.54-.9-.44-1.24-.15-2.56-.77.91,2-.95-1.23-1.71,0-.06.69.52.81.43,1.54-1.05.05-2.05.06-2.56-.39,1.37-.78.29-1.54,2.13-1.54-1.98-1.77.6-3.04.85-5.01-.34-.33-1.17-.23-1.28-.77-.47.35-.29.86,0,1.54-.38-.3-.96-.42-1.7-.39,1.12.66.3,1.18,1.28,2.31-1.93.72-.58-1.53-2.13-1.16.16,1.34,1,2.5-1.28,2.31.28.52.91.72,1.71.77-.7,1.26-2.31-.71-2.99.39-1.13-.56,1.57-.86.85-2.31-1.84.59-2.3-1.76-.85-1.93-.33-.05-.63-.11-.92-.18-.1-.02-.19-.05-.29-.07-.18-.05-.37-.09-.54-.14-.11-.03-.22-.07-.33-.1-.14-.05-.28-.09-.41-.14-.14-.05-.28-.09-.42-.14h-.08v-.03s-.01,0-.02,0c-.17-.06-.33-.11-.49-.17-.14-.05-.27-.09-.41-.14-.15-.05-.3-.09-.45-.13-.11-.03-.22-.06-.33-.09-.17-.04-.36-.07-.53-.1-.1-.02-.19-.04-.28-.05-.28-.04-.58-.06-.89-.06-.57-.26.37-1.17-.85-1.54-.42-1.79,2.55-.52,2.13-2.31-1.55.27-1.97,1.56-3.84,1.54-1.13.12.4-2.16-1.28-1.54.59-1.62,2.4.42,3.84.38-2.17-2.5,1.42-.06,2.13-1.93-1.12-.58-1.61.89-2.98-.38.19-.57.54.15,1.28,0v-1.93c-.99.52-1.41,1.55-3.41,1.15-.66,1.63,2.37-.08,1.71,1.54-.44.86-1.96-.5-3.41,0-.79,1.98-2.51,3.13-3.41,5.01.49.34,1.24-.52,2.57-.14v.91c.13-.3.37-.49.63-.67.46.38,0,1.6,1.49,1.05-1.73.55-1.57.8-1.7,2.31-4.18-.35-7.1-.33-7.25-2.7-1.33-.18-2.06.48-1.28,1.16-.38-.23-2.43-.81-1.28-1.16-.1-.99-.73.53-1.7,0-.7,2.16,2.25.75.85,1.93.27.78,1.99.26,2.13,1.16.82-.04-.66-1.44.43-1.93,1,.38.71,1.93,2.13,1.93,0,.19-.02.36-.06.51-.46.24-.78.58-.78,1.03-.4.28-.88.5-1.29.77-1.13.12.4-2.16-1.28-1.54-.3,1.19-.3.74,0,1.93-2.13.22-2.57-1.75-4.69-.39.23-1.07,1.38-1.09,0-1.93.94-.03,1.43-2.46,2.13-3.85h-1.71c-.26.69,1.25,1.6,0,1.93.51-1.94-2.49-.37-2.56-2.7.91-.18.81.55.85,1.16.7.07.86-2.52-.43-1.93.39-.67,1.33-.85,2.56-.77-1.12-3.03,5.68-1.62,6.82-4.62,1,1.05,1.29.35,2.56,1.16-.18.74-1.22.7-.85,1.93,1.19-.44,2.21-.44,3.41,0-.11-1.13.96-1.18.85-2.31-1.68-.49-1.03,1.12-2.13,1.16-.21-.14-.42-.3-.63-.47-.02-.02-.04-.03-.06-.05-.21-.17-.41-.36-.61-.56-.02-.02-.04-.04-.06-.06-.2-.21-.4-.43-.58-.66,0-.01-.02-.02-.03-.04-.95-1.24-1.49-2.8-.65-4.37,0,0,0,0,0,0-.14-.05-.24-.13-.31-.24-.07-.12-.09-.28-.06-.49.29.08.43.3.41.65h0c.13-.21.26-.43.44-.65-1.26,0-1.72-.7-2.98-1.54,0-.77,1.16-.49.85-1.54.62.21,2.2-.45,2.13.38.87-1.42-.36-.72-2.13-1.15-.22.57-.63.97-.85,1.54-1.98.19-4.08-1.16-5.11.39-.54-.2-2.59-.94-1.28-1.54-1.31-.66-1.44,3.05-1.7,4.62-.89-.09-1.77-.25-2.13,1.16,1.07-.05,1.34-.74,1.7.39.38.79-1.1,1.73-1.28.77-1.27.97,1.15,1.37,2.56,1.93-.1.48-.85.39-.85,0-.43.18-.77.44-1.04.77-.08,0-.15,0-.23,0-.28.43-.42.97-.54,1.53-.65-.02-1-.3-1.17-.76-.45-1.44,1.6-.61,1.28-1.93-.49.94-2.01-.43-.85-.77-.88.15-1.99-.76-3.83-.77.03-.55.07-1.09-.43-1.16.13-.52,1.07-.32,1.7-.39-1.67-1.61-2.08,1.18-3.83.77.87,3.49,4.07.49,5.97,2.7.32,1.32-1.73.49-1.28,1.93.57.39,1.59.36,1.7,1.16-.04.01-.08.02-.12.03-.06-.15-.16-.3-.29-.42-.32.18-.56.42-.66.67-.4.14-.56.37-.63,1.25-.76.05-.9-.47-1.71-.39.89,1.41-.47,1.48-1.28,2.31-.63-.2-1.07-.57-1.7-.77.37-.31.25-1.06.85-1.15,0-1.08-1.16.92-.85-.77-.5.06-.36.7-.43,1.16-1.1-.53-.09-2.36,0-3.08-1.36-.19-1.28-1.67-2.56-1.93-.04,1.51-.75,2.4-1.28,3.47-.05-.01-.08-.04-.12-.05.45-.3.18-1.62-.72-1.1-.1.52.25.64.38.95-.87-.54-1.09-1.67-2.52-1.72v-1.54c.13-.66,1.48.5,1.28-1.15-1.6.85-.93-.79-2.13,0,.3-1.32-2.02-2.36-2.99-3.47-.07-.96.96-.93,1.28-1.54-.83-.4-2.39-.1-2.56-1.93,1.37-.34.88,1,1.7,1.16,1.42.23,2.3-2,1.7-2.31-1.51-.6-.26,1.31-1.28,1.15-.64-.33.12-.58-.42-1.54.39-.67,1.33-.85,2.56-.77-1.55-2.04-3.58-2.71-4.26-3.85-1.04.79,1.04,2.01,0,3.08.38-.3.96-.41,1.7-.38-.07,1.62-2.09,1.7-3.41,1.16,2.59-.74-1.2-2.77-3.41-2.7.54,2.23,1.24,1.94,2.56,3.47-.19.34-.37.69-.85.77-.67-.64.32-1.56-1.7-1.54.53,1.35-.25,1.21-.43,1.93-1.17-.14-.49-1.15-1.7-1.93-1.71.5.12.8,0,1.93-1.98,1.16-4.12,2.19-4.26,5.01-.38-.17-.76-.34-.85-.77.38,2.26,2.71,5.29,2.96,7.39-.08.19-.16.37-.26.54-1.5.92-3.19-1.73-4.4-.61.51-1.06.46-2.04-.85-1.16-.36-1.61.83-1.82.85-3.08-1.65,1.29-2.14,1.29-3.84,2.31-.94-.88,2.19-1.34,2.56-2.31-.55-1.2-2.39.97-2.56-.77-1.3.47.62,1.47-.43,1.93-1.32-.51-1.22.1-2.98,0,.37-1.36.05-.95.43-2.31-1.25-.1-1.31.87-2.56.77.71.76-.04.49,0,1.54-.85,0-.54-1.05-1.7-.77,2.53-.27-.96-1.88,1.28-2.7-.75-.6-2.27-.52-1.71-2.31,1.66.56,1.94,2.35,3.41,3.08-.04-2.09.33-1.45.85-3.47-1.55-.37-.2,1.88-2.13,1.16-.58-.12-.35-.97-.43-1.54-1.16,1.05-1.06-1-2.56-.77-.18.8.29,1.02.43,1.54-.99-.12-1.64.06-2.13.38-1.36-.57-.74-2.92-3.41-2.31.72,1,.99,1.97,2.13.77.26,1.39-1.3,1.14-1.28,2.31-3.09-2.01-.05-3.27-3.41-3.85-.35-1.09.6-1,.42-1.93h-2.13c.24.79,1.28.76.42,1.54-.75-.96-.7-.56-1.7,0-1.39-1.03.49-2.36,2.13-1.93-.76-2.39-1.82.75-3.84-.39.05.96.8,1.19,0,1.93-1.63-.34.36-2.15-1.28-1.93v2.31c-.05.73-1.41.27-1.28,1.16-1.35-.11-.85-2.04,0-2.31-.38-1.04-.95.88-1.7.77-.32,1.19,1.17.74.85,1.93-.28.39-.98.4-.85,1.16-.45-.5.23-2.8-1.7-1.54v-1.54c-1.12,1.01-2.2.03-1.71-1.54-1.73.51-1.04,2.18-.85,3.08.76.05.9-.47,1.7-.39.61.52,1.13,1.71.42,2.31-.07-.02-.14-.05-.21-.08-.07-.1-.19-.18-.35-.23-.2-.19-.25-.4.13-.45-.15-.54-.75-.03-.85.39-.89-2.28-4.78-1.85-4.69-5.01.12-.45,2.42-1.11.43-1.15,5.43-2.27,3.57-10.89-2.99-10.79-7.75.04-6.26,9.97-2.13,11.17.42.62,1.14.89,1.71.39-.49.46-.48,1.36-.43,2.31.78.13,1.1-.12,1.38-.23.11.02.21,0,.28-.04.13.02.28.09.48.27-.62,2.27-2.63,3.28-4.69,4.24-2.42-.79-2.5-2.52-4.26-1.16-.19-1.59,1.8-1.2,1.28-3.08h-1.7c-.4,1.67-1.61,2.02-.85,3.85-.4-.81-2.28-2.28-1.7-2.7-6.92-4.41-16.26,3.24-10.65,8.86-.08,1.87.34,3.29.85,4.62-.01.37-.52.3-.85.38.07.45.78.33,1.28.39-.33,2.53-2.64,3.27-3.41,5.39-1.1-.29.31-2.85-1.28-2.7,3.22-1.41-3.62-7.35,2.98-6.55-.01-.38-.52-.3-.85-.39-.16-.66.33-.73.85-.77-1-2.07-2.81,1.12-3.41-.77-.62.17.04.34,0,.77-3.48-2.32-7.29,1.5-9.38-.77-1.65.62-1.28,1.06-1.7,2.31-1.02-2.65-3.31-1.02-5.54-1.54,1.66-1.49,2.49-5.68.43-7.32.19-1.11,1.51-1.21,1.28-2.7-1.09.04-1.49.71-2.13,1.16-6.04-4.56-14.09-.53-13.21,6.55-.98-1.09-.85-1.76-1.7-3.47-.85.64-.54-.03-1.7,0,.22.31.45.63.43,1.16-2.27-.61-4.91-.02-6.39,1.16-.95-.06.55-.97,0-1.93-1.29.76-2.09,1.96-2.13,3.85-.37.53-1.71-1.02-2.98,0-.02-.66.32-1,.85-1.15-.31-1.42-2.43,1.2-2.13-.77-1.06.06-.12,1.3,0,1.54-.15.61-.75-.34-.85.39-.43.09-.04-4.35,1.28-2.7,1.25-.43-.54-1.25-1.28-1.16-.61-4.08-6.11-3.73-5.11-9.25-1.82-1.57-.28-6.17-3.41-6.55-.36,3.79.93,6.1.85,9.63-.83.29-1.6.66-2.35,1.03v-1.49c-1.45.04-2.67-.52-3.49-1.47-.8.45.39,1.11-.4,1.94-.35-.2-.71-.39-.79,0-1.32-.29-.34-.72,0-1.29-1.32-.6-1.66,1.16-.79,1.29-.16.42-1.88-.59-2.76-.65-.15-.55.31-.61.79-.65-.26-.97-.85.31-1.58,0-.33.91.55.84.39,1.62h2.37c.63,1.27-1.7.11-1.58.97.73.99,1.87-.37,3.16,0-.13.37-1.58.76-1.47,1.09-.15-.02-.3-.05-.46-.08-.06.08-.11.17-.16.25-.2-.34-.67-.63-1.47-.94-.37.24-.6.59-.79.97-1.66-.19-.35-2.48.79-1.29-.19-1.54-3.02-.41-3.55-2.26-.43,1.05,1.96,2.68,2.76,4.52-.51-.45-1.87-.2-2.37-.65.34-.26.23-.89.79-.97-1.32-1.14-2.7-.39-4.34-.97.21-.26.41-.52.39-.97.92-.1,1.52.05,1.97.32-.07-1.85-3,.38-3.16-1.62-.32.06-.39.32-.79.32-.63.45-.42,1.6-1.18,1.94.83.88,1.48-1.14,1.97.32.12,1.32-.55-.05-1.58.32.34.89,1.28,2.35.39,3.23-1.03-.26-1.97-.61-2.89-.97-.23-.42-.43-.87-.59-1.34.19-.56.72-.84,1.11-1.25,0,.18.32.37.4,0-.75-.03-.27-1.07-1.19-.97.05.58-.39.76-1.18.65.13.75-.06,1.24-.39,1.62.19,0,.35.02.5.05-.04.23-.09.45-.17.65-.62-.24-1.25-.48-1.91-.7.47-.48.34-1.45,1.58-1.29-.57-.76-2.35.21-3.16.32-.04-.34-.13-.63-.26-.89-.01-.02-.03-.04-.04-.07-.13-.24-.29-.46-.48-.66-.01.31-.48.25-.79.32.01-.31.48-.25.79-.32,0,0,0,0,0,0-.75-.74-1.93-1.11-3.26-1.37-.06-.01-.12-.02-.19-.04-.42-.08-.85-.15-1.28-.21,0-.12,0-.22.04-.31.41-.17.81-.29,1.11-.4-.04-.11-.07-.2-.1-.28.21-.08.4-.17.53-.31-.13-.21-.35-.33-.63-.41.02-.25.07-.42-.23-.93-.44.18-.72.5-.95.87-1.45.11-3.32.6-4.11.14-.18-.9,2.15.25,1.97-.65-1.27-1.04-3.2.07-4.34-.65-.71,1.16-1.45,2.29-3.94,1.99.4-.23.9-.42,1.56-.55.36-2.56,1.09-3.87.43-6.55,1.8-.68,1.65-3.14,3.84-3.47,2.04,1.73,5.48-.1,7.25.39.31.59.8,1.02,1.08,1.63-.24.2-.17.69-.22,1.07.29-.04.36-.27.39-.55.06.27.08.57.03.93,1.32-.71,2.32,1.59,5.12.77.82-.45-.93-2.44.85-2.7-.1-.55-1.27-.13-1.28-.77,1.54-1.78.79-3.34,1.28-5.78,1.03.23,1.82.29,3.84.38-1.81-1.58,2.82-.11,2.56-2.7-.41.01-.33.47-.42.77-1.65-1.72-4.37-2.47-5.11-5.01-3.5.16-7.97-2.43-11.48-1.9-.25-.05-.53-.06-.87-.02.02.07.05.13.07.2-.16.05-.33.11-.49.18-.09.02-.17.06-.22.11-1.11.56-2.06,1.59-2.79,3.36-.64-.61-2.43-.56-2.13.77,2.58-.4,1.76,2.27,2.99,3.08.36,2.23-3,.62-1.71,1.93-2.08-.51-2.23-.63-4.26-.77,0,1.29-1.39,1.32-1.28,2.7-1.92.37-3.38-.84-3.84.39-.63-.17.17-.49,0-1.16-3.44-.54-3.1,2.33-5.11,3.08.8,2.09-1.04,3.19-1.7,5.01-1.39.1-1.23-1.2-2.13-1.54-1.11.39-.34,1.61-1.2,2.38-.41-.06-.95-.31-1.61-.24-.76.78-2.24.97-2.76,1.94,2.07.1,2.54-1.98,3.98-1.44-.04.02-.07.04-.11.06.35.13.5.27.52.44-.44-.02-.99.09-.09.33.02,0,.02,0,.04-.01-.22.56-.96,1.38-.47,2.71,2.57.4,1.07-1.72,1.71-2.31,1.06.04,1.32.72,2.13,0,1.14,1.22,1.45,2.51,1.58,3.86-.51-.36-1.75.19-1.39.89.12.42.9.29,1.48.32,0,.09.01.17.02.26-.33.49-1.55.24-1.1,1.36-.21.03-.42.01-.62-.02.11-.45.2-.88.03-1.28-1.42-.26-.69.8-.43,1.16-.03,0-.05,0-.08,0-.26-.07-.49-.14-.65-.12-.34-.34-.17-1.13-.97-1.05-.46-.02-.77.1-.99.29-.42.07-.97.49-1.42.37-.03-.88.66-.65,0-1.29-.53.32-1.19.53-1.58.97-.65-.33-.43-1.37-.79-1.94-.97.14-1.5.63-2.36.86-.33-.12-.68-.24-1.07-.32.18-.98-.44-1.74-2.89-1.51-.87.25-.99,1.13-1.58,1.62-.21-.58-3.52-.42-1.97.32-.33.95-1.27-.19-1.97,0,.6-3.8-4.35-.61-5.53.65,1.59.96,2.25-1.6,4.34-1.29.2,1.78-2.14,1.48-3.16,2.26.09,1.18.54,1.24,0,2.26.09.46,1.18.11,1.18.65.88-.89.97-2.44,3.16-2.26-1.58,2.34,2.02-.55,1.97,1.94.7-.32,1.5-.56,2.19-.89-.67.73-1.13,1.6-1.4,2.53-.63.08-.77-.58-.79-1.32-.98-.23-1.67,1.38-.79,1.62-1.95,1.08-.61-1.49-2.37-1.29-.59.14.16.41,0,.97-.56-.03-1.12-.05-1.18.32-.69-.96-2.5-2.15-3.55-.97.34.94.59.36,1.58.32-.23.68-.98.92-.79,1.94-1.28-1.01-.32,1.64-2.37.97-.05.58.48.68.4,1.29-1.63.13-1.75.04-2.73.46.01-.25.05-.52.08-.78.53-.07,1.3.05,1.87,0v-.97c-.94.42-2.5.64-.79,0-.1-.35-.79-.22-.79-.65-1.66.37-2.56,1.35-3.95,1.94,0,.64,1.08.41.79,1.29-2.24-.03-1.82.7-3.06,1.85-.12-.12-.28-.22-.5-.26.53-.65.91-1.34,1.17-2.04,1.48-.86,2.12-2.69,1.2-3.43,1.14-.46,2.86.7,4.34,0-.83-1.01-.73-1.16,1.18-1.29-.11-.67-1.06-.64-1.58-.97,1.89-.25,1.87-2.01,2.37-2.91-.03-1.05-2.35-.23-1.97-1.62,1.31-.1,1.49.72,2.37.97,1.07-.63,2.15-1.25,2.37-2.59-.48-.13-1.58-.3-2.37-.97-.59.14.16.42,0,.97-.83.05-3.4-.95-3.16.65-1.82-2.99-8.49-1.59-11.84-1.94-1.11.32.57.86-.39,1.29-1.47-.67-1.03.46-2.76.32-.26-1.25,0-1.15-.4-1.94-.65.33-.43,1.37-.79,1.94-1.11.06-.99-1.27-1.58,0-1.23-.62.33-1.64.79-1.94.19-1.01-1.06-.85-1.18-1.62-.9.46-3.56,1.78-3.95.65-.54.1-.33.81-.39,1.29-.66,0-1.32,0-1.97,0-.07-.71.32-1.03,1.18-.97-.17-.4-.51-.66-1.18-.65-.54.32-.51,1.09-1.18,1.29-3.26-1.57-5.32,1.07-7.5,2.26,1.73.2.97,2.44,2.76,2.59-.2,1.2-1.81,1.22-.79,1.94-.03.61-1.84-.2-.79-.65-1.81-.17-1.59,1.09-1.18,1.94-.24-.1-1.52-.8-1.58,0,.03.63,1.69-.68,1.18.97,2.44-2.19,3.59-.29,4.34,1.29-.73.96-1.87.04-3.16-.32-.93.47-1.5,1.24-1.91,2.14-.23-.03-.34-.17-.2-.52-.28-.29-.84.1-1.19.66-.41.07-.75.18-1.05.34.59-2.15.09-3.93-1.01-5.27.07.02.15.04.23.06.21-.48.58-.82.79-1.29-.76-.09-1.44.32-1.51.71-.69-.66-1.53-1.18-2.46-1.54.13-1.1.52-2.13,1.6-2.72-.31-.29-.42-.73-.39-1.29-2.91-.33-2.52,2.03-5.53,1.62-.31-.29-.42-.73-.39-1.29-1.55.24-.91,2.27-2.76,2.26-.11.84-.13,1.62,1.18,1.29-.03.04-.06.07-.1.11-1.19.5-2.2,1.33-2.87,2.51-.29.13-.6.24-.98.29-1.33.08-1.14-1.93-2.37-.97.07.37.4.18.39,0,.77,1-2.47,1.81-3.16.32-1.16.27.51.81,0,1.62.94-.2,1.8-.46,3.16-.32.37,1.27-1.37.82-.79,2.26-1.21.23-1.16-.56-2.37-.32-.24,1.16,1.2.95,1.18,1.94-1.85-.28-2.1-2.3-2.76-1.94-.32-.55.92-1.74-.39-2.59-.77.45-.59,1.67-1.18,2.26-1.33-.69-3.03.62-3.95,1.29.52-1-.31-1.26.79-1.94-.7-1.22-1.76-.13-3.16-.65-.54-1.02-.09-1.08,0-2.26-.51,1.24-1.37.32-1.58,1.94-1.23-.41-2.46-.22-3.55,0,.78-.12,1.57.59,2.37,1.29-1.28-.09-1.51.67-2.76,1.29.43-1.43-.67-1.61-.79-2.59-.99.5-1.32,1.31-2.76.65-1.06-.1,1.05,1.25-.79.97.61.58,1.08,1.27,1.58,1.94-.82.49-2.29,1.52-3.16.97.94-.48,2.38-1.7,1.58-2.59-1.19.97-1.18,2.91-3.95,2.59-.47-.43-.15-.51,0-.97-.06-.6-1.34-.2-1.58-.65-.08.93-.05,1.76,1.18,1.62,0,1.18.15,2.5-1.58,2.26.6.82.68,1.83.79,2.26-.12,1.08-1.87-.97-1.58.65-.55-1.13-1.46.03-2.37-.65-.28,1.2.68,1.39.4,2.59h-1.58c-.21-.47.46-1.67-.39-1.62-.19,1.22-.45,2.41-1.58,3.56.01.31.48.25.79.32,1.38-.09-.71-1.43.39-1.29,1.69.3,1.01,2.55.4,3.23.12.44.99.27,1.58.32,0,1.47-1.56,2.03-2.76,1.62.04.61,1.3.22,1.18.97.99.06,1.24-.5,1.58-.97.95-.13-.22,1.47,1.18.97-.12.66-1.07.63-1.18,1.29-.54-.1-.33-.81-.39-1.29-1.45,1.93-2.3-1.38-3.95-.32.59.48.12,1.84,1.58,1.62-.04.82-1.32.64-2.37.65.79-.66.1-.86-.4-1.29-.59.27-.85.81-.79,1.62.74.69,2.29.71,1.97,2.26h-1.97c-.37.24-.6.59-.79.97,1.04-.33,2.42-.39,3.95-.32.75,1.65,2.23,2.7,3.95,3.56-.36.88-1.38-.33-1.98-.32,1.06.82,1.72,2.7,1.58,3.56-.07.37-.4.18-.4,0-.33-.06-.37.13-.39.32-.92-.08-.23-1.42,0-1.62-.88.75-1.54-.11-2.76,0,.66-1.51-.12-1.8-.79-2.91.11.81,0,1.27-.39,2.91-.92-.23-2.95-.82-2.76.65-.35-.2-.71-.39-.79,0-.89-.18.48-.51-.39-.97-.57.18-.96.5-1.18.97-.26,1.29,1.5.92,2.76.97-.34,1.03.62,1,.79,1.62-.56,1.99-.44,2.15,0,3.56.9-.23,2.02-.29,2.76-.65.35-1.04-1.02-.67-1.18-1.29.25-1.48.62-1,1.97-1.29-.49,1,1.51,2.46-.39,2.59.52.46,1.81.81.79,1.62.47.85,1.95.5,2.76,0-.45-.15-1.9-.04-1.58-1.62,1.3,1.07.94-.87,2.37-.65.33.38.52.87.39,1.62-1.14-1.05-.35,1.98.39,1.62-1.39,1.34.49.51.39,2.26-1.51.77-2.77-.59-1.97-1.94-3.49.39-4.94,2.98-3.16,5.17-2.45-.91-3.28-3.14-5.92-3.88-.61-1.15,1.34-.2,1.18-.97.91-.1.44.93,1.18.97.7-.29.5-1.31,1.97-.97.22.72-.75.46-.79.97.72,1.17,1.09-.57,1.97-.32.17-3.09-3.27-1.38-5.13-.97,1.33-1.71-1.14-1.73-1.18-3.23,1.21-.73,2.22-1.63,1.97-3.56-1.97.08-1.68.13-3.16.32-.74-.62-.04-.81,0-1.62-.36-.88-.73.86-1.97.32v-1.29c1.66.08,1.82-1.02,3.16,0-1.06-1.21-.15-2.42-1.97-2.59.63-.89,1.53-1.55,1.58-2.91-.86.59-2.61.45-2.37,1.94-.62-.54-1.81.42-1.97-.97,2.62.33.53-1.25,3.55-1.29.53-.32.79-.86,1.18-1.29-1.88.53-.59-2.22-3.16-1.94.12-1.21,1.32-1.31,2.37-.97.33.91-.56.84-.39,1.62,1.98-.45,2.68-2.7,1.58-3.88-2.69-.58-3.35,1.94-5.92,1.62-1.26-2.02-4.66-1.09-4.34,1.62-3.58-.73-5.72,1.01-9.08-.32v-1.94c-.69,2.68-4.9,2.27-7.9,2.26.17-.67-.27-.86-.39-1.29-1.23-.16-1.91.76-1.18-.32-3.62,2.89-7.77.94-12.63.32.29.3.72.49,1.18.65.07.7-1.4.15-1.97.32.02-.99-.83-1.26-1.18-1.94-.26,1.94-2.61,2.17-3.95,3.23-3.42-.13-4.34.75-7.9,0,.38-1.23,2.51-1.52,1.58-2.91-2.75.23-2.99-.02-5.13,1.29.23-1.03-.74-1,0-1.62-1.21.23-1.44-.33-2.37-.32.46-2.37-.84-3.65-1.97-5.17-.48.19-.81,2.09-.4,1.94-.34.95-.99-.42-1.97,0-.3,1.24-3.22,4.1-3.95,1.94-.86.86-.54,1.47-.4,2.59-1.05-.89-.86.38-1.97.32-.19-1.14-.8-1.94-2.37-1.94-.12-.56,1.53-1.14,1.18,0,1.02-.54-.33-1.86-.79-2.26-1,.59-.54,2.36-2.37,2.26.15,2.36-.85,3.77-.4,4.53.23,1.78-1.32,5.5-.79,7.11-.02,1.49-.8,2.36-2.37,2.59-.46-.73.21-.97-1.18-1.29-1.08.14,1.43-.52,1.97.65.32-.06.39-.32.79-.32-.11-.81-1.48-1.08-.39-1.94h-1.58c-1.23-.1,1,.93-.39.97-1.67-.03-.78-2.17-2.37-2.26.66-1.25.37-1.28,1.18-2.26.05-.58-.48-.68-.39-1.29-.27,1.94-5.1,5.71-1.97,8.41-.26.97-.84-.31-1.58,0,.91.12.53,1.29,1.18,1.62-.47.69-2.14.4-1.58,1.94-.06.06-.11.09-.15.1,0,0-.02,0-.03,0-.04,0-.07-.02-.1-.06,0,0-.01-.02-.01-.03-.02-.04-.04-.09-.05-.15,0-.02-.01-.04-.02-.06-.01-.07-.03-.15-.04-.23-.06-.47-.11-1.13-.32-1.52,0,0,0,0,0,0h.72v-.65h-.79v.54s0,0,0,0c-.04-.06-.1-.1-.15-.14,0,0-.02-.01-.03-.02-.06-.03-.13-.06-.21-.06-1.18.63-1.44.69-1.97-.32-.89.14-.01,1.71-.79,1.94-2.71-.72-1.79-.28-3.95,0,.99-.57.43-.41.39-1.62-1.32,1.21-2.06.73-3.55.32-.55.11-.03.57.39.65-3.02.91-5.98-.1-9.47.97-.46-.48-.46-.82,0-1.29-1.38.17-1.34,1.49-3.55.97,2.02.96-1.56.46-2.37.97-.05-.92-2.24-.06-3.16-.97.35-.57,1.25-.94.4-1.62-.62.65-2.2.93-2.76,0-.32.06-.39.33-.79.32-.18.69.56.62,1.18.65-.14.86-1.04,1.09-1.97,1.29-.28-2.22-3.02.9-3.95-.97-.87.13-.53,1.9.79,1.29-.1.57-.68.74-1.58.65-.36-.89-.72-1.78-1.97-1.94.53-1.02.12-1.11-1.18-1.29.56-.43.56-1.83,0-2.26-.89.18.48.5-.4.97-1.24-.55-.65-1.63,1.18-1.29.68.2-.03,1.53.79,1.62.45-.06.22-.32,0-.32.17-.73,2.09-.01,2.37-.65-.84-.95-4.16-.08-3.55-1.62-1.15.29-1.21.29-2.37,0-.38,0-.31.4-.4.65-1.36-.62.45-1.32,1.58-.97-1.66-2.26,1.95-5.1-3.55-5.5-.17-.67.27-.86.39-1.29.37.24.6.59.79.97,2.58-.1-1-2.85,1.58-2.59-.14-.42-.7-.51-.79-.97-.53.32-.79.86-1.18,1.29-.14-.4-.33-1.33-.79-2.26-.32.17-.64.34-1.18.32,2.1,1.35.12,3.03-.39,4.85-1.33-.28.08-1.52-1.58-1.94.17-.48.51.13,1.18,0,.06-.91-.97-.93-1.97-.97.45,1.27.08,1.2.39,2.59-1.25-1.12-3.37-2.35-4.74-1.62,2.65,1.21,1.45-.36,1.58,2.59.92.43,2.46.36,2.37,1.62.33-.2,1.24-1.51.4-1.62.64-.51,1.74,1.36,1.58,2.59-2.06.08-3.82,1.24-4.34,1.62-1.14-.18.61-.5.4-.97-.57-.05-2.1-.16-2.76-.97.89,1.53-.93.23-1.18,1.94-1.93-.42-.67-1.67-1.97-2.26.29,2.19-1.73-.12-3.55,1.62-.81-1.21-.72.21-2.37,0,.78-.23-.1-1.8.79-1.94-.47-.59-2.06-.25-2.76-.64.96-2.5-2.8-1.87-4.74-2.27.61-.79,1.59-1.29,2.37-1.94-1.22-1.29-1.05-2.62-1.18-4.2.52.39.62.13,1.18,0-.31-1.79-1.71-2.69-2.76-3.88-1.9.7-3.14,5.49-1.18,5.5.54.1.33.81.4,1.29-2.45.11-1.33-1.45-1.97-2.26-.74,1.24-1.49.09-2.37-.32.34-.94.59-.36,1.58-.32.6-.99-2.58-.99-1.97,0-.59-.81-1.66-1.22-2.76-1.62.05-.6.26-1.08.79-1.29-.68-.91-1.03-.3-2.37-.32,1.84.53.01.53.79,1.29-1.22.62-3.48.38-3.95,1.62-.89-.24-.86-1.23-1.97-1.29.54-1.4,1.63.03,2.37.32.75-1.08-1.94-1.18,0-1.29-.39-.33-.78-.65-1.19-.97.05.81-1.49.41-1.97-.65-1.22.08-1.53.9-2.37,1.29-1.96-.23-3.83-.99-5.53-1.29.26,1.8,3.08.65,2.76,2.26.17-1.22,3.04-.22,3.16-.65.88.13.38,1.77-.39,1.62.58.6,2.17.38,1.97,1.62-.38-.01-.31-.4-.39-.65-.64-.09-.68.31-1.18.32-.52,1.39,1.88.4,1.58,1.62-.32-.06-.39-.32-.79-.32-.37.23-.6.59-.79.97-.7-.23-.06-.59,0-.97-.49.14-.81.41-.79.97-1.86-.09-3.76-.15-4.34-1.29,1.73-.37,1.3,0,2.76.32.61-.36.82-1.05,1.97-.97-.9-1.13-1.4.76-2.76.32-1.21-.73-1-2.63-2.76-2.91,1.28,2.24.28,2.25.39,5.82-1.37.05-.63-1.64-1.97-1.62-.47,1.06-1.83.06-2.76-.32-.64-.14-1.33,1.2-.4,1.29-1.32,1.15-1.55-1.69-.39-1.94-1.16.43-2.62.27-3.55-.32-.12-1.32.82-.17,1.58-.32.02-.56-.29-.84-.79-.97.13-.76,1.22-.72,1.58-1.29-.74.03-.61-1.62-1.97-2.59-2.07,1.6-4.57,1.08-6.71.97.45.38.45,1.14.39,1.94-2.12.01-2.07-1.75-3.55-2.26.5-1.6,1.07-2.4,1.58-4.53-2.13-.45-1.3,1.52-2.76,1.62,1.46.51-.02,1.43-.79,1.94-.4.97.88.57,1.58.65-.89.7-1.94,2.54-3.16,1.94-.86-.05-.18,1.15-.4,1.62,1.96-.6,2.24-2.23,4.34-1.94-.02.55.29.84.79.97-1.36.5-1.42-.6-3.16.32-.05.58.48.68.39,1.29-.37-.24-.6-.59-.79-.97-.56,1.05-1.68,1.64-2.37,2.59.64.45,1.25.92,1.97,1.29-.34,1.77-2.62,1.95-3.16,3.56-2.24-.27,1.81-2.44-.39-2.59-.83-.8,1.41.24,2.37,0,.08-1.04-1.72-.53-1.58-1.62-.95-.13-.86.59-1.97.32.21-1.13-.86-1.2-1.18-2.59,1.98.5,1.97.68,2.76,1.94.82-.08.11-1.42.79-1.62-.67-.46-1.99.29-1.58-1.62-.34-.96-.59.75-1.58.32-.13-.75.06-1.24.39-1.62.95-.13.86.59,1.97.32-.96-.98-2.28-1.36-3.16-1.62.18.7.68,3.24-1.58,3.55.24.78.57,1.47.39,2.59-1.58-.07-.87.03-2.76.65.03-.51-.19-1.23.39-1.29-.51-.62-.82.76-1.97,0,.53-.65,1.75-.72,2.76-.97-.18-.29-.35-.58-.79-.65.8-.12,2.5-.26,1.58-1.94-.46.05-.7-.07-.79-.32-1.06.6-1.87,1.77-1.18,2.91-.99.41-1.23-.16-1.58.32-1.13-.55-1.68-1.93-1.18-2.91,1.08-.23.79.64,1.58.65.54-.1.33-.81.39-1.29-2.28-.08-2.65.62-3.95.32.39.68,2.4,2.06,0,2.26-.3-1.17-.91-2.27-2.37-1.62.71-.49,1.21-1.17,2.76-.97-.44-.4-.34-.66.39-.65-.61-.07-2.34-.26-2.76.65-.89-1.21-3.5-1.34-2.37.65-1.05,0-1.01-.9-1.58-1.29.1,1.39-2.76.38-3.95.32-.07,1.84,1.33-.03,1.58.65.1.54,4.13,3,6.71,4.2-.67.31-1.01.89-.79,1.94.54-.1.33-.81.39-1.29.69.08.9.56.79,1.29-1.4.28-.97.04-2.37.32.46,1.12-1.07,1.72.4,2.91-1.87.15-.44-.4-1.18-.97-.59.49-.64,1.42-.79,2.26-.69.09-1.97-.91-2.37,0-1.34.02-.6-1.66-1.97-1.62.47-.84,1.35-.61,2.37-.32.35,1.04-1.3.44-1.18,1.29,2.42-.12,1.39-1.72,1.58-2.26-1.05.99-4.5-.97-4.74.97-1.19-.72-1.38-.38-3.16-.32.3,1.16,3.47-.04,3.16,1.62-1.87.03-2.2-1.22-4.34-.97,1.13-.92-1.43-.47-.79-1.94-1.75.48.35,1.07.4,1.94-1.8-.84-2.54-.83-4.34-1.29.09.81,2.13,1.67,2.37,1.29.87,1.45-3.21.34-4.34,1.62-.48-.19.26-1.22-.39-1.94,1.07.8.21-1.08,1.97,0-.31-.29-.43-.73-.4-1.29-1.64.37-1.54-.68-2.76-.65-1.2,3.24-2.36,5.62-3.16,9.7.29.3.72.49,1.18.65-.39.99-1.05-.37-1.58-.32.21,1.36-.69,1.81-.79,2.91-2.26-2.06,2.66-6.03,0-7.76.21-.26.41-.52.39-.97.67-.12.75.25.79.65,1.43-1.6.89-2.89,1.97-4.85-.39-.9-1.05.47-1.58-.32.17.62,1.13.58.79,1.62-.38-.55-1.24-.71-1.97-.97-.22-.72.75-.46.79-.97-.82-1.2-1.67.98-2.37,0,.13.75-.06,1.24-.39,1.62.39-1.32-1.81-1.63-1.18-2.27-1.81.06-1.96,1.97-1.58,2.91.35-.14.71-.28.79-.65.38,0,.31.39.39.65v.65c-.71.04-.83-.4-1.58-.32-.14.55.31.61.79.65-.17.51-1.24.28-.79,1.29-1.21,0-2.79.95-2.76-.65.93.23,2.5.74,2.37-.65-.76-.19-.65-.92,0-1.94-1.85.1-1.08,1.37-1.58,1.94-1.76-.45-.81-1.49.39-1.94-.26-.33-.91-.33-.79-.97-.2.71-2.24,1.04-2.37,0-.43.08-.27.64-.79.65.22,1.44,1.93,1.66,3.16,2.26-.83,1.43-2.42-.95-3.55-1.29.23.81-1.57.81-2.37,0,1.79-.77-1.04-.88-.39-2.59-.68-.01-1.02.24-1.18.65.34,1.02,1.39,1.45,1.58,2.59-1.4-1.05-1.83.65-3.16.65.29-1.64-.52-2.37-1.18-3.23-.73.94,1.01,2.61.79,4.2-.86-.06-1.26.26-1.18.97-.48-1.13-1.49-.32-1.58-1.29.79-.11,1.24.07,1.18.65,1.04-.43-.55-1.69.15-2.41-.87.67-1.89,1.22-2.92,1.76-.53-.21-.73-.69-.79-1.29-.6,1.77-2.13.54-1.97,1.94-.55-.52-1.12-1.02-1.58-1.62-.91-.1-.44.93-1.18.97-2.62-2.22-2.82-.16-5.92-.65-.87,1.47,3.63,1.47,2.76,0,1.46,1.11.44.81,1.97,2.26-1.47-.32-1.03-.69-2.76-.32.8,1.79,3.07.52,2.76,2.26,5.12-.17,5.9,5.04,10.66,6.14-.47.59-2.06.25-2.76.65-1.64-4.4-7.18-5.17-11.84-4.85.1-.35.79-.22.79-.65-.68-1.05-1.03.84-2.37.32-.5-1.72.24-3.01,0-4.2-1.4-.17-.97,1.15-2.37.97,1.2-1.96,3.19-1.64,3.55-3.88-.75.14-1.7.12-1.58.97-1.02-.42-.92-1.57.79-1.29.49-1.05-1.28-.25-.79-1.29,1.85-.04-.43-.47,0-1.29,1.8-.2,1.62.72,1.18,1.62,1.2-.09.54-1.71,1.58-1.94-1.93-1.35-2.9.85-4.34.97-.16.78.72.7.4,1.62-1.82.19-1.29-1.53-1.58-2.59-1.27.32-.38,2.4-2.37,1.29.58,1.25,1.96,1.85,4.34,1.62-1.43.85.35,1.09-.39,1.94-.96-.94-1.75-.14-2.37-.65.09.42.35,1.97-.4,3.23-1.15-.28-.44-.48-.39-1.29-2.07.08-.41.96-.4,1.94-2.24.31-.34-1.26-1.18-1.62-.35.25-.89.35-1.58.32.87,1.45,2.26,2.46,4.34,2.91-.22.4-2.59.63-1.18,1.29-.99.9-.87-1.86-2.76-1.29.3-1.86-1.57-1.95-2.37-2.91-.86-.05-.18,1.15-.39,1.62-2-.81-.02-1.57-.39-3.23-1.24.36-1.04-.09-1.97.32-.27.87.82.62,1.18.97-.36.36-.73.1-1.97.32.75.96,1.19,2.99-1.18,2.91.17-1.51-1.14-1.85-1.97-3.23-1.07.48.68,1.35,1.18,1.62-.8,4.7,4.72,6.87,8.68,8.73.83-.29,1.17-.99,2.37-.97.07.7-.32,1.03-1.18.97,3.72,2.55,8.57,4.19,12.24,6.79.3-1.06-.66-1.72,0-3.23.7.08.9.56.79,1.29,1.11.27,1.02-.46,1.97-.32-2.98-2.97,2.28,0,2.76,1.62,3.17.61,4.68-.81,8.29-.65,1.88-2.5-.56-3.97-2.37-5.17-.97.48-.86,1.35-1.18,1.62-1.61.24-.07-2.09-1.97-1.62,1.02-1.22,3.73-1.17,4.34.32.4-.21.41-.74,1.18-.65.44.4.34.66-.4.65.51.99,3.89,2.69,3.95.32,1.27,1.16,3.47-1.67,6.32-1.29.75,2.01-2.61.66-2.76,1.94.48,1.22,1.7-.83,1.97,1.29-1.79-.17-2.36.65-3.55.97.21.26.41.53.4.97.65-.54,2.32-.26,3.55-.32,1.53-.9,1.18-3.34,1.97-4.85-.64-.88-1.28-.17-1.58-1.62-1.75-.35-1.96.55-3.16.65-.17-1.26,1.49-1.13,0-1.94,2.49-.1,5.33,2.31,9.47,1.94-.93.64-2.49.76-3.95.97-.63,2.48-2.09,6.84-2.76,10.34-1.95-.87,1.66-3.51,0-5.17-.82,0-2.43,1.98-2.76.32-.71-.04-.83.39-1.58.32.93,1.15-.74,1.22-.79.32-1.48.51-2.6,1.32-3.55,2.26.92,1.16,3.5-.93,4.74-.32-2.23,1.13.42,2.46.79,4.2-.35.14-.71.28-.79.65-1.68-.59-1.67-1.14-3.55-.32.05-.58-.48-.68-.39-1.29,1.16-.29,1.21-.29,2.37,0,.26-1.72-2.66-.84-3.16-1.94-.95.29-.17,1.83.4,1.94-.72.98-1.64-.57-1.97-.97-.9.34-.15,2.03-.4,2.91-1.06-.22-.76.67-1.18.97-1.77-1.34,2.4-4.54,1.18-6.47-1.35.94-4.21.65-5.13,1.94.35-2.23-2.45-1.87-3.55-2.91-1.04.71.76,1.67,1.18,2.91-1.4-.11-.97-.89-2.37-.32.12.66,1.07.63,1.18,1.29.95.13.86-.59,1.97-.32-.62,1.51,1.26,1.84.39,2.59-.93-.1-.73-1.12-1.97-.97-1.23.07-.67,1.61-.79,2.59h-1.97c.21-.85-2.1-2.25-1.97-.97-1.08-.29.7-1.13-.39-1.62-.63.03-1.51-.16-1.58.32.36-1.3-2.27-3.06,0-3.23-.15-.84-1.27-.9-.79-2.26-1.11-.82-3.16-.86-3.55-2.26-.82,1.09-.84,2.54-.4,3.88-1.35-.72-.87-2.81-.79-3.88-.78-1.33-4.5-.51-5.53,0-.29.99.4,1.18.4,1.94-.65.03-1.72-.54-.79,0-1.28.87-1.51-1.34-2.76,0,.05-.58-.48-.68-.39-1.29,1.93.78,2.38-1.35,3.95-.97-1.11-2.01-6.93.11-9.08-1.29-1.59,1.07-.92,3.99-3.95,3.88,1.06-2.26,3.27-3.57,3.55-6.47-.11-.76-1.05.37-1.58.32-.99.62.99-.85,1.18-1.29-.16-.73-2.31.17-1.58-1.29,1.11.37,2.05.37,3.16,0,.39-1.29-1.18-.97-.79-2.26-.23-.78-1.49-.72-2.37-.97.39-1.43.06-.85-.39-1.94.71-.04.83.4,1.58.32-.55-.52-1.36-.83-2.37-.97,2.98-1.9-2.82-1.67-5.13-1.29-.68.01,2.18-1.2,0-1.62-3.02.3.06,1.89-1.58,2.26,2.21.26,2.25,1.64,3.16,2.26-.48.46-1.51.74-1.97.32.55-.2.06-1.24.79-1.29-1.38-.49-2.31-1.34-4.34-1.29v-.97c-.6,0-.87,2.4.39,1.94-1.12.78-.65,1.4,0,2.26-1.88-.87-3.33-.69-4.74-.65.55-.52,1.4-.8,1.19-1.94-.37.24-.6.59-.79.97-.76-.13-.03-1.48-1.58-.97.26-.43.84-.6,1.58-.65-.68-.53-1.44-.98-2.76-.97.01-.31.48-.25.79-.32-.55-.6-1.87.47-1.97-.97-.7.29-1,.9-2.37.65-.74-.62.23-.59,0-1.62.56.03,1.12.05,1.18-.32,1.02.77,1.39,1.09,3.16.32.13.65-.08,1.01-.79.97.67.43,2.66.26,3.16,1.62.52-.11.62-.57,1.18-.65-.25-.88-1.65-.8-1.58-1.94.92-1.46,2.77-.78,2.76.97.92-.11,1.63-.39,2.37-.65.16-.78-.72-.7-.4-1.62-1.16-.08-1.21.73-2.37.65.32-1.25,1.77-1.57,2.37-2.59-.14-.51-.69.28-.79-.32-.95-.13.22,1.47-1.18.97.31-.29.43-.73.39-1.29-.95-.13.22,1.47-1.18.97,0,.64,1.08.41.79,1.29-.66,0-1.32,0-1.97,0,.73-1.13-.3-1.06-.79-1.94-.69.48.35,1.35-1.18,1.62.03.83,1.69.34,1.18,1.62-1.94-2.08-6.44-2.45-6.71.32-.83.37-1.54-.2-2.37.65-.05.58.48.68.39,1.29-1.03-1.39-4.05,1.19-3.16,2.26.42-.24.05-.97.79-1.62h1.58c.4.97-.88.57-1.58.65.25.71.52,1.07,0,1.94,1.87.15.44-.4,1.18-.97.77.22,2.77-.61,1.97.97-.83-.57-2.05-.64-1.18.32.06.92-2.43-.27-2.37.65-.76-.13-.31-1.25-1.58-.97-1.16.28.51.81,0,1.62-1.1-1.07-3.17-.82-5.13-1.29.84-.4,2.91-.76,3.55-.32,1.38-1.25.82-5,1.97-6.79-.09-.83-.68.44-1.58,0,.49.95-.39,2.04.4,3.23-1.05-.89-1.38.24-2.37.32-.54-1.41,1.53-.69,1.18-1.94-1.17.16.14-1.1-1.18-1.94-.29.73-1.67.57-2.37.97,1.52.61-.19,1.86.4,2.26-.34.49-.59-.09-1.58.32,1.43,1.59,4.71-.17,5.53,1.62-1.3-.21-2.78.22-1.18.65-1.45.71-2.8.24-3.95.65.75-.57,1.85-.86,2.76-1.29-2.18-1.28-3.52.17-5.13.97.01.32.48.25.79.32-2.68,1.74-5.99.99-8.68.97.21-.26.41-.52.39-.97-1.47-.13-2.32.26-2.37,1.29-1.24-.89-3.22-.04-3.16.97h-1.97c.37-1.23-1.35-1.99-.39-3.23,1.59.09-.26,1.43,1.58,1.62.45-.06.22-.32,0-.32-.07-.7,1.4-.15,1.97-.32.08-.55-.67-.84,0-.97-.93-.46-4.28-1.1-4.74-.32-1.9-.17-2.15-1.69-4.34-1.62.43.59,2.18.81,1.18,1.62-1.24.15-1.11-.81-1.58-1.29-3.04,1.23-3.98,3.69-9.47,3.56.07-.26.4-.32.39-.65-.05-1-1.68,1.47-1.58-.32-1.38.39-4.59.6-5.92,0-.91-.1-.44.93-1.18.97.32-.06,3.29.81,3.95.32-.25,1.83,2.62,2.04,1.58,4.53-3.09.86-4.37-1.94-3.95-3.88-1.24,1.22-1.14-.29-3.16,0,.8.86.73,1.5-.79,1.94.66-1.05.58-.69.39-2.26-.23.29-1.63,1.19-.79,1.29-1.38,1.36-1.77-3.38-.39-2.59-.88-1.14-2.43-.84-3.55-.32.06.38.72.27,1.18.32-.05.71-1.67.14-2.37.32-.38.6,1.18,1.08,0,1.29,1.34.35,1.2,1.33-.4,2.26.45.39,1.13.59.79,1.62.58.18.61.2,1.18.97.96-.6.04-2.38-.39-2.91.29-.28,1.97-.26,3.16-.65.37.27.84,2.06,0,2.26.33.95,1.27-.19,1.97,0-.68.57-2.82,2.12-.79,2.91-.92-.21-1.64.8-2.37,1.62-.8-.1-1.05-.65-1.58-.97-.46.05-.33.59-.39.97-.7-.7-3.69.27-5.53-.32.14-.42.69-.51.79-.97-.1-.76-1.74-.19-1.97,0-.29.99.4,1.18.4,1.94-2.02-.41-.42.94-1.18.97-1.9-.7-4.08-1.24-6.71-.97-.42,1.21.98.92.79,1.94-1.08.23-.79-.64-1.58-.65-4.06,4.25-.17,10.5-1.18,17.13-2.93-4.2-1.88-8.56-4.34-12.29,3.11,1.43,2.03-3.59.79-4.2-.91-.1-.44.93-1.18.97-1.5.47-.08-1.45-1.58-.97-.06-.43,1.33-1.2.4-1.3.26-.97.84.31,1.58,0-1.17-.41.13-1.57-1.58-1.94-1.89-.04-.92,2.27-2.76,2.26-.45-1.42,1.34-2.67-1.18-2.26-.18-.69.56-.62,1.18-.65.15-1.2-1.6-.84-1.18-2.26.52.11.62.57,1.18.65-.69-.66.3-.63-.39-1.29-.7.29-1.22.72-1.58,1.29-.02.55.29.84.79.97-.26.33-.91.33-.79.97-.7-.24-.06-.59,0-.97-1.46.04-.99.47-.79,1.29-3.14-.09-1.93,3.38-4.74,3.55.27,1.02-.05,1.32.4,1.62-.32.73-2.61,1.51-2.37,0h1.58c.11-.52-.37-.56-.39-.97-2.81.36-.82,2.73-3.16,3.23.41.96.3,2.34,1.18,2.91.7-.18,1.64-.17,1.97-.65.46.05.33.59.39.97.38,0,.31-.4.39-.65,1.11,1.47,4.01,1.45,6.32,1.94,1.41-.37-.73-2.13.39-2.26-.52-.15-1.05-.15-.79-1.62,1.55.3,1-1.12,2.76-.65-.13.76-1.22.72-1.58,1.29.12.44.99.27,1.58.32-.01-.32-.48-.25-.79-.32.16-.73,2.16.05,1.97-.97.95-.13-.22,1.47,1.18.97-1.17.33-2.2.79-3.55.97v1.29c.17.63,1.13-.53.79.97.57.17.96-1.26,1.18-.32.18.69-.56.61-1.18.65.06.6,1.34.2,1.58.65-.49.98-1.36-.35-2.37,0,.41.92.41,1.35,0,2.26-1.13-.05-.72-1.35-.79-2.26-1.46-.84-4.59-1.34-6.32-.97,1.84,3.01,9.34,2.77,7.9,7.43-2.3.17-.45-2.55-1.18-2.91-2.68-.71-4.5-2.13-7.11-2.91-2.03,2.11,2.64,1.49,3.16,2.59-.37-.2-1.46-.75-1.18.32-1.24.15-.89-.99-2.37-.65-1.44.97-.15,5.83-1.18,8.08-1.14-2.05-1.26-8.31-.39-10.67-.57-1.87-2.82-.4-4.74-.97.49.89,1.35,1.48,2.76,1.62-.03.46-.07.92.39.97-.69.8-1.78-1.74-2.76,0-.62-.57-1.81-.67-1.97-1.62-1.26.34,0,1.46-1.18,2.26.63,1.85,2.92,2.35,2.76,4.85-.88-.25-1.54-.68-2.76-.65-.2-1.02.86-1.26,0-1.94-.82.08-.11,1.42-.79,1.62-1.6-.98-3.54-.34-3.55,1.62,1.74.1,5.52-.38,8.29.32-1.01,1.65-3.07,2.44-3.95,4.2-1.28-.02-2.13-.41-2.37-1.29,2.4.92,3.82-.98,4.74-2.26-1.08-.91-3.04,1.33-3.55-.65-1.52,1.09-2.94.34-4.74,1.29.03,1.32-.3,2.34-1.58,2.59.04.59.17,1.1.33,1.59h-5.05c-.52-1.37-1.5-2.62-3.56-1.59,0,.88.69,1.19,1.28,1.59h-3.87c.57-1.72,2.09-2.13,4.57-2.88-2.03-1.52-4.74.75-6.71,1.29-.12.53-.13,1.06-.1,1.59h-1.2c.04-1.37-.03-2.75-.28-4.17-.69.08-.9.56-.79,1.29-.55-1.43,1.21-3.75,1.18-5.82-5.09-.18-8.64,3.7-12.63,5.5,1.07.85,1.55,1.96,1.8,3.2h-5.32c-.03-.09-.04-.18-.04-.29-.67-.07-1.17.01-1.42.29h-.2c-.22-1.81.13-2.74-.35-4.82.58.17.99.48,1.58.65.19-.63-1.06-1.65-1.19-.97-1.19-1.74,2.84-1.98,3.95-2.91,1.06.68-1.69.97-1.97,1.62.3.94,1.87.84,1.58,2.26-1.15-.08-1.21.73-2.37.65.17.67-.27.86-.39,1.29,2.66-2.24,8.86-3.31,9.47-6.14.11-.76,1.06.37,1.58.32,4.29-2.96,12.92-2.35,16.18-6.14h2.37c-.15-.7.63-1.89,1.58-2.59-.16-.72-2.16-.31-1.97.32-.73-.83-.98-.19-1.97-.97.13-.76,1.87-.19,1.58-1.29-2.45-1.24-3.33,1.58-5.53,1.62,1.24-1.67,4.17-1.98,5.13-3.88-.51-.81-2.22.1-2.37.65-1.34-.52-2.82-.92-4.34-1.29-1.29,1.08.66,2.25,2.37,1.94-1.04.76-1.69,1.85-3.95,1.62.45-1.34-.83-1.26-.79-2.26,1.13-.05.72-1.35.79-2.26-1.59,1.14-2.74-.67-4.74.32-.05-1.56,6.08-.84,8.29-1.62,2.26.48,2.94-.37,5.53-.32-.05,1.26-1.93,1-1.97,2.26.38,0,.31-.4.39-.65.46.05.33.59.39.97,2.03.26,3-.34,4.34-.65.11-.52-.37-.56-.39-.97-.45.06-.22.33,0,.32-.12,1.14-1.07-1.14-1.18,0-.93,0,.14-.88.79-.65-.34-.47-.31-1.25-1.58-.97.59-.93-.58-1.47,1.18-1.62-.84-.97-3.21.98-2.76-1.29,2.41,1.3,1.48-1.7,3.16-1.94-1.19-.09-.03-.65,0-1.62.06.57,1.34,1.56,2.76,1.94-.02-1.49-2.25-1.18-1.97-2.91-.81.76-.72.41-2.37.65.31.29.42.73.39,1.29-.78.55-2.91,0-2.37,1.62-.88-.14-2.14-.74-2.37.32-.88-.74,1.41-1.63,2.37-1.94-1.2-.75-3.06.72-4.34.97-.76,1.82,1.74,2.65,2.76,1.94,1.27.55-.99.88-1.58.97-.14-.42-.7-.51-.79-.97-1.16.45-2.49.76-3.95.97-.62,1.11,2.64,1.54,2.37.32,1.13-.06,2.16-.04,1.97.97-.35-.29-4.13,1.31-4.34-.65-1.21-.05-1.77,1.14-2.76.32,1.54-1.54,3.07-1.77,4.74-2.26-1.91-1.09-5.73,1.45-7.5,2.59.32.75,1.85-.17,1.98-.65.61.47.78,1.3,2.37.97-.22.67-2.55.4-2.37-.32-1.84,1.6-3.01.08-5.13.97.23,1,2.11.64,1.58,2.26-1.42-.49-4.6.02-6.31.32.84,1.88,2.22-.63,2.76,1.29-1.76.33-2.78-.98-1.97.65-1.19.33-.7-.72-.79-1.29-2.59-.08-1.3,3.28-3.55,2.59-.23,1.39-1.82,4.28-1.58,7.11-.84-.15-.75.46-.79.97-.66,0-1.32,0-1.97,0,.06-.38.72-.27,1.18-.32-.3-3.15,2.27-5.32,1.58-7.76,1.71.22,1.06-1.5,1.18-2.59.92-.11,1.7-.33,1.97-.97-1.06-.68-3.19-.97-4.34-.65.31-.29.42-.73.39-1.29,2.25,1.62,6.58,1.49,8.69,0-.96-1.61-2.08-.39-3.16.32-1.45-.21-3.1-.26-3.95-.97.71-.82,2.35.7,1.98-1.29-6.23-3.12,4.42-6.11,1.97-9.7-.92.11-1.7.33-1.97.97-.7-.24-.06-.59,0-.97-1.91-.43-1.39,1.1-3.95-.65-.62.46-.78,1.3-2.37.97.45-.41,2.14-1.09,0-.97.17-.62,1.13-.59.79-1.62,1.21-.23,1.16.56,2.37.32.43-.08.27-.64.79-.65-.53-.54-1.76-.5-2.37-.97-.56,1.05-2.27,1.16-3.16,1.94-.81-.39.84-1.75-1.58-1.29,1.15-.52.43-.8.39-1.94h1.58c-.74.57.32.82,0,1.94.86.06.18-1.14.4-1.62-.1-.57-.68-.74-1.58-.65-.29-.88.78-.65.79-1.29-.14-.75-.26-1.52-1.58-1.29,1.05,1.4.88,2.68-1.58,3.23.32,1.43-1.11,2.05.39,2.26-.44.61-.5,1.53-.79,2.26-.56-1.93-.03-2.68-1.58-2.91-.29-.99.68-.95.4-1.94.64-.09.68.3,1.18.32-.32-.23-1.06-2.24.4-1.94.05-.58-.49-.68-.4-1.29-2.07.93-3.74-.94-5.52-1.29.68,1.37,1.09,1.88,0,2.91.16,1.14,1.72.64.79,1.94,1.45-.19,1.81.02,2.37-1.29.94.69.22,2.75-1.19,2.59.21-.26.41-.52.4-.97-1.12.44-1.1,1.81-.79,2.59-1.06-.83-2.24.07-1.97,1.29-.12-1.81-5.29-3.65-3.16-6.14.07-.7-1.4-.15-1.97-.32.17-.62.85-.81.79-1.62-1.54,1.25-1.76-.9-4.74-.32.82-1.25-.59-.53-.39-1.94-.32.17-.64.34-1.18.32.08-.26.4-.32.39-.65-1.26-.96-3.03-.19-4.34-.64.07.26.4.32.39.64.17.48.5-.13,1.18,0-.72,1.64.38.75.79,1.94-1.11-.6-2.96-.6-3.16-1.94-.32.17-.64.34-1.18.32,1.57,1.16,1.33,4.53,2.76,4.85,1.02-.44.09-1.98,0-2.59,2.85.33,2.24-.38,3.16-1.29.71.81-.04,1.33,1.18,1.94-.05.92-1.65.59-2.76.65-.18.53-.7,2.34-1.18,3.56.67.7,2.37,1.7,1.58,2.59-1.15-.28-.45-.48-.4-1.29-.77.59-2.21-.09-3.16-.32.59-.48.12-1.84,1.58-1.62-.25-.77-2.43.05-2.76-.65.24-1.46.36-1.58.79-3.23-2.3-.65-2.69-.99-5.53-.65.3-.84,2.22-1.32,3.16-.65-2.84-1.74,1.68-3.66,3.55-4.53-.08-.26-.4-.32-.4-.65-1.21.17-2.08,1.69-3.16.97.17-.94.83-1.47,1.97-1.62-1.49-1.33.92-.7,0-2.26-1.35.13-.5.87-1.97.32-.3.99,1.08.62.79,1.62-1.98,0-2.42,1.25-2.77,2.59-.56-.51-2.06-.26-1.97-1.3-1.11-.27-1.02.46-1.97.32-.24,1.04,1.42.44.4,1.29,1.21.23,1.44-.33,2.37-.32-.44.46-.43.79.39.97-.39.44-1.05.65-1.58.97.01.31.48.25.79.32-.75,1.78-2.51,1.16-2.76,2.91-1.44-1.2-1.99.24-4.34,0-.29-1.27-2.33-1.11-2.37-2.59,1.64-.68,3.41,1.24,3.16,2.26.61-.36.82-1.05,1.97-.97-1.52-1.66.22-1.82-1.58-3.56-1.2.4.43,1.11,0,1.94-1.9-.06-1.28-2.19-1.97-3.23-.32.17-.64.34-1.18.32.46.38.45,1.14.4,1.94-.55-.52-1.88-.4-1.58-1.62-.91-.1-.44.93-1.18.97.4.64,1.75.51,1.58,1.62-2.03-.28-2.2-2.08-3.95-2.59.28-1,.28-.62,0-1.62.37.55,1.61.65.79,1.29.69.67,2.63.93,2.37-.65-.36-.56-1.23-.71-2.37-.65.11-1.06,1.22-2.47,2.77-3.23-.04-.84-1.69-.34-1.18-1.62-.46.92-.14,4.05-3.16,4.52-1.19-2.31,1.11-3.28,1.18-5.49-1.06.43-.67,2.04-1.58,2.59-.98-.2-2.15-3.21-.79-3.23-.29-.3-.72-.49-1.19-.65-.11-2.14,1.53-2.85,1.58-4.85,1.12-.27,1.02.45,1.98.32-.17,1.65.61,2.52,1.18,3.55,1.22-.3,2.47-.56,1.98-2.26,4.83,3.4,9.67-.85,7.5-5.82-1.71.21-2.45-.37-3.16-.97-3.36,1.77-6.5.4-9.08-.97-2.58,1.56.4,5.38-1.58,7.44-.85-1.94-.05-4.36-.4-5.49-1.66.95.69,5.56-.79,7.43-1.12-.48-1.82-1.31-3.55-1.29.55.84,2.04.92,3.16,1.29.51,2.9-1.46,3.76-1.18,6.47-.8.18-.77.97-1.58.32.33.7,1.02,1.11.79,2.27-2.59-.46-4.84-1.21-6.71-2.27.06-.38.72-.27,1.19-.32-1.06-.79-2.21.37-3.16-.65.06-.8,1.34-.1,1.58,0-.78-.75.1-.36.39-.97-1.37-.57-3.66.12-5.13-.97.85-1.2,1.95-.21,2.76.32,1.38-1.76-3.18-.88-1.97-2.26-2.01,1.03-2.5-.61-4.34-.65.26-1.4-.68-1.81-1.18-2.59-.73.05-.24,1.09-.79,1.29-4.21-1.83-6.52-5.22-11.45-6.47.74,1.44,4.69,3.05,6.32,4.85-.13,1.3-1.62,1.47-1.97,2.59h-2.76c.06.6,1.34.2,1.58.65-1.25.92-1.12,2.96-3.16,3.23-1.16-3.06-4.41-6.05-3.95-9.38-.14-.51-.69.28-.79-.32-.86-.05-.18,1.15-.39,1.62-1.24.16-.9-.99-2.37-.65-.31-2.02,2.36-1.29,3.16-1.62-1.47-.56.63-2.05,2.77-1.62-1.29-1.1-2.06-1.17-2.77-2.26-1.19.58,1.12.99.4,2.26-.82.19-1.35.62-1.58,1.29-.72-.52-1.33.3-1.97-.65-.86-.05-.18,1.15-.4,1.62-2.97-.26-3.9-2.19-6.32-2.91,1.07,1.16,1.23,4.11-.39,4.85,1.31.31,2.64-2.14,5.53-1.62-1.29,3.04-2.47,6.17-5.92,7.44-.89-1.96.64-3.11.4-4.85-.66.43-.61,1.44-1.19,1.94-1.79-1.87-1.76-5.24-2.76-7.76-.85,1.03.41,3.1.39,4.53-.64.09-.68-.31-1.18-.32,1.66,2.21,2.94,5.29,3.95,7.11-4.86.88-5.33,7.04-9.08,7.76,1.06.84-.48.97-.4,1.94-.96-1.35-1.75.72-2.37-.65-1.16.02-.86,1.23-2.37.97-.4.97.88.57,1.58.65-.76.69-1.63,1.06-.79,2.26-.4-.21-.41-.74-1.18-.65,1-1.81-.73-.45-.79-2.27-1,.55-1.9-.19-.4-.32-.16-.81-1.81-.25-1.18.65-1.86-.95-2.26.56-3.95.65.97.53,3.18,1.92,1.18,2.91.08.26.4.32.4.65.45-.06.22-.32,0-.32.22-.94.61.5,1.18.32.37-.99,2.08-.88,2.76-1.62.44.29-.1.78,1.18.97-1.61.6-3.92.97-5.13,1.29-.34,1.04.61,1.01,1.18,1.29-.65,1.5-1.06-.49-2.37-.32.59-.98-.13-1.26.39-1.94-1.12.05-1.65.59-2.76.65-.38-.95-.59-1.2-.79-1.62.3-1.18,1.26.03,2.76-.32-.13-1.78-2.61.26-2.76-1.62-1.03.13-1.19.97-2.37.97-.15.55.31.61.79.65-.41.72-1.82-.42-3.16,0,.44-.4.35-.67-.39-.65.21-.48.58-.82.79-1.29-.56-.98-2.57-.44-3.55,0-1.01-.04-.78-1.08-.79-1.94-.1-.35-.79-.22-.79-.64-.73-.31-.24,1.85-.79.64-2.21,0,1.83-1.25,0-1.94.56,1.03-2.28,1.44-1.18,2.91-.93,0-1.16-.56-2.37-.32,1.1.41.94,1.62,2.37.97.42,2.07-2.66,1.27-3.16,2.59-1.43-.65-.25-2.15,1.58-1.94-.67-.31-.79-1.07-1.58-1.29-.42,1.2-2.68,1.39-3.94.97,1.63.79-.54.35-.4,1.62-.54-.1-.33-.81-.4-1.29-.35.14-.7.28-.79.65.17-1.23-4.32-1.15-5.92.32-.32-.17-.64-.34-1.18-.32.28-1.2-.68-1.39-.4-2.59.4-.21.41-.74,1.19-.65-.81-.52-.92-1.62-.79-2.91,3.59-1.13,8.92,1.63,11.05-1.62-.18-.29-.35-.58-.79-.65-.76.61-1.21,2.53-3.55,1.62.4-.43.38-1.2,1.18-1.29-.75-1.49-3.27-.25-3.55.65-1.33-.09-1.14-1.43-2.37-1.62-.91-.1-.44.93-1.18.97-1.74.38.91-1.81-1.58-1.29-.19-2.53-2.37-3.45-1.97-6.47-.92,1.08-1.77-2.44-.79-3.88-.59-.52-1.66,0-1.98.65-1.1-2.12-1.44-4.86-2.37-7.11-1.14,1.71,3.3,6.03.4,7.11.36-1.37-.65-1.63-1.58-1.94,1.91-3.24-3.84-2.55-3.16-5.82-.81.74-2.03,1.14-2.37,2.26-1.65-.06-3.3-.11-3.95.65.97,1.14,2.94,1.47,4.34,2.26-.47.76-2.54,1.38-3.16,2.91.63-.17,2.68-.78,1.97-.97,1.03-.49,1.19.78.4,1.62.83-.08,1.22-.25,1.58,1.29.88-.14.16-1.59.4-2.26.27-.64,2.35.2,1.97-.97,1.1.72.43,2.88,1.97,3.23.95-.82-.62,1.17-.79-.32-.58.6-1.58.86-1.58,1.94,1.34-.77,1.12-.35,1.97.65,1.88-.99,2.72.78,4.34,0-.04-.8-.74-1,0-1.62,2.82,3.8,5.09,8.37,3.95,12.93-1.67-.74-2.28-2.75-1.97-4.2.52.39.62.13,1.18,0,.19-1.02-.56-1.26-.79-1.94-.92.14-1.06,1.43-1.97.65-.55,1.31.86,1.02.79,1.94-1.75.22-2.94-.97-2.77.97-2.15.15-.46-1.88-1.18-2.26-1.56.1.29,1-.79,1.29-2.1-.34.32-1.66.4-2.26.35.25.89.35,1.58.32.05.6.26,1.08.79,1.29.82-.08.11-1.42.79-1.62-1.85-.21-2.72-1.22-3.55-2.26-1.1.42,1.24.67.79,1.62-1.61.08-2.22.98-3.95.97-.81-.84-1.37-1.89-1.18-3.56-.64-.09-.68.31-1.18.32.06.6.26,1.08.79,1.29-.04.62-1.47-.5-1.97.32.27,1.01,1.05.42,1.97.32-.33.91.56.84.4,1.62-2.3.48-2.16-1.03-3.55-1.29-.37.24-.59.59-.79.97-1.24-1.34-1.17-.55-2.77,0-.13-.65.08-1.01.79-.97-.68-1.45-2.81,1.07-1.97,1.94-1.21-.24-.76.89-1.97.65-.49,1.05,1.28.25.79,1.29-.78.44-2.26.31-3.16.65-.06-1.3,1.01-.86,1.97-.65-.55-1.92-3.49-1.3-4.74-3.23-.57.07-.14.97-.79.97-1.7-.13-.52-1.11-1.18-1.62-2.12.93-1.09,3.8-2.76,6.14.45-.11,1-.57.39-.65.4.18,2.43,0,3.55.32.29.99-1.09.62-.79,1.62-.93-2.24-2.14.46-3.55-.32.47.42.15.51,0,.97,1.2,0,3.22-1.01,3.16.65-.7-.46-.9-.3-.79.65-1.97-1.52-3.5.93-5.52,1.29.4.42.39,1.19.79,1.62.82-.7,1.28.04,1.98.32-1.23,1.35.42,1.33,0,3.56-.79-.54-.5.03-1.58,0-.51-.77-.76-1.75-1.97-1.94.26-.97.84.31,1.58,0,.93-.08.23-1.42,0-1.62-.24.45-1.52.05-1.58.64-.72-.57-1.67-1.36-.4-1.94-2.1-.18-.84-1.85-1.97-2.26-.75.76.35,1.87-1.18.65-1.56.1.29,1-.79,1.29.59,1.15,1.97-.35,1.97,1.29h-1.18c-.95-.13.22,1.47-1.18.97.79-1.18-.03-1.28-1.18-1.62.22-.67.62-.68,1.18-.32.28-.99-.4-1.18-.4-1.94.25-.55,1.2-.53,1.58-.97-1.29-1.28-2.38-.75-3.95-1.62.06-.8,1.34-.09,1.58,0-1.64-2.12-3.55-.5-4.74-3.23-.98-.16,1.3,1.79,0,.97-1.7-.21-3.58-.06-5.13.32.29-.99-.68-.95-.39-1.94-1.7.17-2.21.09-3.16.32.21.26.41.53.39.97.48-.36.72-.92,1.97-.65.04.8.74,1,0,1.62,1.07.53,1.53-.04,2.77.65.53-.32.77-.88,1.58-.97,1.25.16,1.73.95,3.16.97-.79.71-.67,1.17-1.18,2.59-.17.53,1.47-.03,1.58-.32.59.1-.43,1.36.79,1.62-.51.12-2.49.1-1.97,1.94-1.1-1.57-.79-3.68-3.95-2.91.11.67,1.05.64,1.58.97-1.01,1.35-1.6-.36-3.16-.32,1.22-1.65.51-1.23-.39-2.59,1.8-.4,1.25,1.13,2.37,1.29.38-.54,1.31-1.01,1.58,0,.62-.14.34-1.02,1.58-.65v-1.62c-1.51-.86-1.36.84-1.97.97-2.83.61-4.34-2.05-6.32-1.62-.46-.05-.33-.59-.39-.97-.4.21-.41.74-1.19.65,0-.76.68-.95.4-1.94-1.16.29-1.21.29-2.37,0-.35.14-.71.28-.79.65,1.05.54.05,1.17,1.97,1.3.95.66-2.16.11-1.97-.65-.76.03.61,1.21-.4,1.62,1.59.02,7.68-1.01,6.32,2.26-.84.15-.75-.46-.79-.97-.53.07-.73,1.34-.79,0-.64-.23-.64,1.53,0,1.29-.26.33-.91.33-.79.97-.68-1.17-.39-3.13-2.37-3.23-.64-.14-1.32,1.2-.39,1.29-1.6.8-.84-2.36-3.95-1.94.88-1.88-2.79-3.06,0-3.56-.1.35-.79.22-.79.65.27,1.18,1.57-.07,3.16.32-1.27-.62-.11-1.35-1.19-2.26-.37.34-1.46.1-1.18.97-2.36-1.92-5.6,3.35-8.29.32-1.67.54.62.87-.4,1.94-2.06-.45-3.41.86-3.16-.97-.57.18-.96.5-1.18.97-.5-1.81,1.87-4.06,3.55-5.17-.07-1.43-.71-2.05,1.18-2.26-.94-1.54.96-3.22,1.58-4.52-.1-.35-.78-.22-.79-.65-.95,1.23-1.18,3.58-3.55,4.85.84,2.16-2.13,3.81-2.77,5.82-.64.09-.68-.31-1.18-.32v1.62c-1.4.17-.97-1.15-2.37-.97,1.03.57,1.97,1.41,1.97,1.94-1.62.85-.68-1.72-2.37-.65-.16-2.28,2.74-2.06,3.55-3.55-.55-.74-2.9-.25-2.37.97-1.33.31-2.12-1.46-2.76-.65-1.18-.44-1.64-1.46-2.37-2.26.01.93-1.48,3.49-3.55,2.59-.12,1.51,2.41,1.04,1.18,2.59,2.45.06.16-3.76,3.16-3.23-.01.31-.48.25-.79.32.07.26.4.32.4.65.67.12.74-.25.79-.65,1.21.67,1.24.43,2.76.97-.32,1.79-2.51,2.04-3.95,2.91.04.79,1.31.07,1.18-.32,1.28.56-1.03.85-.39,1.94-.82-.38-.96-2.69-3.16-1.62.12.44.99.27,1.58.32-.11.67-1.47.3-1.58.97-1.42.19-.01-1.93-1.58-1.62-.11-.74.09-1.22.79-1.29-.54-1.58-1.62.53-2.37-.32.39.68,2.41,2.06,0,2.26-.34-1.13-.72-2.42-2.37-1.62.03-1.45.91-.41,1.58-.97-.31-.29-.42-.73-.4-1.29-2.03.34-2.43,0-3.95.65-.32-1.23,1.16-.99,1.18-1.94-2.03-.14-1.04.68-1.58,1.29-1.25-.77-1.61-.57-1.97.65-1.09-.1-.68-1,0-1.29-.53-.85-1.75-.62-2.76-.32.37.64,1.28,1.54.39,2.26.52.65,1.3,1.09,2.37,1.29.7.1.71-1.81-.4-1.29-.28-.88,1.86.23,1.58-.65,1,.75.57,1.44.4,2.59-1.29-.08-1.9.38-1.98,1.29-2.04-.16-3.04-1.17-4.74-1.62,1.2-.48.22-.97.79-1.62-2.2-.5-.45,2.22-2.37,1.94-.13-.65.08-1.01.79-.97-.39-.91-1.05.47-1.58-.32,1.07-1.28,2.18-.89,3.95-1.29-.4-.4-2.44-1.72,0-1.62-.31-.29-.42-.73-.39-1.29-1.38,1-1.24-1.11-1.97-.32-1.15-.36.5-1.05,1.18-.97-1.96-.82-4.22,1.17-5.53-.97-1.53-.28-.64,1.41-2.37.97-.28,1.52.81,1.92,1.18,2.91,1.08.03.79-.54,1.58,0-.06-.38.09-.57.4-.65-.44-.5-1.28-.67-1.18-1.62.66-.55,2.32-.26,1.97.97,1.84-.19,2.31-1.28,2.77,1.29-1.32,0-1.35-1.05-2.77-.97.59,1.3,2.7,1.29.79,2.91-1.06.22-.76-.67-1.18-.97-.99.59-.1,2.72-1.98,2.59.79-1.18-.03-1.28-1.18-1.62-1.06.54-.16,3.41-2.37,2.91.69,1.27,2.74,1.53,3.55.32,1.09.14.02,1.02-.79.65-.11.52.38.56.4.97,1.47.34.77-1.09,1.58-1.29,1.04-.1,1.02.67,1.18,1.29-1.55-.41-1.17.76-1.18,1.62-.76-.66-1.13-1.13-2.37-.65.41.78,2.11,1.53,0,.97v.65c.06.38.72.27,1.18.32.82-.84,1.72-1.61,3.16-1.94-.93,1.71-.15,2.19,0,3.56.22-.36.59-1.66,2.76-1.29-.81-.07-2.92-1.34-.4-1.29-.07-.26-.4-.32-.39-.65-.22-.73-.62.39-1.19-.32.43-.12,1.65-1.41,0-1.29.46-.86,2.1-.03,1.58.97,1.18-.37,5.64-.9,5.53.32.88.18.56-.62,1.18-.65-.06-.38-.72-.27-1.18-.32-.51-.8,1.16-1.34,0-1.62,3.29,1.03,4.04-3.28,5.92-.97-1.24-.16-1.05,1.12-1.97.32,2.02,2.08-2.32,5.02.79,6.47-.58.14-1.06.55-1.52.98,1.76.15.03,1.38,1.91,1.61-.31.72-1.38.81-1.97,1.29.35,1.01.74,1.98,1.97,2.26-.11.75-1.05.74-1.58.32-.14.55.31.61.79.65-.26.43-.84.6-1.58.65-.49,1.04,1.28.25.79,1.29-1.78-.24-1.29-.87-2.76,0-.65-1.8-2.69-4.57-1.58-5.82-1.06-.22-.76.67-1.18.97-1.31-.22-4.16-2.26-4.74-.97-.78-.44-.21-1.98-.79-2.59-.54.1-.33.81-.4,1.29-1.24.05-.77-1.31-1.58-1.62.39,1.23-1.53,1.53-.79,2.91-.82.14-1.04-.22-1.58-.32-.22-.72.76-.46.79-.97-.43-.74-2.48-.12-1.97.97-1.22-.23-.76-.23-1.98,0-.15-1.2,1.9-.6,1.98-1.62-.18-.83-.55-1.49-1.18-1.94-.62.03,1,2.97-1.18,2.59.05-1.77,1.17-3.71-1.97-3.88.1-.95-.89-.99-.79-1.94,2.18.45,3.01-1.73,3.95-3.23-.12-.44-.99-.27-1.58-.32-.06-3.56-1.96-5.49-3.95-.97-1.22-.11,1.04-1.65-.4-1.94.59-.49,1.18-.97,1.58-1.62-.03-.95-.14-1.82-1.58-1.62,2.58-.18,4.16-.27,4.34-2.91-1.21.19-.95,1.6-1.58,2.26-2.62-.36-5.19.05-8.29-.32-.54.32.17.53-.79.97.95.96,1.63-1.02,3.55-.32-.44.47-.43.79.39.97.58-.39.38-1.41,1.97-.97.02,1.3.03,2.37.39,2.59-.99.66-3.54.4-2.37,1.94-.78-.14-3.63.13-1.58.32-.57.95-1.59-.39-1.18-1.29-1.06.21-1.18,1.19-1.97,1.62-.96-.5-.38-2.44.79-2.26-.1-.67-1.73-.09-1.97-.65-.75.04-.27,1.07-1.18.97.71.5,1.18,1.19,1.58,1.94.34.68-2.01-.47-.79.32-.12,1.14-1.07-1.14-1.18,0-1.11-.32-.04-1.49.39-1.62-.33.06-.37-.13-.39-.32-.75,1.03-1.22,1.03-1.97,0-1.19.39.21,1.29.79,1.29-.06.8-1.34.1-1.58,0-.11.56,1.26,1.73-.39,1.62,1.06-.84-.48-.97-.39-1.94-.86-.05-.18,1.15-.4,1.62-1.24.37-.96-.51-1.58-.65-.32.06-.39.33-.79.32.09.57.68.74,1.58.65-.26.33-.91.34-.79.97-.46-.05-.33-.59-.39-.97-.35.2-.71.39-.79,0,.12.48-.95,2.69.79,2.91-.76.91-2.06-.44-3.16-.32.92.22.57,1.47,1.58,1.61-.52.65-1.3,1.09-2.37,1.29-.11,1.73,1.69-.11,1.58,1.62-1.2-1.1-1.6,1.39-.79,1.94,1.16-.27-.51-.82,0-1.62,1.08-.24.8.64,1.58.65.15,1.2-1.6.85-1.18,2.26,1.21-1.13,1.36-.59,3.16,0-1.07.74-.47,1.25.4,1.94-.35.37-.95-.08-1.18.97-1.22.24-.76-.89-1.97-.65.12-.44.99-.27,1.58-.32-.34-.75-.34-.86,0-1.62-1.26.36-1.39.08-2.76.65.34.26.24.89.79.97-2.46.81-.32-2.07-1.58-3.88-2.26.29-2.5,1.73-1.97,3.56,1.24-.44,1.36-.1,1.58.97-1.13-.44-2.38.58-1.18.97-.05.71-1.68.14-2.37.32.95-.94-1.84-.89-2.76-1.29-1.3.48,1.32.38.79,1.29-1.17.4-2.6-.41-3.55.65.6-.15,1.98.06,3.55.65-.95,1.24-1.16-.15-2.77,0,1.39.45.55.85,1.88,1.26-.67.08-2.53.52-1.88,1.65-.31-.45-2.18-3.35-1.18-3.56-.82-.21-1.61-1.56-1.97-.32-1.31-.32.44-.64.39-.97-.36-.88-1.39.57-1.97-.32.29-.66,1.19-1.32,1.97-.65-.13-.75.06-1.24.39-1.62-1.11-.27-1.02.46-1.97.32.24-1.08,1.16-1.1.39-2.26h2.37c.18-1.02-.99-.91-1.58-1.29-.45.06-.22.32,0,.32-.1.41-.79.33-.79,0-.42.13-.92,1.77-.39,1.62-1.43.47-.66-2.02.39-2.26-1.13-1.03-.48-2.47-1.58-2.91.61-1.39,2.23-.06,1.18.97.78-.22,1.05-.86,1.18-1.62-.36-.68-2.23-.12-2.37-.97-.07-.81.88-.78,1.18-1.29-1.54-.37-2-3.16-.79-3.88-.68.07-.87-1.81-1.18-.97-.75-.03.1-1.38,1.18-.97.05-.58-.48-.68-.39-1.29-.91,0-2.38,1.36-1.58,0-1.03.92-1.25.83-2.76.97,1.06.45.58.92-.39,1.29.17.4.51.67,1.18.65-.91.88-1.52,1.26-2.37.32-.97.04-.08,1.07.4.97-.35.23-1.86.35-2.37,1.29-1.32-.8.86-1.42,1.18-1.94-.1-.35-.78-.22-.79-.65-1.12.75-.39,1.33-1.58,2.27-.37-.18-.59-.9-.79-.32-.98-.05-.12-1.09,0-1.29-.69.08-.9.56-.79,1.29.06.71,1,.7,1.98.65.07.28-.16.3-.4.32v.65c-1.93-.03-1.7-1.84-3.16-2.26,1.96-.26-.66-1.77,1.58-2.59-2.17-1.23-2.06,2.18-3.55,2.59,0-.86-.22-1.9.79-1.94-.05-.71-1.67-.14-2.37-.32-.07.92,1.33.63.79,1.94-1.01-.04-1.38-.59-1.97-.97-1.27.08,1.25,1.83-.79,1.62-.07-.27.15-.3.4-.32-.4-.54-1.83-.23-1.97-.97-.62.53,1.15,1.84,2.37,1.94-1.52,2.79,3.07,5.48,2.37,9.7-.81-.56-.78.24-1.58-.32-.41,1.09,1.23.5,1.97.64-.26,1.91,1.25,2.43,0,4.85-.74-.64-1,1.41-3.16.32.39-1.43.06-.85-.4-1.94,1.27.14,2.14.62,3.55.65-.42-1.55-2.64-1.64-4.34-1.29.33-.38.52-.87.39-1.62.71.04.84-.4,1.58-.32-.74-.61-.04-.81,0-1.62-.94.2-.65,1.41-2.37.97.31.29.42.73.4,1.29-1.55-.13-2.19-1.01-3.16-1.62.39,1.29.46,1.92,0,2.91-1.36-.23-.26-.97,0-1.62-1.41.15-2.28.53-3.55,0,.04.34,3.17,2.05.39,2.59.92-1.41-1.37.07-1.18.97-.94-.2-.65-1.41-2.36-.97.61.47,1.06,1.07,1.97,1.29-.73.47-1.05,1.3-2.37,1.29,1.66-1.51-.06-1.48-.39-3.23-1.4.23-1.39.33-3.16.65-.21-1.22-.55-1.52.4-2.27-1.5-.47-.76.89-1.97.65-1.26-1.6,1.8-1.84.79-3.23.32.28,1.08.19,1.18.65.53-.41.77-.97,1.58-.32.16-.78-.72-.7-.39-1.62-.84-.15-.75.46-.79.97-1.83-.54.59-.87.39-1.94-1.97-.17.1-.43-.79-2.26.35.25.89.35,1.58.32.16-.77-1.8.18-1.18-.97.57-.72.96.41,1.18-.32-.8-.7-.72-1.11-.39-2.59-.97-.29-2.24-1.3-1.18-2.26-1.44.63-3.73,2.23-5.13,3.24.14.45.7.03.79-.32,1.07.29-1.05.6-.39,1.62-1.92-.15-1.5-2.22-1.58-3.88-1.84.82.26,2.96-.39,4.85-.35.25-.89.35-1.58.32,1.6.62-.25,1.53-.4,2.59-.82-.19-1.35-.62-1.58-1.29-.54.1-.33.81-.39,1.29.1.41.79.33.79,0,.99.32-.32,1.43-1.19,1.29.23-.73-1.81-.69-3.55-1.29-.21,1.14,1.4.79,1.18,1.94,1.35.37,5.65,3.72,2.76,4.85.21.26.41.53.39.97.61.21,1.29-.09,1.52-.41.58.98,1.67,2.75,2.43,4.29-1.06-2.14-2.11.16-1.97.97-1.25.03-.52-1.62-.4-1.94-.72-.28-1.09-.83-1.97-.97,0-.64,1.08-.41.79-1.29-.43-.78-4.16-.88-3.55-2.26-2.54.03-3.41-.47-5.13.32-.34-.48-.99-.7-1.97-.65.19-1.51-.21-2.54,1.97-2.91-.32-1.03-1.17-1.63-1.18-2.91h2.76c-.09,1.02-1.58,2.56-.4,3.55.68-.73.85-1.89.79-3.23.32.06.39.33.79.32.44-.29-.03-.72.79-1.29-.68-.01-1.02.24-1.18.65-.53-.21-.73-.69-.79-1.29,1.01-.01.48.24.4.65.67.02,1.02-.24,1.18-.65-.52-1.3-1.98-1.82-1.97-3.56-.71-.04-.83.4-1.58.32-.32-.81-.51-1.73-1.97-1.62-.17-.67.27-.86.4-1.29-.71-.34-2.36,1.29-3.55,1.62.61,1.56-2.86,2.33-2.37,4.85-1.03-1.39-.38.48-1.58.65.01.32.48.25.79.32-1.7,1.95-1.92,4.82-3.17,6.59-.25-.26-1.06-.07-1.57-.12,1.73-.96.84-2.36,2.37-2.26-1.98-1.2,2.76-4.66-1.97-4.85.55-.8,1.36-.57,2.37-.32.35-.23-.32-1.86,1.19-1.94-1.9-.36-.52-.18,0-1.62.7.24.05.59,0,.97,1.28.4.3-1.05,1.58-.65-1.56-1.06.13-1.08.4-2.27-.09-.41-1.18-.42-1.19,0-1.42-1.08,1.43-1.4,1.19-2.59-1.06-.22-.76.67-1.19.97-.62-.57-.96-1.37-1.58-1.94-.51.59-.19,1.19-.4,2.59-1.11.27-1.02-.45-1.97-.32,1.4-2.08-1.07-2.62,0-4.2-.86.05-.85.81-.79,1.62-1.56-1.46-2.36,1.48-4.74,1.29.14-.55-.31-.61-.79-.65.31-.29.43-.73.39-1.29-1.12.16-.57,1.69-2.37,1.29-.17.52,1.47,1.09,1.58.32.56.55-1.11.76-.79,1.62-1.55-.04-1.21-1.41-2.76-.65.5.81-.2,1.01.39,1.29-.45,1.04-1.13-.31-.79-.97-.77.32-1.21,1.6-2.37.65.91,1.01-.72.91,0,1.29-.35.88-1.75-.27-.79-.65-.52.11-.62.57-1.18.65-.03,1.11,2.4.19,2.37,1.29.8-.58.11-1.19,1.58-.65.25-1.04-1.42-.44-.39-1.29.59.48,1.19.97,1.97,1.29,1.47-.2,2.48-.77,3.95-.97-.21-.26-.41-.53-.4-.97,1.08-.03.8.54,1.58,0-.29-.3-.72-.49-1.18-.65.25-1.17,1.84.75,1.97-.32,1.07.59-1.15,1.19-.39,2.59-.76.17-4.57-.67-4.74,1.62-.46-.48-.99-.91-1.58-1.29.47.28-1.99,2.25,0,2.59-.64.56-.78,1.52-1.58,1.94-.27.87.82.63,1.18.97-3.33,3.31-8.78,4.88-12.24,8.08h-3.16c.88-1.29-.45-2.94-1.97-2.26-.47-3.95-4.86-5.2-3.55-10.02-2.09,1-3.75-.04-4.74-1.29-.79,1.83-2.18,3.17-2.77,5.17-1.02-1.39-.75.18-1.97.32-.69-.66.29-.63-.4-1.29-1.07.34-1.85.21-2.37-.65-1.02.03-.41,1.39-1.97.97.74.62.04.81,0,1.62-2,.6-2.89-.6-4.34-1.29-.83,1.24.57,1.33-1.58.65-.02.55.29.84.79.97-.38.66-1.52.7-2.77.65-.31-.29-.42-.73-.39-1.29-1-.34-2.25.68-1.19.97-.4.65-2.64-1-1.58-1.62h-3.16c-.05-.58.48-.68.4-1.29-1.07.2-.98,1.35-2.37,1.29.44-1.02.04-.73,0-1.94-2.15-.23-4.89.18-6.71.65.48.47,1.51.49,1.97.97-.12.2-.98,1.25,0,1.29-.43.59-3.11-2.35-2.37-2.26-1.02-.61-5.37,2.29-4.74-1.29.47.36.72.92,1.97.65.75-.95-.76-1.21.39-2.26-.91-.17-.64-.23,0-1.29-1.04-.1-1.02.68-1.18,1.29-1.25-.84-1.55-.51-3.55-.32.43-.66,1.89-1.32.79-2.26-.23,1-1.66,1.01-1.58,2.26-.75-.61-.99-.04-1.97,0v-1.62c-1.24-.52-1.36,1.99-1.58.32-1.33-.12-.62,1.43-2.37.97-.19-1.02,1.21-.73.79-1.94-.32-.81-2.08-.45-2.76-.97-.81.09-.09,1.43-1.18,1.29-.19,1.02,1.96.12,1.58,1.29-1.8-.4-1.55.89-3.16.65-.22-.72.75-.46.79-.97-.41.08-2.42.33-1.18-1.29-1.67.42-1.54,3.52-2.76,2.26-1.07.48.69,1.35,1.18,1.62-.33.62-1.73.88-2.37.32-.06-1.4.55-2.06.79-3.88-.76.13-.03,1.48-1.58.97-.13.78.45,2.43-.79,3.23.99,1.28,4.07.81,6.32,0,1.02.56,2.87.45,3.16,1.62-2.99.42-6.61.1-9.48,1.29v-.97c-.82.19-1.13.8-2.37.65-.39-.43-.65-.98-1.18-1.29-1.58.46-3.16.8-4.74,1.94-.7-.18.8-1.25.79-1.94.28-.53-1.86-.53-1.58,0-.81-.18.53-1.25,1.58-.97,1.01,2.08,2.33-1.08,3.55,0v-1.94c.24.19,1.87.76,1.97,0,1.07.29-.18,1.31-1.19.97.34.26.24.89.79.97,1.26-.66.87-.8,2.37-.97-.1-1.39-2.34-1.38-3.55-.97.06-.38-.09-.58-.4-.65,1.27-1.32,1.91.77,2.37-.97.54.1.33.81.4,1.29,1.35.24.65-1.19,1.58-1.29-.17-.51-1.24-.28-.79-1.29-1.53-.28-.65,1.41-2.37.97.13-.75-.06-1.24-.4-1.62-1.23.18-1.24,1.35-2.76,1.29.21-.26.41-.53.39-.97-3.03.43-3.05,4.32-6.32,3.56.35-1.01,1.07-1.71,1.58-2.59-2.12.21-1.72,2.47-3.95,2.59.22,1.52.58,2.72-1.58,2.91.78-.39-.1-1.11-.4-.32-1.09-1.11.28-2.45-.39-3.56,1.24-.15,1.04.87,1.97.97,1.63-2.44,3.17-3.41,4.74-3.88.21-1.64-1.4,0-1.19-1.29-1.18.21.38.69,0,1.29-1.32-.22-1.44.54-1.58,1.29-1.08-1.56-.81,1.64-2.76,1.3.06-1.63-.28-4.17-3.16-3.56-.11.58.37.66.4.32.53.22-.2.86.39,1.62-.74-.24-.27-.97-1.18-.32,1.01,1.2,1.48,3.3.79,4.2.46.05.7-.07.79-.32,1.39.1-1.39.88,0,.97-.71-.06-1.3.53-1.98,1.29.26.97.85-.31,1.58,0,0,.64-1.08.41-.79,1.29,1.7-.29,1.54,1.79,1.18,2.59-.76-.91-1.31-.19-3.16.32-1.14-.97.69-1.34.79-2.26-1.81.2-4.49-1.39-3.55-3.24.72.48.98,1.35,1.97,1.62-1.41-1.11-1.27-3.49-2.76-4.52-.77.34.26,1.91.79,2.26-.69.52-1.44.98-1.18,2.26h-1.97c.22.66,1.19.63.4,1.29,1.24-.22,1.61.04,1.97-.32.99.92,1.57,2.17,1.98,3.56.48-.14.81-.41.79-.97,1.11.34.49,1.28,1.97.65-.12.66-1.07.63-1.18,1.29-.82-.18-.84-.5-.4-.97-1.88.07.66,5.72-.79,2.26-.06-.6-1.34-.2-1.58-.65,0-.32.48-.25.79-.32-.29-1.19-1.18.14-1.97-.65.04-.61,1.31-.22,1.18-.97-.1-.67-1.73-.09-1.97-.65.42.86.29,1.84-1.18,1.94.43-1.25-1.21-1.42-2.56-1.77v47.67l1920,.22ZM1840.66,44.46c-.27-.11-.4-.25-.44-.44.15.14.3.29.44.44ZM1839.15,44.23c-1.68-.45,1.68-.45,0,0h0ZM1838.11,51.63c.14-.08.34-.12.61-.08-.08.25-.29.39-.65.39,0-.09.02-.2.03-.31ZM1837.45,51.16c-1.43.93,1.03-1.29,0,0h0ZM1835.74,45.77h-.44c.17-.29.21-.54-.34-.72-.16.25-.34.49-.47.72h-.45c.48-.8.07-.75.3-1.55.66-.08,1.23-.24,1.82-.37-.48,1.21.12,1.02-.42,1.93ZM1701.32,61.46s0,.04-.01.07c-.02-.03-.04-.06-.07-.09.02,0,.05.01.08.02ZM1650.35,71.97c.1-.3.01-.76.43-.77-.09.3-.01.76-.43.77ZM1654.19,67.34c1.07-.11.42,1.34,1.56,1.17v1.42c-1.25-.58-2.21-1.7-1.56-2.59ZM1654.19,74.66s0,0,0,0c0,0,0,0,0,0h0ZM1655.89,75.82c.24,0,.48.31,0,.38-.07-.45-.67-.42-1.28-.38.01-.34-.08-.59-.2-.81.13-.17.26-.34.28-.61.29-.04.37.29,1.2.27-.01-.24,0-.56.06-.78.11-.02.22-.04.33-.06.01.02.03.04.04.07.35,1.09-.6,1-.43,1.93ZM1661,78.52c.06.96.08,1.87-.85,1.93,0-1.9-2.04-2.95-.85-3.85.49.57.49.97,0,1.54.81-.09.94.43,1.7.39ZM1658.87,75.43c-1.68-.45,1.68-.45,0,0h0ZM1658.42,80.03c-.06-.05-.1-.09,0,0,0,0,0,0,0,0ZM1658.45,70.04c-.11.07-.22.12-.34.16-.15-.19-.26-.42-.33-.67.2.19.42.37.67.51ZM1656.88,72.88c.23-.46.16-.63,0-.77.25-.55.76-.87,1.13-1.3-.15,1.22.6,1.1.69,1.52-1.02-.18-1.17.43-1.69.7-.05-.05-.09-.1-.14-.14ZM1657.37,73.47c.18-.15.29-.38.24-.74.43.25.44.89,1.28.77v-.59c.42-.32.64-.82,1.7-.57v1.16c-.84.11-.85-.52-1.28-.77.13,1.02-.89.99-1.71,1.16-.07-.15-.15-.28-.23-.42ZM1658.02,81.98c-.31-.18-.38-.37-.31-.55.18.09.31.1.73-.22-.09.3-.01.75-.42.76ZM1658.46,81.21s0,0,0,0c-.04-.09-.11-.16-.19-.21.65-.27,1.63-.32,1.88.21-.84.64-.54-.03-1.7,0ZM1660.58,82.37c-1.68-.45,1.68-.45,0,0h0ZM1593.67,68.88c1.57-.37,1.69,1.89.43,1.93-.24-.8-1.22-1.24-.43-1.93ZM1594.95,71.2c-.52-.08-.26-.43,0-.77.43,0,.54.68,0,.77ZM1556.59,80.44c-.1.3-.01.76-.43.77.1-.3.01-.76.43-.77ZM1538.69,70.04c-2.59-.12,1.63-.75,0,0h0ZM1538.69,68.11c-2.59-.12,1.63-.75,0,0h0ZM1542.13,71.05c-.54-.12-.97-.33-.88-1.01.82-.05,1.16.32,1.45.75-.18-.01-.36-.01-.59.02,0,.09,0,.16.02.24ZM1494.79,82.37c.43,0,.53.67,0,.77.04-.43-.62-.6,0-.77ZM1494.79,85.06c.13.79,1.15.76,1.28,1.54-1.32.5-2.42-1.09-1.28-1.54ZM1493.44,82.63c-.03-.09-.08-.16-.15-.21.25.02.4.09.15.21ZM1495.22,88.15c-.78,1.11-1.06.87-2.13,1.16.1-.71,1.82-1.9,2.13-1.16ZM1492.95,82.42c-.17.08-.12.16-.03.28-.51-.16-.29-.26.03-.28ZM1490.95,84.68c.1-.3.01-.76.43-.77-.09.3,0,.76-.43.77ZM1489.72,83.2c.13-.02.27-.03.39-.06-.12-.24-.27-.4-.44-.51.48-.14.92-.22,1.3-.15-.13.05-.08.15.42.28.04-.01.06-.02.09-.03.12.1.23.23.32.41-.33.09-.84.01-.85.38-.49-.03-.91-.13-1.23-.32ZM1488.85,91.31c.45-.13.94-.22,1.68-.08.29.89-1.26,1-2.37.81.46-.11.77-.33.69-.72ZM1488.4,89.69v1.49c-.35-.03-.64,0-.9.05h-.38c-.07-.96.65-1.21,1.28-1.54ZM1481.15,97.78c-.85-.08-1.82,1.63-2.13.77.37-.39,2.99-1.71,2.13-.77ZM1479.02,88.53c-.1.3-.01.76-.42.77.09-.3.01-.76.42-.77ZM1471.24,97.28c.24-.11.44-.28.56-.49.57-.3.89-.83,1.68-.94.64,1.39-1.32,1.93-2.24,1.43ZM1473.91,91.61c-2.59-.12,1.62-.75,0,0h0ZM1415.09,59.25c.1.3.01.76.43.77,0-.21.34-.44.43,0-.43,0-.53.68,0,.77.02-.41.55-.3.43.39-.56-.16-1.24-.19-1.72-.42-.06-.16-.18-.22-.27-.18-.05-.05-.1-.1-.14-.16.71,0,.24-1.07.85-1.16ZM1414.67,61.56c-.1.3-.01.76-.43.77.1-.3.01-.76.43-.77ZM1413.82,63.1c-1.68-.45,1.68-.45,0,0h0ZM1407.42,67.73c-.01-.07-.05-.12-.07-.18.27-.11.54-.2.93-.2-.37-.56-1.05-1.17-1.77-1.48,1.1-.71,2.79.47,3.47,1.48-1,0-1.26.66-2.55.38ZM1401.43,69.97s0,0,0,0c0,.02,0,.04.01.06,0-.02,0-.05-.02-.07ZM1369.49,76.97v-.21c.13.02.26.05.43.1-.13.03-.27.07-.43.12ZM1370.28,76.77c-.14-.36-.43-.59-.79-.75v-.59c.94.44,2.35.44,2.56,1.54-.91-.25-1.19-.32-1.77-.2ZM1327.73,71.2c1.05-.6,1.25,1.31.43,1.15-.02-.24-.06-.46-.43-.39v-.77ZM1326.45,66.57c-1.3,1.05,1.16-1.17,0,0h0ZM1279.99,41.53c-.1.73.48.85.43,1.54-1.19.62-1.18-1.66-.43-1.54ZM1278.52,52.25c.27-.18.59-.32,1.06-.32-.04-.55-.23-.96-.59-1.22.05-.11.09-.22.15-.32,1.39-.1,2.05.46,2.13,1.54-1.42,0-1.46,1.25-2.99,1.15.09-.26.16-.55.23-.83ZM1103.55,18.03c-.85,0-.54,1.05-1.7.77-.27-.08-.46-.23-.63-.4.14-.19.29-.36.64-.37-.19-.58-.63-.93-1.28-1.09,0-.02-.01-.04-.01-.06,1.62-.18,2.66.16,2.98,1.16ZM1096.31,29.2c.06-.45-.07-1.09.42-1.16-.07.45.08,1.09-.42,1.16ZM1095.63,23.02c.57-.2.49-.98,1.52-.76-.17.93.78.84.43,1.93-1.21-.32-1.11.54-2.13.39,0-.16,0-.31,0-.45.13,0,.27.02.44.07.21-.66-.05-.89-.26-1.17ZM1092.9,13.41c-.89.83-1.45.02-1.7-.77.97-.11,1.6.09,1.7.77ZM1091.19,13.02v.37c-.03-.15-.08-.28-.16-.38.05,0,.1,0,.16.01ZM1090.36,13.74c.24.05.51-.03.83-.33v.38c-.43,0-.51.31-.85.39,0-.14.01-.29.02-.44ZM1067.32,33.44c-1.68-.45,1.68-.45,0,0h0ZM1069.62,38.25c.06-.34.58-.29,1.02-.32,0,.1.02.21.03.31-.31.03-.65.04-1.05,0ZM534.33,110.64c-.01-.32-.02-.64-.02-.94-.43.3-.86.6-1.13.94h-3.25c-.05-.15-.05-.35.03-.62-.11.22-.24.42-.37.62h-1.42c1.27-1.05,1.66-2.83,3.76-3.2-.2,1.22-.5,1.47.79,1.94.95-.3,1.91-.59,2.76-.97.32.61.46,1.38.48,2.23h-1.65ZM669.49,110.64h-2.95c.89-.26,1.75-.58,2.39-.94.65.31.67.57.57.94ZM674.06,110.02h-.79c.08.23.18.44.33.62h-.87c-.59-.75-.36-2.34,1.33-1.91-.66.64.04.41,0,1.29ZM687.8,110.64c-.04-.16-.1-.29-.32-.29.03.09.04.19.06.29h-1.83c0-.17-.05-.37-.21-.62,1.2.02,2.01-.29,2.37-.97.49.51.71,1.04.82,1.59h-.89ZM946.84,101.29c-.98-.05-.12-1.09,0-1.29-1.93-.28-.96,1.8-3.16,1.29.63,3.53.78,6.39,1.05,9.35h-1.23c.03-.32.09-.63.18-.94-1.22-.15-1.6.39-1.96.94h-.06c-.5-.32-.76-.85-1.54-.94,4.6-.58,2.27-3.91,2.37-7.43-1.44-.85-3.47-1.51-5.53-.97.85-1.03,3.11-.9,5.13-.97.24-1.83-1.3-3.89-.4-5.17,1.88-.35-.39,2.69,1.97,1.94.47,1.89-.99,2.21-.79,3.88,1.95-.13,1.74-2.03,2.37-3.23.63,1.31,2.22,1.85,3.16,2.91-.9-.09-1.48.08-1.58.65ZM1053.82,50.54s.02-.08.02-.13c.02.04.05.08.07.13-.04,0-.06,0-.1,0ZM1055.77,40.81c-1.18-1.21.61-2.99.03-3.53.79-.63,1.38,0,1.7.84-.43,1.13-.16.97.45,1.86-.83.17-1.55.45-2.18.82ZM1065.28,40.8c-.13,0-.26.02-.4.04-.07-.39.2-.49.54-.55-.05.16-.1.33-.14.51ZM1067.62,45.52c-.1-.09-.18-.19-.23-.32.09.05.17.11.24.17,0,.05-.01.1-.02.15ZM1073.43,44.82c-.05-.07-.08-.15-.14-.21-.25.22-.31.41-.32.61-1.08-.8-2.9.07-3.75.14-.04-.02-.09-.04-.14-.06.06-.36.08-.74-.05-1.08-.31.14-.52.38-.65.68-.23-.19-.38-.44-.34-.84-.22,0-.43,0-.65,0,.34-.87.64-.28,1.64-.23-.04-.26,0-.44.11-.57.02.05.06.1.08.16.6-.81,2.4-2.33,3.95-1.29.15.98-1.44.55-1.58,1.29,0,.91,1.08-.77.79.65.7-.28,1.15-1.03,1.97-.32-.48.22-.71.64-.92,1.07ZM1074.75,42.78c.1-.09.17-.18.25-.27.06.08.11.16.15.25-.12.02-.24.03-.39.02ZM1078.69,39.87c-.16.08-.3.15-.45.2-.24-.53-.75-.82-1.54-.86.1.42.85.26.85.77-.47.56-.77.05-.97-.46.17-.29.09-.66-.26-.85.35-.49,2.68-.53,2.08.54.32-.33.56-.7.82-1.07-.1.44-.04.92.26,1.4-.35-.65-2.01-.08-.79.32ZM1124.44,59.64c-1.3,1.05,1.16-1.17,0,0h0ZM1122.66,59.62c-.12,0-.22.03-.36.02-.29-1.04.88-.75,1.28-1.16.06.68-.22,1.05-.82,1.13.56-.56.21-.28-.1,0ZM1124.01,61.18c0,.21-.11.5-.22.81-.14-.23-.24-.47-.26-.73.13-.03.29-.06.48-.08ZM1121.66,55.2c.05-.02.1-.06.14-.1.87.07,1.46-1.09,1.78-.09-.26.53-1.64.06-1.7.77.26.02.5.06.43.38-.3.02-.49-.05-.64-.17v-.79ZM1121.66,60.3c.46-.1.6-.18,1.49.11-.11.73-.3.97-.24.99-.21.72.46,1.76-.61,2.47-1.15-.46,0-2.01,0-2.7-.29.04-.49.08-.65.12v-1ZM1121.66,92.7v-.39c.07.1.14.25.22.46-.07-.03-.15-.06-.22-.07ZM1121.66,90.38v-.62c.05-.04.12-.08.22-.08-.07.23-.04.55-.22.69ZM1121.88,88.15c-.08-.03-.15-.08-.22-.12v-1.47c.23-.36.52-.66,1.08-.72-.11-.19-.24-.33-.38-.44.72-.41,1.57-.45,2.07.44-1.51.17-1.12,2.07-2.56,2.31ZM1124.01,84.68c-.31-.41-1.66-1.78-.43-2.31.1.6,1.64,1.8.43,2.31ZM1125.71,63.87c-.09-.43-.47-.6-.85-.77.65,2.12-1.36,2.49-3.14,2.25,1.1-.18,1.88-.81,1.44-2.25.12.06.24.11.36.18.04.25.17.47.49.59,0,0,0,0,0,0,0,0,0,0,0,0,.18-.11.29-.23.36-.34.73-.96-.5-2.25.91-2.74-.48,1.36,1.79,2.19.43,3.08ZM1130.82,50.84c.5-.24,1.08-.29,1.71-.07-.35,2.25-1.83,3.48-2.98,5.01-.24-.53-.35-1.08-.38-1.62.75-.93,1.41-1.93,1.65-3.32ZM1131.68,57.71c-.18,1.28-1.36,1.65-2,2.51-.04,0-.09.01-.13.02.02-1.47.29-2.71,2.13-2.53ZM1129.98,61.18c.02.66-.33.99-.85,1.16-.02-.66.33-.99.85-1.16ZM1128.7,88.92c-1.41-.56,1.66-.96,0,0h0ZM1129.55,64.64c-.12-.88.1-1.45.85-1.54.67.57.47,1.72-.85,1.54ZM1131.25,60.79c-1.41-.56,1.66-.96,0,0h0ZM1131.68,89.69c.18.16-.28-.25,0,0h0ZM1131.68,90.46c-1.69-.45,1.68-.45,0,0h0ZM1132.11,80.83c.35-.97-.83-3.32.85-3.08-.03,1.25-.22,2.37-.85,3.08ZM1132.53,75.43c-.03.67.1,1.2.43,1.54-1.19.62-1.18-1.66-.43-1.54ZM1135.09,50.01c-.07.45.07,1.09-.43,1.16.07-.45-.07-1.09.43-1.16ZM1135.94,75.43c-.58.55-.91.08-1.7-.03v-1.12c-.11-.09-.24-.17-.39-.23.62-.31,1.6-.18,2.09.23v1.15ZM1137.31,53.86h1.19c-.5.1-.88.09-1.19,0ZM1138.51,52.32c-1.11-.11-1.39.52-1.28,1.51-.4-.15-.63-.45-.74-.83.17-.32.67-.55,1.17-.68-.28-.4-.64-.72-1.08-.98.06-.2.14-.39.22-.56,1.16.24,2,.76,2.56,1.54-.18.05-.36.11-.52.18-.07-.1-.17-.16-.32-.18ZM1140.63,53.86h-1.7c-.01-.26.02-.55.01-.82.12-.51.48-.8,1.26-.72.63.07.39.93.42,1.54ZM1140.8,50.16c-.24-.28-.51-.09-.65.2-.36-.09-.57-.31-.98-.35.13-.33.2-.71.62-.78-.06-.12-.17-.22-.32-.29.7-.29,1.77-.21,2.01.29-.48.08-.51.57-.69.93ZM1142.76,50.78c-2.02,1.4-.57-2.26,0,0h0ZM1143.61,68.88c-.04-.21-.04-.39-.02-.55.52-.25.95-.59,1.19-1.1.55-.14,1.22-.18,1.81-.28-.36,1.21-1.64,1.6-2.98,1.92ZM1147.02,78.52c-1.66-.96,1.41-.56,0,0h0ZM1148.3,56.94c.12.88-.1,1.45-.85,1.54.1-.68-.43-1.93.85-1.54ZM1147.45,76.59c.1-.3.01-.76.43-.77-.1.3-.01.76-.43.77ZM1147.88,63.49c-.12-.88.1-1.45.85-1.54-.1.68.43,1.93-.85,1.54ZM1148.73,56.94c.07-.58-.15-1.42.43-1.54,0,.51.75.35.85.77-.67.04-.33.98-1.28.77ZM1150.43,54.24c-.34-.05-.64-.31-.87-.67.01-.16.01-.32.02-.48.36-.07.4.15.43.39.94-.87-.05-1.48-.87-2.11.11-.47.38-.85.86-.97.25,1.08,3.11,1.79,1.71,3.08-.02-.23-.07-.46-.43-.39-.04.61.06,1.34-.85,1.16ZM1152.14,60.02h-.85v-1.15h.85v1.15ZM1155.12,66.19s0,0-.01.01c.04-.04.09-.08.13-.12-.04.03-.07.06-.12.11ZM1166.2,66.19c-.68.8-.93,1.99-2.13,2.31.4-1.02.16-.95.04-1.76.1-.16.2-.31.32-.46.92.11,1.71-.86,1.77-.1ZM1166.2,70.42c.18.16-.28-.25,0,0h0ZM1155.97,94.31c.18-.74.15-1.66,1.28-1.54.12,1.01-.15,1.66-1.28,1.54ZM1157.68,82.37c.49,2.47-1.3.84,0,0h0ZM1158.53,55.01c-.02-.66.33-.99.85-1.16.02.66-.33.99-.85,1.16ZM1159.81,85.45c-.12-.22-.91-1.29-.18-1.5.08.1.15.2.19.34.07-.02.13-.04.19-.06.27.45.6,1.18-.2,1.22ZM1161.09,87.37h-.85v-.77h.85v.77ZM1161.51,84.29c-.24-.78-1.28-.76-.43-1.54-.5-.06-1.19.06-1.27-.37,0,0,0,0,0-.01h1.7c-.26.69,1.25,1.6,0,1.93ZM1161.51,68.5c-.02-.66.33-.99.85-1.16.02.66-.33.99-.85,1.16ZM1163.22,87.37c-1.43.93,1.03-1.29,0,0h0ZM1163.65,65.03c1.72-1.94,2,1.34,0,0h0ZM1165.35,68.88c.1.86-.09,1.46-.84,1.54-.17-.15-.07-.06,0,0-.13.01-.27.02-.43,0-.12-1.01.15-1.66,1.28-1.54ZM1164.07,81.98c.6-.88.09-4.78.85-4.24-.02,1.96.9,3.34-.85,4.24ZM1164.92,72.74c.81.09.94-.43,1.7-.39.11,1.13-1.65,1.48-1.7.39ZM1167.05,81.98c-1.43.93,1.03-1.29,0,0h0ZM1217.35,55.78c.52-.56,1.19-.99,1.29-1.92.87-.12.05,1.29.8,1.27-.6.95-1.14,1.96-1.68,2.97-.5-.01-1.04-.09-1.58-.21.38-.71.76-1.42,1.16-2.1ZM1216.92,52.32c-1.43.93,1.03-1.29,0,0h0ZM1215.67,54.05c.33,0,.72-.02,1.26-.11-.14.88-.78,1.31-1.29,1.85-1.14-.3,0-1.08.03-1.74ZM1212.66,43.46c1.59-.16,1.31,1.15.42,1.54-.13-.52-.61-.74-.42-1.54ZM1212.23,45.77c.02.49.55.53.43,1.16-1.05.6-1.25-1.31-.43-1.16ZM1213.51,48.08c-.51,2.13,2.05,1.48,1.71,3.47-1.67.22-1.09-1.59-2.13-1.93,0,.24.04.45.08.66-.61-.59-1.69-.75-1.34-2.2-.37.1-.61.08-.81.02.1-.14.21-.28.37-.4,1.03-.16.93.7,2.13.39ZM1210.06,72.39c-.39.27-.75.47-.81-.04.26-.02.5-.06.43-.39-.15-.04-.34-.05-.51-.08-.09-.08-.2-.16-.31-.23,0-.03-.03-.04-.03-.08.41-.39,1.2-.26,1.76.1-.26.15-.48.42-.52.72ZM1210.52,73.12c-.1.3,0,.76-.42.77.1-.3,0-.76.42-.77ZM1207.95,68.45c0-.1-.01-.21.02-.34,1.06-.06,1.77.2,2.13.77-.43.42-1.39.51-1.87.12.06-.04.13-.07.18-.12-.11-.18-.27-.31-.45-.43ZM1209.31,52.65c-.23.08-.52.11-.91.05.09-.68.35-1.21.74-1.62,0,.43-.07.85-.31,1.24.14.13.3.24.48.33ZM1210.52,56.55c-.54.97-2.43-.74-1.28-1.16.05.73,1.41.27,1.28,1.16ZM1210.1,71.2c.26-.85-.36-.91-.83-1.11,0-.14,0-.27-.02-.43h1.7c.12.88-.1,1.45-.85,1.54ZM1210.25,54.81c.11-.05.21-.11.29-.18.02-.45-.29-.71-.71-.85.59-.24,2.46-.22,2.4.85-.43.39-1.37.48-1.98.18ZM1212.19,60.19c-.04-.27-.06-.51-.04-.71.14.18.13.44.04.71ZM1212.05,58.48c-.25-.03-.49-.03-.7,0-.6-.48.15-.95.7,0ZM1211.8,68.11c.07-.58-.15-1.42.42-1.54,0,.76,1.16.49.85,1.54h-1.28ZM1213.08,71.97c-.67.03-.33.98-1.28.77-.37-.79,1.1-1.73,1.28-.77ZM1211.83,52.95c.23-1.45-.43-2.1-.44-3.33,1.03.34.48,2.12,2.1,1.93.1.43.14.91.02,1.54-.63.02-1.19-.03-1.68-.14ZM1209.67,44.23s-.04.02-.07.02c-.05-.04-.11-.08-.17-.12.08.02.16.04.24.09ZM1208.79,44.35c-.17.44-.66.58-.39,1.42-.17.04-.34-.03-.49-.15.28-.51.56-1,.88-1.27ZM1205.84,39.22c1.5,1.56-1.37.91,0,0h0ZM1205.41,38.06c-1.68-.45,1.69-.45,0,0h0ZM1204.98,46.54c.39-.13.58-.09.69.02-.21.32-.43.6-.68.75-.07.02-.13.04-.19.05.16-.19.23-.45.18-.82ZM1203.15,70.75c.38.46.66.93.02,1.12-.21-.26-.36-.58-.32-1.07.11-.03.2-.04.3-.06ZM1201.9,69.25c.16.27.42.45.93.4-.09.43-.34.71-.83.77-.33-.28-.38-.81-.1-1.17ZM1202.85,75.43c-.7,0-.24,1.07-.85,1.16.46-.98-1.83-1.35-.43-1.93,0,.64,1.18.22,1.28.77ZM1200.3,71.58c1.05.04.09,1.27-.43,1.16-.02-.49-.55-.53-.42-1.16h.85ZM1200.3,50.39c.18.16-.28-.25,0,0h0ZM1200.72,73.51h.85v.77h-.85v-.77ZM1201.57,46.92s-.39-.02-.43,0c-2.31,1.83.79-1.85.43,0ZM1195.21,46.65c.02.1.02.19.02.27-.02,0-.03,0-.05,0,0-.09.02-.18.02-.27ZM1195.19,50.01c1.27.21,2.11-.6,2.42.02-.22.02-.47.03-.73-.02-.38.88.08,2.25-.85,1.54.88-.52-.46-.91-1.04-.44.03-.34.05-.76.2-1.1ZM1197.74,53.47h-.85v-.77h.85v.77ZM1198.59,74.28c-.59-.02-.93.18-1.28.38v-.77c.61-.43,1.04-.42,1.28.39ZM1196.04,71.58c.55.51.56,1.43-.43,1.54.07-.58-.15-1.42.43-1.54ZM1195.61,58.1c-.2-.75,1.15-1.97,1.28-1.16-.81.04-.29,1.27-1.28,1.16ZM1196.04,53.47v-.33c.42,0,.82.11,0,.33ZM1194.59,51.33c-.1-.14-.18-.26-.24-.38.22.07.35.21.24.38ZM1193.18,51.23c.43-.07,1.35.03.3.31-.19-.05-.31-.09-.39-.13.02-.07.05-.13.09-.18ZM1193.05,53.86c1.05.34,2.46.35,2.56,1.54-.85.39-.67,1.7-2.13,1.54,0-.29-.11-.57-.24-.82.17-.28.35-.57.67-.72-.06-.69-.55-.98-1.16-1.17.07-.12.16-.25.3-.37ZM1191.43,61.73c.35-.49.83-.85,1.62-.94-.14,1.47,1.43,3.98-.43,4.62-.38.02-.64-.25-.95-.6.42-.78-.05-2.02-.25-3.09ZM1191.77,59.64c-.02-.24-.06-.46-.43-.39,0,.39.35.46.43.77-1.52-.16-1.2-2-1.28-3.47,1.27.03,2.08,2.46,1.28,3.08ZM1190.04,59.44c-.06.06-.14.11-.26.15-.07-.09-.13-.19-.13-.34.25-.05.35.05.39.19ZM1189.53,62.03c-.31.56-.5,1.22-.74,1.84.18.09.33.19.48.29-.02.03-.03.07-.06.09-.79-.23-1.09-.69-1.33-.84.17-1.13-.47-2.6.06-3.01-.07-.05-.16-.06-.25-.09.84-.13,1.49-.2,1.94.09-.32.25-.21.9-.1,1.62ZM1186.38,55.35c.18-.15.4-.28.71-.33,1.28.23,1.84.89,1.82,1.57-.04,0-.07-.03-.11-.03,0,.17.01.34.01.51-.15.36-.45.7-.88.96-.02-.11-.03-.21,0-.32-.36.04-.48.27-.49.55-.24.09-.5.17-.79.22-.14-.14-.26-.31-.37-.49,1.12-.72,1.3-1.99.08-2.64ZM1187.15,64.12s-.05.09-.07.14c-.05-.08-.08-.16-.11-.23.06.03.12.06.18.09ZM1185.76,62.37c-.13.2-.27.39-.38.59-.01-.17.08-.38.38-.59ZM1185.79,64.72c-.33.03-.6.07-.84.08v-.54c.33.24.59.38.84.46ZM1179.01,66.43c.38-.12.7-.3.8-.68,1.09-1.07,1.97-2.54,2.18-3.81-.21-.01-.38.02-.52.07.35-.47.7-.94,1.05-1.42.12.03.23.09.32.2.21-.4.49-.96.72-1.52.34-.42.71-.82,1.09-1.21.1.16.21.31.33.43.2-.03.38-.08.55-.13-.15.82-.67,1.81-.99,2.45-.64-.8-2.27.75-2.55,1.54.8.09.94-.43,1.71-.39-.42,2.62-3.71,6.08-5.78,5.1.37-.14.75-.35,1.11-.61ZM1183.68,85.45c0-1.02-.16-2.2.42-2.7-.38.27-.68.36-.92.21.02-.2.04-.41.08-.59h1.7c-.24,1.19.12,2.93-1.28,3.08ZM1184.95,88.53c-.43,0-.51.31-.85.38,0-.39-.35-.46-.42-.77.43,0,.51-.31.85-.38,0,.39.35.46.43.77ZM1183.25,83.52s-.07.01-.11.02c.01-.15.02-.29.03-.44.07.1.11.23.08.42ZM1181.12,81.21c-1.17-1.17,1.3,1.05,0,0h0ZM1179.84,67.73c-.1.3-.01.76-.43.77.09-.3.01-.76.43-.77ZM1178.14,75.43c-3.29.06,1.37-.91,0,0h0ZM1177.71,76.2c-.09.3-.01.76-.43.77.1-.3.01-.76.43-.77ZM1177.69,70.76s.02.03.02.04c0,0,0,0,0,0,0-.02,0-.03-.02-.05ZM1178.56,71.97c-1.66-.96,1.41-.56,0,0h0ZM1178.56,68.88c-1.68-.45,1.68-.45,0,0h0ZM1178.14,65.42s0,0,0,0c0,0,0,0,0,0,0,0,0,.01,0,.02,0,0,0-.01,0-.02ZM1177.28,54.63c1.62-.78,1.69,1.75.85,1.93-.18-.73-1.22-.7-.85-1.93ZM1176.43,54.24c-.03.08-.04.18-.05.28-.08-.02-.16-.04-.26-.04.05-.13.12-.23.31-.24ZM1176.43,67.34c.45-.02,1.08.18.43.38-.26.02-.51.06-.43.39.51.02,1.02.45,1.34.97-.16.07-.33.14-.54.17-.09-.15-.21-.28-.38-.36-.45.18-.25.96-.49,1.33.06-.4-.09-.87-.38-1.27,0-.67.06-1.28.44-1.61ZM1168.54,73.97c-.05-.1-.1-.19-.15-.27.18-.65.22-1.43.8-1.73-.01,1.65.91.92,1.28,2.7-1.23.3-1.32-.43-1.92-.7ZM1170.38,78.21c-.05.16-.15.28-.34.3.05-.32,0-.72.13-.95-.02.26.03.48.22.65ZM1169.19,50.39c-.1.3-.01.76-.43.77.09-.3.01-.76.43-.77ZM1168.33,68.11c.3-.07.5-.05.64.03-.2-.02-.42-.02-.63-.03.08.31.43.38.43.77h.47c.02.48-.04,1.03.37,1.16h-.85c-.26-.02-.5-.06-.43-.39,1.1-.09-.58-.66,0-1.54ZM1168.76,75.82c-1.68-.45,1.68-.45,0,0h0ZM1170.04,80.06c-1.66-.96,1.41-.56,0,0h0ZM1169.62,82.37s0,0-.01,0v-1.54c.55-.06.76.18.9.49-.09.1-.1.16.04.09.16.4.24.88.77.95h-1.7ZM1171.31,68.88h-.85c0-.39-.34-.46-.43-.77.67.04,1.48-.05,1.28.77ZM1172.05,75.5c.01.13-.05.24-.13.38-.04-.15-.09-.3-.18-.45.12.02.22.04.31.07ZM1171.95,76.86c.24-.13.52-.24.88-.26,0,.15-.02.3-.04.46-.07.2-.08.37-.05.51-.02.37.01.71.27.95-1.46-.14-1.18-.81-1.07-1.66ZM1172.59,81.21c-1.43.93,1.03-1.29,0,0h0ZM1172.59,79.67c-1.41-.56,1.66-.96,0,0h0ZM1174.58,76.85c.04-.08.09-.17.14-.26-.15,0-.28,0-.4.02-.24-.24-.46-.5-.7-.74.15-.26.24-.43-.18-.82,1.23.01,1.75.67,2.31,1.29-.12.16-.11.43-.17.64.27,0,.33-.21.36-.44.15.16.3.31.48.44-.6.1-.49.84-.85,1.16.2,0,.36.04.49.1-.45.22-.57.74-.49,1.44-.26-.2-.4-.5-.56-.78.03-.72-.81-.94-.54-1.8.07-.05.14-.09.25-.11-.05-.04-.1-.09-.15-.13ZM1176,98.16c.1-.3.01-.76.43-.77-.1.3-.01.76-.43.77ZM1176,99.7c-2.59-.12,1.63-.75,0,0h0ZM1174.92,102.03c.37-.18.74-.36,1.09-.4,0-.15,0-.26-.02-.35,0-.01.01-.02.01-.04,0,0-.01,0-.02,0-.06-.22-.21-.26-.41-.24,0-.04-.01-.08,0-.14,1.04.81,2.19-.61,2.13.77-.97.09-2.15,1.35-2.79.4ZM1176.25,79.96c.19-.3.43-.57.55-.93.13.24.27.47.48.64-.12-1.01.16-1.66,1.28-1.54.2,1.21-.61,1.51-.85,2.31-.7.03-1.06-.24-1.46-.48ZM1179.08,83.53c-.84-.04-1.05-.65-.95-1.55.69-.07.94.25,1.08.67-.08.21-.11.49-.13.88ZM1179.41,70.81c-.22-.57-.63-.97-.85-1.54.59.02.94-.18,1.28-.39-.23.56.5,1.99-.43,1.93ZM1180.77,83.68c.25-.07.51-.12.78-.15.09-.52-.26-.64-.69-.69.05-.2.12-.36.26-.47,0,.02.02.02.02.04.23.72.62.76,1.17.41.01,0,.03,0,.04,0-.23.24-.33.6-.37,1.03-.4.18-.71.44-.86.84.28.31.58.34.86.3,0,.16,0,.32,0,.47.46-.05.72-.28.88-.6.17.05.3.21.39.6-1.6.3-.03,1.35-.85,1.92-.46-.13-1.02-.18-1.46-.32.07-.25-.05-.52-.11-.78.42-.23.85-.46,1.14-.82-.21-.03-.35-.12-.48-.23-.11-.32-.28-.4-.48-.4-.09-.06-.19-.12-.32-.15.04-.4.06-.72.08-1ZM1183.25,88.92c-.09.3-.01.76-.43.77.1-.3.01-.76.43-.77ZM1181.12,88.92c-1.41-.56,1.66-.96,0,0h0ZM1185.8,91.61c-.75.61-2.27.52-3.41.77-.02-.08-.03-.15-.03-.23.69-.08,1.33-.21,1.74-.54.18-.75-1.01-.34-1.47-.3.6-.82,2.02-1.2,2.32-.86-.04.03-.07.06-.11.09-.26.06-.41.13-.24.2-1.56,1.36,1.48-.31,1.2.87ZM1185.2,67.91c.24,0,.46,0,.66.05-.27.01-.5,0-.66-.05ZM1186.04,61.71c-.32.25-.2.12,0-.07,0,.02,0,.05,0,.07ZM1186.66,66.96c.04-.26,0-.46-.07-.63.28-.42.56-.84.5-1.57.43-.05.95-.11,1.69-.12.09.7-.13,1.11-.38,1.49-.88,0-.59,1.06-1.32,1.2.12.39.24.55.39.61-.37-.06-.83-.03-1.26,0-.03-.19-.04-.37-.03-.53.22-.15.42-.33.47-.46ZM1187.94,68.11c-.09-.06-.2-.1-.33-.13.09,0,.19-.03.3-.07.01.07,0,.13.02.2ZM1187.08,90.84c-2.59-.12,1.63-.75,0,0h0ZM1186.66,83.91c.51-.06.45-.62.43-1.15,0,0,0,0,0,0,0,0,0,0,0,0,0-.13-.01-.26,0-.38,1.07.49,1.33-.2,1.71.38-.79.1-1.5,2.19-2.13,1.16ZM1189.21,91.61c-1.43.93,1.03-1.29,0,0h0ZM1189.21,90.46c-.92-.24-.33-.35.11-.33.09.06.15.14.18.23-.07.03-.17.06-.3.1ZM1188.93,67.71c.09,0,.18,0,.29.01-.12-.12-.2-.28-.27-.45.58-.3.28-1.4,1.54-1.09-.03.67.1,1.2.43,1.54-1.17-.17-1.63.66-1.98-.01ZM1190.92,88.15c-.28-.25.18.16,0,0h0ZM1192.2,92c-1.54.37-.43-1.66-1.28-1.93.39-.05.66,0,.85.13-.34.22-.6.64-.42,1.03.36-.09.54-.33.78-.53.11.35.1.81.06,1.3ZM1192.62,69.27c0-.5-.71-.36-.84-.75.15,0,.29,0,.42-.02-.02-.07-.04-.1-.06-.16.74-.36,1.49-.98,1.75.16-.5.06-1.21-.07-1.28.38.24,0,.48.31,0,.39ZM1193.48,83.91c.13.52.61.74.43,1.54-1.19.62-1.18-1.66-.43-1.54ZM1193.48,86.22c-.11,1.15,1.19,2.34-.43,2.7.62-1.33-.47-1.82.43-2.7ZM1194.26,90.48c-.12-.27-.38-.39-.78-.02.06-.06.15.11.22.34-.19.17-.36.36-.66.43-.37-.79,1.11-1.73,1.28-.77-.03,0-.04.02-.07.02ZM1195.18,58.1c.37.68,1.35,1.13.43,1.93-1.32.15-1.74-1.86-.43-1.93ZM1195.18,66.57c-1.17-1.17,1.3,1.05,0,0h0ZM1195.18,68.88c.18.16-.28-.25,0,0h0ZM1195.61,91.61s-.26-1.3-.43-1.16c1.02-.92,1.1,1.26.43,1.16ZM1196.89,82.37c-.58-1.02.49,1.41-1.7.77.1-.4.13-.67.11-.88.55-.58.17-1.47-.39-2.14.18-.33.38-.64.7-.83.86.4,2.36,2.2,1.28,3.08ZM1198.17,76.2c-.53.11-.38.84-.41,1.4-.55.14-1.13.02-1.1-.3.09-.08.18-.17.23-.28.05.19.34.35.42-.05-.13-.04-.25-.09-.35-.15.04-.18.02-.38-.07-.62-.13-.08-.27-.16-.42-.22,0-.06-.02-.1-.02-.17.99-.12,1.64.06,2.13.38.03.09.05.17.07.25-.2-.11-.38-.21-.48-.25ZM1198.23,49.91c-.06-.9-.49-2.15.8-1.83-1.5-.71-2.52-1.85-3.17-3.32.31-.33.77-.53,1.45-.53.38,1.04.95,1.91,1.68,2.63-.45.44-.7.93.25.23.44.38.92.73,1.48,1-1.95-.47.04,2.6-1.28,2.7-.04-1.23-.46-1.04-1.22-.86ZM1200.72,78.9c-.26.02-.5.06-.43.38h-.85c-.66-.95,1.44-1.13,1.28-.38ZM1201.15,76.97c-1.38-.48-.33,1.25-1.7.77.03-.23.01-.51.01-.77.58.32.4.19,0-.05.01-.35.08-.66.41-.73.1.04.28.14.48.25-.01.04-.02.09-.04.13.07,0,.12-.04.16-.07.7.4,1.58.95.68.45ZM1201.74,82.33c.1,0,.19.02.27.04-.09-.16-.23-.3-.39-.42.64-.56,1.71-.24,2.09.42-.49-.17-1.56.2-1.96-.04ZM1203.43,68.81c.57-.3.35-.52-.14-.65,0-.02,0-.03-.01-.05.87-.22,3.2.12,1.71.77-.02-.23-.06-.45-.43-.38v1.16c-.77.08-1-.34-1.13-.84ZM1204.98,78.9c-1.16-1.96,1.49-1.43,0,0h0ZM1205.84,73.12c-.74-.03-1.33.09-1.71.39,0-.14-.02-.27-.05-.38.02,0,.04,0,.06,0,.1-.33.25-.75.34-1.18,1.33-.13.61-.91.07-1.52h.85c.03-.23.06-.46.43-.38.07.06.11.13.16.2-.2.32-.1,1.03.27.77.05.71-.25,1.53-.43,2.11ZM1205.14,51.26c1.01-.27,2.03-.96,2.84-2.03-1.15-1.44.8-2.6,1.65-3.61.15.12.31.18.47.14-.35-1.09.6-1,.42-1.93.16.06.3.13.43.19.08.38.34.59.44.96.11-.05.21-.11.3-.18.04.44-.41.91-.94,1.41-.1-.12-.2-.25-.21-.46-.52-.1-.63.64-.37,1.03-.37.39-.69.79-.8,1.23-.42.55-.38,1.22-.31,1.92-.21.2-.42.38-.65.55,0-.04,0-.07,0-.11-.37.16-.66.38-.91.64-.8.36-1.61.44-2.35.24ZM1207.54,54.63h.75s.07.05.11.07v.7h-.85v-.77ZM1207.76,70.16c.23.08.45.17.58.34-.72,1.31-.94-.03-.58-.34ZM1207.97,75.43c.82-.16.34-1.49,1.71-1.15.32.98-1.63,1.81-1.71,1.15ZM1208.82,81.6c-1.68-.45,1.68-.45,0,0h0ZM1209.25,76.97c-.24,1.16.66,1.2.1,1.81-.3-.2-.61-.4-.8-.71.13-.42.57-.92.8-1.37.45-.37.9-.74,1.59-.89.6.41-.03,1.11-.44,1.75-.19-.33-.55-.57-1.26-.6ZM1211.39,79.28c-.28.04-.35.25-.38.51-.09.02-.19.04-.3.07-.05-.31-.02-.68,0-1.05.08.03.15.06.25.08.8-.74-.25-.7,0-1.93,2.46.1.84,2.66,1.71,3.47.07-.45-.07-1.09.42-1.16.88.68.37,1.19.85,1.54.33.09.84.01.85.38h-1.7c-.01-.37-.52-.3-.85-.38-.48-.35.03-.86-.85-1.54ZM1213.91,61.95c.34-.04.64,0,.81.19-.3.08-.58.17-.78.2.03-.16.01-.28-.02-.39ZM1213.93,81.6c-.1.3-.01.76-.43.77.1-.3.01-.76.43-.77ZM1212.23,86.22c-1.66-.96,1.42-.56,0,0h0ZM1212.23,92v-5.39c1.76.57,2.58,5.29,0,5.39ZM1213.08,83.14c1.07-.07,1.04.86,1.7,1.15-.59.57-2.03.2-1.7-1.15ZM1214.79,81.98c-1.68-.45,1.69-.45,0,0h0ZM1214.36,63.1c1.39-.1,1.23,1.2,2.13,1.54-1.25-.03-1.58-.88-2.13-1.54ZM1215.49,61.96c.13-.45.18-.97.16-1.55-.62-.71-1.86-1.47-2.96-1.8,1.12-.6,3.66.66,4.66,1.8.04,1.19-.19,2.14-.85,2.7.27-1.1-.3-1.25-1-1.14ZM1217.77,84.29h-.85v-.77h.85v.77ZM1217.77,82.75c-2.59-.12,1.63-.75,0,0h0ZM1219.05,64.64c-1.42-.56,1.66-.96,0,0h0ZM1247.55,55.62c.24-.32.5-.62.77-.92.16.11.34.22.56.29,0,0,0,.01,0,.02-.21,1.22,2.11.14,1.7,1.54-.5.96-2.16,1.02-3.27.87.68-.1,1.3-.35,1.57-.87.29-.97-.75-.75-1.34-.93ZM1247.61,60.02c-.42-.14-.59-.5-.77-.86.32-.29.71-.52,1.18-.68.58.38.55,1.3,1.28,1.54,0,0,0,0,0,0-.21.01-.29.15-.32.31-.79,1-.61,2.89-3.08,2.38,0-.05,0-.1-.01-.15.9-.56.86-1.96,1.73-2.55ZM1246.2,66.68c.03.1.05.19.07.28-.75-.05-.9.43-1.65.39-.1-.15-.12-.28-.11-.39.04,0,.07,0,.12,0,.01-.07,0-.13-.04-.18.29-.37,1.26-.37,1.61-.09ZM1245.47,78.9c-.1.3-.01.76-.43.77.1-.3.01-.76.43-.77ZM1241.64,52.7c1.05-.6,1.25,1.31.43,1.15-.02-.23-.06-.46-.43-.38v-.77ZM1242.51,57.71c-.06-.68-.15-1.39.02-1.85.32.75,1.39,1.58-.02,1.85ZM1242.91,63.87c.81-1.47-1.13,2.04,0,0h0ZM1242.49,66.57c-.28-.25.18.16,0,0h0ZM1242.49,58.87c.02-.07.02-.15.03-.22,0,.09,0,.16-.02.22,0,0,0,0,0,0ZM1240.78,68.11c-1.68-.45,1.68-.45,0,0h0ZM1240.36,65.8c.34.13.51,1.02,0,1.16-.99.25-.92-1.51,0-1.16ZM1239.51,55.03c.1-.56.46-.87,1.27-.79.09.17.57.83.48,1.23-.01-.03-.03-.05-.04-.08-.17.07-.27.21-.35.37-.03,0-.05.02-.09.02-.07-.45.08-1.09-.42-1.16-.21.45-.46.87-.85,1.16,0-.06,0-.11-.01-.17.12-.14.1-.36.02-.58ZM1229.71,45.77c0-.05-.02-.1-.04-.14.59-.17,1.61-.75,1.73.14-.75.35-1.25.93-2.13,1.16.17-.29-.01-.56-.2-.79.2-.13.41-.26.64-.37ZM1228.42,45c-.02.15-.02.32-.03.49-.13.05-.25.09-.37.13.02-.31.08-.57.4-.61ZM1230.14,52.32c-.27-1.87-1.44-3.46.43-4.62-.04-.02-.07-.02-.1-.04.51-.26,1.07-.32,1.8.04-.82.51-1.05,1.1-1.04,1.76-.19-.1-.41-.18-.66-.22.07.45-.09.69-.43.77.82.24,1,1.05,1.54,1.54.06.25.12.51.16.77-.63.19-1.15.49-1.67.78,0,0-.01,0-.02,0,0,.01-.02.02-.02.03-.7.38-1.44.73-2.54.74-.03-.12-.04-.22-.05-.32.93-.36,1.62-.93,2.62-1.22ZM1226.51,46.06c.15-.13.18-.36.19-.62,0-.02.01-.04.02-.06.16.11.28.23.39.34.03.13.17.27.3.44.47,1.04-.48,2.21-.94,3.32-.34.22-.71.39-1.13.47.67-1.05.83-2.56,1.18-3.9ZM1227.2,51.36c-.06.54-.46.78-.82,1.05.19-.43.54-.71.82-1.05ZM1225.2,50.14c.17-.03.38-.06.67-.13.01.09,0,.15,0,.23-.2.02-.46.07-.86.16.07-.08.13-.17.19-.25ZM1225.46,57.72s0,0-.01,0c0,0,0,0,0,0,0,0,0,0,0,0ZM1224.59,62.33c-.02-.23-.06-.46-.43-.39v-.77c1.05-.6,1.25,1.31.43,1.16ZM1220.34,53.86c.03-.44,0-.92,0-1.39.48-.13,1.01-.21,1.69-.15,0,1.02.16,2.2-.42,2.7-1.51.6-.27-1.29-1.27-1.16ZM1220.75,93.93c.1-.3,0-.76.42-.77-.1.3,0,.76-.42.77ZM1222.88,90.46c-1.2-.32-1.1.54-2.13.39-.08-.16-.1-.31-.07-.45.14,0,.3,0,.5.06.05-.25,0-.43-.1-.57.7-.45,2.01-.41,1.8.57ZM1222.88,85.83c.1-.3.01-.76.43-.77-.1.3-.01.76-.43.77ZM1223.31,84.68c.04-.43-.62-.6,0-.77.43,0,.53.68,0,.77ZM1224.16,52.32c-1.3,1.05,1.16-1.17,0,0h0ZM1224.16,65.42c.89-.43.9-.42.43.38,1.24.43-.66.42-.43-.38ZM1226.72,90.07c-.96.11-1.58-.09-1.7-.75v-.02c.84-.01.54-1.05,1.7-.77v1.54ZM1226.29,55.01c.1-.3.01-.76.43-.77-.09.3,0,.76-.43.77ZM1229.7,73.89c.14-.9.44-1.66,1.28-1.93-.4.67.01,2.07-1.28,1.93ZM1232.26,78.52c-1.41-.56,1.66-.96,0,0h0ZM1232.69,67.73c-1.43.93,1.03-1.29,0,0h0ZM1226.81,60.06s.02-.01.03-.02c1.25.25,1.22-.5.92-1.23.96-1.71,1.88-4.17,4.51-3.8-.42-.34-.65-.85-.99-1.27.22-.19.41-.41.55-.66,1.25.16,1.38,1.32,2.13,1.93-4.47-.62-4.01,6.87-7.16,5.05ZM1231.96,50.06s-.04-.06-.07-.08c.29-.1.43-.33.37-.75.45.08.8.26,1.08.5-.3.24-1.07.97-.21.28.12-.12.19-.2.24-.25.58.51.84,1.31,1.03,2.18-1.48-.02-1.4-1.45-2.43-1.87ZM1234.82,50.01c-1.3,1.05,1.16-1.17,0,0h0ZM1235.67,70.42c.18.16-.28-.25,0,0h0ZM1237.37,76.59c-.84-.22-.43-.33,0-.33.01.11.04.21.09.31-.03,0-.05.02-.08.02ZM1237.59,75.1c-.91.17-2.33-.42-1.07-.83,0,.56.91.3,1.2.6-.05.07-.09.14-.13.22ZM1238.23,53.09c-1.66-.96,1.41-.56,0,0h0ZM1239.5,68.88c-1.66-.96,1.41-.56,0,0h0ZM1239.08,76.35c.11-.08.24-.15.43-.15-.02-.26-.21-.37-.44-.44.15-.89.88-1.77,1.28-1.1-.26.02-.5.06-.43.39-.13.89,1.23.43,1.28,1.15-.85,0-.54,1.05-1.7.77-.24-.14-.37-.37-.43-.62ZM1240.36,82.75c-.69-.21-1.15-1.25-.54-1.71.24.14.54.23.92.24.44.56.77,1.23-.38,1.47ZM1242.49,100.86c.1-.3.01-.76.43-.77-.1.3-.01.76-.43.77ZM1242.5,80.83c-.02.19.02.34.07.47-.48,0-.83-.11-1.11-.28-.19-.2-.38-.4-.6-.57-.18-.24-.34-.51-.51-.76,1.34,0,2.06.56,2.68,1.22-.16,0-.34-.02-.54-.06ZM1242.06,73.12c.73-.02,1.09.3,1.28.77-.73.02-1.09-.3-1.28-.77ZM1242.91,78.9c-1.68-.45,1.68-.45,0,0h0ZM1242.06,71.2c.03-1.25.54-2.08,1.7-2.31-.24,1.07.04,2.61-1.7,2.31ZM1243.34,65.8c-1.68-.45,1.68-.45,0,0h0ZM1243.34,61.95c.55-1.07.26-1.63-.26-2.44,0-.09,0-.17,0-.26.63-.02,1.3,0,1.11-.76-.5-.05-.74.12-1.03.26.32-1.3,1.26-2.48-.61-2.94.08-.18.18-.32.36-.4.09.3.36.45.85.39.23.56-.5,1.99.43,1.93,1.47-.28.28-1.16,0-1.93.69.16,1.01.41,1.13.72-.11.25-.21.52-.27.82.07.02.16.03.24.05-.18.66-.57,1.43-.52,2.2-.19.25-.34.54-.44.87-.15.08-.16.22-.09.4-.09.43-.11.91-.07,1.45-.11-.27-.36-.4-.83-.34ZM1244.62,97.78c-1.68-.45,1.68-.45,0,0h0ZM1245.9,86.99c-.43,0-.51.31-.85.38.02-.53-.2-.84-.43-1.15h1.28v.77ZM1246.75,81.98s-.08-.01-.12-.02c.09-.15.06-.39-.3-.75-.48.36-.55.62-.44.77-.4.15-.59.49-1.27.39.02-.18,0-.33-.03-.45.13,0,.28.01.47.06v-1.11c.63-.09.96-.44,1.7-.43v1.54ZM1248.03,81.21c1.3,1.3-1.57,1.17,0,0h0ZM1248.03,69.27c.14-.83-.46-1.01-.88-1.33.03-.14.05-.27.07-.41,1.15.37.78-.72.36-1.64.01-.03.02-.06.03-.08,1.2-.42,1.07.38,1.46.69-.22,1.04-.13,2.37-1.05,2.78ZM1251.44,66.18c-.05.09-.11.23-.17.41-.92.08-.56-1-1.52-.88v-.28c-.28-.24-.72-.34-1.22-.38,1.16-.04,2.34-.1,2.92.38v.76ZM1251.44,55.01c-.81.21-1.3-.23-1.67-.49,0-.51-.11-.92-.34-1.22.11-.19.21-.39.3-.6,1.36.05,1.88.87,1.7,2.31ZM1259.96,50.39c.18.16-.28-.25,0,0h0ZM1258.99,52.86c-.13.17-.24.31-.33.41.02-.16.03-.34.02-.57.12.05.22.11.31.16ZM1258.68,50.78c.03.66-.33.99-.85,1.16-.02-.66.33-.99.85-1.16ZM1257.41,49.23c-.09-2.15.75-.46.42.77-.5-.06-1.21.07-1.28-.39.33-.09.84-.01.85-.39ZM1257.83,62.33c-.1.3-.01.76-.42.77.09-.3.01-.76.42-.77ZM1256.13,41.53c.18.16-.28-.25,0,0h0ZM1256.47,51.07c-.21.19-.35.46-.34.86.35-.11.6-.3.74-.6.04.06.07.13.1.22-.51.08-.26.43,0,.77-.63-.07-1.57.14-1.7-.38.19-.15.74-.85,1.2-.86ZM1254.76,52.3c.04.38.09.75.51.78.5.06,1.21-.07,1.28.39-.77-.05-1,.38-.85,1.16-.6.01-1.14-.42-1.5-.97.15-.13.35-.2.65-.18-.05-.35-.5-.35-.93-.37-.12-.32-.17-.64-.13-.91.23.12.6.11.96.11ZM1254.86,63.87c-.11.1-.19.17-.24.22-.3-.21-.47-.54-.86-.67.16-.57.4-1.07.64-1.57.14.17.25.36.45.48.15-.9.28-1.81,1.7-1.54-.41,1.17-1.13,2.06-1.28,3.47-.3.02-.5-.06-.66-.16.3-.27,1.04-.94.24-.22ZM1253.58,64.26c.01-.12.05-.22.07-.33.39.01.71.12-.07.33ZM1252.73,58.48c-.23-.07-.42-.18-.56-.33.24-.43.67-.73,1.41-.82-.02.66.33.99.85,1.15.17,1.05-.07,1.72-.4,2.31-.65.18-.76.87-.87,1.54-.34-.2-.42-.62-.84-.75-.05-.18-.09-.36-.13-.54.39-.66.74-1.37.54-2.57ZM1253.57,64.26s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0ZM1252.29,68.88c.07-.43.23-.99.39-1.5.02-.01.03-.03.04-.04,0-.02-.01-.02-.02-.04.34-1.03.69-1.8.44-.73,0,.64,1.18.22,1.28.77-.78.45-.3,2.04-2.13,1.54ZM1254,84.68c-.07-.12-.1-.22-.11-.31.04-.03.07-.04.12-.08.01-.07,0-.13-.04-.18.37-.46,1.84-.34,1.74.18-.87.67-.84-.29-1.7.39ZM1256.55,63.87c1.23-1.11-1.23,1.11,0,0h0ZM1256.98,69.27c-1.68-.45,1.68-.45,0,0h0ZM1258.26,72.74c-.37-.79,1.11-1.73,1.28-.77-.67.03-.33.98-1.28.77ZM1257.23,71.16c.23-.01.45-.01.61.04,0-.3-.18-.5-.43-.63.79-.3,2.12-.24,2.13.63-.59-.17-1.79.2-2.3-.04ZM1258.26,60.02c1.01-1.06.11-1.86,1.28-3.08.38.54.22,3.05-1.28,3.08ZM1259.96,68.5c-.11-.46-.73-.47-1.08-.7.06-.04.13-.07.24-.07,0-.25-.23-.29-.48-.33-.02-.12-.01-.26.04-.44,1.62.04,2-1.4,1.28.38.33.09.84.01.85.38-.56,0-.39.68-.85.77ZM1260.05,54.79c-.15-.03-.31-.07-.51-.16-.1.5-.07.88,0,1.22-.12.13-.26.25-.44.32-.07-.43-.63-.42-1.21-.39.61-.75.53-2.13,1.1-2.91,1.05.62.74,1.26,1.81-.17-.48.49-.57,1.34-.77,2.08ZM1262.95,56.17v1.16h-1.28c-.12-.79-.55-1.3-.49-2.26.02-.02.05-.04.07-.06-.02-.03-.04-.04-.05-.06.01-.1.02-.21.04-.32,1.07.49,1.33-.2,1.71.39-.59.4-1.26,2.26,0,1.16ZM1266.78,53.09c-.03-.49-.55-.53-.43-1.15,1.05-.6,1.25,1.31.43,1.15ZM1267.21,105.48c-.28-.25.18.16,0,0h0ZM1267.21,70.81c.07-.45-.07-1.09.43-1.16-.07.45.07,1.09-.43,1.16ZM1268.49,67.34c-3.29.06,1.37-.91,0,0h0ZM1294.06,83.91c-.92-.65-.85-2.64.43-1.54-1.49.11,1.07,1.43-.43,1.54ZM1293.21,86.22c.61-.09.72-.64,1.28-.77.37.79-1.1,1.73-1.28.77ZM1293.21,99.7c-2.19-.93,1.46-.99,0,0h0ZM1294.06,85.06c-1.66-.96,1.41-.56,0,0h0ZM1289.5,60.72c.77-.39,1.45-.87,2.86-.69-.2-.12-.5-.21-.85-.27,1-.14,2.07-.03,2.55.27-2.31-.29-2.66,1.19-4.69,1.16,0-.17.05-.32.13-.46ZM1291.93,74.28c.02.66-.33.99-.85,1.15-.02-.66.33-.99.85-1.15ZM1288.94,63.1c.1.73-.48.85-.43,1.54h-1.7c-.04-.5.24-.7.37-1.04,0,.08.01.17.04.27,1.16.28.86-.77,1.7-.77ZM1287.24,86.61c-1.06-.46-1.2-.71-1.95-.34-.42-.77.67-1.17.94-1.67.11.22.4.38,1.01.46.27-.84-1.21-1.23.43-1.16,1.28,1.01-1.8,1.33-.43,2.7ZM1287.85,81.58c.08,0,.15.01.25.02.83-.39.13-.41-.4-.32-.17-.39-.21-.8.39-.84.12.24,1.06,1.48,0,1.54,0,0,0,0,0,0-.04-.07-.14-.22-.24-.4ZM1288.09,61.95c1.03.9-.52.64-.84,1.35,0-.06,0-.12,0-.19-.35,0-.5.19-.65.38-.39.01-.56.22-.72.44-.08,0-.18-.01-.28-.04.31-1.12,2.09-.9,2.5-1.93ZM1285.72,64.64h.66c-.6,2.89-.97,3.13-1.28.39.15-.18.38-.29.62-.39ZM1284.5,83.97c.38-.63,1.14-.92,1.89-1.22,0,.54-.16.99-.21,1.36-.05-.07-.11-.13-.21-.21-1.63-.07-.15.32-.43,1.16-.09-.01-.17-.03-.25-.04.21-.52.19-.81-.78-.44-.07-.17-.06-.37-.02-.6ZM1285.06,86.38c-.12.06-.24.13-.38.22.01-.12.05-.24.09-.36.09.04.19.09.29.14ZM1283.4,63.49c-1.16-1.17,1.3,1.05,0,0h0ZM1282.56,81.6h1.7v.77h-1.7v-.77ZM1282.55,63.1c-.1.3-.01.76-.43.77.1-.3.01-.76.43-.77ZM1280.6,66.39c.48-.47.76-1.14,1.1-1.74,1.05,1.44.41,2.01.43,4.24-.74-.03-1.28-.25-1.68-.6.04-.82.15-1.4.16-1.9ZM1280.42,69.27c-2.59-.12,1.62-.75,0,0h0ZM1280.42,88.15c-1.43.93,1.03-1.29,0,0h0ZM1278.71,81.98c-.08-.07-.16-.17-.25-.29.03-.25-.17-.51-.46-.78-.34-.7-.54-1.47-.14-1.63.45.89,2.98,1.91,2.13,2.7-.11-.6-.93-.27-1.28,0ZM1279.14,65.03c.22.02.43.04.59.12-.11.21-.22.42-.35.63-.34-.02-.63-.07-.67-.36.26-.02.51-.06.43-.39ZM1278.34,67.83c.24.33.55.61.95.79-.07.11-.17.21-.3.3-.4-.09-1.76.18-.77.3-.12.02-.24.04-.36.04-.08-.7.03-1.22.48-1.44ZM1276.75,53.08c.44,0,.75-.11,1.01-.27.16.47-.03.97-.75,1.05-.26-.24-.33-.52-.26-.78ZM1276.16,74.66c-.1.3-.01.76-.42.77.1-.3.01-.76.42-.77ZM1273.17,84.29c-1.69-.45,1.68-.45,0,0h0ZM1276.16,79.28c-.13.05-.18.18-.2.33-.7-.08-1.26,1.11-1.51.05,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,.49-.07.45-.61.42-1.15h.85c.38.05.45.38.44.78,0,0,0-.01-.01-.02ZM1278.29,86.22c.48-1.53.16-2.09-.44-2.32.01-.12.02-.25.02-.38-1.56.23-1.73-.18-1.51-.92.62-.05.97-.13,1.93-.63-.46,1.11-.69,1.83,1.28,1.54.01,1.29-.59,2.04-1.28,2.7ZM1279.57,90.84c-.45-.18-.33-.7,0-1.16,0,0,0,0,0,0,0,0,0,0,0,0,.52-.71,1.56-1.25,1.7,0-1.37-.34-.59,1.27-1.71,1.16ZM1280.85,86.61c1.14,0,.93-1.22,2.13-1.16-.32.84-1.62,2.76-2.13,1.16ZM1283.4,88.53c.16-.5.01-1.27.85-1.15.19.23.36.49.53.74-.31.28-.55.6-.95.8-.17-.11-.31-.25-.43-.39ZM1285.15,89.51c-.27-.09-.55-.18-.83-.26.24-.26.6-.4,1.01-.5.07.06.12.12.2.17.17-.08.31-.2.44-.31.48-.1.95-.21,1.28-.46v-.44c.32-.08.71-.08,1.27.06.07-.45-.07-1.09.43-1.16v1.54c-.72.54-2.15.44-2.83,1.02-.35.14-.66.28-.96.34ZM1287.24,95.85s0,0,0-.01c.02.04.05.08.07.12-.02-.03-.04-.06-.07-.1ZM1287.24,92.77c-1.68-.45,1.68-.45,0,0h0ZM1287.66,97.39c.1-.3.01-.76.43-.77-.1.3-.01.76-.43.77ZM1288.52,93.15c-.28-.25.18.16,0,0h0ZM1288.52,90.46c-.63-.11-1.21-.27-1.78-.44.1-.49,1.12-.15,1.01-.83.46-.19.98-.36,1.62-.27.53,1.25-1.38.29-.85,1.54ZM1288.52,83.91c-.08-1.1-.05-2.1,1.28-1.93-.14.9-.44,1.66-1.28,1.93ZM1289.8,81.6c-2.59-.12,1.62-.76,0,0h0ZM1289.8,80.44c-.09-.47-.47-.24-.85,0-.67-.57-.48-1.72.85-1.54-.41.72,1.28,1.29,0,1.54ZM1288.52,68.88c.81.09.94-.43,1.71-.38-.36,1.23.67,1.19.85,1.93-1.6.17-1.94-.81-2.56-1.54ZM1291.51,102.85c-.27-.47-.37-.79-.01-1.6-.37-.03-.72-.08-.84-.34.19-.09.46-.11.85-.05-.01-.18-.11-.28-.25-.35.83-.05,1.91-.32,1.95.35-1.01-.18-1.24.28-1.22.85-.13-.05-.29-.09-.48-.07v1.22ZM1291.93,105.48c0-.18.05-.33.12-.47.37-.2.71-.47.98-.83.73-.36,1.36-.45.33-.54.21-.45.32-.98.29-1.63-.17.16-.31.26-.43.32v-.7c1.21-.07.99,1.45,2.13.38.11,2.52-1.92,3.45-3.41,3.47ZM1295.34,65.8c.1-.3.01-.76.43-.77-.1.3-.01.76-.43.77ZM1312.38,66.96c-.1.3-.01.76-.43.77.1-.3.01-.76.43-.77ZM1311.1,64.64c.22.57.63.97.85,1.54-.35.63-1.27.35-1.91.22.08-.06.16-.12.22-.22-.11-.28-.26-.52-.42-.76.02-.11.02-.24-.02-.4-.09-.02-.17-.04-.26-.06-.06-.1-.11-.21-.16-.32-2.11-.03-2.77-1.32-4.08-1.73,2.72-.66,2.93,1.69,5.78,1.73ZM1310.68,93.93c.57-1.91,2.01-.6,0,0h0ZM1308.55,82.37c-.68-.09-1.36-.19-1.63-.65.24-.15.69-.11.83-.34.24.04.55-.15,1.65-.55.53,1.25-1.38.29-.85,1.54ZM1309.83,66.96h-1.28c-.07-.22-.07-.39-.04-.52.28.06.6.12.9.13,0,0,0,0,0,0,.26.02.51.06.43.39ZM1308.97,69.65c.18.16-.28-.25,0,0h0ZM1308.12,78.13c-1.68-.45,1.68-.45,0,0h0ZM1309.83,70.81c.22.37,1.91,1.28.85,1.54-.22-.37-1.91-1.28-.85-1.54ZM1305.14,60.02c.18.16-.28-.25,0,0h0ZM1302.92,65.58c.48-.17,1.05-.28,1.79-.16-1.1,1.61.94,1.06,1.71,1.93-1.02.62-2.06.74-2.72.45.34-.1.68-.24,1.03-.45-.43-.49-1.26-.53-1.71-.75,0,0,0-.01,0-.02,0,0-.01,0-.02,0-.31-.16-.41-.43-.07-1ZM1303.43,69.27c.12,1.01-.16,1.66-1.28,1.54.18-.74.16-1.66,1.28-1.54ZM1301.31,66.57c-.01.11.01.2.02.29-.35.03-.67.01-.91-.12.29-.06.59-.12.88-.17ZM1300.02,69.65c.55.51.56,1.43-.43,1.54.07-.58-.15-1.42.43-1.54ZM1298.75,66.19c.39-.22.66-.1.81.13-.25.07-.51.08-.81,0v-.14ZM1298.75,66.76c.24.13.57.14.93.11-.02.29-.19.54-.51.48-.02-.24-.06-.46-.43-.38v-.2ZM1295.35,54.63h-.87c.15-.89.28-1.81,1.7-1.54.15.9-.13,1.41-.83,1.54ZM1295.76,56.55v-1.89s0-.02,0-.04h1.7c-.1,1.07-1.35,1.09-1.7,1.93ZM1298.75,100.09c-2.59-.12,1.63-.76,0,0h0ZM1300.45,104.33h-1.28v-.77c.43,0,.51-.31.85-.38.02.49.54.53.42,1.15ZM1301.3,69.27c-2.59-.12,1.63-.75,0,0h0ZM1300.88,74.66c.52-.21.83-2.53,1.71-1.16-.52.08-.26.43,0,.77-.57-.06-1.59,1.3-1.71.38ZM1301.35,77.92c.15.11.27.24.34.42-.16-.1-.28-.23-.34-.42ZM1302.09,78.49c.02-.12.03-.25.07-.36.31-.06.38.09.41.29,0,.04.01.06,0,.1-.19.01-.34,0-.49-.03ZM1304.29,78.52c-.03-.24-.06-.46-.43-.39-.1.3-.01.76-.43.77.02-.15.03-.28,0-.39.04.04.07.06,0,0,0,0,0,0,0,0-.12-.79-1.17-.74-1.29-1.54,1.02,0,3.12.99,2.13,1.54ZM1305.14,78.52c.18.16-.28-.25,0,0h0ZM1303.86,75.05c.35-.08.81-.51,1.27-.81-.03.11-.03.24.02.42.14.03.25.03.34.02-.69.4-1.4.89-1.63.37ZM1305.84,74.49c.1-.14.13-.33.16-.54.16.03.3.13.42.33-.17.02-.37.1-.58.21ZM1305.99,71.58c-1.68-.45,1.69-.45,0,0h0ZM1308.12,73.51c.48.8.46.82-.43.39-.05.47-.13.91-.85.77-.29-1.04.88-.75,1.28-1.16ZM1306.84,80.83c.12.08.23.14.31.21-.13.05-.25.1-.35.14,0-.11.01-.21.04-.34ZM1308.12,89.69c-.17-.66-.55.08-1.28,0,0-.78.41-1.2.92-1.53.75-.2,1.63-.3,2.08-.78-.03-.21-.16-.33-.32-.41.15-.2.27-.44.31-.74.12.79,1.59.36,1.71,1.15-.85.9-3.22.44-3.41,1.93.24,0,.48.31,0,.38ZM1309.4,89.69c.18.16-.28-.25,0,0h0ZM1309.4,96.62c-1.41-.56,1.66-.96,0,0h0ZM1310,98.21c.13-.1.23-.23.27-.39.36,1.03.64-.93,1.69-.43.33,1.21-1.67,1.22-1.96.81ZM1311.96,70.81c-.04-.29.05-.56.19-.79.08,0,.15,0,.24.02-.02-.09-.06-.14-.09-.21.22-.25.52-.42.81-.47-.23.18-.37.41-.29.68.28.07.49.07.67.05-.48.27-.28,1.16-1.54.72ZM1313.78,70.02c.09-.04.17-.08.24-.13.02.05.05.09.07.15-.13-.03-.22-.02-.31-.02ZM1316.22,66.96c.09.3.36.45.85.38.03-.67-.09-1.2-.43-1.54,1.43-.39.66,1.2.85,1.93-.87.33-2.35-.61-1.28-.77ZM1314.51,70.04c-.09-.31.11-.57.41-.76,0,0,.02,0,.02,0,0,0,0,0,0,0,.61-.37,1.63-.44,1.7,0-.81.16-.77,1.1-2.13.77ZM1315.79,95.08c.02-.11.01-.24,0-.37,0,0,0,0,0-.01,0,0,0,0,0,0-.04-.67-.22-1.48.85-1.16-.06.72-.28,1.29-.85,1.54ZM1317.07,95.47c.1-.3.01-.76.43-.77-.1.3-.01.76-.43.77ZM1317.5,82.75c-.26.02-.51.06-.43.39h-.85c-.66-.95,1.45-1.13,1.28-.39ZM1320.06,86.22c-.74-.72-.55-2.76.42-3.08-.39,1.04-.68,1.82.43,2.31-.26.02-.51.06-.43.38-.02.24-.06.46-.42.39ZM1321.33,92c-.06.96-.81,1.21.43,1.54,0-.21.34-.44.43,0-.7,1.25-2.95-1.55-.85-1.54ZM1322.61,97.01c-1.68-.45,1.68-.45,0,0h0ZM1322.19,86.61c.09-.3,0-.76.42-.77-.1.3-.01.76-.42.77ZM1323.46,89.69c-.85.48-1.14-.67-.79-1.05.1.37.32.63.78.67.03.1.04.22.01.37ZM1323.04,83.14c1.5,1.56-1.37.91,0,0h0ZM1322.18,77.13c-.05-.4-.37-.56-.79-.62-.03-.09-.05-.19-.05-.31.71.51,2.71-.14,2.56,1.16-.54-.1-1.2-.1-1.72-.22ZM1325.17,100.48c.1-.3.01-.76.43-.77-.1.3-.01.76-.43.77ZM1324.31,87.37c1.2-.06,1.23.95,1.28,1.93-1.33.18-1.36-.82-1.28-1.93ZM1326.45,98.55c.18.16-.28-.25,0,0h0ZM1326.02,85.06s0,0,0,0c-.4.02-.32.47-.42.77.4,0,.34-.44.42-.74.04.47.54.52.42,1.13-.97.11-1.6-.09-1.7-.77.5-.11,1.61-1.55,2.13-.39h-.85ZM1329.43,78.13c-.1.3,0,.76-.42.77.1-.3,0-.76.42-.77ZM1327.73,83.52c-.06.45.08,1.09-.43,1.16.07-.45-.07-1.09.43-1.16ZM1327.73,85.06c-.1.3-.01.76-.43.77.1-.3.01-.76.43-.77ZM1327.3,95.47c.5-.11,1.61-1.55,2.13-.39-.5.11-1.61,1.55-2.13.39ZM1328.58,98.16c-2.59-.12,1.63-.75,0,0h0ZM1328.58,99.32c-1.16-1.17,1.3,1.05,0,0h0ZM1329.77,101.68c-.33.01-.59.1-.17.25-.12.1-.3.14-.59.08-.02-.66.33-.99.85-1.15-.02.28-.01.59-.09.82ZM1330.29,76.99v-.02c.36-.05.59-.22.76-.44.15.19.42.46.57.81-.58,0-1.22.05-1.34-.36ZM1331.26,76.24c.19-.31.37-.64.73-.8v1c-.24-.06-.49-.12-.73-.19ZM1331.56,102.02c-1.68-.45,1.68-.45,0,0h0ZM1330.87,74.97c-.06-.07-.11-.17-.16-.31.47.05,1.04-1.06,1.46-.76-.39.4-.74.83-1.3,1.08ZM1332.84,76.2c.71.22,1.43.38,2.19.46-.78.08-1.52.04-2.23-.07-.17-.21-.24-.34.04-.39ZM1335.4,78.52c-1.08.18-1.28-.37-1.73-.25,0-.76,1.17-1.41.88-.14.29-.16.63-.26.98-.36-.15.21-.23.48-.13.75ZM1332.41,75.05c.48-.17.8-.47,1.11-.79.18-.01.38,0,.6.02-.05-.16-.15-.28-.25-.38.3-.31.63-.61,1.1-.77.1.55.7.65.85,1.16-1.91-.24-2.32,1.14-3.41.77ZM1344.38,68.49c-.02-.09-.03-.2-.02-.32.41,0,.81.11.02.32ZM1342.22,68.88c.09.46.1.77.07.98-.18-.1-.36-.17-.55-.21,0-.25.12-.54.48-.77ZM1342.22,72.74c-.1.3-.01.76-.43.77.1-.3.01-.76.43-.77ZM1336.68,99.32c.09-.3.01-.76.42-.77-.09.3-.01.76-.42.77ZM1336.25,78.13c.07-.31.04-.49-.02-.6.42-.18.75-.44.85-.91.55-.08,1.12-.21,1.73-.43.1,1.51-1.58,1.4-2.56,1.93ZM1339.23,76.2c.18-1.06-1.59-.36-1.7-1.15,1.2-.4,2.96.6,1.7,1.15ZM1340.51,98.93c-1.68-.45,1.69-.45,0,0h0ZM1342.64,77.36c.1-.3.01-.76.43-.77-.09.3-.01.76-.43.77ZM1342.22,75.82c0-.51-.75-.35-.85-.77.75.11,1.32-1.81,1.7-.77-1.16-.28.31,1.82-.85,1.54ZM1344.35,70.81c-1.3-.83-.57,1.42-1.7,1.54.24-.82.15-1.21.13-1.59.22-.09.2-.27.03-.48.04-.18.11-.37.26-.63.83-.18,2.18,1.04,1.28,1.16ZM1344.58,68.95c1.02.2.18-1.28,1.47-.84-.09.65.36.82.42,1.33-.36-.11-.81-.14-.84-.56-.52.16-.53.49-.28.77-.22-.02-.42-.07-.58-.14-.01-.24-.1-.41-.2-.57ZM1345.2,93.15c.1-.3.01-.76.43-.77-.09.3,0,.76-.43.77ZM1346.48,92.38c.1-.3.01-.76.43-.77-.1.3-.01.76-.43.77ZM1347.33,98.16c.09-.3.01-.76.42-.77-.1.3-.01.76-.42.77ZM1345.46,90.19c.4-.16.77-.37,1.03-.5-.03-.05-.06-.1-.1-.14.31-.11.6-.24.88-.29.02.09.15.23.5.43.15-.06.24-.12.3-.17.04.05.08.11.12.17-.65.33-2.08,1.16-2.72.5ZM1347.33,68.88c.05.73,1.41.27,1.28,1.16-1.08.41-2.43-.81-1.28-1.16ZM1363.11,101.22c-.24.05-.51.08-.86.03-.13-.84.46-1.02,1.06-1.2-.15.31-.21.71-.19,1.17ZM1362.67,102.4c-.24-.21-.01-.78.43-.39.23.21.01.78-.43.39ZM1362.25,98.16c-.07.45.07,1.09-.43,1.16.07-.45-.07-1.09.43-1.16ZM1362.25,79.28c-3.1,1.46-.09-1.72,0,0h0ZM1361.39,77.74c-2.59-.12,1.63-.75,0,0h0ZM1361.39,71.97c-2.47.41-.18-1.67,0,0h0ZM1358.84,70.04h.85c1.04.04.09,1.27-.43,1.16-.02-.49-.54-.53-.43-1.16ZM1356.69,74.2c.28,0,.54.04.71.16-.33.1-.6.21-.69.3.04-.15.03-.3-.02-.46ZM1355.86,71.97c-.17.02-.26.06-.29.1-.06-.05-.11-.1-.17-.15.12,0,.27.02.46.05ZM1354.4,77.91c.21.38.46.85.18,1.38-.14,0-.27,0-.41,0,0,0,0,0,0,0-.18-.16-.06-.05,0,0-.47,0-.88-.05-1.23-.14.15-.4.02-.77-.15-1.09.21-.13.37-.33.52-.53,0,.07,0,.13,0,.21.52.24.85.2,1.09.16ZM1352.87,80.06c.18.16-.28-.25,0,0h0ZM1354.15,71.97v.38s0,.04-.01.07c-.31-.21-.47-.39.01-.45ZM1351.76,72.38c.08.06.17.18.27.36.35.07.4-.13.42-.36.65-.19.68-.94,1.7-.8v.38c-1.26-.19-.88.18-.27.77-.05,0-.09.01-.15,0-.73-1.36-.86.97-1.7.77.02-.53-.2-.85-.43-1.16.06.02.11.01.17.03ZM1350.74,86.22c-.28-.25.18.16,0,0h0ZM1349.04,71.2c-.28-.25.18.16,0,0h0ZM1349.46,89.69c-1.66-.96,1.41-.56,0,0h0ZM1349.89,88.15c-.02-.66.33-.99.85-1.16.02.66-.33.99-.85,1.16ZM1351.16,92c-1.1-.29-.04-.39.35-.3.03.05.05.09.07.15-.07.04-.2.09-.42.15ZM1353.3,92c.04-.43-.62-.6,0-.77.43,0,.54.67,0,.77ZM1353.72,84.68c-.72.09-1.28-.08-1.68-.38-.02-.71-.39-.96-.69-1.26-.06-.78.42-1.6,1.52-1.83-.18.5-.22.85-.19,1.12-.13-.07-.23-.16-.23-.35-1,.14-.33.9.43.87.35.46.97.64.84,1.83ZM1354.15,95.47c-1.3,1.05,1.16-1.17,0,0h0ZM1354.15,88.53c.1-.3,0-.76.42-.77-.1.3-.01.76-.42.77ZM1354.57,97.78c.1-.3.01-.76.43-.77-.09.3-.01.76-.43.77ZM1354.15,81.98c0,.51.74.35.85.77-.87.44-2.03-.61-.85-.77ZM1355,75.43c-1.68-.45,1.68-.45,0,0h0ZM1355.29,76.84c.16-.12.36-.21.57-.28v.41c.54.1.84-.02,1.12-.15.14.57-.02,1.1-.27,1.31,0,0,0,0,0,0-.34-.54-.6,0-1.48-.3.11-.26.15-.61.06-.98ZM1356.71,80.06c.18.16-.28-.25,0,0h0ZM1355.86,79.28c.18.16-.28-.25,0,0h0ZM1357.13,90.84c-.93.07-1.36-.31-1.28-1.16.79-.02.9.3.42.77.6-.03,1.63.09.85.39ZM1357.56,104.33s0-.03.01-.05c.02,0,.03.02.05.03-.02,0-.03.02-.06.02ZM1357.56,76.16v-.73c1.11-.11,1.83.14,1.71,1.16-.58.12-.81.55-1.71.39v-.38s0,0,.01,0c.02-.16.01-.3-.01-.43ZM1358.41,78.13v.77c-.43,0-.51.31-.85.38.04-.6-.06-1.34.85-1.15ZM1357.99,85.07s0,0,0,0c1.32.11-1.08-1.11.42-1.16-.07,1.07.65,1.32,1.28.77.18,1.44-1.27,1.19-1.7.39ZM1359.69,104.33c-.5.13-.73-.26-.71-.63.2.26.47.46.84.57-.04.03-.08.05-.13.07ZM1359.98,104.03c-.14-.32-.18-.54-.09-.67.11.18.16.45.09.67ZM1359.26,75.05c.18-.65-.28-.85-.86-.85.08-.17.2-.3.45-.31-.79-.26-1.5-.58-2.14-.98v-1.34c1.01,1.01,2.26,1.8,3.84,2.31-.81.04-.3,1.27-1.28,1.16ZM1361.82,104.33c-.8-.09-1.19-.57-1.44-1.16.34-.03.84,0,1.45,0-.48-.44-.89-.71-1.35-.84.15-.03.29-.05.42-.06.01.05.04.09.08.13.32.29.53.06.52-.16.78.01,1.32.29,2.03.94-1.67-.02-2.47-.22-1.7,1.15ZM1363.52,104.33c.1-.3.01-.76.43-.77-.1.3-.01.76-.43.77ZM1364.27,99.77s-.08-.07-.14-.09c.11-.09.2-.2.24-.35-.03.15-.07.3-.11.45ZM1363.52,97.39c.02-.12,0-.22,0-.31,0-.02,0-.05.01-.07-.01,0-.02,0-.03,0-.1-.42-.45-.62-.41-1.17.59.02.94-.18,1.28-.39-.23.69-.22,1.6-.85,1.93ZM1365.23,97.01c-.06.18-.06.42-.14.58-.08,0-.16,0-.25.02.04-.28.05-.59.39-.6ZM1366.08,101.25h-1.28c-.04-.67.09-1.2.42-1.54,1.28-.39.76.86.85,1.54ZM1366.51,98.16c-1.41-.56,1.66-.96,0,0h0ZM1366.51,96.62c-1.41-.56,1.66-.96,0,0h0ZM1366.51,95.47c-1.41-.56,1.66-.96,0,0h0ZM1369.07,83.91v1.16h-.85c0-.39-.35-.46-.43-.77.59.02.94-.18,1.28-.38ZM1369.07,86.61c-2.47.41-.18-1.67,0,0h0ZM1368.21,101.25v-.38s0,0,.01,0c0,0,0-.01-.01-.02v-.75c.97-.11,1.6.09,1.71.77-.74-.03-1.33.09-1.71.38ZM1370.34,83.91c-.28-.25.18.16,0,0h0ZM1372.05,103.94c-.28-.25.18.16,0,0h0ZM1373.33,96.62c-1.68-.45,1.68-.45,0,0h0ZM1373.33,99.32c.18.16-.28-.25,0,0h0ZM1373.75,103.94c.1-.3.01-.76.43-.77-.1.3-.01.76-.43.77ZM1375.88,73.12c-.49.86-.32,4.3-1.7,3.08.74-.93-.5-2.82,1.7-3.08ZM1373.33,79.67c0-.38-.34-.46-.43-.77,0,0,0,0,0,0,.79.36,1.42-1.15,1.7,0-.33.08-.5.32-.43.77h-.85ZM1375.04,81.6c-.94.16-2.35-1.15-1.28-1.54-.63,1.47,1.91.08,1.28,1.54ZM1375.04,78.13v-.77c1.05-.6,1.25,1.31.43,1.16-.02-.24-.06-.46-.43-.39ZM1375.46,84.68c1.13.12-.4-2.16,1.28-1.54-.12.58-.55,2.78-1.28,1.54ZM1387.82,80.44h-.85c0-.39-.34-.46-.43-.77.67.04,1.48-.05,1.28.77ZM1384.61,77.76c1.06.11.45-1.28,1.51-1.18.93.81-.21,1.1,0,2.31-.94.06-1.26-.45-1.58-.96.03-.06.05-.12.07-.18ZM1385.27,80.43s0,0,0,.01h.74c-.4.93-1.73,2-2.45,1.16.78-.27.83-.56.62-.9.13-.22.22-.43.24-.63.18.28.42.44.85.35ZM1384.41,86.22c-.18-.61-1.34-.33-.85-1.54,1.08-.41,1.89,1.3.85,1.54ZM1384.41,97.39c-.28-.25.18.16,0,0h0ZM1383.98,76.2c.01.16.02.32.02.47-.39.24-.28.93-.77,1.08.14-.61.22-1.28.75-1.55ZM1381.42,90.84c-.09.3-.01.76-.43.77.1-.3.01-.76.43-.77ZM1380.57,81.6c-1.43.93,1.03-1.29,0,0h0ZM1380.15,93.54c.05-.43-.62-.6,0-.77.43,0,.54.67,0,.77ZM1381,99.32c.18.16-.28-.25,0,0h0ZM1381.85,97.78c.21-.7-.77-.34-1.34-.34.05-.19.04-.43.06-.65.36-.07.69.18,1.08.15-.27.26-.44.5.22.07.06-.07.1-.13.14-.18.09-.05.18-.11.28-.2-.07.45.07,1.09-.43,1.16ZM1382.28,87.37c.1-.3.01-.76.42-.77-.09.3,0,.76-.42.77ZM1383.13,78.52c.08.02.15.05.22.08.08.06.16.12.26.16.4.34.55.92.8,1.3-.2.12-.36.2-.52.27-.41-.47-.96-1.05-.76-1.81ZM1383.56,97.01c-1.43.93,1.03-1.29,0,0h0ZM1385.69,98.55c.49.15.49,1.87,0,.77-.64-1.16-.76,1.32-1.71,1.16,0-.49-.7-.37-.84-.74,0-.02.02-.03.02-.05.33-.08.59-.21.82-.38,0,0,0,0,0,0,.33.74.44.2.32-.27.66-.62,1.1-1.44,2.22-1.65.13.76-.57.76-.85,1.15ZM1386.11,89.69c.5-.06.97-.69,1.28,0-.51.06-.97.69-1.28,0ZM1386.97,83.14c-1.41-.56,1.66-.96,0,0h0ZM1387.82,97.39c.04-.43-.62-.6,0-.77.43,0,.54.68,0,.77ZM1388.67,84.29c.1-.3.01-.76.43-.77-.1.3-.01.76-.43.77ZM1389.52,93.93c.05-.43-.62-.6,0-.77.43,0,.54.68,0,.77ZM1390.8,80.83h-.85c0-.39-.35-.46-.43-.77.67.04,1.48-.05,1.28.77ZM1402.31,73.89c-.1.3,0,.76-.43.77.1-.3,0-.76.43-.77ZM1401.88,81.21c-1.68-.45,1.68-.45,0,0h0ZM1401.46,78.13c1.14-.26.82.8,1.28,1.15-1.15.27-.82-.8-1.28-1.15ZM1400.6,88.53c-.36-.45-.56-1.03-.43-1.93,1.29-.59,1.12,1.99.43,1.93ZM1400.6,99.7c-1.68-.45,1.68-.45,0,0h0ZM1401.03,85.45c-1.25.32-1.81.07-2.35,1.09-.06.01-.13.03-.2.07-.02.12-.02.22-.02.33-.09-.54-.41-.89-.57-1.2.36-.1.81-.12,1.44-.28.03-.23.01-.42-.04-.57.08-.18.11-.38.03-.58,1.12-.11,1.84.14,1.7,1.16ZM1397.62,80.83c.24,0,.48.31,0,.38-.39-.15-.45-.57-.34-.86.11-.14.16-.23.18-.27.16-.13.39-.07.59.37-.26.02-.5.06-.43.39ZM1398.05,83.52v.75c-.13,0-.27,0-.42.02h-.44v-.77h.85ZM1398.05,100.48c.22.37,1.91,1.28.85,1.54-.26-.33-2.39-.85-.85-1.54ZM1399.32,72.35c-1.41-.56,1.66-.96,0,0h0ZM1398.9,80.44c-1.43.93,1.03-1.29,0,0h0ZM1398.47,72.35c-.56,0-.39.68-.85.77,0-.38-.09-.67-.25-.91.06.04.14.09.26.14,1.34-.77-.39-.66-.38-.3-.26-.3-.61-.5-.98-.7-.32-.39-.74-.71-1.2-.92,0,0,0,0,0-.01,1.23-.73,3.14.58,3.41,1.93ZM1392.51,70.04c.53-.05.86.07,1.06.31-.07.03-.14.04-.2.08.11.17.26.31.42.43.03.21.03.45,0,.72-1.42.39-1.4-.53-1.28-1.54ZM1391.66,97.39c-.07,0-.14,0-.2,0,.17-.17.36-.31.62-.39.07.45.68.42,1.28.39.34,1.33-.4,1.69-1.28,1.93-.09-.3-.01-.76-.43-.77-.01,0-.02,0-.03,0,.14-.27.17-.64.04-1.16ZM1392.08,76.2c.1-.59.19-.99.22-1.36.11.28.08.58.31.87-.13.2-.29.38-.52.49ZM1393.36,103.56c-.63.07-.39.93-.42,1.54h-.85c0-.39-.34-.46-.43-.77.77.04,2.28-2.01,1.7-.77ZM1394.38,75.8c-.52-.52-.04-1.1-1.03-1.53-.06.07-.11.15-.16.23-.35-.13-.65-.31-.96-.48-.04-.16-.08-.32-.16-.51,1.51-.05,2,.82,3.14,1.1,0,.56-.11,1.13-.84,1.2ZM1395.5,73.51c-.1-.01-.16.02-.21.08-.54-.32-.59-.86-.23-1.62.17,0,.3,0,.42.02.26.27.45.62.44,1.14.04,0,.07-.03.11-.04-.04.28,0,.56.31.82-.31-.04-.55-.1-.77-.17-.03-.07-.06-.13-.08-.22ZM1396.12,85.57c.02.07.06.14.1.22-.44-.06-.36-.15-.1-.22ZM1396.34,77.74c.24-.01.3-.15.27-.34.06-.02.12-.04.16-.05-.04-.14-.13-.22-.26-.28-.19-.44-.56-.99-.6-1.26,1.75.01.51-2.4,1.28-2.31.24.8.67.82,1.28.39-.09,1.46-1.34,1.87-1.7,3.08.64.07,1.57-.14,1.7.39-.54.08-2.09,1.12-2.13.38ZM1399.32,105.48c-.59-.17-1.79.2-2.3-.04.23-.01.45-.01.61.04.26-.6-.02-.72-.38-.75.15-.37.16-.86.8-.79-.63,1.46,1.9.08,1.28,1.54ZM1400.6,104.33c-2.59-.12,1.63-.75,0,0h0ZM1401.03,100.86c.1-.3.01-.76.43-.77-.1.3-.01.76-.43.77ZM1401.88,90.46c.31-1.05-.85-.78-.85-1.54.84-.11.84.52,1.28.77-.03-.6,1.24-.27.43,0-.56,0-.39.67-.85.77ZM1402.74,97.01c.09-.3.01-.76.43-.77-.1.3-.01.76-.43.77ZM1403.16,82.75c.1-.3.01-.76.43-.77-.1.3-.01.76-.43.77ZM1403.59,76.59c-1.16-.28.31,1.82-.85,1.54.12-.73-.62-.69-1.26-.73-.05-.27-.09-.55-.01-.71,1.18-.3,2.97-.58,2.13-.11ZM1405.3,90.46s0-.01-.01-.02v-1.14c1.07-.07,1.33.59,1.71,1.15h-1.7ZM1406.14,78.13c.73-.02,1.09.3,1.28.77-.73.02-1.1-.3-1.28-.77ZM1410.41,79.28c.04-.43-.62-.6,0-.77.43,0,.54.67,0,.77ZM1412.51,71.64c-.29.09-.64.13-.83.32-.07-.84.35-1.23,1.28-1.16,0,0,0,0,0,.01-.22.28-.37.55-.46.82ZM1414.52,71.02c.05-.07.09-.14.15-.21.22.07.44.12.67.15-.27.04-.55.06-.81.06ZM1420.21,71.2c.8,1.74-1.53.67-1.71,1.54,2.16.26,1.68,2.7.85,3.85-2.01-.66-.4.23-1.7,1.16-.65.07-1.18.04-1.67-.02,1.25-.92-.32-1.79,1.68-1.13.83-1.15,1.31-3.59-.85-3.85.18-.87,2.5.2,1.71-1.54.85,0,.54,1.05,1.7.77-.42-.4-1.02-.63-.94-1.48.57-.15,1.16-.3,1.78-.44-.36,1.23.37,1.46.85,1.93-1.16.28-.86-.77-1.7-.77ZM1447.06,89.69c1.16.28-.31-1.82.85-1.54.8.73.05.97,0,1.93-.74-.25-1.27-.21-1.69-.04.07-.92.78-1.16,0-1.88-.15-.03-.25-.03-.32,0h-.97c.79-2.87,1.93.46,2.13,1.54ZM1445.36,89.69c-.03-.15-.08-.34-.14-.56.18-.15.36-.3.53-.46.06.51.3,1.18-.39,1.02ZM1443.65,88.92c-2.59-.12,1.63-.75,0,0h0ZM1443.22,85.83c-1.43.93,1.03-1.29,0,0h0ZM1441.94,86.99h.85v1.16h-.85v-1.16ZM1438.12,82.37c-.03-.35.1-.55.23-.76.56-.14,1.16-.32,1.89-.78.1.73-.48.85-.43,1.54-1.45-.53-2.66.98-3.35.08.5-.17,1.05-.3,1.65-.08ZM1439.12,89.68c.16.14.39.18.69.01v1.15h-1.28c-.05-.61.23-.93.59-1.16ZM1437.68,87.37c1.71-1.1.32-3.49,1.71-4.24-.07,1.62-.11,5.27-1.71,4.24ZM1439.81,89.31s0,0,0,0v.03s0-.02,0-.03ZM1436.73,87.51c.2.19.44.35.52.64-.88.34-1.92-1-.85-1.16,0,0,0,0,0,.01-.12.14-.25.26-.42.37.3.2.55.22.75.13ZM1437.62,90.84c0,.17-.11.34-.36.39.02-.16-.07-.28-.14-.39h.5ZM1436.83,79.28c-.48.08-.66.43-.85.77,0,.39.35.46.43.77-2.75-.13,1.48-2.94.43-1.54ZM1431.29,92c-1.68-.45,1.68-.45,0,0h0ZM1429.59,93.93h1.7c.03.67-.1,1.2-.43,1.54-.89.09-1.24-.3-1.29-.97.02-.18.03-.37.02-.57ZM1431.29,98.55c.18.16-.28-.25,0,0h0ZM1428.38,95.37c.19.09.45.13.78.1-1.03.2-1.88,2.52-2.55.77.49-.05,1.21-.62,1.77-.87ZM1426.18,79.67c-.1.3-.01.76-.43.77.1-.3.01-.76.43-.77ZM1424.05,87.76c.57.06,1.28-1.57,1.7-.39-.56-.06-1.59,1.3-1.7.39ZM1424.9,103.17c-1.68-.45,1.68-.45,0,0h0ZM1426.18,93.93c-1.68-.45,1.68-.45,0,0h0ZM1427.03,101.25c.17-.73.09-1.24-.11-1.63.19.05.38.09.58.12-.11.65,1.11,1.58-.47,1.51ZM1431.29,100.48c-.24-.33-.66-.48-1.14-.58.08-.24.15-.48.41-.56-1.36.1-3.16-.45-4.68-.71-.04-.03-.09-.06-.13-.08,1.61-.31,4.54.93,6.51.79-.56.16-.27,1.1-.97,1.14ZM1431.29,93.54c-.38-1.24,1.39-.54,1.7-1.16.13,1.01-.59,1.26-1.7,1.16ZM1432.99,88.15c.1-.3.01-.76.43-.77-.1.3-.01.76-.43.77ZM1433.42,92.38c.09-.3.01-.76.43-.77-.1.3-.01.76-.43.77ZM1433.85,104.33s.08-.06.12-.1c.23-.03.48-.02.74.1-.14-.14-.29-.24-.43-.33.66-.4,1.4-.37,2.12.33-1.22-.54-2.16,1.05-2.56,0ZM1434.7,102.02c.07.39,2.6.38,1.28.77-1.13-.16-1.8-.73-2.05-1.68.49-.14,1-.26,1.15-.72.38-.28.79-.54,1.75-.3.06,1.34-2.16.62-2.13,1.93ZM1436.4,97.01c-1.66-.96,1.41-.56,0,0h0ZM1435.12,95.47s0-.02,0-.04c.24-.03.51-.04.85.04-.1-.33-.48-.4-.74-.59.22-.59.74-.91,1.58-.95-.49,1.21.67.94.85,1.54-1.47-.31-1.8.72-2.56,0ZM1438.54,99.32h-.85v-.77h.85v.77ZM1440.67,96.24c-1.43.93,1.03-1.29,0,0h0ZM1441.09,92.77c-1.4-.34-2.13,1.89-2.98.77.55-.02.72-.38.83-.79.15-.02.3-.02.46.02.05-.4-.03-.68-.22-.86.05-.11.12-.22.21-.29,1.11-.11,1.83.14,1.7,1.16ZM1441.52,89.69c-1.05.6-1.25-1.31-.43-1.16,0,.07.02.13.04.18-.06.04-.05.07.05.11.15.25.43.39.34.86ZM1443.22,95.08c-1.06.06-1.33-.58-1.7-1.14v-.02c.57-.12.81-.55,1.7-.38v1.54ZM1443.65,90.84c.06-.16.14-.3.23-.43.5-.39,1.14-.72,2.28-.36-1.03.45-1.37,1.62-2.51.79ZM1447.06,92.77c-.6.54-1.17.31-1.69-.06.1-.48-.1-.79-.44-.95.44-.17,1.04-.22,1.49-.08-.31.03-.48.14.21.32.1-.03.17-.05.24-.07.19.19.28.46.18.84ZM1448.34,92c-1.68-.45,1.69-.45,0,0h0ZM1449.62,86.61c-.89-.24-.37-.35.07-.33-.02.11-.03.23-.06.33,0,0,0,0,0,0ZM1449.67,86.59c.18-.02.26-.14.3-.29.2.05.23.14-.3.29ZM1451.32,87.37c-1.3,1.05,1.16-1.17,0,0h0ZM1451.33,83.62c0-.17-.02-.33,0-.48.3.14.53.24.74.31-.29.09-.52.15-.74.17ZM1455.58,85.45c-.03-.23-.06-.46-.43-.39-1.11.3-1.7,3.06-2.98,1.93.62-.42.67-.86.46-1.24.25-.33.52-.6.83-.68.36-.07.4.15.43.39,1.36-.81-1.3-.57-1.05-1.82.47.01.91-.18,1.9-.49-1.12,1.82,2.36,1.41.85,2.31ZM1457.71,104.33c.06-.72.28-1.29.85-1.54.12.88-.1,1.45-.85,1.54ZM1459.42,103.17c.05-.29.08-.5.11-.69.1.03.19.06.28.1-.04.28-.05.58-.39.59ZM1459.85,101.63c-.1,0-.18-.02-.25-.04.03-.19.09-.39.24-.73.08-.02.14-.02.21-.03-.02.26-.08.52-.2.8ZM1461.12,84.29h-.85v-1.15h.85v1.15ZM1468.8,102.02c.4-.08.73-.09,1.03-.07.37.45.96.62.26,1.23-.34-.45-.7-.89-1.3-1.1,0-.02.01-.04.02-.05ZM1462.83,95.85c.74,1.26,2.13,1.93,2.56,3.47-.27.21-1.29,1.57-1.71.39,1.76-.25.15-2.17-1.25-2.32-.13-.14-.26-.27-.39-.41.11-.52.33-.92.79-1.12ZM1464.11,102.4c-.1.3-.01.76-.43.77.1-.3.01-.76.43-.77ZM1462.4,94.31c-.1.3-.01.76-.43.77.1-.3.01-.76.43-.77ZM1461.98,101.25c.06-.25-.06-.33-.24-.36.13-1.23-.58-2.25.61-2.62.16.18.28.36.34.54-.03.21-.03.39-.02.55-.11.17-.33.29-.69.34.2.56.54.55.86.36.13.27.29.51.41.8.26.02.51.06.43.38-.63.07-.39.93-.43,1.54-.37.06-.66.06-.92.02.03-.14.04-.28.08-.41-.24,0-.31.16-.35.35-.18-.04-.34-.1-.51-.16,0-.58-.14-1.29.42-1.35ZM1461.98,108.18v-.38s0,0,0,0c0,0,0-.01,0-.02v-.75c.97-.11,1.6.09,1.7.77-.57.12-.82.55-1.7.38ZM1461.98,106.64c.15-.1.26-.19.36-.29.6-.05,1.31-.08,2.21-.09.02-.98-.31-.47-.85-.39-.38-.32-.62-.77-1.29-.85-.07-.13-.14-.27-.21-.41,0-.04-.01-.07-.04-.1-.17-.41-.22-.84.25-1.33-.05,1.4,2.71,1,.85,1.93,1.36-.33,1.62.33,2.13.77.11-.02.21-.05.3-.09.17.09.35.17.54.22,0,.07,0,.15,0,.26-2.15.03-3.22.18-4.26.38ZM1466.66,107.8c-1.41-.56,1.66-.96,0,0h0ZM1468.8,104.71c.89.22.9.6.43,1.15.07.06.13.1.19.13-.5.16-1.09.14-1.61-.03.51-.19.9-.59,1-1.25ZM1469.65,109.72c-2.47.41-.18-1.67,0,0h0ZM1470.92,105.87c.48-.55.46-.94-.42-1.15-.08.54-.35.9-.73,1.12.34-.68.19-2.94,1.59-2.66-.3-.19-.42-.55-.52-.93.39.24.67.58.93.93,1.08-.94-.9-.82-.42-2.31,1.43-.01.87,1.78,1.7,2.31-1.85-.37-.99,3.7-2.13,2.7ZM1478.6,105.48h-.85v-1.16h.85v1.16ZM1478.17,103.56c-1.69-.45,1.68-.45,0,0h0ZM1480.3,110.11h-.85v-.77h.85v.77ZM1489.53,106.01s0,0,0,0c-.15-.12-.26-.29-.28-.53.29.06.52-.02.71-.1.05.03.09.06.15.1.16-.06.25-.12.31-.18.04.03.08.08.11.18-.26.02-.51.06-.43.38.5.06,1.21-.07,1.28.39-.75.04-1.47.05-1.85-.24ZM1491.81,105.48c-1.66-.96,1.41-.56,0,0h0ZM1492.66,106.64c-1.69-.45,1.69-.45,0,0h0ZM1495.65,107.41h-.78c-.01-.12-.03-.24-.06-.38,0,0,0,0,0,0v-.39h.85v.77ZM1515.28,77.13c.05.08.11.17.16.25.18.03.3.11.24.36-.09-.12-.16-.24-.24-.36-.06-.01-.12-.02-.18-.02.01-.08.01-.15.03-.23-1.58-2.8.64-5.05,0,0ZM1512.28,73.36c0-.34,0-.68-.01-1.01,0,0,0,0,0,0,.79.36,1.42-1.15,1.7,0-.89.22.62,1.45.43,2.31-.31.04-.55.12-.73.23-.17-1.51-.95-.53-.54,1.1.03.42.2.87.44,1.26,0,.04,0,.07-.01.11.03,0,.06,0,.09.01.23.33.5.61.75.76-1.93-.02-2.16-1.59-2.15-3.37.13-.05.28-.08.45-.1.09-.4-.19-.88-.43-1.3ZM1511.8,78.7c.44-.19.99-.28,1.75-.18-.6,1.59,1.22,2.98,0,3.85-.12-1.09-1.03-1.46-1.62-2.12-.16-.48-.27-1-.12-1.55ZM1513.55,84.29c-.52.08-.26.43,0,.77h-1.7c-.26-.34-.52-.69,0-.77-2.56-.23-2.98-2.39-4.7-3.37v-.48c3.36.18,3.16,3.56,6.4,3.85ZM1511.41,102.1c-.21.02-.4.05-.59.09-1.35-.38-2.44-.18-2.75-1.16.17-.74.03-1.57-.5-2.4,1.36.33,1.62-.34,2.13-.77.25,1.37,1.71.82,3.41,1.54-.95.82-2.76,1.1-1.7,2.7ZM1511.84,92c-1.62.34-2-1.28-1.28-1.93,1.33-.18,1.36.82,1.28,1.93ZM1511.43,88.97s0-.03,0-.05c-.08.06-.13.13-.16.21-.07.05-.16.11-.27.18-1.21-.48.86-.84.44-.33ZM1507.58,80.06c-1.19.62-1.18-1.66-.43-1.54.13.52.61.74.43,1.54ZM1506.3,71.2h.85v.77h-.85v-.77ZM1505.55,86.94c2.04-1.06,3.1,1.65,3.29,3.15-.16.15-.27.36-.31.58-.54-.29-1.03-.63-1.46-1.03-.21-.98-.71-2.19-1.52-2.7ZM1502.46,92.77c0,.76,1.16.49.85,1.54-1.08.41-1.89-1.3-.85-1.54ZM1502.08,106.85c.1.16.19.32.28.49-.47-.29-.46-.45-.28-.49ZM1501.61,105.87c-.28.53-.59.83-.87.98-.24-.04-.49-.02-.47.12-.48-.05-.42-.76,1.34-1.1ZM1500.01,107.81c1.03.19.79-.78,1.6-.78.76,1.23-1.34,1.59-1.67.87.02-.03.05-.05.06-.09ZM1496.5,107.02c.49,2.47-1.3.85,0,0h0ZM1497.54,109.4c.29-.02.56-.01.76.09-.26.01-.52,0-.76-.09ZM1498.67,110.2c0,.05.01.11,0,.17-.16-.08-.13-.13,0-.17ZM1501.34,110.64c-.43-.34-.87-.68-.57-1.69-.97-.11-1.76-.24-2.5-.3,1.29-.15,2.46.1,4.19.3-.3,1.01.14,1.35.57,1.69h-1.7ZM1504.66,105.93c-.33-1-.66-1.99-1.34-2.67,1.26.15,2.29,0,3.08-.35.24,1.28-.38,2.44-1.74,3.02ZM1511.84,105.57c-.91,3.26-3.24,2.71-5.74,2.39-.04-.21-.11-.4-.22-.54.62-.62,1.2-1.29,2.01-1.75.05.6.11,1.19.54,1.45.62-1.5,3.95-2.58,5.54-1.93-.49.32-1.14.51-2.13.39ZM1513.12,108.26v-2.31c.5.06,1.21-.07,1.28.39-1.34-.19-.32,1.77-1.28,1.93ZM1514.4,92c-.27-.92-2.08-2.4-1.3-3.06,0,0,.01,0,.02-.01.03.23.07.45.43.38-.66-.95,1.44-1.13,1.28-.39-1.71.97,2.02,2.49-.42,3.08ZM1515.31,79c.4-.13.72-.34.79-.63.41-.15,1.05-.56,1.7-.24.21.94-2.1,1.27-2.5.87ZM1516.95,90.46c.2-.87,1.07-3.1,1.7-2.31-1.03.36.26,2.8-1.7,2.31ZM1521.21,104.33c.1-.3.01-.76.43-.77-.1.3-.01.76-.43.77ZM1517.33,101.97c.99-.52,2.11-1.54,3.89-1.11-.18-.27-.44-.44-.75-.54.74-.15,1.43-.16,1.93.09.04.14.1.27.17.4-2.56-.36-3.71,2.28-5.24,1.17ZM1523.97,99.64c.49.3,1.08.5,1.09,1.23.52.12.51-.23.45-.63.28.28.44.62.39,1.4-1.3.3-1.93-1.08-1.94-2ZM1525.8,110.64h-.38c-.13-.26-.44-.4.05-.53.29,0,.42.31.32.53ZM1525.9,103.56c.1-.3.01-.76.43-.77-.1.3-.01.76-.43.77ZM1526.76,102.4c-1.16-1.17,1.3,1.05,0,0h0ZM1526.76,100.86c-.01-.84-.8-.98-1.3-1.38.04-.16.17-.24.46-.17-.08-.44-.43-.21-.43,0-.08.01-.14.01-.2.01-.16-.19-.26-.43-.23-.78,1.34.18,1.13-1.04,2.13-1.15.67,1.51-1.11.8-1.28,1.54.55.02.59.49,1.28.38,0-.21.34-.44.43,0-1.16-.28.3,1.82-.85,1.54ZM1529.31,98.16c.07-.45-.07-1.09.43-1.15-.07.45.07,1.09-.43,1.15ZM1530.6,101.87c.17-.07.33-.14.43-.24-.01-.18-.11-.28-.25-.35.83-.05,1.91-.32,1.95.35-.39.38-1.51.55-2.13.24ZM1568.53,90.46c-.15.21-.3.43-.37.71-.02.02-.04.04-.06.06.2-.35.24-.61.17-.82.09.01.17.02.27.05ZM1567.24,83.52c-.1.3-.01.76-.43.77.1-.3.01-.76.43-.77ZM1568.38,89.35c-.97.36-1.39.12-1.89-.07.98-.31,1.44-.11,1.89.07ZM1566.82,92c.56.96-1.69,1.21-.43,1.54.01-.07.52.04,1.1.16-.12.31-1.16.11-1.94-.05.05-.89.18-1.7,1.26-1.65ZM1567.69,94.93c-.37.11-.69.29-.88.53.03-.24.03-.47,0-.66.31,0,.6.03.87.13ZM1565.54,86.61c-.74-.12-1.5-.21-2.21-.36-.5-.32-1.12-.54-1.84-.66-.07-.04-.15-.08-.21-.13,1.92-.06,3.35.31,4.26,1.16ZM1563.47,102.32c.81-1.01.8,1.14,1.21.08-.02-.03-.04-.07-.06-.1.23.16.47.31.72.46.06.13.12.26.19.41-.99-.12-1.64.06-2.13.38v-.41c.14,0,.28,0,.44.02-.16-.32-.28-.6-.37-.85ZM1564.19,101.11c-.08-.51-.05-1.05.04-1.62.41.23.71.55.9.98-.18.33-.52.52-.94.64ZM1561.28,92h.85v.77h-.85v-.77ZM1559.57,87.37c-1.68-.45,1.69-.45,0,0h0ZM1559.9,90.24s-.14-.03-.33-.07c.15.03.28.06.33.07ZM1559.31,90.11c-.06-.01-.1-.02-.16-.04-.07-.02-.13-.03-.17-.04.07.02.2.05.33.07ZM1560,85.06c-1,.12-.79,1.34-2.13,1.16-.05-.33-.12-.59-.23-.8.16-.18.35-.32.66-.36-.35-.82-1.23-1.16-2.21-1.41-.15-.15-.26-.33-.36-.52,1.56.51,3.67.54,4.26,1.93ZM1551.43,88.88c.8.03.64.94,1.6.82.04.2.03.38-.01.54-.19-.09-.4-.16-.68-.17,0,.36-.17.57-.38.74.16-1.37-.09-1.81-.53-1.93ZM1549.1,96.63c.65,0,.69-.55,1.09-.78.1.55.7.65.85,1.16-.87.16-1.3.38-1.76.01.02,0,.04,0,.07-.01-.05-.16-.14-.27-.25-.38ZM1548.49,89.3h-.85c-.58-.83.95-1.07,1.24-.63-.08.12-.2.21-.38.24.14,0,.28-.02.42-.03,0,.01,0,.02,0,.03-.26.02-.51.06-.43.39ZM1549.77,90.07c-.36,1.37,1.23,2.31-.43,2.7-.18-1.21-1.66-2.37.43-2.7ZM1550.34,86.78s.01.02.02.04c-.17.13-.14.08-.02-.04ZM1550.3,85.48s-.06-.03-.09-.03c0,0,0,0,0,0,0,0,0,0,0,0,.41-.09.33-.24.2-.46.4-.22.76-.5.95-.85.44-.18.5-.48,1.84-.62.03.36-.12.68-.38.94-.21-.13-.5-.2-.89-.17-.03.31.03.53.14.71-.68.35-1.45.52-1.75.48ZM1553.19,86.22s0-.01.01-.02c.85.9,1.1,2.34,1.68,3.48-1.27.28-.86-.97-2.03-.78-.18-.47-.35-.95-.55-1.41-.12-.7-.68-.99-.4-2.05.56.13.97.41,1.3.75-.31.46-.85,1.29-.01.02ZM1554.04,85.06c.29-.11.55-.18.78-.2.06.16.08.35.06.59-.93.07-1.36-.32-1.28-1.16.28-.02.5.01.69.08-.18.14-.31.33-.25.7ZM1554.9,86.2s0,0,0,0c0,0,0,.01-.01.02h0s0,0,0,0c0,0,0-.01.01-.02ZM1554.46,86.86s-.02.04,0,0h0ZM1553.44,93.37c-.11.16-.31.25-.69.17-.01-.31.07-.53.19-.71.16.18.32.37.49.54ZM1552.76,97.01c.7.11.88-.25,1.3-.39.07.32.23.55.39.78h-1.7s0,0,0-.01c0-.16,0-.31,0-.45,0,.03,0,.05.02.08ZM1554.53,99.96c.58-.19,1.17-.52,1.64-1.03.05-.66-.28-.98-.69-1.22.26-.18.61-.3,1.1-.32.62.33,1.35.58,1.28,1.54-1.02,1.11-2.6,1.39-3.41,1.16.03-.04.05-.08.08-.13ZM1557.44,87.37c-.48,1.12-.46-.59.43-.38.01.02.02.03.03.05-.43,0-.88.11-.02.33.07-.02.13-.04.18-.05.25.46.12.41-.62.05ZM1558.29,90.84c.43,0,.54.68,0,.77.04-.43-.62-.6,0-.77ZM1556.1,85.85c.03.11.06.23.08.37.29.04.49,0,.66-.06-.1.43-.21.85-.51,1.1-.03-.05-.07-.12-.11-.18-.08-.56-1.09-1-.13-1.22ZM1556.59,91.61c-1.97,0,.71.69.42,1.54-2.86-.02.62,1.58-.42,3.47-1.21-.32-1.11.54-2.13.39-.04-.14-.05-.3-.09-.45.15,0,.31,0,.52.06.48-.88,0-1.68-.38-2.3.38-.25.7-.53.8-.78-.13-.12-.25-.24-.37-.37.11,0,.23-.01.37-.01.28-.85-2.39-1.54-.42-1.54-.57-.12-.87-.49-1.2-.84.19-.16.34-.36.34-.7,1.36.05,1.41,1.29,2.56,1.54ZM1553.18,80.83c.31,1.13,1.29,1.66,2.13,2.31-.45-.34-1.32-.31-2.14-.33-.41-.3-.82-.6-1.14-.98.28-.43.48-.92,1.15-1ZM1551.48,78.9c-.17.93.78.84.43,1.93-1.36-.08-1.64.24-1.49.89-.15.24-.31.47-.57.61-.66.09-1.19.41-1.79.01.27-.05.56-.06.88.03-.44-1.08-.48-1.64,1.28-1.54.35-1.09-.6-1-.43-1.93-.71.19-1.14.13-1.45-.05-.11-.45-.32-.94-.69-1.49,2.31-.42,1.22,2.24,3.84,1.54ZM1548.5,84.51c.06.43.44.69.22.85-.67.08-1.71.21-2.2.66.24-.28.35-.48.39-.64.69-.08,1.07-.1.3-.31-.4-.52-.77-1.12-1.26-1.47,0-.03-.02-.04-.03-.07,1.28-.63,1.95.14,2.57.98ZM1545.93,71.97c-1.09-.04-2.19-.07-2.13-1.16,1.34-.18,1.74.48,2.13,1.16ZM1544.23,91.61c-1.55-.4-2.64-1.2-3.41-2.31,1.3.62,2.92.96,3.41,2.31ZM1541.24,83.52c-1.68-.45,1.69-.45,0,0h0ZM1541.24,86.61c-1.68-.45,1.69-.45,0,0h0ZM1538.69,89.3c.02,1.27,1.82.92,1.7,2.31-.8.02-.9-.3-.43-.77-.46.07-.96.09-1.44.07-.36-.51-1.17-.61-1.44-1.2.7,0,1.21-.15,1.61-.41ZM1538.27,90.84s-.03.04-.05.05c-.08,0-.16-.01-.24-.02.1-.01.19-.02.29-.03ZM1535.28,88.92s0,0,0,0c.05,1.18,1.66-1.19,1.7,0-.29.07-.44.27-.43.61-.36.14-.81.21-1.36.18-.12-.24-.11-.5.08-.78ZM1536.56,93.15c1.03,2.72-1.46,2.25,0,0h0ZM1533.57,102.4c.75.09,1.13.5,1.38,1.03.06.28.05.58-.1.89.13-.07.25-.13.36-.18.02.06.04.12.05.18-1.58.27-1.88-.61-1.7-1.93ZM1534.92,97.01c.17,0,.33-.02.49-.06.11.14.25.24.3.44-.48-.07-.72-.21-.79-.38ZM1535.71,96.87c.17-.06.32-.14.43-.25-.03-.27-.14-.46-.29-.59.82-.35,1.88-.38,1.99.59-.44.42-1.45.5-2.13.25ZM1537.57,103.98c.07-.03.15-.05.27-.04.69.14.51.37.27.66-.04-.34-.15-.62-.55-.62ZM1538.26,105.48h.75c-.11.13-.33.15-.75,0ZM1541.24,105.48h-1.7c.03-.15.01-.29-.03-.43.19-.51,1.04-.91.03-1.11-.38-.04-.46.19-.46.49-.57-.57-1.37-.98-.81-1.26-.81-.12-1.05-.75-1.41-1.28.12-.32.26-1.07.97-.65.99.39.91,1.75,2.13,1.93-.85.43,1.51,1.18,1.28,2.31ZM1542.58,96.54c-.87.54-1.25,1.52-3.04,1.24.24-.43.88-.52,1.19-.89.76-.2,1.45-.46,1.79-1.04.09.3.1.51.06.69ZM1542.69,97.66c.06-.02.12-.05.17-.08.03.04.06.1.09.19.26-.05.35-.25.39-.5.35-.28.65-.59,1.07-.81,0,.29.15.64.09,1.06-.09-.04-.16.11-.09.31-.04.11-.1.21-.18.33.15,0,.27,0,.39-.03.01.01.02.02.03.03h-1.7c-.21-.18-.27-.37-.27-.5ZM1543.8,105.1c.48-1.21.04-.87,0-2.31,1.55-.35.98,2.54,0,2.31ZM1545.37,80.24c-.21-.35-.52-.6-.72-.96.9-.01,1.59.18,2.06.55-.05.64-.3,1.22-.58,1.77-.15.05-.34.06-.63,0,.13-.5.09-.86-.02-1.14.01,0,.02-.01.03-.01-.04-.08-.1-.13-.14-.2ZM1545.51,92.38c1.85-.41,3.2,2.73,1.7,1.93.26-.02.5-.06.43-.38-.61-.6-2.22-.3-2.13-1.54ZM1546.79,95.85c.09.37.4.54.63.78-.06,0-.12,0-.2,0,.17.23.32.38.47.47.04.18.04.39-.05.68-.81-.09-.94.43-1.7.38.83-1.14-.57-1.9.85-2.31ZM1546.79,98.17s0,0,0-.01c0,0,0,0,0,0,0,0,0,0,0,0ZM1546.8,98.17c1.59.44.61,1.66,1.69,0,.58,1.01,1.79,1.46,2.13,2.7-.6.15-.91.56-1.18,1-.09-.15-.14-.34-.09-.62-.66.41-.88,1.22-1.24,1.91-.02,0-.03.02-.05.02.05-.56-.07-1.01-.24-1.43.26-.39.56-.75,1.1-.88-.34-1.24-1.55-1.68-2.13-2.69ZM1548.49,109.72c-1.43.93,1.03-1.29,0,0h0ZM1551.27,104.3c-.09-.12-.21-.22-.36-.29-.03-.02-.06-.03-.1-.03-.16-.05-.36-.08-.62-.04.05.25.04.46,0,.63,0,0,0,.02,0,.03-.05.19-.15.34-.33.42-.48-.1-1-.16-1.38-.34.05-.17.14-.34.26-.47.16-.06.3-.14.42-.23.11.02.19.12.19.35.71,0,.22-.37.1-.61.05-.06.1-.13.15-.2.12-.01.31,0,.61.04.16-.52.07-.8-.11-1.02.23-.51.48-1.01.95-1.3-.21,1.21,1.31.87.85,2.31-1.71-.26,0,.6-.63.75ZM1551.84,105.39c-.09-.12-.16-.26-.23-.41.29-.17.38-.52.28-1.03.34-.05.58,0,.77.09.05.08.1.17.1.3h.23c.25.35.34.84.62,1.16-.87-.27-1.35-.12-1.76-.1ZM1554.46,104.33c0-.12-.04-.21-.09-.29.26.12.58.18.86.29h-.77ZM1555.71,102.1c-.05-.01-.12-.03-.18-.04.07-.02.13-.03.22-.05,0,.03-.03.05-.03.09ZM1557.03,100.81c.09-.09.18-.18.29-.26-.1.11-.2.2-.29.26ZM1558.3,105.48c-.18-.74-1.22-.7-.85-1.93.99.46,1.47.47,1.66.22-.18,1,.72,1.02.89,1.71h-1.7ZM1559.19,103.58c.12-.61-.47-1.85-.76-2.84.41.63,1.53-1.95,1.57-1.03h0c-.4.02-.32.47-.42.77.39-.01.34-.41.41-.7-.21,1.35,2.66,5.4-.8,3.8ZM1560.41,95c-.09-.89-.76-1.13.44-1.46.02.44.19.73.25.95-.17.22-.39.41-.69.51ZM1561.28,100.48c.1-.3.01-.76.43-.77-.09.3-.01.76-.43.77ZM1562.02,95.3c.03-.1.06-.2.09-.3.92-.31,1-1.37,1.73-1.84.03.06.03.13.05.19-.02.19-.03.39-.04.58.04,0,.07,0,.11,0,0,.3-.04.62-.12.96,0-.06,0-.12,0-.19-.08.35-.17.69-.26,1.03-.31.89-.73,1.78-1.02,2.44-.85-1.51.83-1.81-.54-2.86ZM1563.41,105.48c0-.07.01-.12.02-.17.27-.16.42-.41.45-.78.44-.15,1.11.18,1.66-.58.3,1.42-.67,1.7-2.13,1.54ZM1566,96.6c-.43.03-.78.13-1.08.28.17-.54.34-1.1.49-1.67.05-.04.1-.07.16-.1.15.36.61.44.82.74-.35,0-.47.42-.39.75ZM1570.23,105.48c-.21-.42-.5-.77-.83-1.08.1-.06.22-.1.41-.07-1.02-1.13-1.2-3.03-3.41-3.08.2-.17.33-.44.39-.73,0-.01.02-.02.03-.04,0,0-.01-.02-.01-.03.1-.56-.03-1.2-.4-1.52,1.96,1.15,1.36-1.49.58-2.2.41-.13.9-.19,1.54-.11.85.45,1.67,3.54-.43,2.31.58.49.58,1.82,0,2.31,2.21.05,2.39,1.95,3.41,3.08-.98-.12-.47,1.11-1.28,1.16ZM1571.93,97.01c-1.68-.45,1.68-.45,0,0h0ZM1570.23,95.85c-.04-.32-.21-.56-.45-.73.32-.12.72-.17,1.31-.04-.7-.4-1.32-.87-1.99-1.29.21-.12.13-.41-.57-1.02.64.16,1.19.41,1.7.69,0,.03,0,.05.01.08.03,0,.05-.02.08-.03.86.49,1.61,1.08,2.47,1.57-1.48-.3-1.8.43-2.56.77ZM1569.8,91.61s0-.04,0-.06c.02,0,.04.01.06.01-.02.02-.04.03-.06.04ZM1571.93,93.54c-.02-.24-.07-.46-.43-.39-.26-.02-.5-.06-.43-.38,0,0,0,0,0,0,0,0,0,0,0,0,.59-.11.48-.84.84-1.15-.8-.03-1.15-.43-1.62-.3-.13-.1-.27-.2-.41-.29.08-.21.2-.39.32-.56-.49-.12-.83-.1-1.1-.02-.28-.26-.49-.57-.57-1.01.39.15.83.23,1.66-.12.18,1.76,2.52,1.57,2.56,3.47-.56,0-.39.67-.85.77ZM1575.15,89.76c-.94-1.62-2.93-2.96-4.97-3.41-.13-.04-.25-.09-.39-.12,2.73-.35,6.12,1.52,7.25,3.85-.75,0-1.36-.12-1.89-.32ZM1665.69,82.37c-1.3,1.05,1.16-1.17,0,0h0ZM1655.04,85.06c.5.06,1.21-.07,1.28.39-.67.03-.33.98-1.28.77v-1.16ZM1652.06,97.78c-.53.51-1.76.4-2.88.38.49-.04.92-.13,1.18-.38-.08-.14-.16-.27-.25-.4.08,0,.15.02.24.01,0-.39-.34-.46-.43-.77,1.34-.18,1.74.48,2.13,1.16ZM1651.2,89.3c-.28-.25.18.16,0,0h0ZM1651.2,95.47c-.28-.25.18.16,0,0h0ZM1650.78,93.54c-1.59-.41-1.38.81-2.13,1.15-.27-.33-.53-.67-.81-.99.24-.21.58-.33,1.24-.16.02-.11.02-.21.02-.29,1-.14,1.86-.91,1.67.29ZM1648.65,97.39c-.92.07-1.16-.48-1.48-.95.31-.13.58.17,1.05-.59.38.15.57.46.77.77-.22-.03-.46-.04-.76,0,.08.31.43.38.43.77ZM1648.65,88.53c1.71-.06,1.13.99.85,1.93h-.85c0-.39-.34-.46-.43-.77.33-.09.84-.01.85-.38,0-.39-.35-.46-.43-.77ZM1649.5,92c-.64-.07-1.57.14-1.7-.39.57-.5,1.59-.51,1.7.39ZM1645.66,81.98c-.09.3-.01.76-.43.77.09-.3.01-.76.43-.77ZM1644.81,85.83c1.76-.39,1.87,3.11.85,1.93.26-.02.51-.06.43-.39-.62-.33-1.65-.3-1.28-1.54ZM1644.38,84.68c.54.48.38,1.2-.05,1.73-.18-.3-.45-.54-.81-.59.03-.62.19-1.11.87-1.14ZM1643.96,87.37c.02.53-.2.85-.43,1.16,1.34.44,1.13-.11,2.13.38.38,1.13.38,1.19,0,2.31.09.14.26.25.47.36-.01,0-.02.02-.04.02.09.37.6.38,1.11.37.96.29,1.89.51,1.39.93-.31.08-.73.27-1.18.33-.14-.14-.29-.27-.44-.4.44-.49-1.11-.7-2.18-1.11-.04-.85-.01-1.65.44-2.06-.38.07-.75,0-1.07-.15-.05-.17-.11-.37-.2-.62-.33-.16-.53-.21-.69-.22-.26-.53-.13-1.11.69-1.32ZM1644.75,92.5c-.02.08-.13.17-.37.27-.65-.37-.57-.54-.33-.57.25.08.49.18.7.3ZM1643.1,96.24h.85v.77h-.85v-.77ZM1641.57,103.06c-.36.14-.76.25-1.44.11-.96-.31.46-.36.4-.76.32-.14.72-.28,1.3-.39,1.21.71-.7.77-.26,1.05ZM1640.97,100.09c.1-.3.01-.76.43-.77-.1.3-.01.76-.43.77ZM1641.83,98.55c.18.16-.28-.25,0,0h0ZM1638.42,80.06c0-.21.34-.44.43,0-.48.08-.66.43-.85.77,1.06.16.03,1.49-.85,1.16.04-1.25.22-2.37.85-3.08.07.45-.07,1.09.43,1.15ZM1637.56,87.37c-.13-.91-1.48-.72-1.28-1.92,1.3-.37,1.83,1.89,1.28,1.92ZM1636.29,77.36c.1-.3.01-.76.43-.77-.1.3-.01.76-.43.77ZM1637.14,71.58c.17.66-.63.99,0,1.16.1-.59.7-.06.85.38-1.36-.33-1.62.34-2.13.77-.09-.3-.36-.45-.85-.39.02-.14.08-.26.12-.39.28-.1.63-.13,1.16,0-.15-.44-.75-.98-.85-.38-.06-.02-.1-.04-.14-.06.35-.61.95-.98,1.83-1.1ZM1635.86,70.04c.17.66-.63.99,0,1.16.02-.41.55-.3.43.38-1.83.18-.55-1.04-1.28-1.16-.47.02-.57.37-1.03.4.1-.19.27-.44.18-.78-.06.01-.13.01-.19.02.47-.15,1.37.09,1.89-.02ZM1632.02,69.27c-.1.3-.01.76-.43.77.1-.3.01-.76.43-.77ZM1632.45,75.82c-.69-.1-1.18.17-1.59.49-.18.07-.31.19-.4.34-.19.17-.37.32-.55.42,0-.03-.01-.06-.01-.09-.11.07-.19.13-.26.19-.18.03-.38-.02-.6-.19-.06.51,1.43,1.43.43,1.54-.09-.3-.36-.45-.85-.39.03-.47.04-.94,0-1.34.53-.45,1.11-1.12,2.15-.97-.22-.43-.69-.63-1.28-.72,0-.02,0-.03,0-.05,1.35-.06,2.57-.01,2.98.77ZM1632.02,79.67h0s0,0,0,0h0ZM1631.86,78.38c-.08-.09-.17-.17-.25-.25,0,0,0,0,0,0,.28.04.31.16.25.26ZM1629.04,86.22c-.43,0-.51.31-.85.38.04-.61-.06-1.34.85-1.16v.77ZM1629.04,87.37c-.28-.25.18.16,0,0h0ZM1626.93,77.74c0,.13,0,.25-.01.39.17-.02.3-.01.42.01v.76c-.59.02-.93-.18-1.28-.39v-.77h.88ZM1625.64,82.68v-.64c.03.21.09.4.42.33.98.12.47-1.11,1.28-1.16v1.93c-.62.18-1.32-.12-1.7-.46ZM1627.31,84.77c-.01.33-.06.63-.4.68.03-.21.02-.46.05-.67.09.22.19.15.35,0ZM1624.78,71.58c.46,2.04-1.3.46,0,0h0ZM1624.35,62.33c-.04.6.06,1.34-.85,1.16-.02-.66.33-.99.85-1.16ZM1623.5,74.28c.07.03.13.04.19.06-.07.04-.14.07-.21.1,0-.05,0-.12.02-.17ZM1623.48,75.63c.3-.23.53-.25.46.18.66.05.47-.68.4-1.3.68.11,1.05-.12,1.72-.63-.23.56.5,1.99-.43,1.93.21-1.38-2.5,1.82-1.14,1.61-.16.07-.18.2-.13.34v.74c.15.09.31.18.49.25.06.24-.02.44-.5.52,0-.64-1.18-.21-1.28-.77.68-.46.49-1.72.4-2.88ZM1622.66,81.98c.34-.85.85-1.54,2.13-1.54-.05-.13-.12-.25-.2-.35.19-.11.39-.24.62-.42.73-.02,1.09.3,1.28.77-1.27,0-1.79.69-2.13,1.54-.14,0-.28,0-.42.01,0,0,0,0,0-.01-.01,0-.01,0-.02.01-.48.02-.95.03-1.36,0,.04,0,.07,0,.11,0ZM1625.21,84.68v1.15c-.59.02-.94-.18-1.28-.38v-.77h1.28ZM1622.95,82.59s-.14.07-.3.16c-1.61.84.07-.04.3-.16ZM1622.22,72.74c-.1.3-.01.76-.43.77.1-.3.01-.76.43-.77ZM1621.77,75.44s0,.07,0,.1c0,.07,0,.15.02.22.04.54.09,1.1.07,1.58-.02,0-.04.01-.06.02.25-.68-1.22-1.58-.03-1.92ZM1621.37,78.52c-.1.3-.01.76-.43.77.1-.3.01-.76.43-.77ZM1620.94,72.35c-1.16-1.17,1.3,1.05,0,0h0ZM1621.37,74.66c-.79-.05-1.42-.25-1.7-.77.97-.11,1.6.09,1.7.77ZM1615.4,70.42c.05.47.13.91.85.77-.33,1.47-.95,3.76.43,4.62-1.75.22-.81,2.86-2.56,3.08-.02-.44-.35-.59-.71-.72.2-.41.29-.92.46-1.36.76-.36,1.43-.81,1.95-1.39-.56,0-.39-.67-.85-.77.03.46-.09.74-.27.9-.97-.99-.45-3.02-.15-4.37-.64.12-.78-.21-.83-.61.41-.05.9-.12,1.68-.16ZM1615.83,84.68c-.24-.79-1.28-.76-.42-1.54,1.45-.29,1.66,1.47.42,1.54ZM1613.7,80.83c0-.77-1.16-.49-.85-1.54,1.04-.37,1.41,1.73.85,1.54ZM1614.12,68.11c-.1.3-.01.76-.43.77.1-.3.01-.76.43-.77ZM1614.12,70.04c-1.68-.45,1.68-.45,0,0h0ZM1613.28,74.66c.46.1.29.77.85.77-.07.08-.15.14-.23.21-.26-.11-.51-.32-.63-.6,0,0,0,.02-.01.03.02-.12.03-.25.02-.41ZM1610.29,72.33s0,.01,0,.02c0,0,0,0,0,0,0,0,0-.01,0-.02ZM1608.58,66.19c1.58-.5,1.69,2.28.85,2.7.07-1.22-1.13-1.29-.85-2.7ZM1607.31,69.27c.26-.02.5-.06.43-.39.98.02,1.24.68,1.63,1.22-.07.27-.16.53-.35.7-.22,0-.4-.02-.55-.07.17-.24.36-.47.55-.7-.8-.02-.91.28-1.17.27-.2-.22-.36-.48-.53-.72v-.32ZM1605.16,89.24c-.27.02-.38.17-.41.4v-1.95c.42-.19.8-.25.86.07.43-.11.2-.3.06-.62.39-.32.59-.81,1.63-.54-.17.66.63.99,0,1.16-.13-.7-1.79.39-2.13.77-.08.3-.07.52-.01.71ZM1606.03,86.22c-1.44,1.17-1.29-1.43,0,0h0ZM1606.45,83.52c-1.68-.45,1.68-.45,0,0h0ZM1607.73,81.98c1.5,1.56-1.37.91,0,0h0ZM1607.31,70.04s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0ZM1605.17,66.19c-.35,1.01,1.29,2.11,0,2.7,0-.69-1.15-2.24,0-2.7ZM1603.9,73.12c.67-.03.33-.98,1.28-.77-.46,1.19.19,1.38.82,1.58.02.12.02.22.04.35.29.08.53.11.75.13.05.07.08.16.1.26-2.16-.03,1.98,2.07,0,3.08-1.73-1.58-1.09-2.9-2.56-4.62,0,.21-.35.44-.43,0ZM1604.32,73.89s-.03.02-.05.03c-.03,0-.06-.02-.09-.03.04,0,.08,0,.14,0ZM1604.31,87.92c-.09.66-.67,1.27-.67,1.68-.16-.26-.29-.54-.15-1.06.13-.15.46-.4.83-.62ZM1602.19,83.91h.85c1.04.04.09,1.27-.43,1.16-.02-.49-.55-.53-.43-1.16ZM1603.47,86.61c-.04.3-.08.56-.12.77-.09,0-.18.01-.3,0v2.7c-2.23-.09-.44-1.15-.43-2.31-.26.13-.44.21-.59.27.06-.35.04-.62-.27-.66-.01.14-.08.26-.17.37.03-.23.1-.57.16-1,.43.04.79.04,1.71-.13ZM1601.28,86.69c-1.04.16-1.18.02-2.32-.05-.05-.13-.1-.26-.16-.37.06-.04.11-.09.18-.13.83-.33,3.37-.94,2.36-.3-.5.19-.97.41-1.28.77.56.02.93.05,1.22.08ZM1599.21,93.54c-2.59-.12,1.63-.75,0,0h0ZM1599.14,95.46c-.04.21-.1.39-.35.4.05-.14.05-.32.09-.47.07.04.16.06.27.07ZM1601.71,91.56c.02.27.13.46.48.44-.04-.09-.04-.16-.07-.23.33.08.6-.08.92-.32v1.32c-.72,0-1.27-.15-1.7-.41v-1.13c.13.14.25.25.36.33ZM1601.34,81.98s-.26-1.3-.43-1.16c1.02-.93,1.1,1.26.43,1.16ZM1600.91,82.37c.1.72.7-.22.85.38-.73.04-.77.7-1.05,1.16h-.22c-.02.1-.02.19,0,.26-.18.13-.44.2-.85.12.05-.98.78-1.35,1.28-1.93ZM1598.78,81.21c-1.66-.96,1.41-.56,0,0h0ZM1597.8,88.61c.12.31.29.57.53.76.06.18.09.4.02.7-1.51.15-1.33-1.01-.55-1.46ZM1598.36,90.46c-.24,1.31-.38,2.03-.57,2.74-.46-.1-2.15.26-.27.34.09-.04.15-.07.21-.11-.16.56-.35,1.14-.64,2.03.13-.76-.58-.76-.85-1.16,1.88-.17-1-.54.85-1.16-.43.04-.71-.06-.92-.22.1-.4.2-.84.31-1.4.06.03.12.06.19.08.42-.52,1.14-.77,1.71-1.16ZM1597.08,102.4c-.28-.25.18.16,0,0h0ZM1596.65,95.47c-.09.3-.01.76-.43.77.09-.3.01-.76.43-.77ZM1594.95,81.21c-1.68-.45,1.68-.45,0,0h0ZM1594.56,83.54c.11-.19.23-.4.33-.61.12-.1.27-.16.49-.17.11.6.94.27,1.28,0-.43,1.13-1.67,2.17.43,1.54.06.96-.22,1.6-.85,1.93-.17-.43-.55-.67-.97-.88.1-.29.15-.64.12-1.05-.69.21-1.01.23-1.13.13.17-.24.22-.58.31-.89ZM1594.66,90.14c.27.07.5.19.71.32.14-.89-.07-1.48-.43-1.93.38.05.65.16.87.3-.46.48-.44,1.21.55,1.24-.04.25-.13.49-.26.71-.43.24-.87.47-1.16.83-.35-.07-.42-.39-.85-.38.27-.29.48-.69.56-1.09ZM1593.62,81.08c.33.29.76.71.04.13-.04-.04-.07-.07-.1-.1.02,0,.04-.02.06-.03ZM1593.02,83.12c-.05.09-.09.19-.12.29-.03.04-.05.07-.08.11-1.03.67-.05-.29.2-.4ZM1592.39,80.44c-.09.27-.04.67-.35.74-.02-.02-.04-.04-.06-.06.07-.29.03-.68.41-.69ZM1593.49,88.92c.2.39.28.88.18,1.54-.34-.2-.69-.4-1.28-.38-.16-.02-.25-.11-.31-.22.3-.04.37-.17-.12-.92,0,0,0-.01,0-.02h1.52ZM1591.97,81.21s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0ZM1589.65,88.52c.06,0,.13,0,.19.02-.12-.19-.29-.33-.49-.45,0-.09.01-.19.05-.32,1.06-.06,1.77.2,2.13.77-.51-.11-1.41.13-1.89-.02ZM1591.18,92.61c-.01-.07-.04-.14-.07-.22-.22,0-.35-.08-.47-.17.12-.11.27-.19.48-.21.43.11.21.3.07.61ZM1588.56,83.49v-1.16c.37.18.39.69.84.8.59-.03.26-2.77.85-1.54v1.93c-.58,0-1.21.05-1.7-.03ZM1588.98,85.45c-1.3,1.05,1.16-1.17,0,0h0ZM1588.55,79.28c1.54-.36.59,1.52.85,2.31h-.84c-.24-.49-.33-.35-.38,0h-.05c-.21-1.68,1.31-.82.43-2.31ZM1590.68,86.61c.1-.3.01-.76.43-.77-.1.3-.01.76-.43.77ZM1591.11,78.13c-.69-.14-1.2-.2-1.63-.2.12-.35.26-.77.3-1.14.31-.19.67-.34.48-.98,1.83-.13,1.15,1.4.85,2.31ZM1589.83,71.97c-.41.72,1.28,1.29,0,1.54-.12-.24-1.06-1.48,0-1.54ZM1587.57,76.55c.54-.1.77-.48.92-.94.45-.18.78-.48.49-1.33h1.7c.45,1.35-.63,1.31-1.32,1.64-.19-.08-.45-.12-.8-.1.31,1.05-.85.77-.85,1.54-.03,0-.04,0-.07,0,0-.13-.1-.32-.25-.58.06-.08.13-.15.19-.23ZM1586.42,83.91c-1.03,1.98-1.1-1.33,0,0h0ZM1583.86,74.66c.1.71,1.38,3.48-.43,3.47-.2.05-.24-3.01.43-3.47ZM1584.29,81.21c-.1.3-.01.76-.43.77.1-.3.01-.76.43-.77ZM1583.01,81.21c-1.66-.96,1.41-.56,0,0h0ZM1582.37,81.91s.04-.05.06-.07c.13-.12.32-.21.58-.24.1.55.7.65.85,1.15-.59-.02-.94.18-1.28.39-.38-.35-.49-.89-.22-1.23ZM1580.46,93.54c.02-.21-.13-.36-.21-.48.08-.07.13-.16.15-.27.02,0,.03-.01.06-.02.43,0,.54.67,0,.77ZM1580.69,81.89c-.11.12-.16.26-.17.42-.39.15-.33,1.21-.49,1.22-.53-.29-.94-.7-1.23-1.21.16-.09.41,0,.81.44.8.97.05-.64,0-1.15-.52.76-1.47-.1-.43-.39-.01-.18-.11-.28-.25-.35.83-.05,1.91-.32,1.95.35-.67.18-.52.6-.19.68ZM1581.73,78.13c.02.66-.33.99-.85,1.15-.02-.66.33-.99.85-1.15ZM1581.3,81.6s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0ZM1581.41,82.87c.07-.03.15-.05.23-.06.06.26.03.36-.23.06ZM1581.73,93.15c.07-.45-.07-1.09.42-1.16-.07.45.07,1.09-.42,1.16ZM1583.44,94.7c-1.43.93,1.03-1.29,0,0h0ZM1583.44,89.3c-.12-.81-1.2-.75-1.29-1.59.11-.12.23-.24.35-.36.26-.04.38-.15.37-.3.44-.31.99-.52,1.86-.45.1-.06.14-.1.14-.13.25-.02.49-.04.71-.06-.04.07-.06.15-.08.24-1.25.24-1.66,1.25-2.49,1.87.69-.11,1.15.52.43.77ZM1585.14,95.85c-1.16-1.17,1.3,1.05,0,0h0ZM1584.72,93.15c.47-.16-1.48-2.6,1.28-2.31-.15.79-.33,3.51-1.28,2.31ZM1586.42,86.61c-.1,0-.17,0-.26,0-.05-.06-.09-.13-.12-.22.48-.01.71.03.39.22ZM1586.66,78.13c.56-.21,1.13-.26,2.08-.12-.6.14-1.1.45-1.89.89.05-.36-.07-.57-.19-.77ZM1588.09,82.28c-.05.37-.12.72-.29.83-.11-.17-.16-.41-.1-.74.15-.05.27-.07.39-.09ZM1587.27,85.83c-.28-.25.18.16,0,0h0ZM1587.7,86.22c.02.49.55.53.43,1.15-1.05.6-1.25-1.31-.43-1.15ZM1588.21,92.73c.05-.31.13-.58.36-.73.17.03.27.13.38.21-.24.18-.42.41-.74.52ZM1587.94,89.94c.21,0,.43.01.65.05-.25.01-.47,0-.65-.05ZM1588.98,94.31c0-.11,0-.2.01-.31.29.03.5,0,.67-.09-.12.23-.31.39-.68.4ZM1589.12,93.13c.08-.27.18-.51.29-.74,0,0,0,0,0,0,.23.54,0,.67-.3.74ZM1589.31,89.95c-.47-.61-1.12-1.06-2.03-1.28,0-.05,0-.09,0-.14.27-.01.52,0,.76,0,.1.02.2.03.32.03.96.1,1.68.43,2.22.91.19.48-.25.33-.82.47-.15,0-.3,0-.45,0ZM1590.68,101.25c-1.03-.44-.77-.68-.35-.72-.02.11-.03.23-.06.33.23,0,.3-.15.34-.33.39.05.71.28.08.71ZM1591.69,93.59c-.3,0-.55.12-.36.34-.23.11-.56.13-1.07,0-.39-.91.53-.65.84-.93,0,.05,0,.1.02.16h.76c-.05.15-.11.3-.19.43ZM1591.96,79.28s0,0,0,0c-.02-.02-.04-.04-.06-.06.01.01.03.03.06.06ZM1591.96,100.86c.1-.3.01-.76.43-.77-.1.3-.01.76-.43.77ZM1593.67,94.31c-2.19-.93,1.47-1,0,0h0ZM1594.52,93.15h-1.7c.03-.14.02-.26,0-.35.1-.43.51-.67,0-.81-.16.02-.29.07-.39.14-.01-.04-.02-.09-.03-.14,1.42-.31,1.49.6,2.14.99,0,.05,0,.1-.01.17ZM1594.95,99.32c.18.16-.28-.25,0,0h0ZM1599.21,105.48c-.61-.12-1.19-.1-1.7-.12v-1.04c-.63-.03-1.26-.05-1.67-.28-.02-.15-.04-.31-.04-.49.59.02.94-.18,1.28-.38-.06,1.08,1.04,1.11,2.13,1.15v1.16ZM1599.63,98.93c-.91.34-1.49-.14-1.7-.76v-.78s-.04,0-.07,0c.05-.33.21-.62.48-.77-.05.69.42.9,1.28.77v1.54ZM1599.4,88.37c.25-.47.64-.63.66-1,.67.08.03,1.21-.03,2-.32-.24-.51-.59-.64-1ZM1600.12,90.34c0-.1-.02-.19-.05-.26h.31c.2.08.5.1.96,0,.24.9-.72.71-.94,1.19-.13-.28-.23-.59-.3-.93ZM1600.49,95.08c.56,0,.39-.67.85-.77-.02.53.2.85.43,1.16h-.85c-.26-.02-.51-.06-.43-.39ZM1602.62,99.7c-1.16-.28.31,1.82-.85,1.54-.12-1.29-1.07-.08-1.26-.69,0-.03,0-.05-.01-.08.48-.08.28-.39.03-.72.03-.03.07-.05.11-.06.06,0,.12,0,.18,0,.03,0,.06,0,.1.01,0,0,0,0,0-.01.57,0,1.17.04,1.28-.37-.48-.08-.66-.43-.85-.77,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,.27-.12,1.63-.95,1.7,0-2.01-.18-.79.48-.43,1.16ZM1603.04,97.39c-.02-.24-.06-.46-.43-.39,0,.39.35.46.43.77h-1.28v-.6c.11-.11.1-.22,0-.32v-.24c.87-.33,2.65.33,1.28.77ZM1605.6,90.84c-1.07.62-1.42,1.47-2.42.51.21-.16.44-.34.73-.51.12-.46.03-.73-.09-.96.16.1.45.17.93.19.02.27.05.55.02.77.49-.06.74-.35.83-.77.07.2.1.43.01.77ZM1606.45,90.84c.1-.68-.43-1.93.85-1.54.12.88-.1,1.45-.85,1.54ZM1608.16,101.63c-1.44,1.17-1.29-1.43,0,0h0ZM1608.58,85.45h-.85v-.77h.85v.77ZM1608.41,74.4c-.15-.68-.29-1.57-.68-2.09.09-.42.25-.78.44-1.11.39-.07.85,0,1.25.17-.19.13-.34.32-.4.59.34.15.56.49.71.9-.23.21-.46.43-.7.64.26.86.59.6,1.01.54.08.4.15.77.26,1-.52-.95-.85-.55-1.88-.65ZM1610.29,90.46c.1-.3.01-.76.43-.77-.1.3-.01.76-.43.77ZM1610.71,86.61h-1.28v-.77c.43,0,.51-.31.85-.38.02.49.55.53.43,1.16ZM1612.01,68.87s0,.01,0,.01c.02,0,.02-.01.04-.01.11,0,.23-.01.38.01.17.42.13.66.01.82-.36,0-.71.08-.3.24-.23.12-.49.22-.56.48.26.06.48.1.68.13-.49.06-.86.1-1.38.04.35-.6.2-1.66,1.14-1.73ZM1611.87,75.43c.37.33.89.42,1.19.09-.28.68-.54,1.38-1.49,1.45-.26-.84,0-1.21.3-1.55ZM1612.42,88.15c-1.43.93,1.03-1.29,0,0h0ZM1612.42,83.14c.02-.53-.2-.84-.42-1.15,0,0,0,0,0,0,.79.36,1.42-1.15,1.7,0-.8.04-.3,1.27-1.28,1.16ZM1613.69,104.57c-.02-.3-.15-.52-.35-.67.65-.52,2.15-.29,2.06.82-.66.04-1.31.05-1.71-.14ZM1615.4,88.15c-1.41-.56,1.66-.96,0,0h0ZM1616.18,90.49c-.16.04-.23.16-.26.32-.03,0-.05.03-.09.03.1-.3.01-.76.43-.77-.04.13-.05.28-.08.42ZM1615.47,85.86c.12,0,.25-.02.37-.03-.9-.11-1.83-.91-2.77-1.29.29-.16.59-.22.88-.2.07.09.14.2.18.33.22-.01.37-.09.5-.19.53.19,1.06.53,1.58.82-.08.08,0,.24.47.52.13-.05.21-.1.27-.15.19.07.38.13.57.15-.64.06-1.36.09-2.06.03ZM1617.53,91.23c.1-.3.01-.76.43-.77-.09.3-.01.76-.43.77ZM1618.39,85.83c-1.66-.96,1.41-.56,0,0h0ZM1618.39,72.35c0-1.02.16-2.2-.43-2.7,1.34-.06.83,1.56,1.71,1.93-.52.05-1.01.12-.85.77.06-.11.13-.19.21-.24.05.06.12.13.23.24.84.68.11,0-.2-.26.59-.35,1.33,1.01.62,1.03-.11-.54-.94-.44-1.28-.77ZM1620.09,75.43c-1.69-.45,1.68-.45,0,0h0ZM1620.52,89.69h0s0,0,0,0c0,0,0,0,0,0ZM1622.22,89.69c-1.16.03-.86-.63-1.7,0,0-.04,0-.07,0-.11.03-.33.19-.61.4-.86.42-.16,1.04.11,1.3.59-.01.12-.02.24,0,.39ZM1624.35,98.55c-.26.02-.5.06-.43.39h-.85v-1.16h1.28v.77ZM1624.78,87.37c-.14-.82-1.86.06-2.13.39.68.07,2.24,1.26,1.28,1.54-.29-.54-1.04-.82-1.45-.5-.13-.27-.49-.57-.86-.78.29-.28.5-.56.46-.88.48-.16.94-.17,1.01.24.47-.52.05-.78-.63-.89,1.26-.15,3.15-.03,2.33.89ZM1625.63,97.78c-1.68-.45,1.68-.45,0,0h0ZM1626.48,100.86h-.85c0-.39-.35-.46-.43-.77.59.02.94-.18,1.28-.39v1.16ZM1627.34,92c-.6-.06-1.44.11-1.66-.3,0-.04.01-.09.01-.12.4-.29,2.02-.87,1.65.42ZM1627.76,73.89c.63-.2,1.07-.57,1.71-.77.12.88-.1,1.45-.85,1.54,0-.51-.75-.35-.85-.77ZM1629.04,95.85v.77h-.85v-.77h.85ZM1628.61,99.7c-.12-.24-1.06-1.48,0-1.54-.41.72,1.28,1.29,0,1.54ZM1628.61,88.53c-1.41-.56,1.66-.96,0,0h0ZM1629.47,89.3s.02-.11.03-.16c.05-.02.15-.07.31-.17-.04.18-.11.32-.34.33ZM1629.86,88.69c-.12.1-.26.23-.34.33.03-.24.08-.47.37-.48-.02.05-.02.1-.03.15ZM1630.75,91.61c-.02-.23-.06-.46-.43-.38v-.77c.73.15,1.09-.57,1.28,0-.7,0-.24,1.07-.85,1.16ZM1631.6,88.92c-1.43.93,1.03-1.29,0,0h0ZM1632.02,88.15c-.1-1.06-1.57-.88-2.12-1.53,0,0,0,0,0,0h1.7c-.06.51,1.43,1.43.43,1.54ZM1630.75,84.29c-1.47-.76-1.88,1.31-2.13.39.11-.14.2-.29.29-.45.05.02.09.03.14.06.4-.87.57-1.95,1.05-2.74.05-.07.1-.14.15-.21.04-.06.08-.11.12-.17.07-.08.16-.15.24-.22.05-.04.08-.08.13-.12.27,1.32,1.78-2.16,1.7,0-1.04.73-1.16,2.29-1.7,3.47ZM1633.74,78.13c-.09.02-.16.05-.23.07-.04-.03-.1-.06-.2-.07-.67.41-.58.68-.29.88.05.19.12.39.19.61-.47-.11-.51-.37-.93-.12-.01-.04-.06-.07-.13-.11.07-.26.04-.48-.05-.67.88.27.43-.76-.04-1.67.06-.61.46-.91,1.26-.85.4.84,1.54,2.67.65,2.55-.07-.2-.15-.4-.21-.63ZM1634.16,98.16c.41,2.59-.18-1.11,0,0h0ZM1634.6,71.4s0-.06,0-.09c.04.02.04.05,0,.09ZM1635.43,78.13c.23.81.75,1.45-.43,1.93-.13-.9-.91-1.66.43-1.93ZM1637.57,88.15c-.42.07-.74.05-1.03,0-.49-.33-1-.6-1.54-.77.33-.05.6-.05.85-.03,0,.01,0,.02,0,.03.02,0,.04-.01.05-.02,1.24.15,1.64,1.06,3.35.79.73,2.14,2.78,4.87,2.63,8.09h-.49v.77h.41c-.08.5-.21,1.02-.42,1.54-.79-.07-.97-.7-1.36-1.13.29-1.33.17-2.58-.15-3.75-.14-1.4-.74-2.76-1.61-3.88-.28-.58-.53-1.13-.71-1.65ZM1640.96,110.64h-1.7c1.4-2.68,3.94-4.73,3.85-7.52.5-.17.88-.44,1.69-.33.31,2.97-2.39,5.07-3.85,7.85ZM1645.21,97.22c.13.18.44.19.77.18.05.1.09.22.11.38-1.38.23-1.27-.32-.88-.56ZM1646.55,94.19s.03.03.04.05c-.02.02-.04.04-.07.07-.71.57-.3.18.03-.12ZM1646.51,98.55c.16.13.34.21.53.27-.18.03-.36.05-.55.07-.28-.07-.42-.2.02-.34ZM1646.51,102.4c.31-1.21.04-1.68.15-2.51.16.09.3.2.43.32-.07.07-.13.15-.16.26,1.36.56,1.15,2.56,1.71,3.85-2.05.57-.39-2.21-2.13-1.93ZM1648.65,105.48c-.06-.06-.15-.14,0,0-.75.03-1.64.2-1.28-.76.79.05,1.42.25,1.71.77-.13-.01-.27-.01-.42,0ZM1649.5,100.86c-.46-.3-.71-.78-1.24-1.02.05-.14.26-.21.82-.14-.1-.47-.3-.73-.56-.86,1.04-.15,2-.39,2.26.86-2.14-.29.73,1.57-1.28,1.16ZM1650.35,105.48c-.28-.25.18.16,0,0h0ZM1651.2,105.1c-.28-.25.18.16,0,0h0ZM1652.48,102.79c-.56.39-1.57.38-2.13.77,0-.21.03-.4.06-.59.14-.05.27-.1.38-.18.12-.41.04-.62-.13-.77.13-.3.3-.57.55-.77.17.74,1.65.3,1.28,1.54ZM1652.48,98.55c.18.16-.28-.25,0,0h0ZM1653.33,89.69c-1.3,1.05,1.16-1.17,0,0h0ZM1653.76,88.15c-.24-.8-.67-.82-1.28-.38,0-.02-.01-.04-.02-.05.08-.17.18-.33.45-.33-.08-.44-.43-.21-.43,0-.03.01-.07,0-.1.02-.07-.81.53-1.85.94-.79-1,0,.16,1.05.85.77,0-.21.34-.44.43,0-.56,0-.39.68-.85.77ZM1654.61,102.02c.73-.02,1.09.3,1.28.77-.67-.04-1.48.05-1.28-.77ZM1655.04,98.93c.79.05,1.42.25,1.7.77-.97.11-1.6-.09-1.7-.77ZM1658.45,98.16c-1.43.93,1.03-1.29,0,0h0ZM1659.3,94.7c0-.51-.75-.35-.85-.77.33-.09.49-.32.43-.77-.24,0-.48-.31,0-.38.09.49,1.24,1.89.43,1.93ZM1660.15,86.99c-1.68-.45,1.68-.45,0,0h0ZM1661,100.86c.97-.11,1.6.09,1.71.77-.79-.05-1.42-.25-1.71-.77ZM1665.69,91.23c-.19-.49-.66-1.08-1.17-1.7-.23-1.03-1.17-2.12-1.77-3.12-.02-.63.3-1.23,1.24-1.73-.56,1.84,3.84,4.57,1.71,6.55ZM1667.4,86.22c-1.68-.45,1.69-.45,0,0h0ZM1669.1,85.45c-1.43,1.17-1.29-1.42,0,0h0ZM1669.95,91.61c-.28-.25.18.16,0,0h0ZM1669.95,86.22c-.28-.25.18.16,0,0h0ZM1674.61,70.68c-.05.26-.06.53-.05.81-.33.17-.7.15-.78-.3.4-.06.59-.31.82-.51ZM1672.94,75.43h-.85c.25.23,1,1.83,0,1.93.49-1.21-.67-.94-.85-1.54.27-.21,1.29-1.57,1.71-.39ZM1672.09,105.1c.49,2.47-1.3.85,0,0h0ZM1673.36,80.83c-.14.62-.09,1.63-.15,2.72-.09,0-.17-.03-.27-.03-.09.36.02.54.22.64-.04.44-.12.87-.23,1.29-.79,0-1.3-.09-1.64-.26.37-1.62.16-3.44.37-4.37.43.25.44.89,1.28.77.03-.89-.27-1.48-.57-2.08.37-.39.82-.71,1.41-.62.33.86.9,1.5.85,2.7-.84.11-.85-.52-1.28-.77ZM1674.64,83.52s0,0,0,0c.15.21.29.42.37.69-.3-.08-.48-.25-.38-.69ZM1676.77,76.59c-.28-.34-.69-.57-.97-.91.11-.28.16-.58.19-.87.48-.36.53-.98.46-1.68.17-.17.41-.31.76-.39-.05-.89-.37-1.52-.66-2.64.25-.4.71-.7,1.51-.83.32,1.69.79,2.38.85,3.47-2.03.47-.41,2.65-2.13,3.85ZM1676.77,81.21c.67-.03.33-.98,1.28-.77.37.79-1.11,1.73-1.28.77ZM1675.07,69.65c.02-.18.06-.35.09-.52.24-.22.55-.39,1.19-.25-1.01-.78.4-2.55.56-3.87.15-.46.26-.95.29-1.53,3.49.66-.71,4.19.85,5.39-1.04-.22-1.2.35-1.63.68-.02-.1-.04-.19-.06-.29-.5.08-.86.23-1.13.42-.05-.01-.1-.02-.16-.04ZM1675.28,83.64c.31.13.51.35.63.65-.27-.16-.38-.47-.63-.65ZM1675.92,77.74c-1.16-1.17,1.3,1.05,0,0h0ZM1677.2,84.68c.03-.27-.24-.56-.56-.67-.08-.18-.19-.34-.3-.49.84-.11.84.52,1.28.77.49-.94,2.01.43.85.77-.06-.46-.68-.41-1.27-.39ZM1678.9,98.93c-1.3,1.05,1.16-1.17,0,0h0ZM1695.93,60.5c0,.21.04.45.24.7-.14-.04-.22-.11-.29-.17,0-.19.02-.37.05-.53ZM1688.68,58.37c-.14-.21-.29-.41-.52-.55.22.14.46.26.52.55ZM1687.41,62.65s0,.05.01.07c-.02,0-.03,0-.04-.01.01-.02.02-.04.03-.05ZM1686.93,59.27c0,.08.04.14.09.19,0,.06,0,.12-.01.18-.08-.07-.16-.15-.23-.22.05-.05.11-.09.16-.15ZM1686.38,61.18c-.03.08-.05.16-.05.23-.04-.09-.1-.17-.18-.23.09,0,.16,0,.23,0ZM1686.4,61.69c.09.11.27.2.61.26-.45.38-.72.92-.84,1.6-.12.06-.26-.03-.45-.44.43-.33.73-.93.68-1.42ZM1686.15,68.11c-.25-.23-.37-.58-.42-1,.19,0,.33.24.43.99,0,0,0,0,0,0ZM1685.98,64.95c.08-.06.13-.15.16-.26,0,.12,0,.22.02.34-.07-.02-.12-.06-.18-.08ZM1686.97,64.46c.23.25.52.44.89.57-.11-.8-.05-1.44.13-1.98.11.01.21.03.31.05,0-.15-.1-.21-.21-.26.15-.35.35-.66.63-.9-.21-.04-.36-.09-.47-.15-.04-.07-.08-.1-.13-.1-.35-.38.5-1.03-.19-1.62,0-.02,0-.04,0-.06.44.01.82-.03,1.13-.13.2.06.39.14.56.19-.07,1.08-1.69,1.37-.05,1.87,0-.21.34-.44.43,0-1.91.74-.98,3.35-1.74,5.4h-.56c-.31-.71-.82.42-1.52.76.74-1.08.71-2.45.8-3.65ZM1689.81,62.86c-.08.05-.14.11-.18.19-.25-.03-.49-.08-.5-.33.22.06.5.05.68.14ZM1687.97,67.92c-.04.07-.07.13-.11.2-.02-.13-.03-.24-.05-.34.06.05.11.1.17.14ZM1688.71,70.42c-1.06-.5-1.77,1.13-2.13,0,.1,0,.21,0,.31-.04.04.01.08.02.12.04-.02-.02-.04-.05-.05-.07.74-.3,1.48-1.43,1.75-.7-.52.08-.26.43,0,.77ZM1689.13,64.64c.42.01.33.47.43.77.27-.21.53-.42.77-.62.11.12.22.23.31.29-.28.21-.56.41-.79.66-.32-.3-.6-.63-.72-1.1ZM1692.34,74.43c-.04-.1-.07-.17-.12-.29-.01-.13-.09-.21-.19-.26.11-.04.21-.08.32-.12.03.22.07.44.12.64-.04.01-.08.02-.13.04ZM1694.87,70.72c-.07.03-.13.05-.2.08-.1-.29-.36-.43-.85-.37,0,.21-.35.44-.43,0,.48-.08.66-.43.85-.77,0-.17-.07-.28-.15-.38.05-.1.09-.2.11-.31-.11.01-.22.02-.33.02-.02-.03-.04-.06-.05-.1.97-.11,1.6.09,1.71.77-.61,0-.35.79-.66,1.06ZM1695.38,68.32c.07-.01.12,0,.18,0-.24.11-.52.19-.89.18.2-.38.26-.75.26-1.12.31-.05.73-.56,1.23-.35,0,.64-1.08.41-.79,1.29ZM1696.61,70.78c.05-.85-.11-1.49-.54-2.4.88.32.8,1.69.54,2.4ZM1696.57,65.73c-.6-.05-1.12.37-1.67.96-.09-.88-.25-1.7.63-2.43-2.03-.42-1.74,1.25-1.71,2.7.07,1.09-2.63-.32-2.56.77-.08-.64-.41-1.05-.79-1.41.02-.19.07-.39.17-.58.25.17.44.38.63.59v.38h.34c.26.28.56.52,1.01.65-.23-.18-.41-.41-.57-.65h.02v-.65h-.38c-.27-.58-.48-1.21-.74-1.79.98-.93,1.55-1.87,1.18-3.08-.52.17-.88.49-.85,1.16-1.17-.34.83-1.71-.85-.77.07-1.61,1.37-2.1,3.41-1.93.61.59.46,1.87,1.63,1.95.66,1.2.89,2.75.32,3.5.46.05.7-.07.79-.32,1.39.1-1.39.88,0,.97ZM1698.15,67.03s.07-.05.11-.08c0,.02.01.04.02.06-.04,0-.08.01-.13.02ZM1698.08,66.19c0,.06.02.11.03.17-.13.02-.27.11-.36.34-1.09-1.11.28-2.45-.39-3.56,1.01-.12,1.07.52,1.56.82-.17.84.65,2.57-.83,2.22ZM1712.36,62.18c.24.04.32.21.36.42-.18,0-.36,0-.52.02.05-.11.11-.25.16-.43ZM1711.61,62.87c-.13.14-.21.33-.21.6.49.04,1.02.06,1.56,0,.12,0,.23,0,.32-.04.5-.07.99-.22,1.44-.48.02.28.03.58.02.88-.31.15-.61.32-.94.46-.49-.85-2.11-.86-3.18-.57v-.59h-.63c.71-.74,1.23-.41,1.63-.28ZM1709.83,63.15v.58c-.08.24-.18.46-.33.63-.02-.42-.2-.9-.37-1.12.14-.06.36-.1.7-.1ZM1705.15,66.37c-.12.03-.22.08-.27.14-.07.02-.16.03-.25.04-.03-.06-.01-.14.04-.22.04-.05.08-.1.12-.14.2-.19.55-.38.93-.45-.16.24-.33.47-.57.64ZM1715.56,66.96c.18.24.35.49.51.75-.74.14-1.46.33-2.13.62v-.97c-.82.19-1.13.8-2.37.65-.39-.43-.65-.98-1.18-1.29-1.58.46-3.16.8-4.74,1.94-.63-.16.54-1.06.75-1.74.18-.14.33-.34.44-.61.95.8,2.08-1.5,3.16-.56v-1.94c.24.19,1.87.76,1.97,0,1.07.29-.18,1.31-1.19.97.34.26.24.89.79.97,1.26-.66.87-.8,2.37-.97,0-.03-.02-.04-.02-.07.21.06.42.06.63.02-.12.27-.31.51-.61.7.48.61,1.44.82,2.55.78-.05.49-.11.97-.93.77ZM1721.46,66.02c-.57.03-1.11-.08-1.53-.51.11-.04.22-.07.33-.11.39.21.9.33,1.4.46-.08.04-.14.09-.2.15ZM1723.26,67.04s.07-.08.11-.12c.01.04.04.06.05.1-.05,0-.1.01-.16.02ZM1756.45,68.22c.16-.41.02-1.09.45-1.26.05.26.17.45.33.61-.47.88.29,1.04-.78.66ZM1762.44,65.42c1.29,1.3-1.58,1.17,0,0h0ZM1765.85,64.26c.14.62-.05.94-.36,1.16v-.66c-.08,0-.14,0-.22,0,.21-.15.41-.31.57-.5ZM1767.56,67.19c-.23.21-.45.72-1.12.8-.69-.66.29-.63-.4-1.29-.99.32-1.72.22-2.24-.46.1-.29.26-.53.47-.73.15.09.24.23.35.35-.18.09-.36.19-.49.32.12.91,1.89.24,1.7-.39.57.49.84,1.16,1.71.39.09.42.08.74.01,1.01ZM1768.62,67.07c-.21-.45.12-.82.58-1.19-.21.38-.41.77-.58,1.19ZM1797.38,60.53c-.02.13,0,.24.25.35-.22.5-.48.44-.67.18.07-.19.23-.4.42-.53ZM1796.06,61.22c.09.08.19.15.29.23-.06.05-.13.1-.24.12.01-.11-.03-.21-.08-.29,0-.02.02-.04.03-.06ZM1795.68,55.78c-.47,1.55,1.39,2.97-.43,3.47-.12-.78-.6-1.22-1.08-1.67-.06-.19-.13-.4-.18-.61.83-.15-.01-1.82,1.69-1.18ZM1793.98,61.18c.19.1.32.2.43.3,0,.02,0,.04,0,.06-.14.1-.22.17.06.32-.13.31-.38.36-.62.29.08-.29.14-.59.13-.96ZM1793.73,62.5c.26.02.52.05.72.11-.03.06-.07.12-.11.19-.26-.04-.46-.12-.65-.21.01-.03.02-.06.03-.09ZM1790.88,61.79c.03.05.06.11.11.16-.05.02-.1.03-.16.05.02-.07.03-.14.05-.21ZM1792.27,57.71c.13,0,.24,0,.34,0,.11.11.22.22.33.33-.06.07-.12.16-.17.26h-.43v.65h.79v-.08h.34c.04.11.07.24.09.37-.51.59-.77,1.59-.99,2.6-.03,0-.04.02-.07.02,0,.07,0,.13.02.19-.36,1.67-.67,3.29-1.95,2.99,1.13-2.32,1.96-3.58,1.7-7.32ZM1789.29,63.1h.51c-.11.25-.23.51-.36.77h-.15v-.77ZM1788.43,64.26h.82c-.12.25-.25.5-.38.77.34.08.61.01.83-.14,0,.43-.03.83-.41.91-.18-.6-1.34-.33-.85-1.54ZM1788.03,66.58c.12.03.26.02.39,0,0,0,.02,0,.02,0,0,0,0,0,0,0,.41-.11.84-.42,1.18-.44-.46.27-.86.6-1.46.76-.06-.07-.11-.17-.15-.3,0,0,.01,0,.02,0ZM1788.12,68.07c.06.15.12.31.18.47-.65.22.6.59-.28,1.12-1.14.26-.82-.79-1.28-1.15,0,0,0,0,0,0,0,0,0,0,0,0,.2-.09.94-.52,1.38-.42ZM1787.16,70.81c-.28-.25.18.16,0,0h0ZM1784.61,73.12c-.79-.27.19-.79.46-1.55.79-.04.53-1.04,1.67-.76,0,.02.01.03.02.05-.17.22-.38.4-.86.33,1.08,1.52-.67.59-1.28,1.93ZM1786.81,71.34c-.04.29-.19.55-.36.77.12-.24.24-.5.36-.77ZM1787.16,65.42v.99c-.15.07-.3.13-.45.16h-.4c0-.39-.35-.46-.42-.77.59.02.93-.18,1.28-.38ZM1784.17,64.26c.91.23,1.08.69,1.13,1.25-.3.17-.62.31-1.12.29.08.31.43.38.43.77h.76c.06.38.19.77.51,1.15-.8.85-1.2.57-2,.27.1-.08.19-.16.3-.27-.51-.61-.54-1.23-.56-1.79.63-.39,1.31-.61.55-1.68ZM1782.81,65.06c0,.14-.05.25-.13.34-1.21-.08-.45-.31.13-.34ZM1776.5,62.33c.26-.02.51-.06.43-.39h.85c.66.95-1.45,1.13-1.28.39ZM1773.33,64.04c-.33-.1-.64-.24-.92-.42.48-.74.62-1.1,1.96-.52-.34.32-.69.63-1.04.94ZM1778.64,65.42c-.25.14-.45.29-.63.44-.15-.33-.36-.62-1.08-.44.31.65.32.98.24,1.35-.26.34-.54.68-.94,1.03-.53-1.08-.77-2.33-.31-4.01-.55.26-1.06.38-1.54.39.53-.26,1-.73.95-1.39.3.02.64-.07.8-.26.81.51.62,1.79,2.08.96.09.42.72,1.23.68,2.18-.07-.1-.15-.18-.25-.25ZM1779.21,66.34c.28-.33.61-.64,1.13-.93.48.34.54,1.06.85,1.55-.01.11-.01.24,0,.37-1.47.39-1.73-.3-1.99-1ZM1783.33,71.58c-.67-1.32-1.75-2.27-2.13-3.85.9.15,1.4.49,1.86.55.15.42.36.79.58,1.14.29.47.61.91.92,1.36-.6.09-.53.79-1.23.8ZM1787.17,74.15c-.06-.05.05-.1.22-.15-.08.05-.15.1-.22.15ZM1788.23,71.94c-.07,0-.13.03-.22.02.06.04.11.06.16.09-.5,1-1.05,1.74-1.52,2.44-.73.49-1.43,1-2.05,1.58h-.55c.46-1.1,1.22-1.94,1.97-3.18.03.09.11.16.29.22.61-1.34,2.36-.41,1.28-1.93.84.11.85-.52,1.28-.77-.19.57-.41,1.07-.63,1.52ZM1789.29,70.42c.07-.02.13-.04.19-.07.08.02.16.03.24.07-.05-.03-.07-.08-.11-.12.95-.5.41-1.81-.03-2.73.54-.08,1.16-.1,1.71,0-.27.04-.52.1-.73.16.71.52.14,2.18.85,2.7-1.06-.5-2.07.86-2.13,0ZM1791.06,71.91c-.1-.08-.21-.15-.33-.2.04-.06.12-.1.26-.13-.1-.15-.24-.26-.4-.34,0-.13,0-.27-.03-.43.56.16,1.24.19,1.72.42-.4.23-.81.45-1.22.68ZM1794.4,69.27c.19-1.09-.56-1.57-1.49-1.72-1.02-.7-1.8.06-1.09-1.67.43-.16.95-.24,1.73-.09-.84,1.97.13.91,1.28,1.93-.07.58.15,1.42-.43,1.54ZM1797.07,62.5c-.1.29-.08.48-.01.63-.17.27-.39.6-.52.91-.09.06-.18.13-.27.22-.06,0-.11,0-.17,0,.01.07,0,.11.01.17-.23.29-.41.66-.53,1.12-.41.2-1,.23-1.61.25-.35-.07-.43-.39-.85-.38-.19-1.07.1-1.73.38-2.38.04.31.19.52.45.65-.03.18-.04.37.02.57.85-.64.54.04,1.7,0,.16-.91.78-1.64,1.46-2.24.26.17.53.32.83.45-.25-.03-.54-.03-.9.03ZM1798.81,63.79c-.08-.09-.18-.17-.27-.25.03-.03.07-.05.11-.07.05.11.11.21.17.31,0,0,0,0,0,.01ZM1799.18,62.9c-.34-.15-.65-.33-1.09-.41.95-.14,1.72-.42,2.55-.66,0,.14,0,.27,0,.41-.59.09-1.12.28-1.46.66ZM1803.55,62.18c-.33.08-1.25-.04-2.19,0,0-.18-.07-.35-.23-.47.27-.07.54-.13.85-.17-.21-.26-.41-.53-.4-.97,1.08-.03.8.54,1.58,0-.29-.3-.72-.49-1.18-.65.25-1.17,1.84.75,1.97-.32,1.07.59-1.15,1.19-.39,2.59ZM1810.66,63.47c.07.02.11.05.16.07-.06,0-.12,0-.18,0,0-.02.02-.04.03-.07ZM1807.1,67.35c.51-.74,1.23-.6,2.13-.38-.24.23-.5.44-.76.6-.33-.12-.77-.19-1.37-.22ZM1809.34,70.49c-.08.17-.2.3-.45.32-.08-.07-.13-.18-.18-.27.2-.64.55-1.32.57-1.9.33.17.53.45.72.75-.41.28-.62.67-.66,1.1ZM1809.59,66.6c.03-.56-.05-1.46,1.06-1.52-1.65-.32-.83-.22-.24-1.13.1.1.21.18.33.26-.04.07-.08.15-.09.22.22.07.35.07.46.05.16.14.29.3.33.54-.71.32-1.28.98-1.85,1.57ZM1824.23,53.09c1.03.43-.66,2-.85,1.16.7,0,.24-1.07.85-1.16ZM1823.38,48.46c.13,1.01-.89.99-1.71,1.15-.13-1.01.59-1.26,1.71-1.15ZM1818.28,55.01c-.26-.03-.47-.06-.64-.08.97-.12.9-.1,2.34.08.13,1.45,1.16,2.1,2.31,2.64-.48.03-1.1-.05-1.39.14-1.27-.57-2.47-1.2-2.62-2.78ZM1821.2,60.03c.96-.05,1.77-.24,2.19-.78-.36-.38-.82-.67-1.32-.92.06-.04.13-.06.26-.04v-.62c.99.46,2.07.84,2.75,1.57-.65.84-2.24.84-3.88.78ZM1824.66,70.81c-1.41-.56,1.66-.96,0,0h0ZM1827.22,74.28c-1.68-.45,1.68-.45,0,0h0ZM1828.07,63.49c.07-.45-.07-1.09.43-1.16-.07.45.07,1.09-.43,1.16ZM1826.37,58.48c-.11-.19-.15-.37-.14-.54.17-.1.35-.18.58-.23,0-.07,0-.14,0-.2.35.22.71.33,1.07-.18-.07-.2-.27-.34-.53-.43.61-.13,1.22.08,1.16.81-.81.17-1.07.83-2.13.77ZM1829.35,77.74c-1.43.93,1.03-1.29,0,0h0ZM1831.48,52.7c-2.59-.12,1.62-.76,0,0h0ZM1832,65s-.05.03-.09.03c.07-.22.04-.53.19-.68,0,.22-.04.43-.11.65ZM1833.26,63.92c.12-.32.34-.31.57-.25-.02.13.01.28.12.44-.28-.02-.5-.1-.69-.19ZM1834.46,62.91v-.37c.29.11.2.22,0,.37ZM1842.57,74.45c-.27.18-.45.45-.79.56-.03-.04-.05-.09-.08-.14v-.98c.27.03.6.01.86.06v.5ZM1846.26,74.67c-.16,0-.3.02-.42.05.65-1.06-.76-.24-1.14.57-.13.06-.26.12-.42.15v-.75c.13-.02.27-.03.44-.02-.13-.23-.27-.45-.44-.64v-.51c1.31-.18,1.72.45,2.1,1.11-.04.02-.07.03-.12.05ZM1848.1,61.27c-.43.01-.69-.39-.89-.58.23.21.51.39.89.49,0,.03,0,.06,0,.1ZM1851.23,71.49c-.2.26-.34.51-.27.74-.22-.09-.43-.2-.62-.33,0-.05-.02-.1-.05-.17.35-.54.72-.99-.33-.84.47-.16.89-.34,1.18-.65-.8-.1-.77-.88-1.58-.97-.07.13-.15.23-.24.33.03-.11.04-.22.05-.35,1.03-.16.93.71,2.13.39-.45.56-.5,1.25-.28,1.84ZM1851.79,72.47c.06-.02.11-.05.15-.09.05.04.11.07.16.1,0,.01,0,.02,0,.03-.11,0-.21-.03-.32-.05ZM1852.73,72.84c-.07-.02-.14-.02-.21-.03,0-.05.01-.1.01-.16.33.1.69.14,1.11.08-.21.28-.28.6-.27.92-.21,0-.42.03-.63.05.07-.09.09-.23.07-.4.01-.12,0-.27-.08-.47ZM1853.63,76.55c-.15-.15-.27-.24-.33-.17.38-1.4.05-.83-.4-1.92.24.03.45.07.66.12.27.79.71,1.57.61,2.12-.16-.02-.34-.07-.54-.15ZM1854.92,67.34c.06-.24.17-.44.3-.62.26.52.49,1.06.65,1.63-.44-.23-.76-.56-.95-1.01ZM1861.58,61.85v.65c-1.18-.02-1.56-.71-2-1.33.14-.22.28-.44.41-.67,0,.12,0,.25.02.39.06.71,1,.7,1.98.65.07.28-.16.3-.4.32ZM1870.66,66.06s0,0,0,0c.04.02.07.04.1.07-.04-.02-.06-.05-.1-.06ZM1870.66,64.44c-.04-.46.25-.65.57-.82.47.52.05.89.04,1.3-.31-.07-.56-.19-.61-.48ZM1871.46,71.28c-.27-.03-.39-.24-.39-.53.15,0,.3.03.48.06-.03.16-.05.31-.09.47ZM1871.28,69.9s.03-.06.05-.1c.06.08.13.16.21.23-.13,0-.21-.06-.26-.14ZM1877.6,76.62c.01.25-.07.46-.21.63-.3-.14-.67-.25-1.2-.21.1-.23.2-.46.37-.63.31.04.66.11,1.03.21ZM1875.8,75.43c-1.68-.45,1.68-.45,0,0h0ZM1875.38,77.74c.5-.03.67-.35.82-.69.54.18.74.35.86.51-.63.42-1.57.48-1.68.18ZM1876.3,78.98s-.04-.05-.07-.08c-.36.07-.23.26-.15.43-.02.08-.03.16-.02.25-.02.02-.05.03-.08.04-.12-.18-.26-.42-.41-.68.1-.53,1.02-.7,2.07-.57-.45.1-1.01.29-1.33.6ZM1878.16,78.34s-.05-.02-.07-.02c0,0,0,0,0-.01.21-.03.29-.01.08.04ZM1878.27,77.56c.11-.1.25-.17.39-.19-.14.12-.27.18-.39.19ZM1882.62,71.97c-2.47.41-.18-1.67,0,0h0ZM1880.49,70.04c.09.47.47.24.85,0v.77c-.43,0-.51.31-.85.39-.06-.46-.76-.87,0-1.16ZM1883.29,75.43c-.05.71-1.68.14-2.37.32.57-.56-.19-.77-1.09-.93.29-.39.65-.81,1.09-1.32.34.94,1.21.55,1.92-.26.02.08.03.16.06.25,1.24-.44,1.36-.1,1.58.97-1.12-.44-2.37.58-1.18.97ZM1884.87,69.93c-.49.06-.86.19-1.17.35-.18-.32-.51-.56-1.07-.63.3-.48.91-.54,1.39-.63.39.2.68.7,1.01.67.02.17.02.35.01.54-.05-.1-.1-.2-.17-.3ZM1888.33,72.41c.25-.23.57-.44,1.01-.64.07.02.12.05.19.07-.49.38-.95.8-1.36,1.26-.03-.21.02-.4.15-.69ZM1886.5,63.86c.31-.09.41-.37.81-.37,0,0,.01,0,.02,0-.18.21-.49.3-.83.36ZM1889.44,74.03c-.25.06-.49.18-.62.76-.97.19-.89-.48-1.43-.64.04-.1.08-.21.11-.31.3-.01.64,0,.92-.02-.14-.3-.22-.5-.25-.67.43.59.8.43,1.17.1.13.14.29.28.47.42-.14.12-.27.24-.38.36ZM1891.98,61.53c.4-.32.43-.54.32-.73.1.03.24.05.42.07.17.4.19.73-.73.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1907.61,53.34c-.57.18-2.04-.38-1.97.32.58.17,1,.48,1.58.65.02-.41.5-.45.4-.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1905.24,53.99c-.09-.25-.01-.63-.4-.65.09.25.01.64.4.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1904.84,51.73c-.09-.25-.01-.64-.4-.65.09.25.01.64.4.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1904.05,53.66c-3.05-.05,1.27.76,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1903.66,56.57c.09.25.01.64.4.65-.09-.25-.01-.64-.4-.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1902.08,47.2c.16-.14-.26.21,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1899.71,51.08c-.06-.38.07-.92-.39-.97.06.38-.07.92.39.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1899.32,56.25c-1.56.37,1.56.37,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1896.55,54.63c.98.05,1.92.06,1.97-.65-.75.15-2.38-.44-1.97.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1896.55,46.88c-.26.21.17-.13,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1895.76,54.31c-.7.07-1.98-.33-1.58.65.9.09,1.48-.08,1.58-.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1893.39,54.63c-.7.07-1.98-.33-1.58.65.73-.04,1.32-.21,1.58-.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1892.6,56.25c.4,0,.5-.57,0-.65.04.36-.57.5,0,.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1887.47,53.34c-.02.2-.06.38-.39.32v.65c.97.5,1.16-1.1.39-.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1885.5,58.51c-.9-.09-1.48.08-1.58.65.58.51,1.76.36,1.58-.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1883.13,64.98c-1.56.38,1.56.38,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1881.95,64.98c-1.56.38,1.56.38,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1880.76,56.57c-.86-.06-1.25.27-1.18.97,1.06.22.76-.67,1.18-.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1878.39,51.73c-.61.79,1.34.95,1.18.32-.24-.02-.47-.05-.4-.32h-.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1879.18,66.27c-1.32-.78.95,1.09,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1878.39,49.14c-.09-.25-.01-.64-.4-.65.09.25.01.64.4.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1875.63,51.08c-1.54.8,1.31.47,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1874.05,53.02c.02-.2.06-.38.39-.32v-.65c-.54.01-.87-.15-1.18-.32-.11.74.09,1.22.79,1.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1874.05,57.87v-1.29c-1.23-.03-1.13,1.02-2.77.65-.12.85.83.83,1.58.97-.27-1.07.82-.52,1.19-.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1872.08,51.73c.12-.44.56-.62.4-1.29-1.1-.52-1.09,1.39-.4,1.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1867.73,53.66c-.96.18-1.44.76-1.97,1.29.98.76,2.48.13,1.97-1.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1867.34,56.25c-1.31.47,1.54.8,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1864.97,54.96c.4,0,.5-.57,0-.65.04.36-.57.5,0,.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1864.57,58.19h.79v-1.29h-.79v1.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1864.97,52.05h-1.18c-.58.94,1.76.94,1.18,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1863.79,54.31c-2.29-.34-.17,1.4,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1861.02,58.19c.16-.14-.26.21,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1859.84,47.2c.43-1.71-1.2-.38,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1859.44,60.45c.16-.14-.26.21,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1857.86,42.35c-2.4.1,1.51.63,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1856.29,56.57c-.13-.75.06-1.24.39-1.62-1.7-.4-2.19,1.85-.39,1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1855.89,49.46c.4,0,.5-.57,0-.65.04.36-.57.5,0,.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1854.71,43c1.39-1.31-1.27-.76,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1852.73,54.96c.31.07.46.27.39.65.92-.11,1.85-.21,1.58-1.29-.93.1-1.48.51-2.76.32-.51.76.05.6-.39,1.62,1.63.08.52-1.26,1.18-1.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1854.31,45.91c-.09-.25-.01-.64-.39-.65.09.25.01.64.39.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1852.73,49.14c.16-.14-.26.21,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1852.73,58.84c.16-.14-.26.21,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1851.15,53.02c-.26.21.17-.13,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1850.36,56.25v-1.94c-1.12.16-1.13,1.23-1.58,1.94h1.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1848.78,39.12h-.79v.97h.79v-.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1847.99,41.38c.49,1.05-1.28.25-.79,1.29,1,.34,1.75-1.09.79-1.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1848.39,43.97h-1.18c-.58.94,1.77.94,1.18,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1844.84,51.08c1.44.21,1.55-.67,1.58-1.62-1.14.04-1.88.4-1.58,1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1846.02,48.17c-.06-.38.07-.92-.39-.97.06.38-.07.92.39.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1846.02,53.02c-1.33-.98-1.2,1.2,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1845.23,46.23c-.09-.61.44-.71.4-1.29h-1.18c.05.6.26,1.08.79,1.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1845.23,55.6c-1.31.47,1.54.8,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1845.23,54.63h-.79c0,.32-.32.38-.39.65.62-.03,1.37.04,1.18-.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1844.84,60.78c.06.38-.07.92.4.97-.06-.38.07-.92-.4-.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1845.23,62.72c-.09-.25-.01-.64-.4-.65.09.25.01.64.4.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1844.44,57.22h-.79v.97h.79v-.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1842.86,51.4c-.21,1.14.33,1.66,1.18,1.94-.2-.81.01-1.95-1.18-1.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1842.86,59.16c-.02.56.3.83.79.97-.04-.51.05-1.12-.79-.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1842.47,53.66c-.26.21.17-.13,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1840.89,42.67h.79v-.65h-.79v.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1834.18,55.6c-.06.8.2,1.34.79,1.62-.17-.61.54-1.95-.79-1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1816.02,47.52h-.79v.65h.79v-.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1812.47,50.11c1.33.12.66-1.4,1.18-1.94-2.13-.05-.23,1.32-1.18,1.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1810.89,51.08c.03-.51,1.01-.25.79-.97-.81-.28-1.77.84-.79.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1810.89,56.57c-.09-.25-.01-.64-.4-.65.09.25.01.64.4.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1810.49,45.58c.11-.74-.09-1.22-.79-1.29-.11.74.09,1.22.79,1.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1807.33,51.73c.86.06,1.25-.27,1.18-.97-1.06-.22-.76.67-1.18.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1805.75,51.73c1.17-.66,1-2.42,2.37-2.91h-2.37c1.73,1.34-1.07,1.65,0,2.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1805.36,54.63c-1.56.37,1.56.37,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1803.78,50.43c.09-.46.65-.55.79-.97-.81-.09-.09-1.43-1.18-1.29.34,2.2-.92.51-1.97.32-.14,1.4,1.61,1.27,2.37,1.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1804.17,51.08h-.79v.97h.79v-.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1802.99,56.25c1.35-.09,1.87-3.16.39-3.56.58,1.88-2.55,2.28-.39,3.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1802.2,43.64c-.09-.25-.01-.64-.4-.65.09.25.01.64.4.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1799.83,53.66v1.62c2.09.2,1.69-1.73,0-1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1798.25,44.29c-1.09,1.23,1.45,1.42,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1798.25,58.19c.43-1.71-1.2-.38,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1791.94,54.63c.1-.46.65-.55.79-.97-.44-.07-.61-.36-.79-.65,0-.32.32-.38.4-.65-1.31-.4-.96,2.19-.4,2.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1791.15,48.49c-.09-.25-.01-.64-.4-.65.09.25.01.64.4.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1790.75,53.34c-.09-.25-.01-.64-.4-.65.09.25.01.64.4.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1790.75,54.96c-.09-.25-.01-.64-.4-.65.09.25.01.64.4.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1790.36,68.53c-.26.21.17-.13,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1790.36,47.2c-.06-.38.07-.92-.39-.97.06.38-.07.92.39.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1789.17,54.96c-1.1.14.31-1.76-.79-1.62.29.99-1.08.62-.79,1.62.24.09,1.52.8,1.58,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1788.39,52.69c-1.56.38,1.56.38,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1784.44,55.93c-1.54.8,1.31.47,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1782.86,64.33c.17-.14-.26.21,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1782.86,55.6c-.82-.19-1.28-.68-1.97-.97v1.29c.57-.18,2.04.38,1.97-.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1781.68,52.05c-.4.79-.13.69-.4,1.94,1.26.46,1-1.93.4-1.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1780.1,55.6c-.38-.6,1.18-1.08,0-1.29-.12.2-.98,1.24,0,1.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1776.15,50.43c-.07-.48.14-1.19-.4-1.29-.51.43-.52,1.2.4,1.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1774.57,49.46c-.26.21.17-.13,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1773.38,55.93h-.79v.65h.79v-.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1770.62,54.31v1.29c1.52.25,1.52-1.55,0-1.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1770.22,57.22c-.19-1.01,1.36-.85.4-1.62-1.6-.19-1.25,1.33-.4,1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1769.04,51.73c-.06-.38.07-.92-.39-.97.06.38-.07.92.39.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1768.65,52.69c-.09-.25-.01-.64-.39-.65.09.25.01.64.39.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1763.12,59.16c1.38.06,1.24-1.14,1.97-1.61-1.38-.06-1.24,1.14-1.97,1.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1757.2,64.66c-1.56.37,1.56.37,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1745.36,60.13c.05.6.26,1.08.79,1.29-.09-.61.45-.71.39-1.29h-1.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1744.96,63.36c.37-2.03-1.23-2.44-1.97-3.56,1.09-.26.98-1.93,0-2.26-1.61,2.22-1.09,5.03,1.97,5.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1743.38,46.88c-1.56.37,1.56.37,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1742.99,53.66c-1.32-.78.95,1.09,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1742.2,48.17c.17-.14-.26.21,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1740.62,61.75c-.26.21.17-.13,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1740.22,52.37c.19-1.01-.49-1.32-1.18-1.62-.77.62-.41,1.98,1.18,1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1737.46,56.57c.73-.04,1.32-.21,1.58-.65-.9-.09-1.48.08-1.58.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1738.64,61.75c.02-.41.51-.45.4-.97-.97-.5-1.16,1.1-.4.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1738.64,47.84c-.76.14-1.7.12-1.58.97.99.06,1.24-.5,1.58-.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1738.64,59.16c.43-1.71-1.2-.38,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1737.46,65.63c-2.4.1,1.5.63,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1737.46,58.51h-.79v.65h.79v-.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1735.09,55.28c.56-.4.75-1.11.79-1.94-.84-.02-2.16,2.21-.79,1.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1732.72,60.45c-1.32-.78.95,1.09,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1729.56,51.4c-.69.02-1.23-.07-1.58-.32v.97c.74-.04,1.32-.21,1.58-.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1705.48,61.1c-.24-.02-.47-.05-.4-.32h-.79c-.61.8,1.34.95,1.18.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1703.9,38.79c-.09-.25-.01-.64-.39-.65.09.25.01.64.39.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1702.32,40.41c-.1.46-.65.55-.79.97.82.28,1.77-.84.79-.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1696.01,41.38c.17-.14-.26.21,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1694.03,57.87c-.09-.25-.01-.64-.39-.65.09.25.01.64.39.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1693.28,37.8s-.22.18-.03.03c.02-.01.03-.02.03-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1691.27,48.49c-.09-.25-.01-.64-.4-.65.09.25.01.64.4.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1688.9,50.43c-.02.2-.06.38-.4.32v.65c.97.5,1.16-1.1.4-.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1686.93,47.2c-.09-.25,0-.64-.39-.65.09.25.01.64.39.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1675.48,61.1c1.24.15,1.11-.81,1.58-1.29-1.11-.05-.99.92-1.58,1.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1675.09,59.81c.44-.03.61.47.79,0,0-.32-.69-.41-.79,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1673.51,56.57c.75.04.27,1.07,1.18.97.09-.25.33-.38.79-.32-.78-1.15-.51-.64,0-1.94-1.16.02-1.46.74-1.97,1.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1674.3,49.14c-1.32-.78.95,1.08,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1673.9,54.96c.17-.14-.26.21,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1673.51,53.66c-.26.21.17-.13,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1672.32,52.69c.35-.57.95-.94,1.18-1.62-1.43-.5-2.19,1.18-1.18,1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1664.43,55.6c1.37.38.73-.15,1.18.97,1.44,0,1.77.92,2.77,1.29,1.46-.84.86-.04,3.16-.65v-1.62c-2.79,2.2-4.86-1.92-7.11,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1671.14,60.13c-1.04-.23-.38-1.85-1.58-1.94-.04.51.05,1.12-.79.97.07.94,2.08,2.15,2.37.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1669.96,62.07h.79v-.65h-.79v.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1669.56,54.96c.17-.14-.26.21,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1665.61,53.34c.68.02,1.01-.25,1.19-.65-.62.03-1.37-.04-1.19.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1665.61,60.13c-1.56.37,1.56.37,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1665.61,35.56c-.24-.02-.47-.05-.39-.32h-.79v.97h1.18v-.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1664.82,61.42c-1.54.8,1.31.47,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1665.22,66.27c-.95-1.66-1.02,1.11,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1664.43,49.46c1.08-1.64-1.38-1.2,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1664.43,62.72c-.9-.09-1.48.08-1.58.65.58.51,1.76.36,1.58-.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1663.64,49.78c-.26.21.17-.14,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1662.85,68.53c.31-.07.46-.27.39-.65-.31.07-.46.27-.39.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1662.06,58.51c-2.4.1,1.51.63,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1661.66,57.22c-.36-.57-.14-1.61-.79-1.94-.75.61-.05,1.68.79,1.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1660.48,52.37c.17-.14-.26.21,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1660.48,40.41c-.09-.25-.01-.64-.4-.65.09.25.01.64.4.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1660.08,53.02c-.09-.25-.01-.64-.39-.65.09.25.01.64.39.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1659.69,56.25c.17-.14-.26.21,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1660.08,62.07c-.06-.38.07-.92-.39-.97.06.38-.07.92.39.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1658.9,58.84h.79v-.65h-.79v.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1656.93,50.11c.27-.87-.82-.63-1.18-.97h0c-.07.71.33,1.03,1.18.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1655.74,45.99v1.24c.46-.39.54-1.08.79-1.65-.37.05-.61.2-.79.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1658.51,55.28c.67.12.74-.25.79-.65.39,0,.31.4.4.65.32-.06.39-.32.79-.32.11-.52-.37-.56-.4-.97-.96.29-1.71.75-3.16.65.69-1.81-1.57-2.36-.39-3.56,1.08.3.9,1.63,1.18,2.59,1.51-1.44-.19-2.59-1.97-3.32v7.2c1.08-.4,1.46-.61,3.55-.97-.17-.51-1.24-.28-.79-1.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1871.68,53.34c-1.67-.06-3.6,1.35-2.37,2.59-.36-1.81,1.67-1.65,2.37-2.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1903.66,49.46c-1.2-.88,1.08.98,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1899.71,54.31c.97-.04,1.9-.05,2.37.32-.16-.56.58-.83,0-.97-.18.45-2.12-.99-2.37.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1900.1,51.73c-1.2-.88,1.08.98,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1883.13,66.6c1.28.61-1.94-.92,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1880.36,58.84c1.45-.99,1.4-.23,2.77.32v-1.29c-.92.1-1.52-.05-1.98-.32.49,1.05-1.28.25-.79,1.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1881.15,67.24c.58.17,1,.48,1.58.65.38-.79-1.77-1.07-1.58-.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1878.79,50.76c1.27.37-2.56-.76,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1870.54,57.61c0,.07-.02.24-.05.58-.05.71.03-.38.05-.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1862.21,58.84c-1.2-.88,1.08.98,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1847.6,51.73s0,0,0,0c-.08.14-.19.34-.28.5.06-.12.15-.27.27-.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1847.6,51.72c.16-.28.11-.19,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1842.07,55.6c1.28-.4.3,1.05,1.58.65.29-.72-1.45-1.33-1.58-.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1835.36,56.25c.38.33.78.65,1.18.97-.63-.87.36-2.71-.39-2.26.49,1.05-1.28.25-.79,1.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1815.23,52.05c-1.2-.88,1.08.98,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1814.44,62.07c-1.08.98,1.2-.88,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1813.65,63.04c1.94-.92-1.29.61,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1797.07,56.9c-1.08.98,1.2-.88,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1795.1,52.37c.07.71-.33,1.03-1.18.97.02-.34-.18-.82-.4-.32.1.57.68.74,1.58.65.56-.43.56-1.83,0-2.26-1.03-.09-1.7.12-1.58.97.74.31,1.32-.97,1.58,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1777.73,54.31c-.34.48-1.27.47-1.98.65-.05,2.18,2.93-.29,1.98-.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1775.36,54.63c1,.24,1.85-1.23,1.18-1.29,0,.42-1.1.41-1.18,0,.16-.41.51-.66,1.18-.65-.05-.6-.26-1.08-.79-1.29.18,1.01-.99.91-1.58,1.29-.34,1.25,1.72.53,1.19,1.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1748.12,63.69c-.68,2.14,1.01-2.62,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1742.99,50.11c1.2-.53,2.12-1.28,2.76-2.26-1.24-.15-1.54.46-2.37.65,0-.18-.32-.37-.39,0,1,.25-1.11,1.13,0,1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1742.9,51.12c-.1.05-.17.08-.2.09.03-.02.11-.05.2-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1742.99,51.08c.34-.16.51-.24.59-.28-.12.06-.45.21-.67.32.03-.01.05-.02.08-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1738.64,65.95c-1.08.99,1.2-.88,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1737.85,52.37c-1.07-.29.4-1.13.4-1.62-1.4-.17-2.03.27-2.37.97.79-.07,1.69,1.37,1.97.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1692.85,45.58c-1.08.98,1.2-.88,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1677.06,46.55c-.42-.83,1.7-1.13.4-1.62,0,.48-1.47,1.32-.4,1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1672.72,58.84h-1.18c-.8,1.16,1.83,1.6.79.97-.24-.02-.47-.05-.4-.32.48-.04.94-.1.79-.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1670.74,47.2c-1.08.98,1.2-.88,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1663.24,55.6c.09-.25.33-.38.79-.32,0-.86.22-1.9-.79-1.94-.93.74-1.59,1.64,0,2.26Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 116.2,
    width: 1920,
    height: 5.54
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBorderWhite);
export default __webpack_public_path__ + "static/media/borderWhite.b82622338b97f1880525e1f81f9554fa.svg";
export { ForwardRef as ReactComponent };